webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = apiGet;
/* harmony export (immutable) */ __webpack_exports__["e"] = apiGetExcel;
/* unused harmony export apiUpload */
/* harmony export (immutable) */ __webpack_exports__["a"] = apiPost;
/* harmony export (immutable) */ __webpack_exports__["d"] = apiPut;
/* harmony export (immutable) */ __webpack_exports__["g"] = apiDelete;
/* harmony export (immutable) */ __webpack_exports__["f"] = apiUploadWithParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = notify;
function apiGet(vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params };
  if (params.octopus) {
    url = '' + "https://api-octopus.datacont.com" + url;
    params.token = localStorage.getItem('tokenOctopus');
    // console.log('url:', url)
  } else params.token = localStorage.getItem('token');
  params.empresa = "datacont";
  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    // console.log('data:', data)
    if (data.status === -1) {
      // No se ha logueado
      // localStorage.setItem('token', '')
      // window.location.href = '/'
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiGetExcel(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    responseType: 'arraybuffer',
    params: params
  };

  if (params.octopus) {
    var api = '';
    api = "https://api-octopus.datacont.com";
    url = api + url;
  }

  params.empresa = "datacont";

  if (params.octopus) params.token = localStorage.getItem('tokenOctopus');else params.token = localStorage.getItem('token');

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    onSuccess(data);
    if (onFinish) onFinish();
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiUpload(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPost(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;
  if (params.octopus) {
    url = '' + "https://api-octopus.datacont.com" + url;
    params.token = localStorage.getItem('tokenOctopus');
  } else params.token = localStorage.getItem('token');
  params.empresa = "datacont";

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPut(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.put(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiDelete(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    params: params
  };

  params.empresa = "datacont";
  if (params.octopus) {
    url = '' + "https://api-octopus.datacont.com" + url;
    params.token = localStorage.getItem('tokenOctopus');
  } else params.token = localStorage.getItem('token');

  vm.axios.delete(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiUploadWithParams(vm, url, body, params, onSuccess, onError, onFinish) {
  var obj = body;

  body.empresa = "datacont";
  params.empresa = "datacont".toLowerCase() || 'datacont';
  params.app = 'selfservice';
  if (params.octopus) {
    url = '' + "https://api-octopus.datacont.com" + url;
    params.token = localStorage.getItem('tokenOctopus');
  } else params.token = localStorage.getItem('token');

  vm.axios.post(url, obj, { params: params }).then(function (response) {
    console.Console;
    var data = response.data;
    data.status = +data.status;
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function notify(vm, type, title, text) {
  vm.$notify({
    title: title,
    text: text,
    position: 'bottom right',
    type: type
  });
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ba2200d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-283dba31",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
function scrollTo(_ref) {
  var mobile = _ref.mobile,
      desktop = _ref.desktop,
      ref = _ref.ref,
      vm = _ref.vm,
      hasOverlay = _ref.hasOverlay,
      hasPermisoSolicitud = _ref.hasPermisoSolicitud;

  vm.$nextTick(function () {
    if (hasOverlay) {
      ref = ref.querySelector('.card');
    }
    if (hasPermisoSolicitud) {
      ref = ref.querySelector('.close');
    }

    var offsetTop = getOffsetTop(ref);

    var contenedor = document.getElementsByClassName('contenedor')[0];

    // Si no es modo mobile, contenedor no puede scrollear, tenemos que cambiar al html
    if (window.getComputedStyle(contenedor).overflow !== 'auto') {
      contenedor = document.documentElement;
      offsetTop = offsetTop + desktop;
    } else {
      offsetTop = offsetTop + mobile;
    }

    contenedor.scroll({
      top: offsetTop, // Adjusts the position to be 10px above the element
      behavior: 'smooth'
    });
  });
}

function getOffsetTop(element) {
  var offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6d94cf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(840),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2464dcb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(867),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d8fc792",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(877),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44f58300",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(853),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ee55b0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(876),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44265e70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c1d74e6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(967),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e7e57344",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(827),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1361973e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flag__ = __webpack_require__(275);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: {
    flag: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__flag__["a" /* default */])
  }
}));

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(862),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-378dbfd2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(823),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-106bd79e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c2ba2b6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(970),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f79d4b30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(871),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42920714",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(923),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8409e774",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(579)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(894),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67914582",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Admin_View__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Admin_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Admin_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Vacaciones_View__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Vacaciones_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Vacaciones_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Boletines_Mensuales_View__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Boletines_Mensuales_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Boletines_Mensuales_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_View_Vacaciones_Equipo__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_View_Vacaciones_Equipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_View_Vacaciones_Equipo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_View_Vacaciones_Excepcion__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_View_Vacaciones_Excepcion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_View_Vacaciones_Excepcion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_View_Vacaciones_Reporte__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_View_Vacaciones_Reporte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_View_Vacaciones_Reporte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_View_Mis_Funciones__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_View_Mis_Funciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_View_Mis_Funciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_View_Mis_Datos__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_View_Mis_Datos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_View_Mis_Datos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_View_Mis_Boletas__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_View_Mis_Boletas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_View_Mis_Boletas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_View_Boletas_Transferidas__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_View_Boletas_Transferidas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_View_Boletas_Transferidas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_View_Boletas_Reporte__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_View_Boletas_Reporte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_View_Boletas_Reporte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_View_Boletas_Carga_Manual__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_View_Boletas_Carga_Manual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_View_Boletas_Carga_Manual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_View_Boletas_Pendientes_Generar__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_View_Boletas_Pendientes_Generar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_View_Boletas_Pendientes_Generar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_View_Permisos_Mis_Permisos__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_View_Permisos_Mis_Permisos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_View_Permisos_Mis_Permisos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_View_Permisos_Mi_Equipo__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_View_Permisos_Mi_Equipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_View_Permisos_Mi_Equipo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_View_Permisos_Excepcion__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_View_Permisos_Excepcion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_View_Permisos_Excepcion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_View_Permisos_Por_Aprobar_RRHH__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_View_Permisos_Por_Aprobar_RRHH___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_View_Permisos_Por_Aprobar_RRHH__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_View_Permisos_Reporte__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_View_Permisos_Reporte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_View_Permisos_Reporte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_View_Contratos_Equipo__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_View_Contratos_Equipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_View_Contratos_Equipo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_View_Contratos_Gestion__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_View_Contratos_Gestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_View_Contratos_Gestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_View_Contratos_Carga_Manual__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_View_Contratos_Carga_Manual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_View_Contratos_Carga_Manual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_View_Gestion_Empleado__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_View_Gestion_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__views_View_Gestion_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_View_Gestion_Documentos_Importantes__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_View_Gestion_Documentos_Importantes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__views_View_Gestion_Documentos_Importantes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_View_Documentos_Importantes__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_View_Documentos_Importantes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__views_View_Documentos_Importantes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_View_Gestion_Boletas_Tipo__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_View_Gestion_Boletas_Tipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__views_View_Gestion_Boletas_Tipo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_View_Gestion_Links_Importantes__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_View_Gestion_Links_Importantes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__views_View_Gestion_Links_Importantes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_View_Links_Importantes__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_View_Links_Importantes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__views_View_Links_Importantes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_View_Auditoria__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_View_Auditoria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__views_View_Auditoria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_View_Horas_Extras__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_View_Horas_Extras___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__views_View_Horas_Extras__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_View_Reporte_Vacaciones__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_View_Reporte_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__views_View_Reporte_Vacaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Component_Gestion_Delegaciones_RRHH__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Component_Gestion_Delegaciones_RRHH___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Component_Gestion_Delegaciones_RRHH__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Component_Asignar_Delegaciones__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Component_Asignar_Delegaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Component_Asignar_Delegaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Component_Administrador_Funciones__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Component_Administrador_Funciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Component_Administrador_Funciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_View_Cumpleanios__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_View_Cumpleanios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_View_Cumpleanios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_View_Component_Gestion_Areas__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_View_Component_Gestion_Areas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_View_Component_Gestion_Areas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_View_Component_Gestion_Gerencias__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_View_Component_Gestion_Gerencias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_View_Component_Gestion_Gerencias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Component_Reporte_Calendario_vue__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Component_Reporte_Calendario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Component_Reporte_Calendario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Component_Solicitudes_No_Aprobadas__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Component_Solicitudes_No_Aprobadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Component_Solicitudes_No_Aprobadas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_View_Empleado_Sin_Nacimiento__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_View_Empleado_Sin_Nacimiento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__views_View_Empleado_Sin_Nacimiento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_View_Mis_Contratos__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_View_Mis_Contratos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__views_View_Mis_Contratos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_View_Mis_Documentos_Firmar__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_View_Mis_Documentos_Firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__views_View_Mis_Documentos_Firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_View_Gestion_Cursos__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_View_Gestion_Cursos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__views_View_Gestion_Cursos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_View_Cursos_Virtuales__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_View_Cursos_Virtuales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__views_View_Cursos_Virtuales__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_View_Cursos_Virtuales_Clases__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_View_Cursos_Virtuales_Clases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__views_View_Cursos_Virtuales_Clases__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_View_Cursos_Virtuales_Video__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_View_Cursos_Virtuales_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__views_View_Cursos_Virtuales_Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_View_Gestion_Cursos_Editar__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_View_Gestion_Cursos_Editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__views_View_Gestion_Cursos_Editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_View_Gestion_Clases_Editar__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_View_Gestion_Clases_Editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__views_View_Gestion_Clases_Editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_View_Reporte_Cursos_Virtuales__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_View_Reporte_Cursos_Virtuales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__views_View_Reporte_Cursos_Virtuales__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_View_Dias_Festivos__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_View_Dias_Festivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__views_View_Dias_Festivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_View_Reporte_Curso_Terminado_Alumno__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_View_Reporte_Curso_Terminado_Alumno___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__views_View_Reporte_Curso_Terminado_Alumno__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_View_Reporte_Contratos__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_View_Reporte_Contratos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__views_View_Reporte_Contratos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_View_Reporte_Documentos_Firmar__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_View_Reporte_Documentos_Firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__views_View_Reporte_Documentos_Firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_View_Documentos_Firmar__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_View_Documentos_Firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__views_View_Documentos_Firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_View_Administrador_Noticias__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_View_Administrador_Noticias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__views_View_Administrador_Noticias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_vue_notification__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__websanova_vue_upload__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__websanova_vue_upload_dist_drivers_http_axios_esm_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_View_Gestion_Salas_Reuniones__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_View_Gestion_Salas_Reuniones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__views_View_Gestion_Salas_Reuniones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_View_Reuniones__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_View_Reuniones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__views_View_Reuniones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_View_Reuniones_Editar__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_View_Reuniones_Editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__views_View_Reuniones_Editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_View_Reunion_Vista_Detallada__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_View_Reunion_Vista_Detallada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__views_View_Reunion_Vista_Detallada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__guards__ = __webpack_require__(274);









































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

// Vue.use(require('@websanova/vue-upload'))







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_62__websanova_vue_upload__["a" /* default */], {
  http: __WEBPACK_IMPORTED_MODULE_63__websanova_vue_upload_dist_drivers_http_axios_esm_js__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_60_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-selfservice.datacont.com";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_61_vue_clickaway__["mixin"]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'admin',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Admin_View___default.a
  }, {
    path: '/vacaciones',
    name: 'vacaciones',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Vacaciones_View___default.a
  }, {
    path: '/vacaciones-equipo',
    name: 'vacaciones-equipo',
    component: __WEBPACK_IMPORTED_MODULE_9__components_View_Vacaciones_Equipo___default.a
  }, {
    path: '/vacaciones-excepciones',
    name: 'vacaciones-excepciones',
    component: __WEBPACK_IMPORTED_MODULE_10__components_View_Vacaciones_Excepcion___default.a
  }, {
    path: '/vacaciones-reportes/:tipo',
    name: 'vacaciones-reportes',
    component: __WEBPACK_IMPORTED_MODULE_11__components_View_Vacaciones_Reporte___default.a,
    props: true
  }, {
    path: '/funciones',
    name: 'mis-funciones',
    component: __WEBPACK_IMPORTED_MODULE_12__components_View_Mis_Funciones___default.a
  }, {
    path: '/datospersonales',
    name: 'mis-datos',
    component: __WEBPACK_IMPORTED_MODULE_13__components_View_Mis_Datos___default.a
  }, {
    path: '/boletines',
    name: 'boletines',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Boletines_Mensuales_View___default.a
  }, {
    path: '/dias-festivos',
    name: 'dias-festivos',
    component: __WEBPACK_IMPORTED_MODULE_54__views_View_Dias_Festivos___default.a
  }, {
    path: '/boletas',
    name: 'mis-boletas',
    component: __WEBPACK_IMPORTED_MODULE_14__components_View_Mis_Boletas___default.a
  }, {
    path: '/boletas-transferidas',
    name: 'boletas-transferidas',
    component: __WEBPACK_IMPORTED_MODULE_15__components_View_Boletas_Transferidas___default.a
  }, {
    path: '/boletas-reporte',
    name: 'boletas-reporte',
    component: __WEBPACK_IMPORTED_MODULE_16__components_View_Boletas_Reporte___default.a
  }, {
    path: '/vacaciones-reporte-excel',
    name: 'vacaciones-reporte-excel',
    component: __WEBPACK_IMPORTED_MODULE_35__views_View_Reporte_Vacaciones___default.a
  }, {
    path: '/boletas-pendientes-generar',
    name: 'boletas-pendientes-generar',
    component: __WEBPACK_IMPORTED_MODULE_18__components_View_Boletas_Pendientes_Generar___default.a
  }, {
    path: '/permisos',
    name: 'permisos',
    component: __WEBPACK_IMPORTED_MODULE_19__components_View_Permisos_Mis_Permisos___default.a
  }, {
    path: '/permisos-equipo',
    name: 'permisos-equipo',
    component: __WEBPACK_IMPORTED_MODULE_20__components_View_Permisos_Mi_Equipo___default.a
  }, {
    path: '/permisos-excepciones',
    name: 'permisos-excepciones',
    component: __WEBPACK_IMPORTED_MODULE_21__components_View_Permisos_Excepcion___default.a
  }, {
    path: '/permisos-aprobar-rrhh',
    name: 'permisos-aprobar-rrhh',
    component: __WEBPACK_IMPORTED_MODULE_22__components_View_Permisos_Por_Aprobar_RRHH___default.a
  }, {
    path: '/permisos-reportes/:tipo',
    name: 'permisos-reportes',
    component: __WEBPACK_IMPORTED_MODULE_23__components_View_Permisos_Reporte___default.a,
    props: true
  }, {
    path: '/contratos-equipo',
    name: 'contratos-equipo',
    component: __WEBPACK_IMPORTED_MODULE_24__components_View_Contratos_Equipo___default.a,
    props: true
  }, {
    path: '/contratos-gestion',
    name: 'contratos-gestion',
    component: __WEBPACK_IMPORTED_MODULE_25__components_View_Contratos_Gestion___default.a,
    props: true
  }, {
    path: '/gestion/empleado',
    name: 'gestion-empleado',
    component: __WEBPACK_IMPORTED_MODULE_27__views_View_Gestion_Empleado___default.a
  }, {
    path: '/gestion/documentos-importantes',
    name: 'gestion-documentos-importantes',
    component: __WEBPACK_IMPORTED_MODULE_28__views_View_Gestion_Documentos_Importantes___default.a
  }, {
    path: '/documentos-importantes',
    name: 'documentos-importantes',
    component: __WEBPACK_IMPORTED_MODULE_29__views_View_Documentos_Importantes___default.a
  }, {
    path: '/boletas-carga-manual',
    name: 'boletas-carga-manual',
    component: __WEBPACK_IMPORTED_MODULE_17__views_View_Boletas_Carga_Manual___default.a
  }, {
    path: '/boletas-tipo',
    name: 'boletas-tipo',
    component: __WEBPACK_IMPORTED_MODULE_30__views_View_Gestion_Boletas_Tipo___default.a
  }, {
    path: '/gestion/links-importantes',
    name: 'gestion-links-importantes',
    component: __WEBPACK_IMPORTED_MODULE_31__views_View_Gestion_Links_Importantes___default.a
  }, {
    path: '/links-importantes',
    name: 'links-importantes',
    component: __WEBPACK_IMPORTED_MODULE_32__views_View_Links_Importantes___default.a
  }, {
    path: '/auditoria',
    name: 'auditoria',
    component: __WEBPACK_IMPORTED_MODULE_33__views_View_Auditoria___default.a
  }, {
    path: '/horas-extras-reporte',
    name: 'horas-extras-reporte',
    component: __WEBPACK_IMPORTED_MODULE_34__views_View_Horas_Extras___default.a
  }, {
    path: '/gestion-delegaciones-rrhh',
    name: 'gestion-delegaciones-rrhh',
    component: __WEBPACK_IMPORTED_MODULE_36__components_Component_Gestion_Delegaciones_RRHH___default.a
  }, {
    path: '/gestion-delegaciones-jefes',
    name: 'gestion-delegaciones-jefes',
    component: __WEBPACK_IMPORTED_MODULE_37__components_Component_Asignar_Delegaciones___default.a
  }, {
    path: '/solicitudes-no-aprobadas',
    name: 'solicitudes-no-aprobadas',
    component: __WEBPACK_IMPORTED_MODULE_43__components_Component_Solicitudes_No_Aprobadas___default.a
  }, {
    path: '/administrador-funciones',
    name: 'administrador-funciones',
    component: __WEBPACK_IMPORTED_MODULE_38__components_Component_Administrador_Funciones___default.a
  }, {
    path: '/administrador-noticias',
    name: 'administrador-noticias',
    component: __WEBPACK_IMPORTED_MODULE_59__views_View_Administrador_Noticias___default.a
  }, {
    path: '/reporte-calendario',
    name: 'reporte-calendario',
    component: __WEBPACK_IMPORTED_MODULE_42__components_Component_Reporte_Calendario_vue___default.a
  }, {
    path: '/cumpleanios',
    name: 'cumpleanios',
    component: __WEBPACK_IMPORTED_MODULE_39__components_View_Cumpleanios___default.a
  }, {
    path: '/empleado-sin-nacimiento',
    name: 'empleado-sin-nacimiento',
    component: __WEBPACK_IMPORTED_MODULE_44__views_View_Empleado_Sin_Nacimiento___default.a
  }, {
    path: '/gestion-areas',
    name: 'gestion-areas',
    component: __WEBPACK_IMPORTED_MODULE_40__components_View_Component_Gestion_Areas___default.a
  }, {
    path: '/gestion-gerencias',
    name: 'gestion-gerencias',
    component: __WEBPACK_IMPORTED_MODULE_41__components_View_Component_Gestion_Gerencias___default.a
  }, {
    path: '/contratos-carga-manual',
    name: 'contratos-carga-manual',
    component: __WEBPACK_IMPORTED_MODULE_26__views_View_Contratos_Carga_Manual___default.a
  }, {
    path: '/mis-contratos',
    name: 'mis-contratos',
    component: __WEBPACK_IMPORTED_MODULE_45__views_View_Mis_Contratos___default.a
  }, {
    path: '/reporte-contratos',
    name: 'reporte-contratos',
    component: __WEBPACK_IMPORTED_MODULE_56__views_View_Reporte_Contratos___default.a
  }, {
    path: '/gestion-documentos-firmar',
    name: 'gestion-documentos-firmar',
    component: __WEBPACK_IMPORTED_MODULE_58__views_View_Documentos_Firmar___default.a
  }, {
    path: '/reporte-documentos-firmar',
    name: 'reporte-documentos-firmar',
    component: __WEBPACK_IMPORTED_MODULE_57__views_View_Reporte_Documentos_Firmar___default.a
  }, {
    path: '/mis-documentos-firmar',
    name: 'mis-documentos-firmar',
    component: __WEBPACK_IMPORTED_MODULE_46__views_View_Mis_Documentos_Firmar___default.a
  }, {
    path: '/gestion-cursos',
    name: 'gestion-cursos',
    component: __WEBPACK_IMPORTED_MODULE_47__views_View_Gestion_Cursos___default.a
  }, {
    path: '/gestion-cursos/:id',
    name: 'gestion-cursos-editar',
    component: __WEBPACK_IMPORTED_MODULE_51__views_View_Gestion_Cursos_Editar___default.a
  }, {
    path: '/gestion-cursos/:id/gestion-clases/:idClase',
    name: 'gestion-clases-editar',
    component: __WEBPACK_IMPORTED_MODULE_52__views_View_Gestion_Clases_Editar___default.a
  }, {
    path: '/mis-cursos',
    name: 'mis-cursos',
    component: __WEBPACK_IMPORTED_MODULE_48__views_View_Cursos_Virtuales___default.a
  }, {
    path: '/mis-cursos/:idCurso/clases',
    name: 'mis-clases',
    component: __WEBPACK_IMPORTED_MODULE_49__views_View_Cursos_Virtuales_Clases___default.a
  }, {
    path: '/mis-cursos/:idCurso/clases/:idClase',
    name: 'clase-video',
    component: __WEBPACK_IMPORTED_MODULE_50__views_View_Cursos_Virtuales_Video___default.a
  }, {
    path: '/reporte-cursos',
    name: 'reporte-cursos',
    component: __WEBPACK_IMPORTED_MODULE_53__views_View_Reporte_Cursos_Virtuales___default.a
  }, {
    path: '/reporte-cursos-terminados-alumnos',
    name: 'reporte-cursos-terminados-alumnos',
    component: __WEBPACK_IMPORTED_MODULE_55__views_View_Reporte_Curso_Terminado_Alumno___default.a
  }, {
    path: '/gestion-sala-reuniones',
    name: 'gestion-sala-reuniones',
    component: __WEBPACK_IMPORTED_MODULE_64__views_View_Gestion_Salas_Reuniones___default.a
  }, {
    path: '/mis-reuniones',
    name: 'mis-reuniones',
    component: __WEBPACK_IMPORTED_MODULE_65__views_View_Reuniones___default.a
  }, {
    path: '/gestion-reuniones/:idReunion',
    name: 'gestion-reuniones-editar',
    component: __WEBPACK_IMPORTED_MODULE_66__views_View_Reuniones_Editar___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_68__guards__["a" /* verificarAccesoEditar */]
  }, {
    path: '/reunion-vista-detallada/:idReunion',
    name: 'reunion-vista-detallada',
    component: __WEBPACK_IMPORTED_MODULE_67__views_View_Reunion_Vista_Detallada___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_68__guards__["b" /* verificarAccesoEsAsistente */]
  }]
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('setSidebarMobile', false);
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_View__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Forgot_Password_Request__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_View_Forgot_Password_Request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_View_Forgot_Password_Request__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_View_Forgot_Password_Post__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_View_Forgot_Password_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_View_Forgot_Password_Post__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "https://api-selfservice.datacont.com";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login_View___default.a
  }, {
    path: '/forgot-password-request',
    name: 'forgot-password-request',
    component: __WEBPACK_IMPORTED_MODULE_5__components_View_Forgot_Password_Request___default.a
  }, {
    path: '/forgot-password-post',
    name: 'forgot-password-post',
    component: __WEBPACK_IMPORTED_MODULE_6__components_View_Forgot_Password_Post___default.a
  }, {
    path: '/*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login_View___default.a
  }]
}));

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(968),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(899),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(822),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10135485",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Not_Logged_App__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Not_Logged_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Not_Logged_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Admin_App__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Admin_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Admin_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_not_logged__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_admin__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Component_Loading__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Component_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Component_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_es__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_locale_es__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('es');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('twoDecimals', function (value) {
  return value.toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateHour', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('DD/MM/yyyy HH:mm');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('truncateText', function (value, limit) {
  if (!value) return '';
  limit = limit || 50; // Si no se pasa un límite, se usa 50 por defecto
  var final = value.length > limit ? value.substring(0, limit) + '...' : value;
  return final;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('fromNow', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).fromNow();
});

// Filtro para formatear la fecha como "24 de abril"
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('customDate', function (value) {
  if (!value) return '';
  // Formatea la fecha con moment
  var formattedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('D [de] MMMM');

  // Capitaliza la primera letra del mes
  formattedDate = formattedDate.replace(/(?:de\s)(\w+)/, function (match, p1) {
    return 'de ' + p1.charAt(0).toUpperCase() + p1.slice(1).toLowerCase();
  });
  // Devuelve la fecha con el mes capitalizado
  return formattedDate;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loading', __WEBPACK_IMPORTED_MODULE_7__components_Component_Loading___default.a);

// require('vue2-animate/dist/vue2-animate.min.css')

/* eslint-disable no-new */
var token = localStorage.getItem('token');

window._ = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a;
window.moment = __WEBPACK_IMPORTED_MODULE_2_moment___default.a;

if (token) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_6__router_admin__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
    template: '<adminApp/>',
    components: { adminApp: __WEBPACK_IMPORTED_MODULE_4__Admin_App___default.a }
  });
} else {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_5__router_not_logged__["a" /* default */],
    template: '<notLoggedApp/>',
    components: { notLoggedApp: __WEBPACK_IMPORTED_MODULE_3__Not_Logged_App___default.a }
  });
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export notify */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return verificarAccesoEditar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return verificarAccesoEsAsistente; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);





function notify(type, title, text) {
  __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$notify({
    title: title,
    text: text,
    position: 'bottom right',
    type: type
  });
}

var verificarAccesoEditar = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var params, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            params = {
              empresa: "datacont",
              token: localStorage.getItem('token')
            };

            if (!(+to.params.idReunion === 0)) {
              _context.next = 5;
              break;
            }

            next();
            return _context.abrupt('return');

          case 5:
            _context.next = 7;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/reunion/gestion/' + to.params.idReunion + '/verificar/acceso/editar', { params: params });

          case 7:
            response = _context.sent;


            if (response.data.status === 1) {
              next();
            } else {
              notify('error', 'Error', 'No tiene acceso');
              next('/mis-reuniones');
            }
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](0);

            notify('error', 'Error', _context.t0.message);
            next('/mis-reuniones');

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 11]]);
  }));

  return function verificarAccesoEditar(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var verificarAccesoEsAsistente = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
    var params, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            params = {
              empresa: "datacont",
              token: localStorage.getItem('token')
            };
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/reunion/gestion/' + to.params.idReunion + '/verificar/acceso/es-asistente', { params: params });

          case 4:
            response = _context2.sent;


            if (response.data.status === 1) {
              next();
            } else {
              notify('error', 'Error', 'No tiene acceso');
              next('/mis-reuniones');
            }
            _context2.next = 12;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](0);

            notify('error', 'Error', _context2.t0.message);
            next('/mis-reuniones');

          case 12:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 8]]);
  }));

  return function verificarAccesoEsAsistente(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var flag = {
  state: {
    showSidebarMobile: false,
    showSidebarDesktop: false,
    showPopupBirthday: false,
    isUserBirthday: false,
    estoySiendoReemplazado: false,
    estoyReemplazando: false,
    nombreReemplazo: '',
    fechaInicio: '',
    fechaFin: '',
    codigoEmpleadoOrigen: 0,
    codigoEmpleadoReemplazante: 0,
    id: 0,
    documentosPorFirmar: 0, // Nueva propiedad añadida,
    contratosPorFirmar: 0,
    cursosSinTerminar: 0
  },
  mutations: {
    SET_SIDEBAR_MOBILE: function SET_SIDEBAR_MOBILE(state, payload) {
      state.showSidebarMobile = payload;
    },
    SET_SIDEBAR_DESKTOP: function SET_SIDEBAR_DESKTOP(state, payload) {
      state.showSidebarDesktop = payload;
    },
    SET_POPUP_BIRTHDAY: function SET_POPUP_BIRTHDAY(state, payload) {
      state.showPopupBirthday = payload;
    },
    SET_USER_BIRTHDAY: function SET_USER_BIRTHDAY(state, payload) {
      state.isUserBirthday = payload;
    },
    SET_ESTOY_SIENDO_REEMPLAZADO: function SET_ESTOY_SIENDO_REEMPLAZADO(state, payload) {
      state.estoySiendoReemplazado = payload;
    },
    SET_ESTOY_REEMPLAZANDO: function SET_ESTOY_REEMPLAZANDO(state, payload) {
      state.estoyReemplazando = payload;
    },
    SET_NOMBRE_REEMPLAZO: function SET_NOMBRE_REEMPLAZO(state, payload) {
      state.nombreReemplazo = payload;
    },
    SET_FECHA_INICIO: function SET_FECHA_INICIO(state, payload) {
      state.fechaInicio = payload;
    },
    SET_FECHA_FIN: function SET_FECHA_FIN(state, payload) {
      state.fechaFin = payload;
    },
    SET_CODIGO_EMPLEADO_ORIGEN: function SET_CODIGO_EMPLEADO_ORIGEN(state, payload) {
      state.codigoEmpleadoOrigen = payload;
    },
    SET_CODIGO_EMPLEADO_REEMPLAZANTE: function SET_CODIGO_EMPLEADO_REEMPLAZANTE(state, payload) {
      state.codigoEmpleadoReemplazante = payload;
    },
    SET_ID: function SET_ID(state, payload) {
      state.id = payload;
    },
    SET_DOCUMENTOS_POR_FIRMAR: function SET_DOCUMENTOS_POR_FIRMAR(state, payload) {
      // Nueva mutation añadida
      state.documentosPorFirmar = payload;
    },
    SET_CONTRATOS_POR_FIRMAR: function SET_CONTRATOS_POR_FIRMAR(state, payload) {
      // Nueva mutation añadida
      state.contratosPorFirmar = payload;
    },
    SET_CURSOS_SIN_TERMINAR: function SET_CURSOS_SIN_TERMINAR(state, payload) {
      state.cursosSinTerminar = payload;
    }
  },
  actions: {
    setSidebarMobile: function setSidebarMobile(_ref, payload) {
      var commit = _ref.commit;

      commit('SET_SIDEBAR_MOBILE', payload);
    },
    setSidebarDesktop: function setSidebarDesktop(_ref2, payload) {
      var commit = _ref2.commit;

      commit('SET_SIDEBAR_DESKTOP', payload);
    },
    setPopupBirthday: function setPopupBirthday(_ref3, payload) {
      var commit = _ref3.commit;

      commit('SET_POPUP_BIRTHDAY', payload);
    },
    setUserBirthday: function setUserBirthday(_ref4, payload) {
      var commit = _ref4.commit;

      commit('SET_USER_BIRTHDAY', payload);
    },
    setEstoySiendoReemplazado: function setEstoySiendoReemplazado(_ref5, payload) {
      var commit = _ref5.commit;

      commit('SET_ESTOY_SIENDO_REEMPLAZADO', payload);
    },
    setEstoyReemplazando: function setEstoyReemplazando(_ref6, payload) {
      var commit = _ref6.commit;

      commit('SET_ESTOY_REEMPLAZANDO', payload);
    },
    setNombreReemplazo: function setNombreReemplazo(_ref7, payload) {
      var commit = _ref7.commit;

      commit('SET_NOMBRE_REEMPLAZO', payload);
    },
    setFechaInicio: function setFechaInicio(_ref8, payload) {
      var commit = _ref8.commit;

      commit('SET_FECHA_INICIO', payload);
    },
    setFechaFin: function setFechaFin(_ref9, payload) {
      var commit = _ref9.commit;

      commit('SET_FECHA_FIN', payload);
    },
    setCodigoEmpleadoOrigen: function setCodigoEmpleadoOrigen(_ref10, payload) {
      var commit = _ref10.commit;

      commit('SET_CODIGO_EMPLEADO_ORIGEN', payload);
    },
    setCodigoEmpleadoReemplazante: function setCodigoEmpleadoReemplazante(_ref11, payload) {
      var commit = _ref11.commit;

      commit('SET_CODIGO_EMPLEADO_REEMPLAZANTE', payload);
    },
    setId: function setId(_ref12, payload) {
      var commit = _ref12.commit;

      commit('SET_ID', payload);
    },
    setDocumentosPorFirmar: function setDocumentosPorFirmar(_ref13, payload) {
      var commit = _ref13.commit;
      // Nueva action añadida
      commit('SET_DOCUMENTOS_POR_FIRMAR', payload);
    },
    setContratosPorFirmar: function setContratosPorFirmar(_ref14, payload) {
      var commit = _ref14.commit;
      // Nueva action añadida
      commit('SET_CONTRATOS_POR_FIRMAR', payload);
    },
    setCursosSinTerminar: function setCursosSinTerminar(_ref15, payload) {
      var commit = _ref15.commit;

      commit('SET_CURSOS_SIN_TERMINAR', payload);
    }
  },
  getters: {
    showSidebarMobile: function showSidebarMobile(state) {
      return state.showSidebarMobile;
    },
    showSidebarDesktop: function showSidebarDesktop(state) {
      return state.showSidebarDesktop;
    },
    showPopupBirthday: function showPopupBirthday(state) {
      return state.showPopupBirthday;
    },
    isUserBirthday: function isUserBirthday(state) {
      return state.isUserBirthday;
    },
    estoySiendoReemplazado: function estoySiendoReemplazado(state) {
      return state.estoySiendoReemplazado;
    },
    estoyReemplazando: function estoyReemplazando(state) {
      return state.estoyReemplazando;
    },
    nombreReemplazo: function nombreReemplazo(state) {
      return state.nombreReemplazo;
    },
    fechaInicio: function fechaInicio(state) {
      return state.fechaInicio;
    },
    fechaFin: function fechaFin(state) {
      return state.fechaFin;
    },
    codigoEmpleadoOrigen: function codigoEmpleadoOrigen(state) {
      return state.codigoEmpleadoOrigen;
    },
    codigoEmpleadoReemplazante: function codigoEmpleadoReemplazante(state) {
      return state.codigoEmpleadoReemplazante;
    },
    id: function id(state) {
      return state.id;
    },
    documentosPorFirmar: function documentosPorFirmar(state) {
      return state.documentosPorFirmar;
    }, // Nuevo getter añadido
    contratosPorFirmar: function contratosPorFirmar(state) {
      return state.contratosPorFirmar;
    }, // Nuevo getter añadido
    cursosSinTerminar: function cursosSinTerminar(state) {
      return state.cursosSinTerminar;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (flag);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Logged__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Logged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header_Logged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Bottom_Bar__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Bottom_Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Component_Bottom_Bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_gestion_delegaciones_rrhh_guardar__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_gestion_delegaciones_rrhh_guardar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_gestion_delegaciones_rrhh_guardar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component_Mis_Documentos_Sin_Cargar_vue__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component_Mis_Documentos_Sin_Cargar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Component_Mis_Documentos_Sin_Cargar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {},
      mostrarModalDelegacion: false
    };
  },
  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    showSidebarMobile: function showSidebarMobile() {
      return this.$store.getters.showSidebarMobile;
    },
    showPopupBirthday: function showPopupBirthday() {
      return this.$store.getters.showPopupBirthday;
    }
  },
  created: function created() {
    var vm = this;
    if (!localStorage.getItem('sidebar-show')) {
      localStorage.setItem('sidebar-show', 'true');
    }
    var showSidebar = localStorage.getItem('sidebar-show') === 'true';
    vm.$store.dispatch('setSidebarDesktop', showSidebar);
    vm.verificarNacimiento();
    vm.fetchReemplazo();
  },

  components: {
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_Header_Logged___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default.a,
    BottomBar: __WEBPACK_IMPORTED_MODULE_2__components_Component_Bottom_Bar___default.a,
    GestionDelegacionGuardar: __WEBPACK_IMPORTED_MODULE_4__components_c_gestion_delegaciones_rrhh_guardar___default.a,
    ComponentMisDocumentosSinCargar: __WEBPACK_IMPORTED_MODULE_5__components_Component_Mis_Documentos_Sin_Cargar_vue___default.a
  },
  name: 'adminApp',
  methods: {
    fetchReemplazo: function fetchReemplazo() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["c" /* apiGet */])(vm, '/delegaciones/empleado', obj, function (data) {
        if (data.noReemplazo) {
          return;
        }
        if (data.estoySiendoReemplazado) {
          vm.$store.dispatch('setEstoySiendoReemplazado', true);
          vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo);
        } else if (data.estoyReemplazando) {
          vm.$store.dispatch('setEstoyReemplazando', true);
          vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo);
        }
        vm.$store.dispatch('setFechaInicio', data.delegacion.fechaInicio);
        vm.$store.dispatch('setFechaFin', data.delegacion.fechaFin);
        vm.$store.dispatch('setCodigoEmpleadoOrigen', data.delegacion.codigoEmpleadoOrigen);
        vm.$store.dispatch('setCodigoEmpleadoReemplazante', data.delegacion.codigoEmpleadoReemplazante);
        vm.$store.dispatch('setId', data.delegacion.id);
      }, function (error) {
        console.error('error', error);
      });
    },
    cerrarPopupBirthday: function cerrarPopupBirthday() {
      localStorage.setItem('birthday_popup_close', true);
      this.$store.dispatch('setPopupBirthday', false);
    },
    sidebarHide: function sidebarHide() {
      var vm = this;
      vm.$store.dispatch('setSidebarDesktop', !vm.showSidebarDesktop);
      localStorage.setItem('sidebar-show', vm.showSidebarDesktop);
    },
    verificarNacimiento: function verificarNacimiento() {
      var vm = this;
      var mesActual = new Date().getMonth() + 1;
      var diaActual = new Date().getDate();
      var nacimiento = localStorage.getItem('nacimiento');
      var mesNacimiento = __WEBPACK_IMPORTED_MODULE_3_moment___default()(nacimiento).format('MM');
      var diaNacimiento = __WEBPACK_IMPORTED_MODULE_3_moment___default()(nacimiento).format('DD');

      if (+mesActual === +mesNacimiento && +diaActual === +diaNacimiento) {
        vm.$store.dispatch('setUserBirthday', true);
        var birthdayPopupClose = localStorage.getItem('birthday_popup_close');
        if (!birthdayPopupClose) {
          vm.$store.dispatch('setPopupBirthday', true);
        }
      } else {
        localStorage.removeItem('birthday_popup_close');
      }
      // birthday_popup_close setear en true cuando cierre el popup y se crea cuando se cierra en el popup
      // fondo rosado el badge
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Not_Logged_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Not_Logged_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header_Not_Logged_vue__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_0__components_Header_Not_Logged_vue___default.a
  },
  name: 'app'
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Dashboard_KPI__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Dashboard_KPI___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Dashboard_KPI__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Dashboard_KPI_jefe_New__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Dashboard_KPI_jefe_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Dashboard_KPI_jefe_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Dashboard_KPI_usuario__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Dashboard_KPI_usuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Dashboard_KPI_usuario__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      perfilVacaciones: localStorage.getItem('perfilVacaciones'),
      showKpiRRHH: true,
      showKpiJefe: true,
      showKpiUsuario: true
    };
  },

  components: {
    'component-dashboard-kpi': __WEBPACK_IMPORTED_MODULE_0__Component_Dashboard_KPI___default.a,
    'component-dashboard-kpi-jefe': __WEBPACK_IMPORTED_MODULE_1__Component_Dashboard_KPI_jefe_New___default.a,
    'component-dashboard-kpi-usuario': __WEBPACK_IMPORTED_MODULE_2__Component_Dashboard_KPI_usuario___default.a
  },
  methods: {
    close: function close(componente) {
      this[componente] = false;
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boletines',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Administrador_Funciones_Editar__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Administrador_Funciones_Editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Administrador_Funciones_Editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Cargo__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Cargo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Cargo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'administrador-funciones',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      cargo: null,
      isScroll: false,
      disabledScrollExecute: true,
      skip: 0,
      noMore: false,
      solicitudSeleccionada: null,
      mostrarConfirmacionEliminar: false,
      empleadosValidados: [],
      isSending: false,
      mostrarBusquedaCargo: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'editar-administrador-funciones': __WEBPACK_IMPORTED_MODULE_0__components_Component_Administrador_Funciones_Editar___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a,
    'lookup-cargo': __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Cargo___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    seleccionarCargo: function seleccionarCargo(o) {
      var vm = this;
      vm.cargo = o.cargo;
      vm.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      var obj = {
        skip: vm.skip,
        cargo: vm.cargo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/funciones_pdf/obtener', obj, function (data) {
        data.lista.forEach(function (o) {
          // o.fecha = moment(o.fecha).format('DD/MM/YYYY HH:mm:ss')
          vm.lista.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    verAdjuntoLegacy: function verAdjuntoLegacy(pathPdf) {
      var url = "https://api-selfservice.datacont.com" + '/funciones_pdf/mostrarPath?ruta=' + pathPdf;
      window.open(url, '_blank');
    },
    openModalEditar: function openModalEditar(cargo) {
      var vm = this;
      if (cargo) vm.cargo = cargo;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.cargo = null;
      if (refresh) vm.fetch();
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var _this = this;

      this.empleadosValidados = [];
      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionEliminar = true;
      var contenedor = document.getElementsByClassName('contenedor')[0];
      if (window.getComputedStyle(contenedor).overflow !== 'auto') {
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_scroll__["a" /* scrollTo */])({
            vm: _this,
            ref: _this.$refs.confirmarEliminar.$el,
            mobile: 0,
            desktop: -400,
            hasOverlay: false
          });
        });
      }
    },
    eliminar: function eliminar() {
      var vm = this;
      var obj = {
        cargo: vm.solicitudSeleccionada.cargo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["g" /* apiDelete */])(vm, '/funciones_pdf', obj, function (data) {
        vm.mostrarConfirmacionEliminar = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    validarEliminar: function validarEliminar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        cargo: vm.solicitudSeleccionada.cargo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["g" /* apiDelete */])(vm, '/funciones_pdf/validarEliminar', obj, function (data) {
        if (data.lista.length > 0) {
          vm.empleadosValidados = data.lista;
          vm.isSending = false;
        } else {
          vm.eliminar();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'solicitud_vacaciones_component',
  components: {
    'upload-image': __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image___default.a
  },
  props: ['cargo'],
  data: function data() {
    return {
      pathPdf: '',
      isSaving: false,
      mostrarModalAdjuntar: false,
      isLoading: false,
      cargoLocal: ''
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.cargo) {
      vm.cargoLocal = vm.cargo;
      vm.fetch();
    }
  },

  methods: {
    verAdjuntoLegacy: function verAdjuntoLegacy() {
      var url = "https://api-selfservice.datacont.com" + '/funciones_pdf/mostrarPath?ruta=' + this.pathPdf;
      window.open(url, '_blank');
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        cargo: vm.cargo || vm.cargoLocal
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/funciones_pdf/obtener/funcion', obj, function (data) {
        vm.pathPdf = data.funcion.pathPdf;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardar: function guardar() {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        cargo: vm.cargoLocal,
        pathPdf: vm.pathPdf
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/funciones_pdf', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.codigoEmpleado = o.codigo;
      this.empleadoExcepcion = {};
      this.asignarEmpleadoExcepcion();
    },
    asignarEmpleadoExcepcion: function asignarEmpleadoExcepcion() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/uno/' + this.codigoEmpleado, obj, function (data) {
        vm.empleadoExcepcion = data.data;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      vm.closeModalAdjuntar();
      vm.pathPdf = fileSubido.file.ruta;
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Component_Asignar_Delegaciones',
  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default.a
  },
  data: function data() {
    return {
      fechaInicio: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      fechaFin: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'month').format('YYYY-MM-DD'),
      mostrarBusquedaReemplazante: false,
      codigoReemplazante: ''
    };
  },

  computed: {
    estoySiendoReemplazado: function estoySiendoReemplazado() {
      return this.$store.getters.estoySiendoReemplazado;
    },
    nombreReemplazo: function nombreReemplazo() {
      return this.$store.getters.nombreReemplazo;
    }
  },
  methods: {
    submitForm: function submitForm() {
      var vm = this;
      var data = {
        codigoEmpleadoReemplazante: vm.codigoReemplazante,
        fechaInicio: vm.fechaInicio,
        fechaFin: vm.fechaFin
      };
      if (!vm.codigoReemplazante) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe seleccionar un reemplazante');
        return;
      }
      if (!vm.fechaInicio) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe seleccionar una fecha de inicio');
        return;
      }
      if (!vm.fechaFin) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe seleccionar una fecha de fin');
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/delegaciones', data, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Se ha asignado el reemplazo correctamente');
        vm.$store.dispatch('setEstoySiendoReemplazado', true);
        vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    seleccionarReemplazante: function seleccionarReemplazante(o) {
      this.codigoReemplazante = o.codigo;
    },
    getTodayDate: function getTodayDate() {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var day = today.getDate();

      // Asegúrate de que el mes y el día tengan dos dígitos
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;

      return year + '-' + month + '-' + day;
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boleta-item-lista',
  props: ['boleta'],
  data: function data() {
    return {
      marcandoComoVisto: false
    };
  },

  watch: {},
  created: function created() {},

  methods: {
    ver: function ver() {
      var vm = this;
      if (vm.boleta.visto) {
        vm.$emit('ver', vm.boleta);
        return;
      }

      vm.marcandoComoVisto = true;

      var obj = {
        periodo: vm.boleta.periodo,
        mes: vm.boleta.mes,
        tipo: vm.boleta.tipo,
        codigo: vm.boleta.codigo
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/boleta/empleado/visto', obj, function (data) {
        vm.$emit('ver', vm.boleta);
        vm.$emit('refresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.marcandoComoVisto = false;
      });
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Positioned__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Positioned___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Positioned__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boleta-item-transferidos',
  props: ['boleta'],
  data: function data() {
    return {
      showConfirm: false
    };
  },

  components: {
    ConfirmarAccionPositioned: __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Positioned___default.a
  },
  watch: {},
  created: function created() {},

  methods: {
    ver: function ver() {
      var vm = this;
      if (!vm.boleta.visto) {
        // Marcar que lo vio
        vm.$emit('ver', vm.boleta);
      } else {
        vm.$emit('ver', vm.boleta);
      }
    },
    firmar: function firmar() {},
    closeConfirm: function closeConfirm() {
      this.showConfirm = false;
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_boletas_pendientes_generar',
  data: function data() {
    return {
      lista: [],
      codigoLogueadoJefe: localStorage.getItem('codigo') + '',
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      solicitudSeleccionada: {},
      filtroCodigoEmpleado: '',
      filtroTipo: '',
      filtroMes: 'all',
      filtroPeriodo: '',
      filtroVisto: '',
      tipos: [],
      meses: [{ codigo: 1, descripcion: 'Enero' }, { codigo: 2, descripcion: 'Febrero' }, { codigo: 3, descripcion: 'Marzo' }, { codigo: 4, descripcion: 'Abril' }, { codigo: 5, descripcion: 'Mayo' }, { codigo: 6, descripcion: 'Junio' }, { codigo: 7, descripcion: 'Julio' }, { codigo: 8, descripcion: 'Agosto' }, { codigo: 9, descripcion: 'Setiembre' }, { codigo: 10, descripcion: 'Octubre' }, { codigo: 11, descripcion: 'Noviembre' }, { codigo: 12, descripcion: 'Diciembre' }],
      periodos: [],
      path: '',
      activateFrame: false
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.loadPeriodos();
    this.fetchTipos();
    this.fetch();
  },

  watch: {
    filtroCodigoEmpleado: function filtroCodigoEmpleado(value) {
      return this.fetch();
    },
    filtroTipo: function filtroTipo(value) {
      return this.fetch();
    },
    filtroMes: function filtroMes(value) {
      return this.fetch();
    },
    filtroPeriodo: function filtroPeriodo(value) {
      return this.fetch();
    },
    filtroVisto: function filtroVisto(value) {
      return this.fetch();
    }
  },
  methods: {
    loadPeriodos: function loadPeriodos() {
      var vm = this;
      var periodoInicial = 2018;
      var periodoActual = +window.moment().format('YYYY');
      vm.filterPeriodo = periodoActual;

      while (periodoActual >= periodoInicial) {
        vm.periodos.push(periodoActual);
        periodoActual--;
      }
    },
    fetchTipos: function fetchTipos() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/boleta/tipos', obj, function (data) {
        vm.tipos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var filtros = {
        periodo: vm.filtroPeriodo,
        mes: vm.filtroMes,
        tipo: vm.filtroTipo,
        codigoEmpleado: vm.filtroCodigoEmpleado,
        visto: vm.filtroVisto
      };

      var obj = {
        filtros: filtros
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/boleta/pendiente-generar', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroTipo = 1;
      this.filtroCodigoEmpleado = '';
      this.filtroMes = +window.moment().format('MM');
      this.filtroPeriodo = +window.moment().format('YYYY');
      this.filtroVisto = 'all';
    },
    verPdf: function verPdf(boleta) {
      var vm = this;
      // Obtener path enviando los datos
      vm.tituloFrame = 'Boleta de ' + boleta.nombreMes + ' ' + boleta.periodo + ' - ' + boleta.descripcionTipo;
      vm.activateFrame = true;
      var token = localStorage.getItem('token');
      this.path = "https://api-selfservice.datacont.com" + '/boleta/empleado/pdf?token=' + token + '&empresa=' + "datacont" + '&codigo=' + boleta.codigo + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo;
      // this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      // Scroll top
      // document.body.scrollTop = 0; // For Safari
      // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    cerrarFrame: function cerrarFrame() {
      this.path = '';
      this.activateFrame = false;
    },
    notificar: function notificar(o) {
      var vm = this;

      var obj = {
        periodo: o.periodo,
        mes: o.mes,
        tipo: o.tipo,
        codigo: o.codigo
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/boleta/empleado/notificar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se le notifico al empleado');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_boletas_reporte_component',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      mostrarNotificacionMasiva: false,
      mostrarObservaciones: false,
      solicitudSeleccionada: {},
      filtroCodigoEmpleado: '',
      filtroTipo: '',
      filtroMes: 'all',
      filtroPeriodo: '',
      filtroVisto: '',
      tipos: [],
      observaciones: [],
      meses: [{ codigo: 1, descripcion: 'Enero' }, { codigo: 2, descripcion: 'Febrero' }, { codigo: 3, descripcion: 'Marzo' }, { codigo: 4, descripcion: 'Abril' }, { codigo: 5, descripcion: 'Mayo' }, { codigo: 6, descripcion: 'Junio' }, { codigo: 7, descripcion: 'Julio' }, { codigo: 8, descripcion: 'Agosto' }, { codigo: 9, descripcion: 'Setiembre' }, { codigo: 10, descripcion: 'Octubre' }, { codigo: 11, descripcion: 'Noviembre' }, { codigo: 12, descripcion: 'Diciembre' }],
      periodos: [],
      path: '',
      activateFrame: false,
      boletaEliminar: {},
      mostrarModalEliminar: false,
      isProcessing: false
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_2__components_Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.loadPeriodos();
    this.fetchTipos();
    this.filtroVisto = this.$route.query.visto || 'all';
    this.filtroTipo = this.$route.query.tipo || 1;
    this.filtroMes = this.$route.query.mes || +window.moment().format('MM');
    this.filtroPeriodo = this.$route.query.anio || +window.moment().format('YYYY');
    this.filtroCodigoEmpleado = this.$route.query.codigoEmpleado || '';
    this.fetch();
  },

  watch: {
    filtroCodigoEmpleado: function filtroCodigoEmpleado(value) {
      return this.fetch();
    },
    filtroTipo: function filtroTipo(value) {
      return this.fetch();
    },
    filtroMes: function filtroMes(value) {
      return this.fetch();
    },
    filtroPeriodo: function filtroPeriodo(value) {
      return this.fetch();
    },
    filtroVisto: function filtroVisto(value) {
      return this.fetch();
    }
  },
  methods: {
    loadPeriodos: function loadPeriodos() {
      var vm = this;
      var periodoInicial = 2018;
      var periodoActual = +window.moment().format('YYYY');
      vm.filterPeriodo = periodoActual;

      while (periodoActual >= periodoInicial) {
        vm.periodos.push(periodoActual);
        periodoActual--;
      }
    },
    fetchTipos: function fetchTipos() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/boleta/tipos', obj, function (data) {
        vm.tipos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var filtros = {
        periodo: vm.filtroPeriodo,
        mes: vm.filtroMes,
        tipo: vm.filtroTipo,
        codigoEmpleado: vm.filtroCodigoEmpleado,
        visto: vm.filtroVisto
      };

      if (filtros.visto !== 'all') {
        filtros.visto = +filtros.visto;
      }

      var obj = {
        filtros: filtros
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/boleta/reporte', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroTipo = 1;
      this.filtroCodigoEmpleado = '';
      this.filtroMes = +window.moment().format('MM');
      this.filtroPeriodo = +window.moment().format('YYYY');
      this.filtroVisto = 'all';
    },
    verPdf: function verPdf(boleta) {
      var vm = this;
      // Obtener path enviando los datos
      vm.tituloFrame = 'Boleta de ' + boleta.nombreMes + ' ' + boleta.periodo + ' - ' + boleta.descripcionTipo;
      vm.activateFrame = true;
      var token = localStorage.getItem('token');
      this.path = "https://api-selfservice.datacont.com" + '/boleta/empleado/pdf?token=' + token + '&empresa=' + "datacont" + '&codigo=' + boleta.codigo + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo;
      // this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      // Scroll top
      // document.body.scrollTop = 0; // For Safari
      // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    cerrarFrame: function cerrarFrame() {
      this.path = '';
      this.activateFrame = false;
    },
    notificar: function notificar(o) {
      var vm = this;

      var obj = {
        periodo: o.periodo,
        mes: o.mes,
        tipo: o.tipo,
        codigo: o.codigo
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/boleta/empleado/notificar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se le notifico al empleado');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    openModalNotificacionMasiva: function openModalNotificacionMasiva() {
      this.mostrarNotificacionMasiva = true;
    },
    closeModalNotificacionMasiva: function closeModalNotificacionMasiva() {
      this.mostrarNotificacionMasiva = false;
    },
    notificacionMasiva: function notificacionMasiva() {
      var vm = this;
      vm.isLoading = true;
      vm.observaciones = [];

      var filtros = {
        periodo: vm.filtroPeriodo,
        mes: vm.filtroMes,
        tipo: vm.filtroTipo,
        codigoEmpleado: vm.filtroCodigoEmpleado,
        visto: vm.filtroVisto
      };

      if (filtros.visto !== 'all') {
        filtros.visto = +filtros.visto;
      }

      var obj = {
        filtros: filtros
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/boleta/notificar/filtrados', obj, function (data) {
        vm.closeModalNotificacionMasiva();
        if (data.observaciones.length > 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se notifico correctamente pero hay algunas observaciones.');
          vm.observaciones = data.observaciones;
          vm.mostrarObservaciones = true;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se notifico correctamente a todos.');
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    closeModalObservaciones: function closeModalObservaciones() {
      var vm = this;
      vm.observaciones = [];
      vm.mostrarObservaciones = false;
    },
    confirmacionEliminar: function confirmacionEliminar(o) {
      var _this = this;

      var vm = this;
      vm.boletaEliminar = {
        periodo: o.periodo,
        mes: o.mes,
        tipo: o.tipo,
        codigo: o.codigo
      };
      vm.mostrarModalEliminar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_scroll__["a" /* scrollTo */])({
          ref: _this.$refs.confirmarEliminar.$el,
          vm: _this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    eliminarBoleta: function eliminarBoleta() {
      var vm = this;

      if (!vm.isProcessing) {
        vm.isProcessing = true;
        var obj = {
          periodo: vm.boletaEliminar.periodo,
          mes: vm.boletaEliminar.mes,
          tipo: vm.boletaEliminar.tipo,
          codigo: vm.boletaEliminar.codigo
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, '/boleta/eliminar', obj, function (data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se elimino boleta exitosamente');
          vm.isProcessing = false;
          vm.boletaEliminar = {};
          vm.fetch();
          vm.mostrarModalEliminar = false;
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          vm.isProcessing = false;
        });
      }
    },
    closeModalEliminar: function closeModalEliminar() {
      var vm = this;
      vm.boletaEliminar = [];
      vm.mostrarModalEliminar = false;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      perfilUsuario: localStorage.getItem('perfilVacaciones'),
      empresa: "datacont"
    };
  },

  computed: {
    showSidebarMobile: function showSidebarMobile() {
      return this.$store.getters.showSidebarMobile;
    }
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      this.$store.dispatch('setSidebarMobile', !this.showSidebarMobile);
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lookups_Area__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lookups_Area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lookups_Area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__c_modal_trabajadores_area_vue__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__c_modal_trabajadores_area_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__c_modal_trabajadores_area_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cambio_dias_vacaciones_component',
  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado___default.a,
    'lookup-area': __WEBPACK_IMPORTED_MODULE_2__lookups_Area___default.a,
    'modal-trabajadores-area': __WEBPACK_IMPORTED_MODULE_3__c_modal_trabajadores_area_vue___default.a
  },
  data: function data() {
    return {
      empresa: "datacont",
      signo: '-',
      dias: 1,
      mostrarBusquedaEmpleado: false,
      codigoEmpleado: '',
      motivo: '',
      empleado: {},
      isSaving: false,
      motivosEjemplo: ['Vacaciones no aprobadas oportunamente del xx/xx/xxxx al xx/xx/xxxx', 'Retorno de días que quedaron del sistema anterior', 'Se tomó días a cuenta de vacaciones del xx/xx/xxxx al xx/xx/xxxx por enfermedad'],
      opcionCambiarDias: 'individual',
      isLoading: false,
      idArea: '',
      nombreArea: '',
      nombreGerencia: '',
      mostrarBusquedaArea: false,
      mostrarModalTrabajadores: false,
      trabajadoresArea: [],
      trabajadoresSeleccionados: [],
      isLoadingTrabajadores: false,
      fechaInicioQuitaDia: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),
      fechaFinQuitaDia: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(1, 'day').format('YYYY-MM-DD')
    };
  },

  computed: {
    cantidadTrabajadoresSeleccionados: function cantidadTrabajadoresSeleccionados() {
      return this.trabajadoresSeleccionados.length;
    },
    puedeCambiarDias: function puedeCambiarDias() {
      if (!this.dias || Number(this.dias) <= 0) {
        return false;
      }

      if (!this.motivo || !this.motivo.trim()) {
        return false;
      }

      if (this.opcionCambiarDias === 'individual') {
        return this.empleado && this.empleado.codigo;
      }

      if (this.opcionCambiarDias === 'area') {
        return this.idArea && this.trabajadoresSeleccionados.length > 0;
      }

      return this.opcionCambiarDias === 'todo';
    }
  },
  methods: {
    handlerModalidad: function handlerModalidad() {
      var vm = this;
      if (vm.opcionCambiarDias === 'individual') {
        vm.mostrarBusquedaArea = false;
        vm.mostrarBusquedaEmpleado = true;
      } else if (vm.opcionCambiarDias === 'area') {
        vm.empleado = {};
        vm.codigoEmpleado = '';
        vm.mostrarBusquedaArea = true;
        vm.mostrarBusquedaEmpleado = false;
        vm.borrarArea();
      } else if (vm.opcionCambiarDias === 'todo') {
        vm.mostrarBusquedaArea = false;
        vm.mostrarBusquedaEmpleado = false;
        vm.empleado = {};
        vm.codigoEmpleado = '';
      }
    },
    seleccionarArea: function seleccionarArea(area) {
      this.idArea = area.codigo || area.idArea;
      this.nombreArea = area.nombre || area.nombreArea;
      this.nombreGerencia = area.nombreGerencia || area.gerencia || '';

      this.mostrarBusquedaArea = false;

      // Limpiamos la selección anterior.
      this.trabajadoresSeleccionados = [];
      this.trabajadoresArea = [];

      this.cargarTrabajadoresArea();

      this.mostrarModalTrabajadores = true;
    },
    cargarTrabajadoresArea: function cargarTrabajadoresArea() {
      var vm = this;
      vm.isLoadingTrabajadores = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/area/' + vm.idArea, obj, function (data) {
        vm.trabajadoresArea = data.data || [];
      }, function (error) {
        vm.trabajadoresArea = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingTrabajadores = false;
      });
    },
    aceptarTrabajadores: function aceptarTrabajadores(trabajadores) {
      this.trabajadoresSeleccionados = trabajadores;
      this.mostrarModalTrabajadores = false;
    },
    abrirModalTrabajadores: function abrirModalTrabajadores() {
      if (!this.idArea) {
        return;
      }

      this.mostrarModalTrabajadores = true;
    },
    borrarArea: function borrarArea() {
      this.idArea = '';
      this.nombreArea = '';
      this.nombreGerencia = '';
      this.trabajadoresArea = [];
      this.trabajadoresSeleccionados = [];
      this.mostrarModalTrabajadores = false;
    },
    cambiarSigno: function cambiarSigno(signo) {
      this.signo = signo;
    },
    cambiar: function cambiar() {
      var vm = this;
      vm.isSaving = true;

      var obj = {
        codigoEmpleado: vm.codigoEmpleado,
        idArea: vm.idArea,
        todaLaEmpresa: vm.opcionCambiarDias === 'todo',
        dias: +vm.dias,
        signo: vm.signo,
        motivo: vm.motivo,
        fechaInicio: vm.fechaInicioQuitaDia ? vm.fechaInicioQuitaDia : null,
        fechaFin: vm.fechaFinQuitaDia ? vm.fechaFinQuitaDia : null
      };

      if (vm.signo === '-') {
        var desde = __WEBPACK_IMPORTED_MODULE_4_moment___default()(vm.fechaInicioQuitaDia, 'YYYY-MM-DD');
        var hasta = __WEBPACK_IMPORTED_MODULE_4_moment___default()(vm.fechaFinQuitaDia, 'YYYY-MM-DD');

        if (!vm.fechaInicioQuitaDia) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'Debe ingresar fecha desde');
          vm.isSaving = false;
          return;
        }
        if (!vm.fechaFinQuitaDia) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'Debe ingresar fecha hasta');
          vm.isSaving = false;
          return;
        }
        if (desde.isAfter(hasta)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'La Fecha inicial no puede ser mayor a la fecha final');
          vm.isSaving = false;
          return;
        }

        obj.dias = hasta.diff(desde, 'days') + 1;
      }

      if (vm.opcionCambiarDias === 'individual' && !obj.codigoEmpleado) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'Debe ingresar el empleado');
        vm.isSaving = false;
        return;
      }
      if (vm.opcionCambiarDias === 'area' && !obj.idArea) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'Debe ingresar una área');
        vm.isSaving = false;
        return;
      }

      if (obj.dias <= 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'Debe ingresar un número de días en positivo');
        vm.isSaving = false;
        return;
      }

      if (!obj.motivo) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'Debe ingresar un motivo');
        vm.isSaving = false;
        return;
      }

      // if (!vm.puedeCambiarDias) {
      //   notify(vm, 'error', 'Validación', 'Complete los datos requeridos antes de continuar')
      //   vm.isSaving = false
      //   return
      // }

      if (vm.opcionCambiarDias === 'area' && vm.trabajadoresSeleccionados.length === 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'Debe seleccionar al menos un trabajador');
        vm.isSaving = false;
        return;
      }

      if (this.opcionCambiarDias === 'individual') {
        obj.codigoEmpleado = [this.empleado.codigo];
      }

      if (this.opcionCambiarDias === 'area') {
        obj.idArea = this.idArea;

        obj.codigoEmpleado = this.trabajadoresSeleccionados.map(function (trabajador) {
          return trabajador.codigo;
        });
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/vacaciones/empleado/cambiodias', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Cambiado correctamente');
        vm.clear();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.codigoEmpleado = o.codigo;
      this.empleado = {};
      this.asignarEmpleadoExcepcion();
    },
    asignarEmpleadoExcepcion: function asignarEmpleadoExcepcion() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/uno/' + this.codigoEmpleado, obj, function (data) {
        vm.empleado = data.data;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    clear: function clear() {
      this.codigoEmpleado = '';
      this.idArea = '';
      this.opcionCambiarDias = 'individual';
      this.signo = '-';
      this.dias = 1;
      this.motivo = '';
      this.fechaInicioQuitaDia = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD');
      this.fechaFinQuitaDia = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(1, 'day').format('YYYY-MM-DD');
      this.empleado = {};
    },
    calculoDias: function calculoDias() {
      var vm = this;
      var desde = __WEBPACK_IMPORTED_MODULE_4_moment___default()(vm.fechaInicioQuitaDia, 'YYYY-MM-DD');
      var hasta = __WEBPACK_IMPORTED_MODULE_4_moment___default()(vm.fechaFinQuitaDia, 'YYYY-MM-DD');

      if (desde.isAfter(hasta)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Validación', 'La Fecha inicial no puede ser mayor a la fecha final');
        return;
      }

      vm.dias = hasta.diff(desde, 'days') + 1;
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['message']
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmar_accion_overlay',
  data: function data() {
    return {
      loading: false
    };
  },
  created: function created() {},

  methods: {
    emitDo: function emitDo() {
      var vm = this;
      if (vm.loading) return;
      vm.loading = true;
      vm.$emit('do');
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmar_accion_overlay',
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Pedir_Una_Renovacion__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Pedir_Una_Renovacion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Pedir_Una_Renovacion__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_equipo_contratos_component',
  data: function data() {
    return {
      equipo: [],
      mostrarRenovacion: true,
      isLoading: false,
      codigoLogueadoJefe: localStorage.getItem('codigo') + '',
      isShowingJefeDirecto: true
    };
  },

  components: {
    'pedir-una-renovacion': __WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Pedir_Una_Renovacion___default.a
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/contratos/empleado/equipo/cascada', obj, function (data) {
        vm.equipo = data.lista;
        var contador = 0;
        // validacion para verificar si el codigo del jefe logueado es igual al codigo del jefe del array entero
        vm.equipo.forEach(function (element, index) {
          if (vm.codigoLogueadoJefe === element.codigoJefe + '') {
            contador += 1;
          }
        });
        if (contador === vm.equipo.length) {
          vm.isShowingJefeDirecto = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    refreshRenovar: function refreshRenovar() {
      var vm = this;
      vm.mostrarRenovacion = false;
      setTimeout(function () {
        vm.mostrarRenovacion = true;
      }, 300);
      vm.fetch();
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_aprobadas_component',
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default.a
  },
  data: function data() {
    return {
      fechaFinContrato: '',
      lista: [],
      isLoading: true,
      mostrarConfirmacionGestionar: false,
      solicitud: {
        id: 0
      }
    };
  },
  created: function created() {
    this.fetch();
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    confirmacionYaSeGestiono: function confirmacionYaSeGestiono(item) {
      var vm = this;
      vm.mostrarConfirmacionGestionar = true;
      vm.solicitud.id = item.id;
    },
    gestionarRenovacion: function gestionarRenovacion() {
      var vm = this;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.solicitud);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/contratos/lo-tomo', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.fetch();
        vm.mostrarConfirmacionGestionar = false;
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        fechaFinContrato: vm.fechaFinContrato
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/contratos/solicitud/aprobadas', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close');
        }

        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_por_aprobar_component',
  data: function data() {
    return {
      lista: [],
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionRechazar: false,
      solicitudSeleccionada: {},
      isLoading: false
    };
  },

  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/contratos/solicitud/poraprobar', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close');
        }

        vm.lista = data.lista;
        // esto replica la lista 3 veces
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 100})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 200})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 300})));
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    enterEditMode: function enterEditMode(o) {
      this.solicitudSeleccionada = o;
      this.isEditing = true;
    },
    confirmarAprobar: function confirmarAprobar(o) {
      var _this = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionAprobar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this.$refs.confirmarAprobar.$el,
          vm: _this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazo: function confirmarRechazo(o) {
      var _this2 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionRechazar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this2.$refs.confirmarRechazar.$el,
          vm: _this2,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    aprobar: function aprobar() {
      var vm = this;
      var obj = {
        id: vm.solicitudSeleccionada.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/contratos/solicitud/renovacion/aprobar', obj, function (data) {
        vm.mostrarConfirmacionAprobar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    rechazar: function rechazar() {
      var vm = this;

      var obj = {
        id: this.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, '/contratos/solicitud/renovacion', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    seleccionarEmpleadoParaReemplazo: function seleccionarEmpleadoParaReemplazo(o, empleado) {
      // Primero guardamos esto
      var vm = this;
      var obj = {
        id: o.id,
        codigoEmpleadoReemplazante: empleado.codigo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/vacaciones/solicitud/reemplazo', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se asigno el empleado de reemplazo correctamente');
        o.codigoEmpleadoReemplazante = empleado.codigo;
        o.nombreEmpleadoReemplazante = empleado.nombre;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pedir_una_renovacion_component',
  data: function data() {
    return {
      mesesARenovar: '3',
      indeterminado: 0,
      disableMeses: false,
      isSaving: false
    };
  },

  props: ['codigo', 'nombre', 'idSolicitud', 'descripcionEstado'],
  watch: {
    indeterminado: function indeterminado(value) {
      if (value) {
        this.mesesARenovar = '';
        this.disableMeses = true;
      } else {
        this.mesesARenovar = '3';
        this.disableMeses = false;
      }
    }
  },
  created: function created() {},

  methods: {
    pedirRenovacion: function pedirRenovacion(noRenovar) {
      var vm = this;

      if (noRenovar) {
        vm.indeterminado = 0;
        vm.mesesARenovar = 0;
      } else {
        if (!vm.indeterminado && vm.mesesARenovar < 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Ingrese un número de meses correcto para renovar');
          return;
        }
      }

      vm.isSaving = true;
      var obj = {
        codigo: vm.codigo,
        mesesARenovar: vm.mesesARenovar,
        indeterminado: vm.indeterminado,
        noRenovar: noRenovar
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/contratos/solicitud/renovacion', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_empleado_por_areas__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_empleado_por_areas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_empleado_por_areas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_solicitudes_v_pendiente_aprobar_jefe__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_solicitudes_v_pendiente_aprobar_jefe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_solicitudes_v_pendiente_aprobar_jefe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_top_empleados_mas_dias_disponibles__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_top_empleados_mas_dias_disponibles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_top_empleados_mas_dias_disponibles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cantidad_contratos_sin_firmar__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cantidad_contratos_sin_firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cantidad_contratos_sin_firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cantidad_documentos_sin_firmar__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cantidad_documentos_sin_firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cantidad_documentos_sin_firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kpis_c_kpi_cantidad_permisos_sin_aprobar_rrhh__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kpis_c_kpi_cantidad_permisos_sin_aprobar_rrhh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__kpis_c_kpi_cantidad_permisos_sin_aprobar_rrhh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kpis_c_kpi_cantidad_boletas_sin_visualizar__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kpis_c_kpi_cantidad_boletas_sin_visualizar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__kpis_c_kpi_cantidad_boletas_sin_visualizar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  components: {
    'empleados-por-areas': __WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_empleado_por_areas___default.a,
    'cantidad-solicitudes-v-pendiente-aprobar-jefe': __WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_solicitudes_v_pendiente_aprobar_jefe___default.a,
    'top-empleados-mas-dias-disponibles': __WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_top_empleados_mas_dias_disponibles___default.a,
    'cantidad-boletas-sin-visualizar': __WEBPACK_IMPORTED_MODULE_6__kpis_c_kpi_cantidad_boletas_sin_visualizar___default.a,
    'cantidad-permisos-sin-aprobar-rrhh': __WEBPACK_IMPORTED_MODULE_5__kpis_c_kpi_cantidad_permisos_sin_aprobar_rrhh___default.a,
    'cantidad-documentos-sin-firmar': __WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cantidad_documentos_sin_firmar___default.a,
    'cantidad-contratos-sin-firmar': __WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cantidad_contratos_sin_firmar___default.a
  },
  data: function data() {
    return {
      perfilVacaciones: localStorage.getItem('perfilVacaciones'),
      isHorizontal: false,
      showCantidadBoletasSinVisualizar: true,
      showCantidadPermisosSinAprobarRRHH: true,
      showCantidadDocumentosSinFirmar: true,
      showCantidadContratosSinFirmar: true
    };
  },

  computed: {
    closeComponentUsuario: function closeComponentUsuario() {
      return !this.showCantidadMisDocumentosSinFirmar && !this.showCantidadMisContratosSinFirmar && !this.showCantidadMisBoletasSinVisualizar;
    }
  },
  methods: {
    redirigir: function redirigir(to, isQuery) {
      var objPush = { path: '/' + to };
      if (isQuery) {
        var queryParamsValues = {
          'reporte-contratos': { firmado: 0 },
          'reporte-documentos-firmar': { estado: 1 },
          'boletas-reporte': { visto: 0, anio: 'all', mes: 'all', tipo: 'all' }
        };
        objPush.query = queryParamsValues[to];
      }
      this.$router.push(objPush);
    },
    handleResize: function handleResize() {
      if (window.innerWidth <= 820) {
        this.$store.dispatch('setSidebarDesktop', true);
        localStorage.setItem('sidebar-show', true);
      } else if (window.innerWidth < 1140) {
        this.$store.dispatch('setSidebarDesktop', false);
        localStorage.setItem('sidebar-show', false);
      }
    },
    close: function close(componente) {
      this[componente] = false;
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kpis_dashboard_c_dashboard_header_vue__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kpis_dashboard_c_dashboard_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kpis_dashboard_c_dashboard_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kpis_dashboard_c_pendiente_jefe_vue__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kpis_dashboard_c_pendiente_jefe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__kpis_dashboard_c_pendiente_jefe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kpis_dashboard_c_mis_pendientes_vue__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kpis_dashboard_c_mis_pendientes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__kpis_dashboard_c_mis_pendientes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kpis_dashboard_c_nuevos_empleados_vue__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kpis_dashboard_c_nuevos_empleados_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__kpis_dashboard_c_nuevos_empleados_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kpis_dashboard_c_cumpleanios_hoy_vue__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kpis_dashboard_c_cumpleanios_hoy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__kpis_dashboard_c_cumpleanios_hoy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kpis_dashboard_c_mis_cursos_vue__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kpis_dashboard_c_mis_cursos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__kpis_dashboard_c_mis_cursos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kpis_dashboard_c_noticias_vue__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kpis_dashboard_c_noticias_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__kpis_dashboard_c_noticias_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  components: {
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_0__kpis_dashboard_c_dashboard_header_vue___default.a,
    PendientesJefe: __WEBPACK_IMPORTED_MODULE_1__kpis_dashboard_c_pendiente_jefe_vue___default.a,
    MisPendientes: __WEBPACK_IMPORTED_MODULE_2__kpis_dashboard_c_mis_pendientes_vue___default.a,
    NuevosEmpleados: __WEBPACK_IMPORTED_MODULE_3__kpis_dashboard_c_nuevos_empleados_vue___default.a,
    CumpleaniosHoy: __WEBPACK_IMPORTED_MODULE_4__kpis_dashboard_c_cumpleanios_hoy_vue___default.a,
    MisCursos: __WEBPACK_IMPORTED_MODULE_5__kpis_dashboard_c_mis_cursos_vue___default.a,
    Noticias: __WEBPACK_IMPORTED_MODULE_6__kpis_dashboard_c_noticias_vue___default.a
  },
  data: function data() {
    return {
      perfilVacaciones: localStorage.getItem('perfilVacaciones'),
      nombreUsuario: localStorage.getItem('nombre')
    };
  },

  computed: {
    totalPendientesJefe: function totalPendientesJefe() {
      return this.pendientesJefe.reduce(function (total, item) {
        return total + item.cantidad;
      }, 0);
    }
  },
  methods: {
    abrirPendiente: function abrirPendiente(item) {
      if (item.ruta) {
        this.$router.push(item.ruta);
      }
    },
    verEmpleado: function verEmpleado(empleado) {
      this.$router.push('/empleados/' + empleado.id);
    },
    continuarCurso: function continuarCurso(curso) {
      this.$router.push('/cursos/' + curso.id);
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_cantidad_mis_documentos_sin_firmar__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_cantidad_mis_documentos_sin_firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_cantidad_mis_documentos_sin_firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_cantidad_mis_contratos_sin_firmar__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_cantidad_mis_contratos_sin_firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_cantidad_mis_contratos_sin_firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_cantidad_mis_boletas_sin_visualizar__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_cantidad_mis_boletas_sin_visualizar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_cantidad_mis_boletas_sin_visualizar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cumpleanos__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cumpleanos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cumpleanos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cursos__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cursos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cursos__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard_usuario',
  components: {
    'cantidad-mis-documentos-sin-firmar': __WEBPACK_IMPORTED_MODULE_0__kpis_c_kpi_cantidad_mis_documentos_sin_firmar___default.a,
    'cantidad-mis-contratos-sin-firmar': __WEBPACK_IMPORTED_MODULE_1__kpis_c_kpi_cantidad_mis_contratos_sin_firmar___default.a,
    'cantidad-mis-boletas-sin-visualizar': __WEBPACK_IMPORTED_MODULE_2__kpis_c_kpi_cantidad_mis_boletas_sin_visualizar___default.a,
    'kpi-cumpleanos': __WEBPACK_IMPORTED_MODULE_3__kpis_c_kpi_cumpleanos___default.a,
    'kpi-cursos': __WEBPACK_IMPORTED_MODULE_4__kpis_c_kpi_cursos___default.a
  },
  data: function data() {
    return {
      isHorizontal: false,
      showCantidadMisDocumentosSinFirmar: true,
      showCantidadMisContratosSinFirmar: true,
      showCantidadMisBoletasSinVisualizar: true
    };
  },

  computed: {
    closeComponentUsuario: function closeComponentUsuario() {
      return !this.showCantidadMisDocumentosSinFirmar && !this.showCantidadMisContratosSinFirmar && !this.showCantidadMisBoletasSinVisualizar;
    }
  },
  methods: {
    redirigir: function redirigir(to, isQuery) {
      var objPush = { path: '/' + to };
      if (isQuery) {
        var queryParamsValues = {
          'reporte-contratos': { firmado: 0 },
          'reporte-documentos-firmar': { estado: 1 },
          'boletas-reporte': { visto: 0, anio: 'all', mes: 'all', tipo: 'all' }
        };
        objPush.query = queryParamsValues[to];
      }
      this.$router.push(objPush);
    },
    handleResize: function handleResize() {
      if (window.innerWidth <= 820) {
        this.$store.dispatch('setSidebarDesktop', true);
        localStorage.setItem('sidebar-show', true);
      } else if (window.innerWidth < 1140) {
        this.$store.dispatch('setSidebarDesktop', false);
        localStorage.setItem('sidebar-show', false);
      }
    },
    close: function close(componente) {
      this[componente] = false;
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datos_conjuntos',
  props: {
    title: String,
    model: String,
    capitalize: Boolean,
    dangerMessage: String
  },
  computed: {
    formattedValue: function formattedValue() {
      return this.capitalize ? this.model.toUpperCase() : this.model;
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Datos_Conjuntos__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Datos_Conjuntos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Datos_Conjuntos__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datos_personales_consulta_component',
  components: {
    'datos-conjuntos': __WEBPACK_IMPORTED_MODULE_1__Component_Datos_Conjuntos___default.a
  },
  data: function data() {
    return {
      empleado: {},
      empleadoPersonal: {},
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/personal/empleado', obj, function (data) {
        data.empleado.codigo = data.empleado.codigo.toString();
        data.empleado.dni = data.empleado.dni.toString();
        vm.empleado = data.empleado;
        vm.empleadoPersonal = data.empleadoPersonal;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datos_personales_editable_component',
  data: function data() {
    return {
      empleado: {
        genero: '',
        estaCasado: false,
        tieneHijos: false
      },
      hijos: [{
        nombre: '',
        dni: '',
        fechaNacimiento: '',
        genero: ''
      }],
      isSaving: false,
      isLoading: false
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/personal/empleado', obj, function (data) {
        vm.hijos = data.hijos;
        if (vm.hijos.length > 0) {
          data.empleadoPersonal.tieneHijos = true;
        } else {
          data.empleadoPersonal.tieneHijos = false;
          vm.hijos = [{
            nombre: '',
            dni: '',
            fechaNacimiento: '',
            genero: ''
          }];
        }

        if (data.empleadoPersonal && data.empleadoPersonal.codigo) {
          if (data.empleadoPersonal.dniConyugue) {
            data.empleadoPersonal.estaCasado = true;
          } else {
            data.empleadoPersonal.estaCasado = false;
          }
          vm.empleado = data.empleadoPersonal;
        } else {
          vm.empleado = {
            genero: '',
            estaCasado: false,
            tieneHijos: false
          };
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    agregarHijoVacio: function agregarHijoVacio() {
      this.hijos.push({
        nombre: '',
        dni: '',
        fechaNacimiento: '',
        genero: ''
      });
    },
    quitarHijo: function quitarHijo(index) {
      this.hijos.splice(index, 1);
    },
    guardar: function guardar() {
      var vm = this;
      vm.isSaving = true;

      // Algunas validaciones
      if (!vm.empleado.estaCasado) {
        vm.empleado.nombreConyugue = null;
        vm.empleado.dniConyugue = null;
        vm.empleado.fechaNacimientoConyugue = null;
      } else {
        if (!vm.empleado.nombreConyugue) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Ingrese el nombre de su conyugue');
          vm.isSaving = false;
          return;
        }
        if (!vm.empleado.dniConyugue) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Ingrese el dni de su conyugue');
          vm.isSaving = false;
          return;
        }
        if (!vm.empleado.fechaNacimientoConyugue) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Ingrese la fecha de nacimiento de su conyugue');
          vm.isSaving = false;
          return;
        }
      }

      if (!vm.empleado.tieneHijos) {
        vm.hijos = [];
        vm.agregarHijoVacio();
      }

      var obj = {
        empleado: vm.empleado,
        hijos: vm.hijos
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/personal/empleado', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datos_personales_foto_perfil_component',
  components: {
    'upload-image': __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default.a
  },
  data: function data() {
    return {
      empleado: {},
      empleadoPersonal: {},
      isLoading: true,
      mostrarModalAdjuntar: false,
      codigoEmpleado: +localStorage.getItem('codigo'),
      mostrarConfirmacionEliminar: false
    };
  },
  created: function created() {
    this.fetch();
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        codigo: vm.codigoEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/personal/fotoPerfil', obj, function (data) {
        vm.pathFoto = data.foto;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardarFotoPerfil: function guardarFotoPerfil() {
      var vm = this;
      var obj = {
        codigo: vm.codigoEmpleado,
        pathFoto: vm.pathFoto
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/personal/fotoPerfil', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        window.location.reload();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      vm.closeModalAdjuntar();
      if (fileSubido) vm.pathFoto = fileSubido.file.ruta;else vm.pathFoto = '';
      vm.guardarFotoPerfil();
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    eliminarFotoPerfil: function eliminarFotoPerfil() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        codigo: vm.codigoEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["g" /* apiDelete */])(vm, '/personal/fotoPerfil', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        window.location.reload();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datos_personales_seguridad_component',
  data: function data() {
    return {
      newPassword: '',
      repeatNewPassword: '',
      email: '',
      password: '',
      isMobile: false,
      isSaving: false,
      isLoading: false
    };
  },
  created: function created() {
    this.fetch();
    window.addEventListener('resize', this.updateIsMobile);
  },
  mounted: function mounted() {
    this.updateIsMobile();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },

  methods: {
    updateIsMobile: function updateIsMobile() {
      this.isMobile = window.innerWidth <= 650;
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/personal/empleado/seguridad', obj, function (data) {
        vm.newPassword = '';
        vm.repeatNewPassword = '';
        vm.email = data.data.email;
        vm.password = '';
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardar: function guardar() {
      var vm = this;
      vm.isSaving = true;

      // Algunas validaciones
      if (!vm.password) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Debe ingresar su contraseña actual para hacer cambios en estos datos');
        vm.isSaving = false;
        return;
      }

      if (!vm.email) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Ingrese el email');
        vm.isSaving = false;
        return;
      }

      if (!vm.validateEmail(vm.email)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Ingrese el email correcto');
        vm.isSaving = false;
        return;
      }

      var obj = {
        empleado: {
          newPassword: vm.newPassword,
          repeatNewPassword: vm.repeatNewPassword,
          email: vm.email,
          password: vm.password
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/personal/empleado/seguridad', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-delegaciones-informe-rrhh',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      tipoIcon: {
        'guardar': 'fa fa-save',
        'enviar': 'fa fa-check',
        'aprobar': 'fa fa-check',
        'rechazar': 'fa fa-times',
        'desactivar': 'fa fa-times',
        'no lo tomo': 'fa fa-times',
        'notificar': 'fa fa-envelope',
        'editar': 'fa fa-edit',
        'adjuntar': 'fa fa-paperclip',
        'ver': 'fa fa-eye'
      }
    };
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },
  mounted: function mounted() {
    this.fetchInforme(this.id);
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    fetchInforme: function fetchInforme(idDelegacion) {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        idDelegacion: idDelegacion
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/delegaciones/informe', obj, function (data) {
        data.informe.forEach(function (o) {
          o.datos = JSON.parse(o.datos);
        });
        vm.lista = data.informe;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        if (vm.lista.length === 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'warning', 'Información', 'No se encontraron datos');
          vm.closeModalInforme();
        }
      });
    },
    closeModalInforme: function closeModalInforme() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Seleccionar_Documentos_Firmar__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Seleccionar_Documentos_Firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Component_Seleccionar_Documentos_Firmar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Component_Lookup_Cargo__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Component_Lookup_Cargo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Component_Lookup_Cargo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lookups_Area__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lookups_Area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__lookups_Area__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'component-empleado-editar',
  props: {
    codigoEmpleado: {
      type: Number,
      default: 0
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      empresa: "datacont",
      mostrarModalSeleccionarDocumentosFirmar: false,
      mostrarModalListaLibrosVacaciones: false,
      codigoEmpleadoInterno: this.codigoEmpleado,
      isLoading: false,
      mostrarBusquedaJefe: false,
      mostrarBusquedaCargo: false,
      mostrarObservaciones: false,
      mostrarBusquedaArea: false,
      observaciones: [],
      nombreArea: '',
      nombreGerencia: '',
      empleado: {
        codigo: 0,
        password: '',
        usuario: '',
        perfilVacaciones: '',
        nombre: '',
        fechaNacimiento: '',
        idArea: '',
        cargo: '',
        email: '',
        codigoJefe: '',
        fechaIngreso: '',
        dni: '',
        contratoIndeterminado: 0,
        fechaFinContrato: '',
        tipoPension: '',
        afpCodigo: '',
        afpNombre: '',
        sueldoCuenta: '',
        sueldoCodigoBanco: '',
        sueldoNombreBanco: '',
        sueldoMoneda: 'soles',
        ctsCuenta: '',
        ctsCodigoBanco: '',
        ctsNombreBanco: '',
        ctsMoneda: 'soles'
      },
      fotoPerfil: null,
      fotoPreview: null
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    showSidebarMobile: function showSidebarMobile() {
      return this.$store.getters.showSidebarMobile;
    }
  },
  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_5__components_Component_Lookup_Small_Empleado___default.a,
    'lookup-cargo': __WEBPACK_IMPORTED_MODULE_6__Component_Lookup_Cargo___default.a,
    'lookup-area': __WEBPACK_IMPORTED_MODULE_7__lookups_Area___default.a,
    SeleccionarDocumentosFirmar: __WEBPACK_IMPORTED_MODULE_3__Component_Seleccionar_Documentos_Firmar___default.a,
    'component-lista-libros-vacaciones': __WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones___default.a
  },
  created: function created() {
    var vm = this;
    if (vm.codigoEmpleadoInterno > 0) {
      vm.fetch();
    }
  },

  methods: {
    closeModalListaLibrosVacaciones: function closeModalListaLibrosVacaciones() {
      this.mostrarModalListaLibrosVacaciones = false;
    },
    verLibroDeVacaciones: function verLibroDeVacaciones() {
      var vm = this;
      vm.mostrarModalListaLibrosVacaciones = true;
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        codigo: vm.codigoEmpleadoInterno
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/empleado/obtener/one', obj, function (data) {
        vm.empleado = data.empleado;
        vm.empleado.fechaIngreso = data.empleado.fechaIngresoString;
        vm.empleado.fechaFinContrato = data.empleado.fechaFinContratoString;
        vm.empleado.fechaNacimiento = data.empleado.fechaNacimientoString;
        vm.codigoEmpleadoInterno = data.empleado.codigo;
        vm.fotoPreview = data.empleado.pathFoto;
        if (vm.empresa !== 'raymisa') {
          vm.nombreArea = data.empleado.nombreArea;
          vm.nombreGerencia = data.empleado.nombreGerencia;
        } else {
          vm.empleado.idArea = '';
        }
        if (!data.empleado.regimen || data.empleado.regimen === null) {
          vm.empleado.regimen = 'general';
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardarEmpleado: function guardarEmpleado() {
      var openAsignarDoc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;
      vm.observaciones = [];
      if (vm.isLoading) return;

      vm.isLoading = true;
      if (vm.empleado.contratoIndeterminado === 0) {
        if (vm.empleado.fechaFinContrato !== '') {
          vm.empleado.fechaFinContrato = __WEBPACK_IMPORTED_MODULE_2_moment___default()(vm.empleado.fechaFinContrato, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
      }

      if (vm.empleado.fechaIngreso !== '') {
        vm.empleado.fechaIngreso = __WEBPACK_IMPORTED_MODULE_2_moment___default()(vm.empleado.fechaIngreso, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }

      var obj = {
        empleado: vm.empleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/empleado/', obj, function (data) {
        vm.codigoEmpleadoInterno = data.codigo;
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
          vm.fetch();
        }, 2000);
        if (openAsignarDoc === true) {
          vm.openModalSeleccionarDocumentosFirmar();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.isLoading = false;
        if (vm.empleado.contratoIndeterminado === 0) {
          if (vm.empleado.fechaFinContrato !== '') {
            vm.empleado.fechaFinContrato = __WEBPACK_IMPORTED_MODULE_2_moment___default()(vm.empleado.fechaFinContrato, 'DD/MM/YYYY').format('YYYY-MM-DD');
          }
        }
        if (vm.empleado.fechaIngreso !== '') {
          vm.empleado.fechaIngreso = __WEBPACK_IMPORTED_MODULE_2_moment___default()(vm.empleado.fechaIngreso, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        if (error.observaciones.length > 0) {
          vm.mostrarObservaciones = true;
          vm.observaciones = error.observaciones;
        }
      }, function () {});
    },
    seleccionarJefe: function seleccionarJefe(o) {
      var vm = this;
      vm.empleado.codigoJefe = o.codigo;
    },
    seleccionarCargo: function seleccionarCargo(o) {
      var vm = this;
      vm.empleado.cargo = o.cargo;
    },
    seleccionarArea: function seleccionarArea(o) {
      var vm = this;
      vm.empleado.idArea = o.idArea;
      vm.empleado.nombreArea = o.nombreArea;
      vm.empleado.nombreGerencia = o.nombreGerencia;
      vm.nombreArea = o.nombreArea;
      vm.nombreGerencia = o.nombreGerencia;
    },
    borrarArea: function borrarArea() {
      var vm = this;
      vm.empleado.idArea = '';
      vm.empleado.nombreArea = '';
      vm.empleado.nombreGerencia = '';
      vm.nombreArea = '';
      vm.nombreGerencia = '';
    },
    closeModalObservaciones: function closeModalObservaciones() {
      this.mostrarObservaciones = false;
    },
    closeModalSeleccionarDocumentosFirmar: function closeModalSeleccionarDocumentosFirmar() {
      this.mostrarModalSeleccionarDocumentosFirmar = false;
    },
    openModalSeleccionarDocumentosFirmar: function openModalSeleccionarDocumentosFirmar() {
      var vm = this;
      if (vm.codigoEmpleadoInterno > 0) {
        this.mostrarModalSeleccionarDocumentosFirmar = true;
        return;
      }
      vm.guardarEmpleado(true);
    },
    close: function close() {
      this.$emit('close');
    },
    seleccionarFoto: function seleccionarFoto(event) {
      var vm = this;
      var file = event.target.files[0];

      if (!file) {
        return;
      }

      var tiposPermitidos = ['image/jpeg', 'image/png', 'image/webp'];

      if (!tiposPermitidos.includes(file.type)) {
        this.$toast.error('Solo se permiten imágenes JPG, PNG o WEBP');
        return;
      }

      var maxSize = 5 * 1024 * 1024;

      if (file.size > maxSize) {
        this.$toast.error('La imagen no debe superar los 5 MB');
        return;
      }

      this.fotoPerfil = file;

      if (this.fotoPreview && this.fotoPreview.startsWith('blob:')) {
        URL.revokeObjectURL(this.fotoPreview);
      }
      vm.uploadFile(file, function (err, response) {
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
        } else {
          vm.empleado.foto = response.file.ruta;
          vm.fotoPreview = URL.createObjectURL(file);
        }
      });
    },
    uploadFile: function uploadFile(file, callback) {
      var vm = this;
      var url = '/upload';
      var fd = new FormData();
      fd.append('file', file);
      var params = {
        carpeta: 'fotoPerfil',
        usuario: localStorage.getItem('usuario')
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["f" /* apiUploadWithParams */])(vm, url, fd, params, function (res) {
        callback && callback(null, res);
      }, function (err) {
        callback && callback(err);
      });
    },
    eliminarFoto: function eliminarFoto() {
      var vm = this;
      if (this.fotoPreview && this.fotoPreview.startsWith('blob:')) {
        URL.revokeObjectURL(this.fotoPreview);
      }

      this.fotoPerfil = null;
      this.fotoPreview = null;

      if (this.$refs.inputFoto) {
        this.$refs.inputFoto.value = '';
      }
      if (+vm.codigoEmpleadoInterno > 0) {
        var obj = {
          codigo: vm.codigoEmpleadoInterno
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["g" /* apiDelete */])(vm, '/personal/fotoPerfil', obj, function (data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        });
      }
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contratos-carga-manual',
  props: ['errores'],
  methods: {
    emitClose: function emitClose() {
      this.$emit('close');
    }
  },
  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lookups_Gerencia__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lookups_Gerencia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lookups_Gerencia__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'areas_editar',
  components: {
    Gerencia: __WEBPACK_IMPORTED_MODULE_1__lookups_Gerencia___default.a
  },
  props: ['area'],
  data: function data() {
    return {
      isSaving: false,
      mostrarModalAdjuntar: false,
      mostrarBusquedaGerencia: false,
      id: '',
      nombre: '',
      idGerencia: '',
      nombreGerencia: ''
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.area) {
      vm.id = vm.area.idArea;
      vm.nombre = vm.area.nombreArea;
      vm.idGerencia = vm.area.idGerencia;
      vm.nombreGerencia = vm.area.nombreGerencia;
    }
  },

  methods: {
    guardar: function guardar() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;

      var obj = {
        id: vm.id,
        area: vm.nombre,
        idGerencia: vm.idGerencia
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/area', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    borrarGerencia: function borrarGerencia() {
      var vm = this;
      vm.idGerencia = '';
      vm.nombreGerencia = '';
    },
    seleccionarGerencia: function seleccionarGerencia(o) {
      var vm = this;
      vm.idGerencia = o.id;
      vm.nombreGerencia = o.nombre;
      vm.mostrarBusquedaGerencia = false;
    },
    emitClose: function emitClose() {
      this.$emit('close');
    },
    closeModalAdd: function closeModalAdd() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_gestion_delegaciones_rrhh_guardar__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__c_gestion_delegaciones_rrhh_guardar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__c_gestion_delegaciones_rrhh_guardar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Delegaciones_Informe_vue__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Delegaciones_Informe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Component_Delegaciones_Informe_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-delegaciones-rrhh',
  components: {
    'gestion-delegaciones-rrhh-guardar': __WEBPACK_IMPORTED_MODULE_2__c_gestion_delegaciones_rrhh_guardar___default.a,
    'delegaciones-informe': __WEBPACK_IMPORTED_MODULE_3__Component_Delegaciones_Informe_vue___default.a
  },
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      info: {},
      mostrarModalEditar: false,
      showClosed: false,
      codigoEmpleado: localStorage.getItem('codigo'),
      verInactivas: false,
      disabledScrollExecute: true,
      modalConfirmacionInactivar: false,
      modalInforme: false,
      isScroll: true,
      skip: 0,
      noMore: false,
      objInactivar: {},
      informe: {}
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    abrirModalInactivar: function abrirModalInactivar(o) {
      this.objInactivar = o;
      this.modalConfirmacionInactivar = true;
    },
    abrirModalInforme: function abrirModalInforme(o) {
      this.informe = o;
      this.modalInforme = true;
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    handlerVerInactivas: function handlerVerInactivas() {
      this.verInactivas = !this.verInactivas;
      this.fetch();
    },
    inactivar: function inactivar() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        fechaInicio: vm.objInactivar.fechaInicio,
        fechaFin: vm.objInactivar.fechaFin,
        codigoEmpleadoOrigen: vm.objInactivar.codigoEmpleadoOrigen,
        codigoEmpleadoReemplazante: vm.objInactivar.codigoEmpleadoReemplazante,
        activo: 0,
        id: vm.objInactivar.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/delegaciones', obj, function (data) {
        if (data.estoyReemplazando || data.estoySiendoReemplazado) {
          vm.$store.dispatch('setEstoyReemplazando', false);
          vm.$store.dispatch('setEstoySiendoReemplazado', false);
          vm.$store.dispatch('setNombreReemplazo', '');
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        if (+obj.codigoEmpleadoOrigen === +vm.codigoEmpleado || +obj.codigoEmpleadoReemplazante === +vm.codigoEmpleado) {
          window.location.reload();
        } else {
          vm.isLoading = false;
          vm.modalConfirmacionInactivar = false;
          vm.fetch();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    fetch: function fetch() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      var obj = {};
      if (vm.verInactivas) {
        obj.activo = 0;
      } else {
        obj.activo = 1;
      }
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/delegaciones', obj, function (data) {
        data.lista.forEach(function (o) {
          o.creado = __WEBPACK_IMPORTED_MODULE_1_moment___default()(o.creado).format('DD/MM/YYYY HH:mm');
          vm.lista.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    openModalEditar: function openModalEditar(id) {
      var vm = this;
      if (id) {
        var obj = vm.lista.find(function (o) {
          return o.id === id;
        });
        vm.info = {
          id: obj.id,
          fechaInicio: __WEBPACK_IMPORTED_MODULE_1_moment___default()(obj.fechaInicio).format('YYYY-MM-DD'),
          fechaFin: __WEBPACK_IMPORTED_MODULE_1_moment___default()(obj.fechaFin).format('YYYY-MM-DD'),
          codigoEmpleadoOrigen: obj.codigoEmpleadoOrigen,
          codigoEmpleadoReemplazante: obj.codigoEmpleadoReemplazante,
          activo: obj.activo
        };
      }
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.info = {};
      if (refresh) vm.fetch();
    },
    closeModalInforme: function closeModalInforme() {
      this.modalInforme = false;
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gerencia_editar',
  props: ['gerencia'],
  data: function data() {
    return {
      isSaving: false,
      nombre: '',
      id: ''
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.gerencia) {
      vm.nombre = vm.gerencia.nombre;
      vm.id = vm.gerencia.id;
    }
  },

  methods: {
    guardar: function guardar() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      var obj = {
        id: vm.id,
        gerencia: vm.nombre
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/gerencia', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    closeModalAdd: function closeModalAdd() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_equipo_vacaciones_component',
  data: function data() {
    return {
      equipo: [],
      codigoLogueadoJefe: localStorage.getItem('codigo') + '',
      isLoading: false,
      isShowingJefeDirecto: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/equipo/cascada', obj, function (data) {
        vm.equipo = data.lista;
        var contador = 0;
        // validacion para verificar si el codigo del jefe logueado es igual al codigo del jefe del array entero
        vm.equipo.forEach(function (element, index) {
          if (vm.codigoLogueadoJefe === element.codigoJefe + '') {
            contador += 1;
          }
        });
        if (contador === vm.equipo.length) {
          vm.isShowingJefeDirecto = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_libros_vacaciones_component',
  props: {
    codigoEmpleado: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function data() {
    return {
      libros: [],
      hojas: [],
      periodoSeleccionado: 0,
      loadingHojas: false,
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      if (vm.codigoEmpleado) {
        obj.codigo = vm.codigoEmpleado;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/libro', obj, function (data) {
        vm.libros = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    mostrarHojas: function mostrarHojas(libro) {
      if (libro.periodo !== this.periodoSeleccionado) {
        var vm = this;
        this.periodoSeleccionado = libro.periodo;
        this.hojas = [];
        this.loadingHojas = true;

        var obj = {
          id: libro.id
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/hoja', obj, function (data) {
          vm.hojas = data.lista;
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        }, function () {
          vm.loadingHojas = false;
        });
      }
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_scroll__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_por_aprobar_component',
  data: function data() {
    return {
      solicitudes: [],
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionRechazar: false,
      isLoadingReemplazante: false,
      isLoading: false,
      isApproving: false,
      diasCambioSolicitud: 0,
      trIndex: 0,
      solicitud: {},
      modalEditar: false,
      isSaving: false
    };
  },

  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a,
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado___default.a
  },
  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    diasDisponiblesCambiosSolicitud: function diasDisponiblesCambiosSolicitud() {
      return this.solicitud.diasDisponibles + this.solicitud.dias - this.diasCambioSolicitud;
    }
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    calcRetorno: function calcRetorno() {
      var vm = this;
      if (!vm.validarFechas()) return;
      var desde = __WEBPACK_IMPORTED_MODULE_5_moment___default()(vm.solicitud.desde, 'YYYY-MM-DD');
      var hasta = __WEBPACK_IMPORTED_MODULE_5_moment___default()(vm.solicitud.hasta, 'YYYY-MM-DD');
      vm.diasCambioSolicitud = __WEBPACK_IMPORTED_MODULE_5_moment___default()(hasta, 'YYYY-MM-DD').diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(desde, 'YYYY-MM-DD'), 'days') + 1;
      vm.solicitud.retorno = hasta.add(1, 'days').format('YYYY-MM-DD');
    },
    validarFechas: function validarFechas() {
      var vm = this;
      if (!vm.solicitud.desde || !vm.solicitud.hasta) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar las fechas');
        return false;
      }
      var desde = __WEBPACK_IMPORTED_MODULE_5_moment___default()(vm.solicitud.desde, 'YYYY-MM-DD');
      var hasta = __WEBPACK_IMPORTED_MODULE_5_moment___default()(vm.solicitud.hasta, 'YYYY-MM-DD');
      if (desde.isAfter(hasta)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'La fecha desde no puede ser mayor a la fecha hasta');
        vm.solicitud.hasta = '';
        return false;
      }
      return true;
    },
    abrirModalEditar: function abrirModalEditar(o) {
      this.solicitud = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, o);
      this.solicitud.desde = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.solicitud.desde, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.solicitud.hasta = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.solicitud.hasta, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.solicitud.retorno = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.solicitud.retorno, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.diasCambioSolicitud = this.solicitud.dias;
      this.modalEditar = true;
    },
    closeModalEditar: function closeModalEditar() {
      this.solicitud = {};
      this.modalEditar = false;
    },
    guardarEditarFechas: function guardarEditarFechas() {
      var vm = this;
      if (vm.isSaving) return;
      if (!vm.validarFechas()) return;
      vm.isSaving = true;
      var obj = {
        id: vm.solicitud.id,
        desde: vm.solicitud.desde,
        hasta: vm.solicitud.hasta
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/vacaciones/solicitud/editar-fechas-jefe', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        vm.solicitud = {};
        vm.modalEditar = false;
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/vacaciones/jefe/poraprobar', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close');
        }

        for (var i = 0; i < data.lista.length; i++) {
          var element = data.lista[i];
          element.mostrarBusquedaEmpleado = false;
        }
        vm.solicitudes = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    enterEditMode: function enterEditMode(o) {
      this.solicitudSeleccionada = o;
      this.isEditing = true;
    },
    confirmarAprobar: function confirmarAprobar(o) {
      var _this = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionAprobar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_scroll__["a" /* scrollTo */])({
          ref: _this.$refs.confirmarAprobar.$el,
          vm: _this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazo: function confirmarRechazo(o) {
      var _this2 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionRechazar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_scroll__["a" /* scrollTo */])({
          ref: _this2.$refs.confirmarRechazar.$el,
          vm: _this2,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    aprobar: function aprobar() {
      var vm = this;
      if (vm.isApproving) {
        return;
      }
      vm.isApproving = true;
      var obj = {
        id: vm.solicitudSeleccionada.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/vacaciones/solicitud/aprobar', obj, function (data) {
        vm.mostrarConfirmacionAprobar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isApproving = false;
      });
    },
    rechazar: function rechazar() {
      var vm = this;
      if (vm.isApproving) {
        return;
      }
      vm.isApproving = true;
      var obj = {
        id: this.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["g" /* apiDelete */])(vm, '/vacaciones/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isApproving = false;
      });
    },
    seleccionarEmpleadoParaReemplazo: function seleccionarEmpleadoParaReemplazo(o, empleado) {
      // Primero guardamos esto
      var vm = this;
      vm.isLoadingReemplazante = true;
      vm.trIndex = vm.solicitudes.indexOf(o);
      var obj = {
        id: o.id,
        codigoEmpleadoReemplazante: empleado.codigo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/vacaciones/solicitud/reemplazo', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se asigno el empleado de reemplazo correctamente');
        o.codigoEmpleadoReemplazante = empleado.codigo;
        o.nombreEmpleadoReemplazante = empleado.nombre;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingReemplazante = false;
      });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_vacaciones_component',
  data: function data() {
    return {
      vacaciones: [],
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/vacaciones', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close');
        }
        vm.vacaciones = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Component_Loading'
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Cargando__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Cargando___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Cargando__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lookup_cargo',
  components: {
    'loading-global': __WEBPACK_IMPORTED_MODULE_2__Component_Cargando___default.a
  },
  data: function data() {
    return {
      empleados: [],
      filteredLista: [],
      filtro: '',
      isLoading: false,
      isScroll: false,
      disabledScrollExcecute: true,
      skip: 0,
      noMore: false
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },

    fetchSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (value) {
      var vm = this;
      vm.fetch();
    }, 300),
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExcecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.filteredLista = [];
        vm.skip = 0;
      }
      var obj = {
        cargo: vm.filtro,
        skip: vm.skip
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/funciones_pdf/obtener', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.filteredLista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExcecute = false;
        }

        vm.isLoading = false;
        vm.isScroll = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExcecute = true;
        vm.isScroll = false;
      });
    },
    selectFirst: function selectFirst() {
      if (this.filteredLista.length === 0) {
        this.$emit('close');
      } else {
        this.$emit('selected', this.filteredLista[0]);
        this.$emit('close');
      }
    },
    seleccionarClick: function seleccionarClick(o) {
      this.$emit('selected', o);
      this.$emit('close');
    },
    close: function close() {
      this.$emit('close', this.filteredLista[0]);
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Cargando__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Cargando___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Cargando__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lookup_small_empleado',
  components: {
    'loading-global': __WEBPACK_IMPORTED_MODULE_2__Component_Cargando___default.a
  },
  props: ['codigo', 'tipo', 'empleadosInactivos'],
  data: function data() {
    return {
      empleados: [],
      filteredEmpleados: [],
      filtro: '',
      isLoading: false,
      isScroll: false,
      disabledScrollExcecute: true,
      numeroRecnum: 0,
      noMore: false
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },

    fetchSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (value) {
      var vm = this;
      vm.fetch();
    }, 300),
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExcecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.filteredEmpleados = [];
        vm.numeroRecnum = 0;
      }
      var obj = {
        filtro: vm.filtro,
        numeroRecnum: vm.numeroRecnum
      };
      if (typeof vm.tipo !== 'undefined') {
        obj.tipo = vm.tipo;
      }
      if (typeof vm.empleadosInactivos !== 'undefined') {
        obj.empleadosInactivos = vm.empleadosInactivos;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/active', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.filteredEmpleados.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExcecute = false;
        }

        vm.isLoading = false;
        vm.isScroll = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExcecute = true;
        vm.isScroll = false;
      });
    },
    selectFirst: function selectFirst() {
      if (this.filteredEmpleados.length === 0) {
        this.$emit('close');
      } else {
        this.$emit('selected', this.filteredEmpleados[0]);
        this.$emit('close');
      }
    },
    seleccionarClick: function seleccionarClick(o) {
      this.$emit('selected', o);
      this.$emit('close');
    },
    close: function close() {
      this.$emit('close', this.filteredEmpleados[0]);
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lookup_small_tipos_permiso',
  props: ['codigo'],
  data: function data() {
    return {
      lista: [],
      filtered: [],
      searchTerm: '',
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  watch: {
    searchTerm: function searchTerm(value) {
      return this.sendSearch(value);
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/permisos/tipo', {}, function (data) {
        vm.lista = data.lista;
        vm.filtered = vm.lista;
        vm.isLoading = false;
        if (vm.codigo) {
          vm.searchTerm = vm.codigo;
          vm.sendSearch(vm.searchTerm);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    selectFirst: function selectFirst() {
      if (this.filtered.length === 0) {
        this.$emit('close');
      } else {
        this.$emit('selected', this.filtered[0]);
        this.$emit('close');
      }
    },
    seleccionarClick: function seleccionarClick(o) {
      this.$emit('selected', o);
      this.$emit('close');
    },
    close: function close() {
      this.$emit('close', this.filtered[0]);
    },
    sendSearch: function sendSearch(value) {
      if (value) {
        value = value + '';
        this.filtered = this.lista.filter(function (e) {
          return e.descripcion.toLowerCase().includes(value.toLowerCase()) || (e.codigo + '').includes(value);
        });
      } else {
        this.filtered = this.lista;
      }
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mis_documentos_sin_cargar',
  data: function data() {
    return {
      lista: [],
      isModalActive: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  created: function created() {
    // Verifica si ya estás en la ruta '/mis-documentos-firmar'
    if (this.$route.path !== '/mis-documentos-firmar') {
      this.fetch();
    } else {
      this.isModalActive = false;
    }
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
        if (data.lista.length > 0) {
          vm.isModalActive = true;
          vm.lista = data.lista;
        }
      });
    },
    goToMisDocumentos: function goToMisDocumentos() {
      this.$router.push('/mis-documentos-firmar');
      this.isModalActive = false;
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_mis_permisos_component',
  data: function data() {
    return {
      lista: [],
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/permisos/empleado/permisos', obj, function (data) {
        if (data.lista.length === 0) {
          vm.lista = [];
          vm.$emit('close');
        } else {
          vm.lista = data.lista;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_scroll__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Solicitud__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Solicitud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Solicitud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Component_Upload_Image__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'nueva-solicitud': __WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Solicitud___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay___default.a,
    'upload-image': __WEBPACK_IMPORTED_MODULE_4__Component_Upload_Image___default.a
  },
  data: function data() {
    return {
      solicitudes: [],
      solicitudSeleccionada: {},
      showClosed: false,
      isEditing: false,
      mostrarConfirmacionEnviar: false,
      mostrarConfirmacionRechazar: false,
      isLoading: true,
      isMostrandoAdjuntar: false,
      isSavedAdjunto: false,
      screenWidth: window.innerWidth,
      isSending: false
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', function () {
      _this.screenWidth = window.innerWidth;
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    window.removeEventListener('resize', function () {
      _this2.screenWidth = window.innerWidth;
    });
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/permisos/empleado/solicitud', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          data.lista[i].motivoLista = data.lista[i].motivo.split('\n');
        }
        vm.solicitudes = data.lista;
        if (vm.solicitudes.length === 0) vm.$emit('close');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    enterEditMode: function enterEditMode(o) {
      var _this3 = this;

      this.solicitudSeleccionada = o;
      this.isEditing = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this3,
          ref: _this3.$refs.editarSolicitud.$el,
          mobile: -20,
          desktop: -60,
          hasPermisoSolicitud: true
        });
      });
      // scrollTo({vm:this, mobile: -70, desktop: -40, ref: this.$refs.editarSolicitud})
    },
    confirmarEnviar: function confirmarEnviar(o) {
      var _this4 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionEnviar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this4,
          ref: _this4.$refs.confirmarEnviar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazo: function confirmarRechazo(o) {
      var _this5 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionRechazar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this5,
          ref: _this5.$refs.confirmarRechazar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    enviarJefe: function enviarJefe() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: vm.solicitudSeleccionada.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/permisos/solicitud/send', obj, function (data) {
        vm.mostrarConfirmacionEnviar = false;
        vm.fetch();
      }, function (error) {
        alert('error:' + error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    rechazar: function rechazar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: this.solicitudSeleccionada.id,
        isMisSolictudes: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["g" /* apiDelete */])(vm, '/permisos/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    abrirAdjuntar: function abrirAdjuntar(o) {
      var _this6 = this;

      this.solicitudSeleccionada = o;
      this.isMostrandoAdjuntar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this6,
          ref: _this6.$refs.adjuntarSolicitud,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      var obj = {
        id: this.solicitudSeleccionada.id,
        fileSubido: fileSubido
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/permisos/solicitud/adjuntar', obj, function (data) {
        vm.fetch();
        vm.closeAdjuntar();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Adjuntado correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    closeAdjuntar: function closeAdjuntar() {
      this.solicitudSeleccionada = {};
      this.isMostrandoAdjuntar = false;
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_permisos_por_aprobar_component',
  data: function data() {
    return {
      lista: [],
      seleccionadosTodos: false,
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionAprobarMasiva: false,
      mostrarConfirmacionRechazar: false,
      mostrarConfirmacionRechazarMasiva: false,
      mostrarMensajeDeNoSolicitudes: true,
      isLoading: true,
      isSending: false
    };
  },

  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default.a
  },
  computed: {
    isSeleccionMasiva: function isSeleccionMasiva() {
      return this.lista.filter(function (o) {
        return o.seleccionado;
      }).length > 0;
    }
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    check: function check(row) {
      if (row === 'all') {
        this.seleccionadosTodos = !this.seleccionadosTodos;
        for (var i = 0; i < this.lista.length; i++) {
          this.$set(this.lista[i], 'seleccionado', this.seleccionadosTodos);
        }
        return;
      }
      row.seleccionado = !row.seleccionado;
      if (!row.seleccionado) {
        this.seleccionadosTodos = false;
      }
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/permisos/jefe/poraprobar', obj, function (data) {
        vm.lista = data.lista;
        // esto replica la lista 3 veces
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 200})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 300})));
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    confirmarAprobar: function confirmarAprobar(o) {
      var _this = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionAprobar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this.$refs.aprobarSolicitud.$el,
          vm: _this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazo: function confirmarRechazo(o) {
      var _this2 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionRechazar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this2.$refs.confirmarRechazar.$el,
          vm: _this2,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazoMasivo: function confirmarRechazoMasivo() {
      var _this3 = this;

      this.mostrarConfirmacionRechazarMasiva = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this3.$refs.confirmarRechazarMasiva.$el,
          vm: _this3,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarAprobarMasivo: function confirmarAprobarMasivo() {
      var _this4 = this;

      this.mostrarConfirmacionAprobarMasiva = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this4.$refs.confirmarAprobarMasiva.$el,
          vm: _this4,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    aprobar: function aprobar() {
      var vm = this;
      var obj = {
        id: vm.solicitudSeleccionada.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/permisos/solicitud/aprobar', obj, function (data) {
        vm.mostrarConfirmacionAprobar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    rechazar: function rechazar() {
      var vm = this;

      var obj = {
        id: this.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, '/permisos/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    rechazarMasivo: function rechazarMasivo() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        ids: vm.lista.filter(function (o) {
          return o.seleccionado;
        }).map(function (o) {
          return o.id;
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, '/permisos/empleado/masivo/solicitud', obj, function (data) {
        vm.isLoading = false;
        vm.mostrarConfirmacionRechazarMasiva = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Solicitudes rechazadas');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    aprobarMasivo: function aprobarMasivo() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        ids: vm.lista.filter(function (o) {
          return o.seleccionado;
        }).map(function (o) {
          return o.id;
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/permisos/solicitud/masivo/aprobar', obj, function (data) {
        vm.isLoading = false;
        vm.mostrarConfirmacionAprobarMasiva = false;
        vm.fetch();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Solicitudes aprobadas');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_permisos_por_aprobar_rrhh_component',
  data: function data() {
    return {
      lista: [],
      seleccionadosTodos: false,
      mostrarConfirmacionAprobarMasiva: false,
      mostrarConfirmacionRechazarMasiva: false,
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionRechazar: false,
      mostrarMensajeDeNoSolicitudes: true,
      isSending: false,
      isLoading: true
    };
  },

  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.fetch();
  },

  computed: {
    isSeleccionMasiva: function isSeleccionMasiva() {
      return this.lista.filter(function (o) {
        return o.seleccionado;
      }).length > 0;
    }
  },
  methods: {
    check: function check(row) {
      if (row === 'all') {
        this.seleccionadosTodos = !this.seleccionadosTodos;
        for (var i = 0; i < this.lista.length; i++) {
          this.$set(this.lista[i], 'seleccionado', this.seleccionadosTodos);
        }
        return;
      }
      row.seleccionado = !row.seleccionado;
      if (!row.seleccionado) {
        this.seleccionadosTodos = false;
      }
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/permisos/rrhh/poraprobar', obj, function (data) {
        vm.lista = data.lista;
        // esto replica la lista 3 veces
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 651})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 800})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 1452})));
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    confirmarAprobar: function confirmarAprobar(o) {
      var _this = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionAprobar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this.$refs.confirmarAprobar.$el,
          vm: _this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazo: function confirmarRechazo(o) {
      var _this2 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionRechazar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this2.$refs.confirmarRechazar.$el,
          vm: _this2,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazoMasivo: function confirmarRechazoMasivo() {
      var _this3 = this;

      this.mostrarConfirmacionRechazarMasiva = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this3.$refs.confirmarRechazarMasiva.$el,
          vm: _this3,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarAprobarMasivo: function confirmarAprobarMasivo() {
      var _this4 = this;

      this.mostrarConfirmacionAprobarMasiva = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_scroll__["a" /* scrollTo */])({
          ref: _this4.$refs.confirmarAprobarMasiva.$el,
          vm: _this4,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    aprobar: function aprobar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: vm.solicitudSeleccionada.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/permisos/solicitud/aprobar/rrhh', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Aprobado correctamente');
        vm.mostrarConfirmacionAprobar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    rechazar: function rechazar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: this.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, '/permisos/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    aprobarMasivo: function aprobarMasivo() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        ids: vm.lista.filter(function (o) {
          return o.seleccionado;
        }).map(function (o) {
          return o.id;
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/permisos/solicitud/masivo/aprobar/rrhh', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Aprobado correctamente');
        vm.mostrarConfirmacionAprobarMasiva = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    rechazarMasivo: function rechazarMasivo() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        ids: vm.lista.filter(function (o) {
          return o.seleccionado;
        }).map(function (o) {
          return o.id;
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, '/permisos/empleado/masivo/solicitud', obj, function (data) {
        vm.isLoading = false;
        vm.mostrarConfirmacionRechazarMasiva = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Solicitudes rechazadas');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_permisos_component',
  data: function data() {
    return {
      solicitudes: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      mostrarConfirmacionNoLoTomo: false,
      solicitudSeleccionada: {},
      filtroCodigoEmpleado: '',
      filtroMes: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format('YYYY-MM-DD'),
      filtroYear: __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format('YYYY-MM-DD'),
      filtroTipo: 'all',
      meses: [{ codigo: 1, descripcion: 'Enero' }, { codigo: 2, descripcion: 'Febrero' }, { codigo: 3, descripcion: 'Marzo' }, { codigo: 4, descripcion: 'Abril' }, { codigo: 5, descripcion: 'Mayo' }, { codigo: 6, descripcion: 'Junio' }, { codigo: 7, descripcion: 'Julio' }, { codigo: 8, descripcion: 'Agosto' }, { codigo: 9, descripcion: 'Setiembre' }, { codigo: 10, descripcion: 'Octubre' }, { codigo: 11, descripcion: 'Noviembre' }, { codigo: 12, descripcion: 'Diciembre' }],
      years: [2018, 2019, 2020, 2021, 2022, 2023, 2024],
      tipos: []
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default.a
  },
  created: function created() {
    this.fetchTipos();
    this.fetch();
  },

  watch: {
    filtroCodigoEmpleado: function filtroCodigoEmpleado(value) {
      return this.fetch();
    },
    filtroTipo: function filtroTipo(value) {
      return this.fetch();
    }
  },
  methods: {
    fetchTipos: function fetchTipos() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/permisos/tipo', obj, function (data) {
        vm.tipos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        tipo: vm.filtroTipo,
        desde: vm.filtroMes,
        hasta: vm.filtroYear
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/permisos/reporte', { filtros: filtros }, function (data) {
        vm.solicitudes = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroTipo = 'all';
      this.filtroCodigoEmpleado = '';
      this.filtroMes = __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format('YYYY-MM-DD');
      this.filtroYear = __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format('YYYY-MM-DD');
    },
    exportarExcel: function exportarExcel() {
      var vm = this;
      vm.isLoading = true;

      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        tipo: vm.filtroTipo,
        desde: vm.filtroMes,
        hasta: vm.filtroYear
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiGetExcel */])(vm, '/permisos/reporte/excel', { filtros: filtros }, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'permisos' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    exportarNuevoExcel: function exportarNuevoExcel() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        tipo: vm.filtroTipo,
        desde: vm.filtroMes,
        hasta: vm.filtroYear
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiGetExcel */])(vm, '/permisos/reporte/excelNuevo', { filtros: filtros }, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'reporteVacacionesEmpleado' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_permisos_solicitud_component',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      solicitudSeleccionada: {},
      filtroCodigoEmpleado: '',
      filtroEstado: 3,
      filtroTipo: 'all',
      estados: [],
      tipos: [],
      perfilVacaciones: localStorage.getItem('perfilVacaciones'),
      isScroll: false,
      disabledScrollExecute: true,
      skip: 0,
      noMore: false
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.fetchEstados();
    this.fetchTipos();
    this.fetch();
  },

  watch: {
    filtroCodigoEmpleado: function filtroCodigoEmpleado(value) {
      return this.fetch();
    },
    filtroEstado: function filtroEstado(value) {
      return this.fetch();
    },
    filtroTipo: function filtroTipo(value) {
      return this.fetch();
    }
  },
  methods: {
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetchEstados: function fetchEstados() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/permisos/estado', obj, function (data) {
        vm.estados = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    fetchTipos: function fetchTipos() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/permisos/tipo', obj, function (data) {
        vm.tipos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    fetch: function fetch() {
      var vm = this;
      if (vm.isLoading) return;

      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        estado: vm.filtroEstado,
        tipo: vm.filtroTipo
      };

      var obj = {
        filtros: filtros
      };
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/permisos/solicitud', obj, function (data) {
        data.lista.forEach(function (o) {
          vm.lista.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroEstado = this.perfilVacaciones === 'jefe' ? 'all' : 3;
      this.filtroCodigoEmpleado = '';
      this.filtroTipo = 'all';
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Tipos_Permiso_vue__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Tipos_Permiso_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Tipos_Permiso_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'solicitud_permisos_component',
  components: {
    LookupSmallTiposPermiso: __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Tipos_Permiso_vue___default.a,
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue___default.a
  },
  props: ['isEditing', 'solicitud', 'isExcepcion'],
  data: function data() {
    return {
      tipo: '',
      descripcionTipo: '',
      motivo: '',
      jefe: '',
      mostrarIndicaciones: true,
      mostrarBusquedaTipo: false,
      mostrarBusquedaEmpleado: false,
      codigoEmpleado: '',
      nombreEmpleado: '',
      empleadoExcepcion: {},
      isSaving: false,
      isLoading: false,
      detalle: []
    };
  },

  watch: {},
  created: function created() {
    this.fetchInfoJefe();
    // Si viene editando muestro los datos de la solicitud
    if (this.isEditing) {
      this.tipo = this.solicitud.tipo;
      this.descripcionTipo = this.solicitud.descripcionTipo;
      this.motivo = this.solicitud.motivo;

      for (var i = 0; i < this.solicitud.detalle.length; i++) {
        var aux = {
          desde: window.moment(this.solicitud.detalle[i].desde, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          hasta: window.moment(this.solicitud.detalle[i].hasta, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          horaDesde: this.solicitud.detalle[i].horaDesde,
          horaHasta: this.solicitud.detalle[i].horaHasta
        };
        this.detalle.push(aux);
      }
    } else {
      this.agregarDetalleVacio();
    }
  },

  methods: {
    fetchInfoJefe: function fetchInfoJefe() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/jefe', obj, function (data) {
        vm.jefe = data.data.nombre;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    validar: function validar(obj, callback) {
      if (!obj.tipo) {
        callback(new Error('Por favor seleccione el tipo de permiso'));
        return;
      }

      if (!obj.detalle) {
        callback(new Error('Por favor ingrese las fechas en que se ausentará'));
        return;
      }

      if (obj.detalle.length === 0) {
        callback(new Error('Por favor ingrese las fechas en que se ausentará'));
        return;
      }

      if (!obj.motivo) {
        callback(new Error('Por favor ingrese el motivo del permiso'));
        return;
      }

      // var today = window.moment(window.moment().format('YYYY-MM-DD')).toDate()

      // Validaremos si es que hay datos iguales, no deberia haber
      var desde = [];
      for (var i = 0; i < obj.detalle.length; i++) {
        // Validamos que la fecha de fin no sea antes de la fecha desde
        if (window.moment(obj.detalle[i].desde).isAfter(window.moment(obj.detalle[i].hasta))) {
          callback(new Error('La fecha hasta no puede ser anterior de la fecha desde'));
          return;
        }

        var index = desde.indexOf(obj.detalle[i].desde);
        if (index === -1) {
          desde.push(obj.detalle[i].desde);
        } else {
          // Encontro un desde igual
          callback(new Error('No puedes ingresar fechas repetidas, por favor verifica'));
          return;
        }

        // if (!obj.isExcepcion) {
        //   if (window.moment(obj.detalle[i].desde).isBefore(window.moment(today))) {
        //     callback(new Error('No puedes ingresar fecha anteriores a hoy'))
        //     return
        //   }
        // }
      }
      callback();
    },
    guardar: function guardar(isSending) {
      var vm = this;
      vm.isSaving = true;

      var obj = {
        tipo: vm.tipo,
        motivo: vm.motivo,
        isSending: isSending,
        detalle: vm.detalle
      };

      if (vm.isEditing) {
        obj.id = vm.solicitud.id;
        obj.isEditing = vm.isEditing;
      }

      if (vm.isExcepcion) {
        obj.isExcepcion = vm.isExcepcion;
        obj.codigoEmpleado = vm.codigoEmpleado;
      }

      // validamos
      vm.validar(obj, function (err) {
        if (err) {
          vm.isSaving = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
          return;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/permisos/solicitud', obj, function (data) {
          vm.clear();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
          if (vm.isEditing) {
            vm.$emit('closeRefresh');
          } else {
            vm.$emit('successNew');
          }
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        }, function () {
          vm.isSaving = false;
        });
      });
    },
    seleccionarTipo: function seleccionarTipo(o) {
      this.tipo = o.codigo;
      this.descripcionTipo = o.descripcion;
    },
    agregarDetalleVacio: function agregarDetalleVacio() {
      this.detalle.push({
        desde: window.moment().format('YYYY-MM-DD'),
        hasta: window.moment().format('YYYY-MM-DD'),
        horaDesde: '08:00',
        horaHasta: '18:00'
      });
    },
    eliminarDetalle: function eliminarDetalle(index) {
      this.detalle.splice(index, 1);
    },
    clear: function clear() {
      this.tipo = '';
      this.descripcionTipo = '';
      this.motivo = '';
      this.detalle = [];
      this.codigoEmpleado = '';
      this.nombreEmpleado = '';
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.codigoEmpleado = o.codigo;
      this.nombreEmpleado = o.nombre;
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(490);
__webpack_require__(491);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_equipo_vacaciones_component',
  data: function data() {
    return {
      lista: [],
      codigoLogueadoJefe: localStorage.getItem('codigo') + '',
      perfilVacaciones: localStorage.getItem('perfilVacaciones'),
      isLoading: false,
      isShowingJefeDirecto: true,
      showDate: new Date(),
      periodStart: '',
      periodEnd: '',
      isModalActive: false,
      items: [{ id: 1, startDate: '2024-01-01', endDate: '2024-01-02', classes: 'vacaciones', title: 'Marco Torres' }, { id: 2, startDate: '2024-01-03', endDate: '2024-01-04', classes: 'solicitud-vacaciones', title: 'Juan Perez' }, { id: 3, startDate: '2024-01-05', endDate: '2024-01-06', classes: 'permisos', title: 'Maria Rodriguez' }, { id: 4, startDate: '2024-01-07', endDate: '2024-01-08', classes: 'solicitud-permisos', title: 'Jose Gomez' }, { id: 5, startDate: '2024-01-09', endDate: '2024-01-10', style: 'background-color: #fff !important;', title: 'Carlos Sanchez' }, { id: 6, startDate: '2024-01-01', endDate: '2024-01-05', style: 'background-color: #fff !important;', title: 'Luisa Perez' }],
      item: {},
      verTodos: false,
      meIncluyo: true,
      creadoComponente: false,
      verSolicitudesAprobadas: false
    };
  },

  components: {
    CalendarView: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarView"],
    CalendarViewHeader: __WEBPACK_IMPORTED_MODULE_1_vue_simple_calendar__["CalendarViewHeader"]
  },
  created: function created() {
    if (this.perfilVacaciones === 'recursos humanos') {
      this.verTodos = true;
      this.meIncluyo = false;
    }
    this.creadoComponente = true;
  },

  methods: {
    verTodosChanged: function verTodosChanged() {
      this.verTodos = !this.verTodos;
      if (this.verTodos) {
        this.meIncluyo = false;
      }
      this.fetch();
    },
    meIncluyoChanged: function meIncluyoChanged() {
      this.meIncluyo = !this.meIncluyo;
      if (this.meIncluyo) {
        this.verTodos = false;
      }
      this.fetch();
    },
    verSolicitudesAprobadasChanged: function verSolicitudesAprobadasChanged() {
      this.verSolicitudesAprobadas = !this.verSolicitudesAprobadas;
      this.fetch();
    },
    setShowDate: function setShowDate(d) {
      this.showDate = d;
    },
    onItemClick: function onItemClick(item, e) {
      var vm = this;
      vm.isModalActive = true;
      vm.item = item.originalItem;
    },
    closeModalActive: function closeModalActive() {
      this.isModalActive = false;
    },
    fetch: function fetch(obj) {
      var vm = this;
      vm.isLoading = true;

      var periodStart = '';
      var periodEnd = '';

      if (obj && obj.displayFirstDate) {
        periodStart = obj.displayFirstDate;
        periodEnd = obj.displayLastDate;
        vm.periodStart = obj.displayFirstDate;
        vm.periodEnd = obj.displayLastDate;
      } else {
        periodStart = vm.periodStart;
        periodEnd = vm.periodEnd;
      }

      var objSend = {
        desde: periodStart,
        hasta: periodEnd,
        meIncluyo: vm.meIncluyo,
        verSolicitudesAprobadas: vm.verSolicitudesAprobadas
      };
      if (vm.perfilVacaciones === 'recursos humanos') {
        objSend.verTodos = vm.verTodos;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/empleado/obtener/cascada/calendario', objSend, function (data) {
        vm.lista = data.lista;
        if (!vm.creadoComponente && vm.perfilVacaciones === 'recursos humanos') {
          vm.meIncluyo = data.meIncluyoCheckbox;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.creadoComponente = false;
        if (vm.verTodos) {
          vm.meIncluyo = false;
        }
        if (vm.meIncluyo) {
          vm.verTodos = false;
        }
      });
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_scroll__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_contratos_component',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      perfil: localStorage.getItem('perfilVacaciones'),
      filtros: {
        codigoEmpleado: '',
        desde: '',
        hasta: '',
        firmado: 'all',
        indeterminado: 'all'
      },
      mostrarModalEliminar: false,
      mostrarModalNotificar: false,
      contrato: {},
      isProcessing: false
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, this.$route.query);
    this.fetch();
  },

  methods: {
    changeFecha: function changeFecha() {
      if (this.indeterminado === 1) {
        this.indeterminado = 0;
      }
      this.fetch();
    },
    changeIndeterminado: function changeIndeterminado() {
      if (this.filtros.indeterminado === 1) {
        this.filtros.desde = '';
        this.filtros.hasta = '';
      }
      this.fetch();
    },
    changeFiltro: function changeFiltro() {
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.filtros);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/reporte', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtros.codigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtros = {
        codigoEmpleado: '',
        mes: 'all',
        anio: 'all',
        firmado: 'all',
        indeterminado: 'all'
      };
      this.fetch();
    },
    notificar: function notificar() {
      var vm = this;
      if (vm.isProcessing) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/contratos/notificar/no-firmados', {}, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se le notifico masivamente a los empleados');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isProcessing = false;
        vm.mostrarModalNotificar = false;
      });
    },
    openModalNotificacionMasiva: function openModalNotificacionMasiva() {
      this.mostrarModalNotificar = true;
    },
    confirmacionEliminar: function confirmacionEliminar(o) {
      var _this = this;

      var vm = this;
      vm.contrato = {
        id: o.id
      };
      vm.mostrarModalEliminar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_scroll__["a" /* scrollTo */])({
          ref: _this.$refs.confirmarEliminar.$el,
          vm: _this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    eliminar: function eliminar() {
      var vm = this;
      if (vm.isProcessing) return;
      vm.isProcessing = true;
      var obj = { id: vm.contrato.id };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/contratos/eliminar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.contrato = {};
        vm.fetch();
        vm.mostrarModalEliminar = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isProcessing = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(function (a) {
            return !a.firmado;
          }).length);
        });
      });
    },
    closeModalEliminar: function closeModalEliminar() {
      var vm = this;
      vm.contrato = {};
      vm.mostrarModalEliminar = false;
    },
    closeModalNotificar: function closeModalNotificar() {
      var vm = this;
      vm.mostrarModalNotificar = false;
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_contratos_component',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      filtros: {
        activo: 1,
        estado: 0,
        codigoEmpleado: '',
        id: ''
      },
      documentos: [],
      mostrarModalEliminar: false,
      mostrarModalNotificar: false,
      isProcessing: false,
      motivoRechazo: '',
      mostrarModalRechazo: false,
      disabledScrollExecute: true,
      isScroll: false,
      documento: {},
      skip: 0,
      noMore: false,
      isSaving: false
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.filtros = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtros, this.$route.query);
    this.fetchDocumentos();
    this.fetch();
  },

  methods: {
    changeFiltro: function changeFiltro() {
      this.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetchDocumentos: function fetchDocumentos() {
      var vm = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/', {}, function (data) {
        vm.documentos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.filtros);
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/reporte', obj, function (data) {
        for (var index = 0; index < data.lista.length; index++) {
          var element = data.lista[index];
          vm.lista.push(element);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtros.codigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtros = {
        activo: 0,
        estado: 0,
        codigoEmpleado: '',
        id: ''
      };
      this.fetch();
    },
    notificar: function notificar(o) {
      var vm = this;
      if (vm.isProcessing) return;
      var obj = {};
      if (o) {
        obj.codigoEmpleado = o.codigoEmpleado;
        obj.id = o.id;
      } else {
        obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.filtros);
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/documentos-firmar/notificar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se le notifico masivamente a los empleados');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isProcessing = false;
        vm.mostrarModalNotificar = false;
      });
    },
    openModalNotificacionMasiva: function openModalNotificacionMasiva() {
      this.mostrarModalNotificar = true;
    },
    closeModalNotificar: function closeModalNotificar() {
      var vm = this;
      vm.mostrarModalNotificar = false;
    },
    abrirModalRechazo: function abrirModalRechazo(o) {
      var vm = this;
      vm.documento = o;
      vm.mostrarModalRechazo = true;
    },
    cerrarModalRechazo: function cerrarModalRechazo() {
      var vm = this;
      vm.mostrarModalRechazo = false;
      vm.documento = {};
      vm.motivoRechazo = null;
    },
    revisar: function revisar(row) {
      var vm = this;
      if (vm.isProcessing) return;
      vm.isProcessing = true;
      var obj = {
        idDetalle: row.idDetalle,
        nombreEmpleado: row.nombreEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/revisar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Revisado');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isProcessing = false;
        vm.fetch();
      });
    },
    rechazar: function rechazar() {
      var vm = this;
      var obj = {
        idDocumento: vm.documento.id,
        nombreEmpleado: vm.documento.nombreEmpleado,
        codigoEmpleado: vm.documento.codigoEmpleado,
        email: vm.documento.email,
        motivo: vm.motivoRechazo
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/documentos-firmar/rechazar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Rechazado correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.mostrarModalNotificar = false;
        vm.cerrarModalRechazo();
        vm.fetch();
      });
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_empleados_vacaciones_component',
  data: function data() {
    return {
      lista: [],
      listaFiltrada: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      mostrarConfirmacionNoLoTomo: false,
      empleadoSeleccionado: {},
      filtroCodigoEmpleado: '',
      filtroUrgencia: 'white',
      filtrosUrgencia: ['white', 'green', 'yellow', 'red'],
      muestraModalExcelSaldo: false,
      mesExportar: '',
      periodoExportar: '',
      arrayMeses: [{ id: '1', nombre: 'Enero' }, { id: '2', nombre: 'Febrero' }, { id: '3', nombre: 'Marzo' }, { id: '4', nombre: 'Abril' }, { id: '5', nombre: 'Mayo' }, { id: '6', nombre: 'Junio' }, { id: '7', nombre: 'Julio' }, { id: '8', nombre: 'Agosto' }, { id: '9', nombre: 'Setiembre' }, { id: '10', nombre: 'Octubre' }, { id: '11', nombre: 'Noviembre' }, { id: '12', nombre: 'Diciembre' }],
      arrayYear: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: __WEBPACK_IMPORTED_MODULE_1_moment___default()().year() - 2020 + 1 }, function (_, i) {
        var year = __WEBPACK_IMPORTED_MODULE_1_moment___default()().year() - i;
        return { id: year, nombre: String(year) };
      })
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.fetch();
  },

  watch: {
    filtroCodigoEmpleado: function filtroCodigoEmpleado(value) {
      return this.fetch();
    },
    filtroUrgencia: function filtroUrgencia(value) {
      return this.filtrarUrgencia();
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.listaFiltrada = [];

      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado
      };

      var obj = {
        filtros: filtros
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado', obj, function (data) {
        vm.lista = data.lista;
        if (vm.filtroUrgencia !== 'white') {
          vm.filtrarUrgencia();
        } else {
          vm.listaFiltrada = vm.lista;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroCodigoEmpleado = '';
      this.filtroUrgencia = 'white';
    },
    filtrarUrgencia: function filtrarUrgencia() {
      var vm = this;
      // Hacemos el filtro local
      if (vm.filtroUrgencia === 'white') {
        vm.listaFiltrada = vm.lista;
      } else {
        if (vm.filtroUrgencia === 'green') {
          vm.listaFiltrada = vm.lista.filter(function (e) {
            return e.diasDisponibles < 35;
          });
        } else if (vm.filtroUrgencia === 'yellow') {
          vm.listaFiltrada = vm.lista.filter(function (e) {
            return e.diasDisponibles >= 35 && e.diasDisponibles <= 40;
          });
        } else if (vm.filtroUrgencia === 'red') {
          vm.listaFiltrada = vm.lista.filter(function (e) {
            return e.diasDisponibles > 40;
          });
        }
      }
    },
    exportarExcel: function exportarExcel() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        codigoEmpleado: vm.filtroCodigoEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["e" /* apiGetExcel */])(vm, '/vacaciones/empleado/vacacionesReporte', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'reporteVacacionesEmpleado' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    showModalExportarExcelSaldo: function showModalExportarExcelSaldo() {
      var vm = this;
      vm.muestraModalExcelSaldo = true;
    },
    closeModalExcelSaldo: function closeModalExcelSaldo() {
      var vm = this;
      vm.mesExportar = '';
      vm.periodoExportar = '';
      vm.muestraModalExcelSaldo = false;
    },
    fetchExportarExcelSaldo: function fetchExportarExcelSaldo() {
      var vm = this;
      if (!vm.mesExportar) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Mes es Obligatorio');
        return;
      }
      if (!vm.periodoExportar) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Periodo es Obligatorio');
        return;
      }
      vm.isLoading = true;
      var obj = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        mes: vm.mesExportar,
        periodo: vm.periodoExportar
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["e" /* apiGetExcel */])(vm, '/vacaciones/empleado/vacacionesReporteSaldo', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'reporteVacacionesEmpleadoSaldo' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
        vm.closeModalExcelSaldo();
        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_scroll__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_component',
  data: function data() {
    return {
      perfilUsuario: localStorage.getItem('perfilVacaciones'),
      solicitudes: [],
      isLoading: false,
      isSending: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      mostrarConfirmacionNoLoTomo: false,
      solicitudSeleccionada: {},
      filtroCodigoEmpleado: '',
      filtroEstado: 3,
      filtroMes: 'all',
      filtroYear: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY'),
      estados: {},
      meses: [{ codigo: 'all', descripcion: 'Todos' }, { codigo: 1, descripcion: 'Enero' }, { codigo: 2, descripcion: 'Febrero' }, { codigo: 3, descripcion: 'Marzo' }, { codigo: 4, descripcion: 'Abril' }, { codigo: 5, descripcion: 'Mayo' }, { codigo: 6, descripcion: 'Junio' }, { codigo: 7, descripcion: 'Julio' }, { codigo: 8, descripcion: 'Agosto' }, { codigo: 9, descripcion: 'Setiembre' }, { codigo: 10, descripcion: 'Octubre' }, { codigo: 11, descripcion: 'Noviembre' }, { codigo: 12, descripcion: 'Diciembre' }],
      years: ['all', 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
      disabledScrollExecute: false,
      isScroll: false,
      noMore: false,
      skip: 0
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__Component_Lookup_Small_Empleado_vue___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.fetchEstados();
    this.fetch();
  },

  watch: {
    filtroCodigoEmpleado: function filtroCodigoEmpleado(value) {
      return this.fetch();
    },
    filtroEstado: function filtroEstado(value) {
      return this.fetch();
    },
    filtroMes: function filtroMes(value) {
      return this.fetch();
    },
    filtroYear: function filtroYear(value) {
      return this.fetch();
    }
  },
  methods: {
    fetchEstados: function fetchEstados() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/vacaciones/estado', obj, function (data) {
        vm.estados = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;

      vm.disabledScrollExecute = true;
      vm.noMore = false;
      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        estado: vm.filtroEstado,
        mes: vm.filtroMes,
        year: vm.filtroYear
      };

      var obj = {
        filtros: filtros
      };
      if (!vm.isScroll) {
        vm.solicitudes = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/vacaciones/solicitud/reporte', obj, function (data) {
        data.lista.forEach(function (o) {
          vm.solicitudes.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
        // esto replica la lista 3 veces
        // vm.solicitudes.push(...data.lista.map(obj => ({...obj, id: obj.id + 200})));
        // vm.solicitudes.push(...data.lista.map(obj => ({...obj, id: obj.id + 300})));
        // vm.solicitudes.push(...data.lista.map(obj => ({...obj, id: obj.id + 400})));
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroEstado = 3;
      this.filtroCodigoEmpleado = '';
      this.filtroMes = 'all';
      this.filtroYear = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY');
    },
    confirmarNoLoTomo: function confirmarNoLoTomo(o) {
      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionNoLoTomo = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_scroll__["a" /* scrollTo */])({
          vm: this,
          ref: this.$refs.confirmarNoLoTomo.$el,
          mobile: -20,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    noLoTomo: function noLoTomo() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: this.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["d" /* apiPut */])(vm, '/vacaciones/empleado/solicitud/nolotomo', obj, function (data) {
        vm.mostrarConfirmacionNoLoTomo = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    limpiarEmpleado: function limpiarEmpleado() {
      this.filtroCodigoEmpleado = '';
      this.fetch();
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'document-selector',
  props: {
    idEmpleado: Number // Se pasan como prop los empleados previamente seleccionados
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a
  },
  data: function data() {
    return {
      filteredDocumentos: [],
      documentosAuxiliar: [],
      filtro: '',
      nombreEmpleado: localStorage.getItem('nombre'),
      isLoading: false,
      isScroll: false,
      isSaving: false,
      disabledScrollExecute: true,
      numeroRecnum: 0,
      noMore: false,
      mostrarModalEmpleadosConDocumentos: false,
      mostrarConfirmacionModal: false,
      mensajeRespuesta: '',
      listaEmpleadosRespuesta: [],
      tipoConfirmacion: {}
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  created: function created() {
    if (this.idEmpleado) {}
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },

    fetchSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (value) {
      var vm = this;
      vm.fetch();
    }, 300),
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.filteredDocumentos = [];
        vm.numeroRecnum = 0;
      }
      var obj = {
        filtro: vm.filtro,
        numeroRecnum: vm.numeroRecnum,
        codigoEmpleado: vm.idEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/seleccionado/documentos', obj, function (data) {
        var _loop = function _loop() {
          var documento = data.lista[i];
          // Verifico en los empleados auxiliar si esta seleccionado o no (esta logica es para que este visualmente seleccionado o no)
          var documentoAux = vm.documentosAuxiliar.find(function (e) {
            return e.codigo === documento.codigo;
          });
          if (documentoAux) {
            documento.seleccionado = documentoAux.seleccionado;
          }
          // Aqui pusheo el empleado debido al scroll infinito
          vm.filteredDocumentos.push(documento);
        };

        for (var i = 0; i < data.lista.length; i++) {
          _loop();
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExecute = false;
        }
        vm.isLoading = false;
        vm.isScroll = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExecute = true;
        vm.isScroll = false;
      });
    },
    toggleSelection: function toggleSelection(documento) {
      // Actualiza el estado seleccionado del empleado en filteredDocumentos
      documento.seleccionado = !documento.seleccionado;

      // Actualiza el estado seleccionado en documentosAuxiliar
      var index = this.documentosAuxiliar.findIndex(function (e) {
        return e.codigo === documento.codigo;
      });
      if (index !== -1) {
        // Actualiza el estado seleccionado sin modificar otras propiedades
        this.documentosAuxiliar[index].seleccionado = documento.seleccionado;
      } else {
        // Solo guarda el codigo y seleccionado
        this.documentosAuxiliar.push({
          codigo: documento.codigo,
          seleccionado: documento.seleccionado
        });
      }
    },
    close: function close() {
      this.$emit('close');
    },
    selectFirst: function selectFirst() {
      if (this.filteredDocumentos.length >= 1) {
        this.toggleSelection(this.filteredDocumentos[0]);
      }
    },
    asignarDocumentos: function asignarDocumentos(eliminarForzado) {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        documentos: vm.documentosAuxiliar,
        codigoEmpleado: vm.idEmpleado,
        nombreEmpleado: vm.nombreEmpleado
      };
      if (eliminarForzado) {
        obj.eliminarForzado = true;
      } else {
        obj.eliminarForzado = false;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/documentos-firmar/asignar-documentos', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message;
          vm.listaEmpleadosRespuesta = data.lista;
          vm.mostrarModalEmpleadosConDocumentos = true;
          return;
        }
        if (obj.eliminarForzado) {
          vm.cerrarModalEmpleadosConDocumentos();
        }
        vm.documentosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
        // vm.fetch()
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    cerrarModalEmpleadosConDocumentos: function cerrarModalEmpleadosConDocumentos() {
      this.mostrarModalEmpleadosConDocumentos = false;
      this.listaEmpleadosRespuesta = [];
      this.tipoConfirmacion.tipo = '';
    },
    abrirModalConfirmacion: function abrirModalConfirmacion(tipo) {
      this.tipoConfirmacion.tipo = tipo;
      this.tipoConfirmacion.descripcion = tipo === 'asignarTodos' ? 'asignar todos los documentos' : 'desasignar todos los documentos';
      this.mostrarConfirmacionModal = true;
    },
    validarModalEmpleadoConDocumentos: function validarModalEmpleadoConDocumentos() {
      if (this.tipoConfirmacion.tipo === 'desasignarTodos') {
        this.desasignarTodos(true);
      } else {
        this.asignarDocumentos(true);
      }
    },
    validarConfirmacion: function validarConfirmacion() {
      if (this.tipoConfirmacion.tipo === 'asignarTodos') {
        this.asignarTodos();
      } else {
        this.desasignarTodos(false);
      }
      this.mostrarConfirmacionModal = false;
    },
    desasignarTodos: function desasignarTodos(_desasignarTodos) {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        codigoEmpleado: vm.idEmpleado,
        nombreEmpleado: vm.nombreEmpleado
      };
      if (_desasignarTodos) {
        obj.desasignarForzado = true;
      } else {
        obj.desasignarForzado = false;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["g" /* apiDelete */])(vm, '/documentos-firmar/desasignar-todos/documentos', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message;
          vm.listaEmpleadosRespuesta = data.lista;
          vm.mostrarModalEmpleadosConDocumentos = true;
          return;
        }
        if (obj.desasignarForzado) {
          vm.cerrarModalEmpleadosConDocumentos();
        }
        vm.documentosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    asignarTodos: function asignarTodos() {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        codigoEmpleado: vm.idEmpleado,
        nombreEmpleado: vm.nombreEmpleado
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/documentos-firmar/asignar-todos/documentos', obj, function (data) {
        vm.documentosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lookups_Area__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lookups_Area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lookups_Area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'employee-selector',
  props: {
    idDocumentoFirmar: Number // Se pasan como prop los empleados previamente seleccionados
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a,
    'lookup-area': __WEBPACK_IMPORTED_MODULE_2__lookups_Area___default.a
  },
  data: function data() {
    return {
      filteredEmpleados: [],
      empleadosAuxiliar: [],
      filtro: '',
      isLoading: false,
      isScroll: false,
      isSaving: false,
      disabledScrollExecute: true,
      numeroRecnum: 0,
      noMore: false,
      mostrarModalEmpleadosConDocumentos: false,
      mostrarConfirmacionModal: false,
      mensajeRespuesta: '',
      listaEmpleadosRespuesta: [],
      tipoConfirmacion: {},
      nombreArea: '',
      nombreGerencia: '',
      area: {
        idArea: '',
        idGerencia: '',
        nombreArea: '',
        nombreGerencia: ''
      },
      mostrarBusquedaArea: false,
      empresa: "datacont"
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  created: function created() {
    if (this.idDocumentoFirmar) {}
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    borrarArea: function borrarArea() {
      var vm = this;
      vm.area = {};
      vm.fetch();
    },
    seleccionarArea: function seleccionarArea(o) {
      var vm = this;
      vm.area = o;
      vm.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },

    fetchSearch: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (value) {
      var vm = this;
      vm.fetch();
    }, 300),
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.filteredEmpleados = [];
        vm.numeroRecnum = 0;
      }
      var obj = {
        filtro: vm.filtro,
        numeroRecnum: vm.numeroRecnum,
        idDocumentoFirmar: vm.idDocumentoFirmar
      };
      if (vm.area.idArea) {
        obj.area = vm.area;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/seleccionado', obj, function (data) {
        var _loop = function _loop() {
          var empleado = data.lista[i];
          // Verifico en los empleados auxiliar si esta seleccionado o no (esta logica es para que este visualmente seleccionado o no)
          var empleadoAux = vm.empleadosAuxiliar.find(function (e) {
            return e.codigo === empleado.codigo;
          });
          if (empleadoAux) {
            empleado.seleccionado = empleadoAux.seleccionado;
          }
          // Aqui pusheo el empleado debido al scroll infinito
          vm.filteredEmpleados.push(empleado);
        };

        for (var i = 0; i < data.lista.length; i++) {
          _loop();
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExecute = false;
        }
        vm.isLoading = false;
        vm.isScroll = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
        vm.disabledScrollExecute = true;
      });
    },
    toggleSelection: function toggleSelection(employee) {
      // Actualiza el estado seleccionado del empleado en filteredEmpleados
      employee.seleccionado = !employee.seleccionado;

      // Actualiza el estado seleccionado en empleadosAuxiliar
      var index = this.empleadosAuxiliar.findIndex(function (e) {
        return e.codigo === employee.codigo;
      });
      if (index !== -1) {
        // Actualiza el estado seleccionado sin modificar otras propiedades
        this.empleadosAuxiliar[index].seleccionado = employee.seleccionado;
      } else {
        // Solo guarda el codigo y seleccionado
        this.empleadosAuxiliar.push({
          codigo: employee.codigo,
          seleccionado: employee.seleccionado,
          nombre: employee.nombre
        });
      }
    },
    close: function close() {
      this.$emit('close');
    },
    selectFirst: function selectFirst() {
      if (this.filteredEmpleados.length >= 1) {
        this.toggleSelection(this.filteredEmpleados[0]);
      }
    },
    asignarEmpleados: function asignarEmpleados(eliminarForzado) {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        empleados: vm.empleadosAuxiliar,
        idDocumentoFirmar: vm.idDocumentoFirmar
      };
      if (eliminarForzado) {
        obj.eliminarForzado = true;
      } else {
        obj.eliminarForzado = false;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/documentos-firmar/asignar-empleados', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message;
          vm.listaEmpleadosRespuesta = data.lista;
          vm.mostrarModalEmpleadosConDocumentos = true;
          return;
        }
        if (obj.eliminarForzado) {
          vm.cerrarModalEmpleadosConDocumentos();
        }
        vm.empleadosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
        // vm.fetch()
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    cerrarModalEmpleadosConDocumentos: function cerrarModalEmpleadosConDocumentos() {
      this.mostrarModalEmpleadosConDocumentos = false;
      this.listaEmpleadosRespuesta = [];
      this.tipoConfirmacion.tipo = '';
    },
    abrirModalConfirmacion: function abrirModalConfirmacion(tipo) {
      this.tipoConfirmacion.tipo = tipo;
      this.tipoConfirmacion.descripcion = tipo === 'asignarTodos' ? 'asignar a todos los empleados' : 'desasignar a todos los empleados';
      this.mostrarConfirmacionModal = true;
    },
    validarModalEmpleadoConDocumentos: function validarModalEmpleadoConDocumentos() {
      if (this.tipoConfirmacion.tipo === 'desasignarTodos') {
        this.desasignarTodos(true);
      } else {
        this.asignarEmpleados(true);
      }
    },
    validarConfirmacion: function validarConfirmacion() {
      if (this.tipoConfirmacion.tipo === 'asignarTodos') {
        this.asignarTodos();
      } else {
        this.desasignarTodos(false);
      }
      this.mostrarConfirmacionModal = false;
    },
    desasignarTodos: function desasignarTodos(_desasignarTodos) {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        idDocumentoFirmar: vm.idDocumentoFirmar
      };
      if (_desasignarTodos) {
        obj.desasignarForzado = true;
      } else {
        obj.desasignarForzado = false;
      }
      if (vm.area.idArea) {
        obj.area = vm.area;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["g" /* apiDelete */])(vm, '/documentos-firmar/desasignar-todos', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message;
          vm.listaEmpleadosRespuesta = data.lista;
          vm.mostrarModalEmpleadosConDocumentos = true;
          return;
        }
        if (obj.desasignarForzado) {
          vm.cerrarModalEmpleadosConDocumentos();
        }
        vm.empleadosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    asignarTodos: function asignarTodos() {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        idDocumentoFirmar: vm.idDocumentoFirmar
      };
      if (vm.area.idArea) {
        obj.area = vm.area;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/documentos-firmar/asignar-todos', obj, function (data) {
        vm.empleadosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'solicitud_vacaciones_component',
  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado_vue___default.a
  },
  props: ['isEditing', 'solicitud', 'isExcepcion'],
  data: function data() {
    return {
      desde: '',
      hasta: '',
      retorno: '',
      dias: 7,
      jefe: '',
      mostrarIndicaciones: true,
      mostrarSolicitud: true,
      mostrarBusquedaEmpleado: false,
      codigoEmpleado: '',
      empleadoExcepcion: {},
      isSaving: false,
      isLoading: false
    };
  },

  watch: {
    desde: function desde(value) {
      var startDate = window.moment(value, 'YYYY-MM-DD');
      var endDate = window.moment(this.hasta, 'YYYY-MM-DD');
      if (!startDate.isBefore(endDate) || endDate.diff(startDate, 'days') < 7) {
        this.hasta = startDate.add(6, 'days').format('YYYY-MM-DD');
      }
      this.calcularDiasYRetorno();
    },
    hasta: function hasta(value) {
      this.calcularDiasYRetorno();
    }
  },
  created: function created() {
    this.desde = window.moment().add(15, 'days').format('YYYY-MM-DD');
    this.hasta = window.moment().add(21, 'days').format('YYYY-MM-DD');
    if (this.isExcepcion) this.mostrarIndicaciones = false;
    if (!this.isExcepcion) this.fetchInfoJefe();

    // Si viene editando muestro los datos de la solicitud
    if (this.isEditing) {
      this.desde = window.moment(this.solicitud.desde, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.hasta = window.moment(this.solicitud.hasta, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.dias = this.solicitud.dias;
      this.retorno = window.moment(this.solicitud.retorno, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
  },

  methods: {
    calcularDiasYRetorno: function calcularDiasYRetorno() {
      var startDate = window.moment(this.desde, 'YYYY-MM-DD');
      var endDate = window.moment(this.hasta, 'YYYY-MM-DD');
      this.dias = endDate.diff(startDate, 'days') + 1;
      this.retorno = endDate.add(1, 'days').format('DD/MM/YYYY');
    },
    fetchInfoJefe: function fetchInfoJefe() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/jefe', obj, function (data) {
        vm.jefe = data.data.nombre;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardar: function guardar(isSending) {
      var vm = this;
      vm.isSaving = true;

      var obj = {
        desde: window.moment(vm.desde, 'YYYY-MM-DD').toDate(),
        hasta: window.moment(vm.hasta, 'YYYY-MM-DD').toDate(),
        retorno: window.moment(vm.retorno, 'DD/MM/YYYY').toDate(),
        dias: vm.dias,
        isSending: isSending
      };

      if (vm.isEditing) {
        obj.id = vm.solicitud.id;
        obj.isEditing = vm.isEditing;
      }

      if (vm.isExcepcion) {
        obj.isExcepcion = vm.isExcepcion;
        obj.codigoEmpleado = vm.codigoEmpleado;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/vacaciones/solicitud', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        if (vm.isEditing) {
          vm.$emit('closeRefresh');
        } else {
          vm.$emit('successNew');
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.codigoEmpleado = o.codigo;
      this.empleadoExcepcion = {};
      this.asignarEmpleadoExcepcion();
    },
    asignarEmpleadoExcepcion: function asignarEmpleadoExcepcion() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/uno/' + this.codigoEmpleado, obj, function (data) {
        vm.empleadoExcepcion = data.data;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_scroll__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import data from '../util/data'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default.a
  },
  data: function data() {
    return {
      solicitudes: [],
      solicitudSeleccionada: {},
      isEditing: false,
      isLoading: true,
      mostrarConfirmacionEnviar: false,
      mostrarConfirmacionRechazar: false,
      mostrarConfirmacionAprobarMasiva: false,
      mostrarConfirmacionRechazarMasiva: false,
      isSending: false,
      screenWidth: window.innerWidth,
      seleccionadosTodos: false
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', function () {
      _this.screenWidth = window.innerWidth;
    });
  },

  computed: {
    isSeleccionMasiva: function isSeleccionMasiva() {
      return this.solicitudes.filter(function (o) {
        return o.seleccionado;
      }).length > 0;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    window.removeEventListener('resize', function () {
      _this2.screenWidth = window.innerWidth;
    });
  },

  methods: {
    check: function check(row) {
      if (row === 'all') {
        this.seleccionadosTodos = !this.seleccionadosTodos;
        for (var i = 0; i < this.solicitudes.length; i++) {
          this.$set(this.solicitudes[i], 'seleccionado', this.seleccionadosTodos);
        }
        return;
      }
      row.seleccionado = !row.seleccionado;
      if (!row.seleccionado) {
        this.seleccionadosTodos = false;
      }
    },
    confirmarRechazoMasivo: function confirmarRechazoMasivo() {
      var _this3 = this;

      this.mostrarConfirmacionRechazarMasiva = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          ref: _this3.$refs.confirmarRechazarMasiva.$el,
          vm: _this3,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarAprobarMasivo: function confirmarAprobarMasivo() {
      var _this4 = this;

      this.mostrarConfirmacionAprobarMasiva = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          ref: _this4.$refs.confirmarAprobarMasiva.$el,
          vm: _this4,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/rrhh/noaprobadas', obj, function (data) {
        vm.solicitudes = data.lista;
        if (vm.solicitudes.length === 0) vm.$emit('close');
      }, function (error) {
        alert('error: ' + error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    confirmarAprobar: function confirmarAprobar(o) {
      var _this5 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionEnviar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this5,
          ref: _this5.$refs.confirmarAprobar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazo: function confirmarRechazo(o) {
      var _this6 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionRechazar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this6,
          ref: _this6.$refs.confirmarRechazar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    aprobar: function aprobar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: vm.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/vacaciones/rrhh/noaprobadas', obj, function (data) {
        vm.mostrarConfirmacionEnviar = false;
        vm.fetch();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Solicitud aprobada', 'La solicitud ha sido aprobada');
      }, function (error) {
        alert('error:' + error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    rechazar: function rechazar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: this.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["d" /* apiPut */])(vm, '/vacaciones/empleado/solicitud/nolotomo', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    rechazarMasivo: function rechazarMasivo() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        ids: vm.solicitudes.filter(function (o) {
          return o.seleccionado;
        }).map(function (o) {
          return o.id;
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["d" /* apiPut */])(vm, '/vacaciones/empleado/solicitud/nolotomo/masivo', obj, function (data) {
        vm.isLoading = false;
        vm.mostrarConfirmacionRechazarMasiva = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Solicitudes rechazadas');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    aprobarMasivo: function aprobarMasivo() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        ids: vm.solicitudes.filter(function (o) {
          return o.seleccionado;
        }).map(function (o) {
          return o.id;
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/vacaciones/rrhh/noaprobadas/masivo', obj, function (data) {
        vm.isLoading = false;
        vm.mostrarConfirmacionAprobarMasiva = false;
        vm.fetch();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Solicitudes aprobadas');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upload_component',
  props: ['url', 'name', 'isSaved', 'observations', 'folder', 'onlyPdf', 'onlyImg', 'onlyPng', 'onlyWord'],
  data: function data() {
    return {
      fileSubido: {},
      apiRoute: "https://api-selfservice.datacont.com",
      filename: '',
      isSaving: false,
      extensions: ['pdf', 'png', 'jpg', 'docx', 'doc', 'xlsx', 'pptx', 'txt', 'zip', 'pbix', 'pbit', 'pbip', 'pbir']
    };
  },

  computed: {
    _meta: function _meta() {
      var vm = this;
      return this.$upload.meta(vm.name);
    },
    _file: function _file() {
      var vm = this;
      return vm.$upload.file(vm.name);
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.create();
    vm.$forceUpdate();
  },
  beforeDestroy: function beforeDestroy() {
    var vm = this;
    vm.$upload.off(vm.name);
  },

  methods: {
    create: function create() {
      var _this = this;

      var vm = this;
      if (vm.onlyPdf) {
        vm.extensions = ['pdf'];
      } else if (vm.onlyImg) {
        vm.extensions = ['png', 'jpg', 'jpeg', 'webp'];
      } else if (vm.onlyPng) {
        vm.extensions = ['png'];
      } else if (vm.onlyWord) {
        vm.extensions = ['docx', 'doc'];
      }

      vm.$upload.on(vm.name, {
        extensions: vm.extensions,
        maxSizePerFile: 1024 * 1024 * 5,
        dropzoneId: 'dropzone',
        startOnSelect: false,
        http: function http(data) {},
        onSelect: function onSelect(files, res) {
          vm.fileSubido = vm._file.$file;
          vm.filename = vm._file.$file.name;
          var extension = vm.filename.substring(vm.filename.lastIndexOf('.') + 1, vm.filename.length);
          if (!vm.extensions.includes(extension)) {
            vm.$upload.reset(vm.name);
            vm.fileSubido = {};
            vm.filename = '';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Solo se permiten archivos ' + vm.extensions.join(', '));
          }
        },
        onProgress: function onProgress(file, res) {},

        onSuccess: function onSuccess(file, res) {
          _this.file = res.data.data;
        },
        onError: function onError(file, res) {},
        onEnd: function onEnd(files, res) {}
      });
    },
    select: function select() {
      var vm = this;
      vm.$upload.select(vm.name);
    },
    start: function start() {
      var vm = this;
      vm.$upload.start(vm.name);
    },
    reset: function reset() {
      var vm = this;
      this.$upload.reset(vm.name);
    },
    limpiar: function limpiar() {
      var vm = this;
      vm.fileSubido = {};
      vm.filename = '';
      this.$upload.reset(vm.name);
    },
    update: function update() {
      var vm = this;
      vm.$upload.reset(vm.name);
    },
    uploadClipBoard: function uploadClipBoard(e) {
      var vm = this;
      if (e.clipboardData && e.clipboardData.items) {
        var ele = e.clipboardData.items;
        for (var i = 0; i < ele.length; ++i) {
          if (ele[i].kind === 'file' && ele[i].type.indexOf('image/') !== -1) {
            var blob = ele[i].getAsFile();
            vm.$upload.reset(vm.name);
            vm.fileSubido = blob;
            vm.filename = blob.name;
            vm.update();
          }
        }
      } else {
        return;
      }
    },
    uploadFile: function uploadFile() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      if (vm.$upload.errors(vm.name).length > 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Por favor corrija los errores del archivo adjunto');
        return;
      }

      var fd = new FormData();
      fd.append('file', vm._file.$file);
      var params = {
        carpeta: vm.folder,
        usuario: localStorage.getItem('usuario')
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["f" /* apiUploadWithParams */])(vm, '/upload', fd, params, function (res) {
        vm.limpiar();
        vm.update();
        vm.$emit('save', res);
      }, function (err) {
        console.error(err);
      }, function () {
        vm.isSaving = false;
      });
    },
    close: function close() {
      var vm = this;
      vm.$emit('close');
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__c_delegaciones_mostrar_reemplazo__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__c_delegaciones_mostrar_reemplazo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__c_delegaciones_mostrar_reemplazo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topbar',
  components: {
    DelegacionesMostrarReemplazo: __WEBPACK_IMPORTED_MODULE_0__c_delegaciones_mostrar_reemplazo___default.a
  },
  data: function data() {
    return {
      sidebar: {
        opened: true,
        hidden: false
      },
      empresa: "datacont",
      empresa_full: "Datacont S.A.C.",
      showLogOutModal: false
    };
  },

  computed: {
    estoySiendoReemplazado: function estoySiendoReemplazado() {
      return this.$store.getters.estoySiendoReemplazado;
    },
    estoyReemplazando: function estoyReemplazando() {
      return this.$store.getters.estoyReemplazando;
    }
  },
  methods: {
    logout: function logout() {
      this.showLogOutModal = true;
      setTimeout(function () {
        localStorage.setItem('token', '');
        localStorage.setItem('perfilVacaciones', '');
        window.location.href = '/';
      }, 300);
    },
    test: function test() {
      var obj = {
        params: {
          token: localStorage.getItem('token')
        }
      };
      this.axios.get('/test', obj).then(function (response) {
        var data = response.data;
        data.status = +data.status | 0;
        if (data.status === -1) {
          // No se ha logueado
          alert('No esta logueado');
          localStorage.setItem('token', '');
          window.location.href = '/';
        } else if (data.status === 0) {
          // Algun error de usuario
          alert('error');
        } else {
          // Success
          alert('exito');
        }
      }).catch(function (error) {
        console.error('Error:', error);
      });
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'welcome',
  data: function data() {
    return {
      empresa: "datacont",
      empresa_full: "Datacont S.A.C."
    };
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lookups_Empleados_Multiple__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lookups_Empleados_Multiple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lookups_Empleados_Multiple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_asistentes_externos_internos_lista',
  props: ['codigoCreador', 'esReunionTerminada', 'esReunionAnulada'],
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      isSendingEliminar: false,
      disabledScrollExecute: true,
      mostrarModalAsignarEmpleado: false,
      mostrarModalAsignarAsistenteExterno: false,
      skip: 0,
      noMore: false,
      filtroAsignarEmpleado: '',
      objAux: { idReunion: this.idReunion },
      nombreCreador: localStorage.getItem('nombre'),
      cambiosAsistencia: [],
      isSaving: false,
      asistenteExterno: {
        nombreExterno: '',
        cargoExterno: ''
      }
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idReunion: function idReunion() {
      return +this.$route.params.idReunion;
    },
    baseEP: function baseEP() {
      return '/reunion/gestion/' + this.idReunion;
    },
    fetchEndpoint: function fetchEndpoint() {
      return this.baseEP + '/asistente/asignar';
    },
    asignarEmpleadosEndpoint: function asignarEmpleadosEndpoint() {
      return this.baseEP + '/asistente/asignar';
    },
    asignarTodosEndpoint: function asignarTodosEndpoint() {
      return this.baseEP + '/asistente/asignar-todos';
    },
    desasignarTodosEndpoint: function desasignarTodosEndpoint() {
      return this.baseEP + '/asistente/desasignar-todos';
    }
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a,
    'seleccionar-empleado': __WEBPACK_IMPORTED_MODULE_2__lookups_Empleados_Multiple___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    var vm = this;
    if (vm.idReunion) {
      vm.fetch();
    } else {
      vm.lista.push({ nombre: vm.nombreCreador });
    }
  },

  methods: {
    abrirModalAsignarAsistenteExterno: function abrirModalAsignarAsistenteExterno(o) {
      var vm = this;
      vm.asistenteExterno = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, o);
      vm.mostrarModalAsignarAsistenteExterno = true;
    },
    changeCheckbox: function changeCheckbox(e, row) {
      var isChecked = e.target.checked;
      var nombre = row.nombreExterno;
      this.registrarCambioAsistencia(row.codigo, nombre, isChecked);
    },
    registrarCambioAsistencia: function registrarCambioAsistencia(codigo, nombre, nuevoEstado) {
      console.log(codigo, nombre, nuevoEstado);
      var index = this.cambiosAsistencia.findIndex(function (asistente) {
        return asistente.codigo === codigo || asistente.nombre === nombre;
      });
      if (index !== -1) {
        this.cambiosAsistencia[index].asistio = nuevoEstado;
      } else {
        // this.cambiosAsistencia.push({ codigo, nombre, asistio: nuevoEstado });
        if (codigo) this.cambiosAsistencia.push({ codigo: codigo, asistio: nuevoEstado });else this.cambiosAsistencia.push({ nombre: nombre, asistio: nuevoEstado });
      }
      console.log(this.cambiosAsistencia);
    },
    closeModalAsignarEmpleado: function closeModalAsignarEmpleado() {
      this.mostrarModalAsignarEmpleado = false;
      this.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      var obj = {};
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, vm.baseEP + '/asistente', obj, function (data) {
        data.lista.forEach(function (o) {
          vm.lista.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip = data.numeroRecnum;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExecute = true;
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    abrirModalAsignarEmpleados: function abrirModalAsignarEmpleados(o) {
      var vm = this;
      if (vm.esReunionTerminada || vm.esReunionAnulada) {
        return;
      }
      if (!vm.idReunion) {
        vm.$emit('save');
        return;
      }
      if (o.externo) {
        vm.asistenteExterno = o;
        vm.mostrarModalAsignarAsistenteExterno = true;
        return;
      }
      var dni = o ? o.dni : '';
      vm.filtroAsignarEmpleado = dni;
      this.mostrarModalAsignarEmpleado = true;
    },
    guardarAsistentes: function guardarAsistentes() {
      var vm = this;
      if (!vm.esReunionTerminada) return;
      vm.isSaving = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiPut */])(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/marcar-asistencia', { asistentes: vm.cambiosAsistencia }, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha marcado la asistencia correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    guardarAsistenteExterno: function guardarAsistenteExterno() {
      var vm = this;

      if (!vm.asistenteExterno.nombreExterno) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un nombre.');
      if (!vm.asistenteExterno.cargoExterno) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un cargo.');

      if (vm.asistenteExterno && vm.asistenteExterno.id) {
        vm.actualizarAsistenteExterno();
      } else {
        vm.insertarAsistenteExterno();
      }
    },
    closeModalAsignarAsistenteExterno: function closeModalAsignarAsistenteExterno() {
      var vm = this;
      vm.mostrarModalAsignarAsistenteExterno = false;
      vm.asistenteExterno = {};
    },
    insertarAsistenteExterno: function insertarAsistenteExterno() {
      var vm = this;
      vm.isSaving = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/gestion/0/asignar/externo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.asistenteExterno), function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha insertado el asistente correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        vm.closeModalAsignarAsistenteExterno();
        vm.fetch();
      });
    },
    actualizarAsistenteExterno: function actualizarAsistenteExterno() {
      var vm = this;
      vm.isSaving = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiPut */])(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/gestion/' + vm.asistenteExterno.id + '/asignar/externo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.asistenteExterno), function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha actualizado el asistente correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        vm.closeModalAsignarAsistenteExterno();
        vm.fetch();
      });
    },
    borrarAsistenteExterno: function borrarAsistenteExterno(o) {
      var vm = this;
      vm.isSaving = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["g" /* apiDelete */])(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/gestion/' + o.id + '/asignar/externo', {}, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha borrado el asistente correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        vm.fetch();
      });
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_scroll__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Solicitud_Vacaciones__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Solicitud_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Solicitud_Vacaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import data from '../util/data'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'nueva-solicitud-vacaciones': __WEBPACK_IMPORTED_MODULE_2__Component_Solicitud_Vacaciones___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_3__Component_Confirmar_Accion_Overlay___default.a
  },
  data: function data() {
    return {
      solicitudes: [],
      solicitudSeleccionada: {},
      showClosed: false,
      isEditing: false,
      isLoading: true,
      mostrarConfirmacionEnviar: false,
      mostrarConfirmacionRechazar: false,
      isSending: false,
      screenWidth: window.innerWidth
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', function () {
      _this.screenWidth = window.innerWidth;
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    window.removeEventListener('resize', function () {
      _this2.screenWidth = window.innerWidth;
    });
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/solicitud', obj, function (data) {
        vm.solicitudes = data.lista;
        if (vm.solicitudes.length === 0) vm.$emit('close');
      }, function (error) {
        alert('error: ' + error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    enterEditMode: function enterEditMode(o) {
      var _this3 = this;

      this.solicitudSeleccionada = o;
      this.isEditing = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this3,
          ref: _this3.$refs.editarSolicitud.$el,
          mobile: 0,
          desktop: -60,
          hasPermisoSolicitud: true
        });
      });
    },
    confirmarAprobar: function confirmarAprobar(o) {
      var _this4 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionEnviar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this4,
          ref: _this4.$refs.confirmarAprobar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    confirmarRechazo: function confirmarRechazo(o) {
      var _this5 = this;

      this.solicitudSeleccionada = o;
      this.mostrarConfirmacionRechazar = true;
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_scroll__["a" /* scrollTo */])({
          vm: _this5,
          ref: _this5.$refs.confirmarRechazar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      });
    },
    aprobar: function aprobar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: vm.solicitudSeleccionada.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/vacaciones/solicitud/send', obj, function (data) {
        vm.mostrarConfirmacionEnviar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    },
    rechazar: function rechazar() {
      var vm = this;
      if (vm.isSending) return;

      vm.isSending = true;
      var obj = {
        id: this.solicitudSeleccionada.id,
        isMisSolicitudes: true
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["g" /* apiDelete */])(vm, '/vacaciones/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false;
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import data from '../util/data'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      isLoading: false
    };
  },

  methods: {
    login: function login() {
      var vm = this;
      this.isLoading = true;
      this.errorMessage = '';

      var obj = {
        username: this.username,
        password: this.password
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/login', obj, function (data) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('codigo', data.codigo);
        localStorage.setItem('email', data.email);
        localStorage.setItem('perfilVacaciones', data.perfilVacaciones);
        localStorage.setItem('nombre', data.nombre);
        localStorage.setItem('username', data.username);
        localStorage.setItem('nacimiento', data.nacimiento);
        localStorage.setItem('tokenOctopus', data.tokenOctopus);
        window.location.reload(true);
      }, function (error) {
        vm.errorMessage = error.message;
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_delegaciones_mostrar_reemplazo__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_delegaciones_mostrar_reemplazo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_delegaciones_mostrar_reemplazo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  components: {
    DelegacionesMostrarReemplazo: __WEBPACK_IMPORTED_MODULE_1__c_delegaciones_mostrar_reemplazo___default.a
  },
  data: function data() {
    return {
      perfilUsuario: localStorage.getItem('perfilVacaciones'),
      menu: [],
      isLoadingMenu: false,
      datos: {
        diasVacaciones: 0,
        nombre: '',
        documentoSinCargar: 0
      },
      show: false,
      empresa: "datacont",
      isSaliendo: false,
      pathFoto: '',
      codigoEmpleado: +localStorage.getItem('codigo')
    };
  },
  created: function created() {
    this.fetchMenu();
    this.fetchInfoUsuario();
    this.fetchFotoUsuario();
    this.fetchDocumentosSinCargar();
    this.fetchContratosSinCargar();
    this.fetchCursosSinTerminar();
  },
  beforeDestroy: function beforeDestroy() {
    this.isSaliendo = false;
  },

  computed: {
    logo: function logo() {
      return '/static/logo_' + "datacont" + '.png';
    },
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    showSidebarMobile: function showSidebarMobile() {
      return this.$store.getters.showSidebarMobile;
    },
    isUserBirthday: function isUserBirthday() {
      return this.$store.getters.isUserBirthday;
    },
    estoySiendoReemplazado: function estoySiendoReemplazado() {
      return this.$store.getters.estoySiendoReemplazado;
    },
    estoyReemplazando: function estoyReemplazando() {
      return this.$store.getters.estoyReemplazando;
    },
    documentosPorFirmar: function documentosPorFirmar() {
      return this.$store.getters.documentosPorFirmar;
    },
    contratosPorFirmar: function contratosPorFirmar() {
      return this.$store.getters.contratosPorFirmar;
    },
    cursosSinTerminar: function cursosSinTerminar() {
      return this.$store.getters.cursosSinTerminar;
    }
  },
  methods: {
    abrirDelegacion: function abrirDelegacion() {
      this.$emit('delegacion');
    },
    logout: function logout() {
      localStorage.setItem('token', '');
      localStorage.setItem('perfilVacaciones', '');
      this.isSaliendo = true;
      window.location.href = '/';
    },
    fetchCursosSinTerminar: function fetchCursosSinTerminar() {
      var vm = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/sin-terminar', {}, function (data) {
        vm.$store.dispatch('setCursosSinTerminar', data.cantidad);
      });
    },
    fetchDocumentosSinCargar: function fetchDocumentosSinCargar() {
      var vm = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
        if (data.lista.length > 0) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        }
      });
    },
    fetchContratosSinCargar: function fetchContratosSinCargar() {
      var vm = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
        if (data.lista.length > 0) {
          vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(function (a) {
            return !a.firmado;
          }).length);
        }
      });
    },
    fetchMenu: function fetchMenu() {
      var vm = this;
      this.isLoadingMenu = true;
      var obj = {
        perfilVacaciones: localStorage.getItem('perfilVacaciones'),
        username: localStorage.getItem('username')
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/usuario/menu', obj, function (data) {
        vm.menu = data.menu;
      }, function (error) {
        alert('error: ' + error.message);
      }, function () {
        vm.isLoadingMenu = false;
      });
    },
    fetchInfoUsuario: function fetchInfoUsuario() {
      var vm = this;
      var obj = {
        codigo: localStorage.getItem('codigo')
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/diasdisponibles', obj, function (data) {
        vm.datos.diasVacaciones = data.count;
        vm.datos.nombre = data.nombre;
      }, function (error) {
        alert('error: ' + error.message);
      });
    },
    fetchFotoUsuario: function fetchFotoUsuario() {
      var vm = this;
      var obj = {
        codigo: vm.codigoEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/personal/fotoPerfil', obj, function (data) {
        vm.pathFoto = data.foto;
      }, function (error) {
        alert('error: ' + error.message);
      }, function () {});
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Solicitud_Vacaciones__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Solicitud_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Solicitud_Vacaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Lista_Solicitud_Vacaciones_Component__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Lista_Solicitud_Vacaciones_Component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Lista_Solicitud_Vacaciones_Component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Lista_Vacaciones__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Lista_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Component_Lista_Vacaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vacaciones',
  components: {
    'nueva-solicitud-vacaciones': __WEBPACK_IMPORTED_MODULE_1__Component_Solicitud_Vacaciones___default.a,
    'lista-solicitud-vacaciones': __WEBPACK_IMPORTED_MODULE_2__Lista_Solicitud_Vacaciones_Component___default.a,
    'lista-vacaciones': __WEBPACK_IMPORTED_MODULE_3__Component_Lista_Vacaciones___default.a,
    'lista-libros-vacaciones': __WEBPACK_IMPORTED_MODULE_4__Component_Lista_Libros_Vacaciones___default.a
  },
  data: function data() {
    return {
      mostrarSolicitud: true,
      mostrarListaSolicitudes: true,
      mostrarListaVacaciones: true,
      mostrarListaLibrosVacaciones: true,
      mostrarMensajeDeSolicitud: false,
      empleado: {}
    };
  },

  watch: {},
  created: function created() {
    this.fetchPrivateInformation();
  },

  methods: {
    fetchPrivateInformation: function fetchPrivateInformation() {
      var vm = this;
      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/private', obj, function (data) {
        vm.empleado = data.data;

        // Vemos si mostramos o no
        if (vm.empleado.diasDisponibles < 1) {
          vm.mostrarSolicitud = false;
          vm.mostrarMensajeDeSolicitud = true;
        }
      }, function (error) {
        alert('error: ' + error.message);
      });
    },
    recargarListaSolicitudes: function recargarListaSolicitudes() {
      this.mostrarListaSolicitudes = true;
      this.$refs.listasolicitudes.fetch();
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Pendientes_Lista__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Pendientes_Lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Pendientes_Lista__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boletas-pendientes',
  components: {
    'lista-boletas-pendientes': __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Pendientes_Lista___default.a
  },
  data: function data() {
    return {
      mostrarReporteBoletasPendientes: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Reporte_Lista__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Reporte_Lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Reporte_Lista__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boletas-reportes',
  components: {
    'lista-boletas': __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Reporte_Lista___default.a
  },
  props: ['tipo'],
  data: function data() {
    return {
      mostrarReporteBoletas: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Transferidos__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Transferidos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Transferidos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_circle_progress__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_circle_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_circle_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boletas-transferidas',
  components: {
    BoletaItemTransferidos: __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Transferidos___default.a,
    VueCircle: __WEBPACK_IMPORTED_MODULE_2_vue2_circle_progress___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      boletas: [],
      isFetching: true,
      isGenerating: false,
      isExporting: false,
      boletasGeneradas: 0,
      cantidadBoletas: 0,
      fillCircle: { color: '#3a4dc7' }
    };
  },

  watch: {},
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isFetching = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/boleta/transferidas', obj, function (data) {
        vm.boletas = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isFetching = false;
      });
    },
    empezarAGenerar: function empezarAGenerar() {
      var vm = this;
      vm.boletasGeneradas = 0;
      vm.cantidadBoletas = vm.boletas.length;
      vm.isGenerating = true;
      vm.generar();
    },
    generar: function generar() {
      var vm = this;
      vm.isGenerating = true;

      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/boleta/transferidas/generar', obj, function (data) {
        if (data.noMore) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Todas las boletas generadas correctamente');
          vm.fetch();
          vm.isGenerating = false;
        } else {
          // notify(vm, 'success', 'Éxito', 'Generado correctamente boleta de ' + data.nombre)
          vm.boletasGeneradas++;
          var progresoPorcentaje = vm.boletasGeneradas / vm.cantidadBoletas * 100.0;
          vm.$refs.progressCircle.updateProgress(progresoPorcentaje);
          vm.generar();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.isGenerating = false;
      });
    },
    exportarExcel: function exportarExcel() {
      var vm = this;
      vm.isExporting = true;
      var obj = {
        unico: 'transferido'
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiGetExcel */])(vm, '/boleta/auxiliar/excel/descarga', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'transferidos_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        console.error('Error:' + error.message);
      }, function () {
        vm.isExporting = false;
      });
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Areas_Editar__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Areas_Editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Areas_Editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'administrador-funciones',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      filtro: '',
      areaSeleccionada: null,
      mostrarConfirmacionEliminar: false,
      empleadosValidados: [],
      isSending: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    shadowList: function shadowList() {
      var _this = this;

      if (!this.filtro) return this.lista;else {
        return this.lista.filter(function (o) {
          return o.nombreArea.toLowerCase().includes(_this.filtro.toLowerCase()) || o.nombreGerencia.toLowerCase().includes(_this.filtro.toLowerCase());
        });
      }
    }
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default.a,
    'gestion-areas-editar': __WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Areas_Editar___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/area', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalEditar: function openModalEditar(areaSeleccionada) {
      var vm = this;
      if (areaSeleccionada) vm.areaSeleccionada = areaSeleccionada;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.areaSeleccionada = null;
      if (refresh) vm.fetch();
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var _this2 = this;

      this.areaSeleccionada = o;
      this.mostrarConfirmacionEliminar = true;
      var contenedor = document.getElementsByClassName('contenedor')[0];
      if (window.getComputedStyle(contenedor).overflow !== 'auto') {
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_scroll__["a" /* scrollTo */])({
            vm: _this2,
            ref: _this2.$refs.confirmarEliminar.$el,
            mobile: 0,
            desktop: -400,
            hasOverlay: false
          });
        });
      }
    },
    eliminar: function eliminar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;

      var obj = { id: vm.areaSeleccionada.idArea };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/area', obj, function (data) {
        vm.mostrarConfirmacionEliminar = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Gerencias_Editar__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Gerencias_Editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Gerencias_Editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'administrador-funciones',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      filtro: '',
      gerenciaSeleccionada: null,
      mostrarConfirmacionEliminar: false,
      isSending: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    shadowList: function shadowList() {
      var _this = this;

      if (!this.filtro) return this.lista;else {
        return this.lista.filter(function (o) {
          return o.nombre.toLowerCase().includes(_this.filtro.toLowerCase());
        });
      }
    }
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default.a,
    'gestion-gerencias-editar': __WEBPACK_IMPORTED_MODULE_1__Component_Gestion_Gerencias_Editar___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/gerencia', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalEditar: function openModalEditar(gerenciaSeleccionada) {
      var vm = this;
      if (gerenciaSeleccionada) vm.gerenciaSeleccionada = gerenciaSeleccionada;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.gerenciaSeleccionada = null;
      if (refresh) vm.fetch();
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var _this2 = this;

      this.gerenciaSeleccionada = o;
      this.mostrarConfirmacionEliminar = true;
      var contenedor = document.getElementsByClassName('contenedor')[0];
      if (window.getComputedStyle(contenedor).overflow !== 'auto') {
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_scroll__["a" /* scrollTo */])({
            vm: _this2,
            ref: _this2.$refs.confirmarEliminar.$el,
            mobile: 0,
            desktop: -400,
            hasOverlay: false
          });
        });
      }
    },
    eliminar: function eliminar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;

      var obj = {
        id: vm.gerenciaSeleccionada.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/gerencia', obj, function (data) {
        vm.mostrarConfirmacionEliminar = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Por_Aprobar__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Por_Aprobar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Por_Aprobar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Lista_Equipo__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Lista_Equipo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Lista_Equipo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contratos-equipo',
  components: {
    'lista-solicitudes-por-aprobar': __WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Por_Aprobar___default.a,
    'lista-equipo-contratos': __WEBPACK_IMPORTED_MODULE_1__Component_Contratos_Lista_Equipo___default.a
  },
  data: function data() {
    return {
      mostrarListaSolicitudesPorAprobar: true,
      mostrarListaEquipo: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Aprobadas__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Aprobadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Aprobadas__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contratos-equipo',
  components: {
    'lista-solicitudes-aprobadas': __WEBPACK_IMPORTED_MODULE_0__Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Aprobadas___default.a
  },
  data: function data() {
    return {
      mostrarListaSolicitudesAprobadas: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-cumpleanios',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      lista: [],
      mes: __WEBPACK_IMPORTED_MODULE_2_moment___default()().month() + 1,
      isLoading: false,
      disabledScrollExecute: false,
      noMore: false,
      isScroll: false,
      skip: 0,
      name: 'plantilla_empleados',
      mensajeProcesoPlantilla: '',
      meses: [{ codigo: 1, descripcion: 'Enero' }, { codigo: 2, descripcion: 'Febrero' }, { codigo: 3, descripcion: 'Marzo' }, { codigo: 4, descripcion: 'Abril' }, { codigo: 5, descripcion: 'Mayo' }, { codigo: 6, descripcion: 'Junio' }, { codigo: 7, descripcion: 'Julio' }, { codigo: 8, descripcion: 'Agosto' }, { codigo: 9, descripcion: 'Septiembre' }, { codigo: 10, descripcion: 'Octubre' }, { codigo: 11, descripcion: 'Noviembre' }, { codigo: 12, descripcion: 'Diciembre' }]
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }

      var obj = {
        mes: vm.mes,
        skip: vm.skip
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/empleado/cumpleanios', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.isLoading = false;
      });
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgot-password-request',
  data: function data() {
    return {
      newPassword: '',
      repeatNewPassword: '',
      errorMessage: '',
      isLoading: false
    };
  },

  methods: {
    restablecer: function restablecer() {
      var vm = this;
      this.errorMessage = '';

      if (!vm.newPassword || !vm.repeatNewPassword) {
        vm.errorMessage = 'Ingrese la nueva contraseña dos veces';
        return;
      }

      if (vm.newPassword !== vm.repeatNewPassword) {
        vm.errorMessage = 'Las contraseñas deben ser iguales';
        return;
      }

      this.isLoading = true;

      var obj = {
        newPassword: vm.newPassword,
        dni: vm.$route.query.dni,
        resetToken: vm.$route.query.resettoken
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/forgot-password-post', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Contraseña cambiada con exito');
        setTimeout(function () {
          window.location.href = '/';
        }, 1000);
      }, function (error) {
        vm.errorMessage = error.message;
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import data from '../util/data'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgot-password-request',
  data: function data() {
    return {
      username: '',
      errorMessage: '',
      isLoading: false
    };
  },

  methods: {
    restablecer: function restablecer() {
      var vm = this;
      this.isLoading = true;
      this.errorMessage = '';

      var obj = {
        username: this.username
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/forgot-password-request', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Hemos enviado un email ' + data.email + ' con las indicaciones para restablecer la contraseña');
        // vm.username     = ''
        vm.errorMessage = '';
      }, function (error) {
        vm.errorMessage = error.message;
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Lista__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mis-boletas',
  components: {
    BoletaItemLista: __WEBPACK_IMPORTED_MODULE_0__Component_Boletas_Item_Lista___default.a
  },
  data: function data() {
    return {
      boletas: [],
      activateFrame: false,
      path: '',
      periodos: [],
      filterPeriodo: '',
      tituloFrame: '',
      isLoading: true
    };
  },

  watch: {
    filterPeriodo: function filterPeriodo(value) {
      this.fetch();
    }
  },
  created: function created() {
    this.loadPeriodos();
  },

  methods: {
    loadPeriodos: function loadPeriodos() {
      var vm = this;
      var periodoInicial = 2018;
      var periodoActual = +window.moment().format('YYYY');
      vm.filterPeriodo = periodoActual;

      while (periodoActual >= periodoInicial) {
        vm.periodos.push(periodoActual);
        periodoActual--;
      }
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        periodo: vm.filterPeriodo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/boleta/empleado', obj, function (data) {
        vm.boletas = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    verPdf: function verPdf(boleta) {
      var vm = this;
      // Obtener path enviando los datos
      vm.tituloFrame = 'Boleta de ' + boleta.nombreMes + ' ' + boleta.periodo + ' - ' + boleta.descripcionTipo;
      vm.activateFrame = true;
      var token = localStorage.getItem('token');
      // this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&codigo=' + boleta.codigo + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      this.path = "https://api-selfservice.datacont.com" + '/boleta/empleado/pdf?token=' + token + '&empresa=' + "datacont" + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo;
      // Scroll top
      // document.body.scrollTop = 0; // For Safari
      // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    cerrarFrame: function cerrarFrame() {
      this.path = '';
      this.activateFrame = false;
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Datos_Personales_Seguridad__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Datos_Personales_Seguridad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Datos_Personales_Seguridad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Datos_Personales_Consulta__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Datos_Personales_Consulta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Datos_Personales_Consulta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Datos_Personales_Editable__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Datos_Personales_Editable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Datos_Personales_Editable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Datos_Personales_Foto_Perfil__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_Datos_Personales_Foto_Perfil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Component_Datos_Personales_Foto_Perfil__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mis-datos',
  components: {
    DatosPersonalesSeguridad: __WEBPACK_IMPORTED_MODULE_0__Component_Datos_Personales_Seguridad___default.a,
    DatosPersonalesConsulta: __WEBPACK_IMPORTED_MODULE_1__Component_Datos_Personales_Consulta___default.a,
    DatosPersonalesEditable: __WEBPACK_IMPORTED_MODULE_2__Component_Datos_Personales_Editable___default.a,
    DatosPersonalesFotoPerfil: __WEBPACK_IMPORTED_MODULE_3__Component_Datos_Personales_Foto_Perfil___default.a
  },
  data: function data() {
    return {
      mostrarDatosSeguridad: true,
      mostrarDatosConsulta: true,
      mostrarDatosEditable: true,
      mostrarDatosFotoPerfil: true,
      username: localStorage.getItem('username')
    };
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mis-funciones',
  data: function data() {
    return {
      path: '',
      isLoading: true,
      lista: []
    };
  },

  watch: {},
  created: function created() {
    this.obtenerFuncion();
  },

  methods: {
    obtenerFuncion: function obtenerFuncion() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        empresa: "datacont",
        codigo: localStorage.getItem('codigo')
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/funciones_pdf/obtener/funcion', obj, function (data) {
        if (data.lista.length === 1) {
          vm.path = data.lista[0].pathPdf;
          if (!vm.path.startsWith('http')) {
            vm.path = "https://api-selfservice.datacont.com" + '/funciones_pdf/mostrarPath?ruta=' + vm.path;
          }
        } else {
          for (var i = 0; i < data.lista.length; i++) {
            if (+data.lista[i].codigo === +localStorage.getItem('codigo')) data.lista[i].isme = true;else data.lista[i].isme = false;
            vm.lista.push(data.lista[i]);
          }
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    verAdjunto: function verAdjunto(pdf) {
      var url = "https://api-selfservice.datacont.com" + '/funciones_pdf/mostrarPath?ruta=' + pdf;
      window.open(url, '_blank');
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'permisos-excepcion',
  components: {
    'nueva-solicitud-vacaciones': __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud___default.a
  },
  data: function data() {
    return {
      mostrarSolicitud: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'permisos-equipo',
  components: {
    'lista-solicitud-permisos-por-aprobar': __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar___default.a
  },
  data: function data() {
    return {
      mostrarListaSolicitudesPorAprobar: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Lista_Solicitud__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Lista_Solicitud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Lista_Solicitud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Lista_Mis_Permisos__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Lista_Mis_Permisos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Lista_Mis_Permisos__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { apiGet } from '../util/general'



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vacaciones',
  components: {
    'nueva-solicitud-permiso': __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Solicitud___default.a,
    'lista-solicitud-permiso': __WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Lista_Solicitud___default.a,
    'lista-mis-permisos': __WEBPACK_IMPORTED_MODULE_2__Component_Permisos_Lista_Mis_Permisos___default.a
  },
  data: function data() {
    return {
      mostrarSolicitud: true,
      mostrarListaSolicitudes: true,
      mostrarListaMisPermisos: true,
      empleado: {}
    };
  },

  watch: {},
  created: function created() {},

  methods: {
    recargarListaSolicitudes: function recargarListaSolicitudes() {
      this.mostrarListaSolicitudes = true;
      this.$refs.listasolicitudes.fetch();
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar_RRHH__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar_RRHH___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar_RRHH__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'permisos-equipo',
  components: {
    'lista-solicitud-permisos-por-aprobar': __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Lista_Solicitudes_Por_Aprobar_RRHH___default.a
  },
  data: function data() {
    return {
      mostrarListaSolicitudesPorAprobar: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Reporte_Solicitud__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Reporte_Solicitud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Reporte_Solicitud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Reporte__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Reporte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Reporte__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'permisos-reportes',
  components: {
    'lista-solicitud-permisos': __WEBPACK_IMPORTED_MODULE_0__Component_Permisos_Reporte_Solicitud___default.a,
    'lista-permisos': __WEBPACK_IMPORTED_MODULE_1__Component_Permisos_Reporte___default.a
  },
  props: ['tipo'],
  data: function data() {
    return {
      mostrarListaSolicitudes: false,
      mostrarListaPermisos: false
    };
  },

  watch: {
    tipo: function tipo(value) {
      return this.rerun();
    }
  },
  created: function created() {
    this.rerun();
  },

  methods: {
    rerun: function rerun() {
      if (this.tipo === 'solicitud') {
        this.mostrarListaSolicitudes = true;
        this.mostrarListaPermisos = false;
      } else if (this.tipo === 'permisos') {
        this.mostrarListaSolicitudes = false;
        this.mostrarListaPermisos = true;
      }
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lista_Solicitud_Vacaciones_Por_Aprobar__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Lista_Solicitud_Vacaciones_Por_Aprobar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Lista_Solicitud_Vacaciones_Por_Aprobar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lista_Equipo_Vacaciones__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lista_Equipo_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Lista_Equipo_Vacaciones__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vacaciones-equipo',
  components: {
    'lista-solicitud-vacaciones-por-aprobar': __WEBPACK_IMPORTED_MODULE_0__Component_Lista_Solicitud_Vacaciones_Por_Aprobar___default.a,
    'lista-equipo-vacaciones': __WEBPACK_IMPORTED_MODULE_1__Component_Lista_Equipo_Vacaciones___default.a
  },
  data: function data() {
    return {
      mostrarListaSolicitudesPorAprobar: true,
      mostrarListaEquipoVacaciones: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Solicitud_Vacaciones__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Solicitud_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Solicitud_Vacaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Cambio_Dias_Vacaciones__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Cambio_Dias_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Cambio_Dias_Vacaciones__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vacaciones',
  components: {
    'nueva-solicitud-vacaciones': __WEBPACK_IMPORTED_MODULE_0__Component_Solicitud_Vacaciones___default.a,
    'cambio-dias-vacaciones': __WEBPACK_IMPORTED_MODULE_1__Component_Cambio_Dias_Vacaciones___default.a
  },
  data: function data() {
    return {
      mostrarSolicitud: true,
      mostrarCambioDias: true
    };
  },

  watch: {},
  created: function created() {},

  methods: {}
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Reporte_Lista_Solicitud_Vacaciones__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Reporte_Lista_Solicitud_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Reporte_Lista_Solicitud_Vacaciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Reporte_Lista_Empleados_Vacaciones__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Reporte_Lista_Empleados_Vacaciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Reporte_Lista_Empleados_Vacaciones__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vacaciones-reportes',
  components: {
    'lista-solicitud-vacaciones': __WEBPACK_IMPORTED_MODULE_0__Component_Reporte_Lista_Solicitud_Vacaciones___default.a,
    'lista-empleados-vacaciones': __WEBPACK_IMPORTED_MODULE_1__Component_Reporte_Lista_Empleados_Vacaciones___default.a
  },
  props: ['tipo'],
  data: function data() {
    return {
      mostrarListaSolicitudes: false,
      mostrarListaEmpleados: false
    };
  },

  watch: {
    tipo: function tipo(value) {
      return this.rerun();
    }
  },
  created: function created() {
    this.rerun();
  },

  methods: {
    rerun: function rerun() {
      if (this.tipo === 'solicitud') {
        this.mostrarListaSolicitudes = true;
        this.mostrarListaEmpleados = false;
      } else if (this.tipo === 'empleado') {
        this.mostrarListaSolicitudes = false;
        this.mostrarListaEmpleados = true;
      }
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lookups_Empleados_Multiple__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lookups_Empleados_Multiple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lookups_Empleados_Multiple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_alumnos_lista',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      isSendingEliminar: false,
      disabledScrollExecute: true,
      mostrarModalAsignarEmpleado: false,
      skip: 0,
      noMore: false,
      filtroAsignarEmpleado: '',
      objAux: { idCurso: this.idCurso }
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.id;
    },
    idClase: function idClase() {
      return +this.$route.params.idClase;
    },
    baseEP: function baseEP() {
      return '/curso/gestion/' + this.idCurso;
    },
    fetchEndpoint: function fetchEndpoint() {
      return this.baseEP + '/alumno/asignar';
    },
    asignarEmpleadosEndpoint: function asignarEmpleadosEndpoint() {
      return this.baseEP + '/alumno/asignar';
    },
    asignarTodosEndpoint: function asignarTodosEndpoint() {
      return this.baseEP + '/alumno/asignar/todos';
    },
    desasignarTodosEndpoint: function desasignarTodosEndpoint() {
      return this.baseEP + '/alumno/desasignar/todos';
    }
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__Component_Confirmar_Accion_Overlay___default.a,
    'seleccionar-empleado': __WEBPACK_IMPORTED_MODULE_1__lookups_Empleados_Multiple___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    var vm = this;
    if (vm.idCurso) {
      vm.fetch();
    }
  },

  methods: {
    closeModalAsignarEmpleado: function closeModalAsignarEmpleado() {
      this.mostrarModalAsignarEmpleado = false;
      this.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      var obj = {};
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, vm.baseEP + '/alumno', obj, function (data) {
        data.lista.forEach(function (o) {
          vm.lista.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip = data.numeroRecnum;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExecute = true;
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    abrirModalAsignarEmpleados: function abrirModalAsignarEmpleados(dni) {
      var vm = this;
      if (!vm.idCurso) {
        vm.$emit('save');
        return;
      }
      vm.filtroAsignarEmpleado = dni;
      this.mostrarModalAsignarEmpleado = true;
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cursos-virtuales-clase-lista',
  data: function data() {
    return {
      lista: [], // Lista de cursos
      isLoading: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.idCurso;
    }
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/lista/' + vm.idCurso + '/clase', { modulo: 'alumno' }, function (data) {
        vm.lista = data.lista;
        console.log('data.lista >>>', data.lista);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    verClase: function verClase(id, estado) {
      var vm = this;
      vm.$router.push('/mis-cursos/' + vm.idCurso + '/clases/' + id);
    },
    continuarCurso: function continuarCurso(id) {},
    volverIniciarCurso: function volverIniciarCurso(id) {}
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cursos-virtuales-lista',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      isScroll: false,
      numeroRecnum: 0,
      noMore: false,
      disabledScrollExcecute: true
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.numeroRecnum = 0;
      }
      vm.disabledScrollExcecute = true;
      vm.noMore = false;

      var obj = {
        numeroRecnum: vm.numeroRecnum
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/lista', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExcecute = false;
        }
      }, function (error) {
        vm.disabledScrollExcecute = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.isLoading = false;
      });
    },
    iniciarCurso: function iniciarCurso(id) {
      var vm = this;
      vm.verCurso(id).then(function () {
        vm.$router.push('/mis-cursos/' + id + '/clases');
      });
    },
    verCurso: function verCurso(id) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var vm = _this;
        vm.isLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/curso/virtual/alumno/lista/' + id + '/ver-curso', {}, function (data) {
          resolve(null);
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          reject(error);
        }, function () {
          vm.isLoading = false;
        });
      });
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cursos-virtuales-lista',
  data: function data() {
    return {
      isLoading: false,
      iframe: '',
      idYT: '',
      estado: '',
      esUltimaClase: false,
      idClaseSiguiente: '',
      titulo: '',
      descripcion: ''
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.idCurso;
    },
    idClase: function idClase() {
      return +this.$route.params.idClase;
    }
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    convertirSaltosDeLinea: function convertirSaltosDeLinea(texto) {
      return texto ? texto.replace(/\n/g, '<br>') : '';
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/lista/' + vm.idCurso + '/clase/lista/' + vm.idClase, { modulo: 'alumno' }, function (data) {
        vm.idYT = data.clase.idYT;
        vm.esUltimaClase = data.esUltimaClase;
        vm.estado = data.clase.estado;
        vm.titulo = data.clase.titulo;
        vm.descripcion = data.clase.descripcion;
        if (vm.idYT) vm.getIframe();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.$emit('volver');
      }, function () {
        vm.isLoading = false;
      });
    },
    getIframe: function getIframe() {
      var iframe = '\n        <iframe\n        style="height:350px; width:100%; border-radius:7px"\n        src="https://www.youtube.com/embed/' + this.idYT + '?feature=oembed"\n        frameborder="0"\n        allow="accelerometer;\n        autoplay;\n        clipboard-write;\n        encrypted-media;\n        gyroscope;\n        picture-in-picture;\n        web-share"\n        referrerpolicy="strict-origin-when-cross-origin"\n        allowfullscreen\n        title="C\xF3mo no mejorar tu salario como programador">\n        </iframe>\n      ';
      this.iframe = iframe;
    },
    acabarClase: function acabarClase() {
      var vm = this;
      var obj = {};
      if (!vm.esUltimaClase) obj.obtenerSiguienteClase = true;
      vm.terminarClase(obj).then(function () {
        if (!vm.esUltimaClase && !vm.idClaseSiguiente) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'No se encontró la siguiente clase');
        } else if (vm.idClaseSiguiente) {
          vm.$router.push('/mis-cursos/' + vm.idCurso + '/clases/' + vm.idClaseSiguiente);
        }
        vm.fetch();
        vm.$emit('cfetch');
      }).finally(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/sin-terminar', {}, function (data) {
          vm.$store.dispatch('setCursosSinTerminar', data.cantidad);
        });
      });
    },
    terminarClase: function terminarClase(obj) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var vm = _this;
        vm.isLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["d" /* apiPut */])(vm, '/curso/virtual/alumno/lista/' + vm.idCurso + '/clase/lista/' + vm.idClase + '/terminar', obj, function (data) {
          if (!obj.obtenerSiguienteClase && data.status === 1) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha terminado la clase');
          }
          vm.idClaseSiguiente = data.idClaseSiguiente;
          resolve(null);
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          reject(error);
        }, function () {
          vm.isLoading = false;
        });
      });
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_delegaciones_mostrar_reemplazo',
  props: ['isMobile'],
  data: function data() {
    return {
      showPopup: false,
      badgeHeight: 0,
      mostrarInactivarDelegación: false,
      isLoading: false
    };
  },

  computed: {
    estoySiendoReemplazado: function estoySiendoReemplazado() {
      return this.$store.getters.estoySiendoReemplazado;
    },
    estoyReemplazando: function estoyReemplazando() {
      return this.$store.getters.estoyReemplazando;
    },
    nombreReemplazo: function nombreReemplazo() {
      return this.$store.getters.nombreReemplazo;
    },
    nombreReemplazoTrim: function nombreReemplazoTrim() {
      return this.nombreReemplazo.substring(0, 13) + '...';
    },
    fechaInicio: function fechaInicio() {
      return this.$store.getters.fechaInicio;
    },
    fechaFin: function fechaFin() {
      return this.$store.getters.fechaFin;
    },
    id: function id() {
      return this.$store.getters.id;
    },
    codigoEmpleadoOrigen: function codigoEmpleadoOrigen() {
      return this.$store.getters.codigoEmpleadoOrigen;
    },
    codigoEmpleadoReemplazante: function codigoEmpleadoReemplazante() {
      return this.$store.getters.codigoEmpleadoReemplazante;
    },
    fechaInicioFormat: function fechaInicioFormat() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.fechaInicio).format('DD/MM/YYYY');
    },
    fechaFinFormat: function fechaFinFormat() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.fechaFin).format('DD/MM/YYYY');
    }
  },
  mounted: function mounted() {
    var vm = this;
    var node = document.querySelectorAll('.badge-delegacion.is-in-mobile');
    if (node && node.length > 0) {
      var height = node[0].clientHeight;
      vm.badgeHeight = height;
    }
  },

  methods: {
    inactivar: function inactivar() {
      var vm = this;
      var obj = {
        fechaInicio: vm.fechaInicio,
        fechaFin: vm.fechaFin,
        codigoEmpleadoOrigen: vm.codigoEmpleadoOrigen,
        codigoEmpleadoReemplazante: vm.codigoEmpleadoReemplazante,
        activo: 0,
        id: vm.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/delegaciones', obj, function (data) {
        vm.$store.dispatch('setEstoyReemplazando', false);
        vm.$store.dispatch('setEstoySiendoReemplazado', false);
        vm.$store.dispatch('setNombreReemplazo', '');
        vm.$store.dispatch('setFechaInicio', '');
        vm.$store.dispatch('setFechaFin', '');
        vm.$store.dispatch('setId', 0);
        vm.$store.dispatch('setCodigoEmpleadoOrigen', 0);
        vm.$store.dispatch('setCodigoEmpleadoReemplazante', 0);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Inactivado correctamente');
        window.location.reload();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    away: function away() {
      this.showPopup = false;
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Seleccionar_Empleado__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Seleccionar_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Seleccionar_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Upload_Image__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'documentos_firmar_editar',
  components: {
    'seleccionar-empleado': __WEBPACK_IMPORTED_MODULE_1__Component_Seleccionar_Empleado___default.a,
    'upload-image': __WEBPACK_IMPORTED_MODULE_2__Component_Upload_Image___default.a
  },
  props: ['id'],
  data: function data() {
    return {
      orden: 100,
      descripcion: '',
      activo: true,
      ruta: '',
      isSaving: false,
      mostrarModalAdjuntar: false,
      isLoading: false,
      mostrarModalSeleccionarEmpleado: false,
      initialSelectedEmployees: []
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.id) {
      vm.fetch();
    }
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        id: vm.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/unico/', obj, function (data) {
        vm.orden = data.data.orden;
        vm.descripcion = data.data.descripcion;
        vm.activo = data.data.activo;
        vm.ruta = data.data.rutaSinLlenar;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardar: function guardar() {
      var openAsignarEmpleado = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        orden: vm.orden,
        descripcion: vm.descripcion,
        activo: vm.activo,
        ruta: vm.ruta
      };

      if (vm.id) {
        obj.id = vm.id;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/documentos-firmar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        if (openAsignarEmpleado) {
          // vm.id = data.insertedId
          vm.$emit('changeId', data.insertedId);
          vm.$nextTick(function () {
            vm.$emit('refresh');
            vm.openModalSeleccionarEmpleado();
          });
        } else {
          vm.$emit('closeRefresh');
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      vm.closeModalAdjuntar();
      vm.ruta = fileSubido.file.ruta;
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    emitClose: function emitClose() {
      this.$emit('close');
    },
    openModalSeleccionarEmpleado: function openModalSeleccionarEmpleado() {
      var vm = this;
      if (vm.id) {
        this.mostrarModalSeleccionarEmpleado = true;
        return;
      }
      vm.guardar(true);
    },
    closeModalSeleccionarEmpleado: function closeModalSeleccionarEmpleado() {
      this.mostrarModalSeleccionarEmpleado = false;
    },
    guardarSeleccion: function guardarSeleccion(data) {
      this.initialSelectedEmployees = data.codigos;
      this.closeModalSeleccionarEmpleado();
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_evaluaciones_lista',
  props: {
    type: {
      type: String,
      required: true
    },
    modulo: {
      type: String,
      required: false,
      default: 'gestion'
    },
    fetchURL: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      id: '',
      titulo: '',
      descripcion: '',
      link: '',
      showModalEditar: false,
      isSaving: false,
      mostrarConfirmacionEliminar: false,
      confirmacionEliminarId: '',
      confirmacionEliminarTitulo: '',
      confirmacionEliminarDescripcion: '',
      isSendingEliminar: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.id || +this.$route.params.idCurso;
    },
    idClase: function idClase() {
      return +this.$route.params.idClase;
    },
    baseURL: function baseURL() {
      return '/curso/gestion/' + this.idCurso + '/clase/' + this.idClase + '/evaluacion';
    }
  },
  components: {
    'upload-image': __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    var vm = this;
    if (vm.type === 'curso' && vm.idCurso || vm.type === 'clase' && vm.idClase) {
      vm.fetch();
    }
  },

  methods: {
    convertirSaltosDeLinea: function convertirSaltosDeLinea(texto) {
      return texto ? texto.replace(/\n/g, '<br>') : '';
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var vm = this;
      vm.confirmacionEliminarId = o.id;
      vm.confirmacionEliminarTitulo = 'Eliminar material';
      vm.confirmacionEliminarDescripcion = '¿Estás seguro de eliminar la evaluacion ' + o.titulo + '?';

      vm.mostrarConfirmacionEliminar = true;
    },
    eliminar: function eliminar() {
      var vm = this;
      vm.isSendingEliminar = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["g" /* apiDelete */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/evaluacion/' + vm.confirmacionEliminarId, {}, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Evaluación eliminado con éxito.');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSendingEliminar = false;
        vm.mostrarConfirmacionEliminar = false;
        vm.fetch();
      });
    },
    setear: function setear(obj) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this, obj);
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, vm.fetchURL || vm.baseURL, { tipo: vm.type, modulo: vm.modulo }, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        if (vm.lista.length === 0) {
          vm.$emit('close');
        }
      });
    },
    fetchEvaluacion: function fetchEvaluacion() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/evaluacion/' + vm.id, { tipo: vm.type }, function (data) {
        vm.setear(data.evaluacion);
        vm.showModalEditar = true;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    abrirModalEditar: function abrirModalEditar(idEvaluacion) {
      var vm = this;
      if (vm.modulo === 'alumno') return;
      if (vm.type === 'curso' && !vm.idCurso || vm.type === 'clase' && !vm.idClase) {
        vm.closeModalAdd();
        vm.$emit('save');
        return;
      }
      if (idEvaluacion) {
        vm.id = idEvaluacion;
        vm.fetchEvaluacion();
      } else {
        vm.showModalEditar = true;
      }
    },
    closeModalAdd: function closeModalAdd() {
      this.showModalEditar = false;
      this.limpiarDatos();
    },
    isFormsURL: function isFormsURL(url) {
      // Expresión regular para verificar si la URL es de un formulario de Google Forms, con o sin parámetros
      // const regex = /^https:\/\/docs\.google\.com\/forms\/d\/e\/forms\.gle\/[a-zA-Z0-9_-]+\/viewform(\?.*)?$/;
      // const regex = /^https:\/\/(?:forms\.gle\/[a-zA-Z0-9]{17}|docs\.google\.com\/forms\/d\/e\/[a-zA-Z0-9_-]+\/viewform(\?.*))$/;
      // const regex = /^https:\/\/(?:forms\.gle\/[a-zA-Z0-9_-]+|docs\.google\.com\/forms\/d\/e\/[a-zA-Z0-9_-]+\/viewform(?:\?.*)?|forms\.office\.com\/Pages\/ResponsePage\.aspx\?.+)$/;
      var regex = /^https:\/\/(?:forms\.gle\/[a-zA-Z0-9_-]+|docs\.google\.com\/forms\/d\/e\/[a-zA-Z0-9_-]+\/viewform(?:\?.*)?|forms\.office\.com\/Pages\/ResponsePage\.aspx\?.+|forms\.cloud\.microsoft\/r\/[a-zA-Z0-9_-]+)$/;
      return regex.test(url);
    },
    guardar: function guardar() {
      if (!this.titulo) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(this, 'error', 'Error', 'Escribir un titulo.');
      if (!this.isFormsURL(this.link)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(this, 'error', 'Error', 'El link de la evaluacion no tiene el formato correcto.');
      if (this.id) {
        this.actualizar();
      } else {
        this.insertar();
      }
    },
    insertar: function insertar() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        link: vm.link,
        tipo: vm.type
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/evaluacion/0', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Creado correctamente');
        vm.fetch();
        vm.limpiarDatos();
        vm.showModalEditar = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    actualizar: function actualizar() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        link: vm.link,
        idCurso: vm.idCurso,
        tipo: vm.type
      };

      if (vm.idClase) obj.idClase = vm.idClase;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiPut */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/evaluacion/' + vm.id, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Actualizado correctamente');
        vm.fetch();
        vm.limpiarDatos();
        vm.showModalEditar = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    limpiarDatos: function limpiarDatos() {
      var vm = this;
      vm.id = '';
      vm.titulo = '';
      vm.descripcion = '';
      vm.link = '';
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-boletas-tipo-editar',
  props: ['codigo'],
  data: function data() {
    return {
      descripcion: '',
      isSaving: false,
      isLoading: false
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.codigo) {
      vm.fetch();
    }
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        codigo: vm.codigo
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/boleta/tipos', obj, function (data) {
        vm.codigo = data.lista[0].codigo;
        vm.descripcion = data.lista[0].descripcion;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardar: function guardar() {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {};
      if (vm.codigo) {
        obj.codigo = vm.codigo;
      }
      if (!vm.descripcion) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar una descripción');
        vm.isSaving = false;
        return;
      }
      obj.descripcion = vm.descripcion;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/boleta/tipos', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-cursos-virtuales-lista',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      idSeleccionado: null,
      confirmacionEliminarId: '',
      confirmacionEliminarTitulo: '',
      confirmacionEliminarDescripcion: '',
      mostrarConfirmacionEliminar: false,
      isSendingEliminar: ''
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  mounted: function mounted() {
    this.fetch();
  },

  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay___default.a
  },
  methods: {
    confirmarEliminar: function confirmarEliminar(o) {
      var vm = this;
      vm.confirmacionEliminarId = o.id;
      vm.confirmacionEliminarTitulo = 'Eliminar curso';
      vm.confirmacionEliminarDescripcion = 'Al eliminar el curso, eliminara a los alumnos y sus notas.';

      vm.mostrarConfirmacionEliminar = true;
    },
    eliminar: function eliminar() {
      var vm = this;
      vm.isSendingEliminar = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, '/curso/gestion/' + vm.confirmacionEliminarId, {}, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Curso eliminado con éxito.');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSendingEliminar = false;
        vm.mostrarConfirmacionEliminar = false;
        vm.fetch();
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/curso', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    redirigir: function redirigir(id) {
      var objPush = { path: '/gestion-cursos/' + id };
      this.$router.push(objPush);
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'delegaciones-rrhh-guardar',
  components: {
    'lookup-small-empleado': __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado_vue___default.a
  },
  props: {
    info: {
      type: Object,
      required: false
    },
    isCreatingSelf: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      id: 0,
      fechaInicio: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
      fechaFin: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
      codigoEmpleadoOrigen: 0,
      codigoEmpleadoReemplazante: 0,
      activo: true,
      mostrarBusquedaEmpleadoOrigen: false,
      mostrarBusquedaEmpleadoReemplazante: false,
      isSaving: false,
      isLoading: false,
      codigoEmpleado: localStorage.getItem('codigo'),
      perfil: localStorage.getItem('perfilVacaciones')
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.info).length) {
      this.isLoading = true;
      var data = ['id', 'fechaInicio', 'fechaFin', 'codigoEmpleadoOrigen', 'codigoEmpleadoReemplazante', 'activo'];
      data.forEach(function (d) {
        _this[d] = _this.info[d];
      });
      this.isLoading = false;
    }
  },

  methods: {
    guardar: function guardar() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      var obj = {
        fechaInicio: vm.fechaInicio,
        fechaFin: vm.fechaFin,
        codigoEmpleadoOrigen: vm.codigoEmpleadoOrigen,
        codigoEmpleadoReemplazante: vm.codigoEmpleadoReemplazante,
        activo: 1
      };
      if (vm.id) {
        obj.id = vm.id;
      }
      if (vm.isCreatingSelf) {
        obj.codigoEmpleadoOrigen = vm.codigoEmpleado;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/delegaciones', obj, function (data) {
        if (vm.activo) {
          if (data.estoyReemplazando) {
            vm.$store.dispatch('setEstoyReemplazando', true);
            vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo);
          } else if (data.estoySiendoReemplazado) {
            vm.$store.dispatch('setEstoySiendoReemplazado', true);
            vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo);
          }
        } else if ((data.estoyReemplazando || data.estoySiendoReemplazado) && !vm.activo) {
          vm.$store.dispatch('setEstoyReemplazando', false);
          vm.$store.dispatch('setEstoySiendoReemplazado', false);
          vm.$store.dispatch('setNombreReemplazo', '');
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        if (vm.id && vm.perfil === 'recursos humanos' && (+vm.codigoEmpleadoOrigen === +vm.codigoEmpleado || +vm.codigoEmpleadoReemplazante === +vm.codigoEmpleado || +vm.info.codigoEmpleadoOrigen === +vm.codigoEmpleado || +vm.info.codigoEmpleadoReemplazante === +vm.codigoEmpleado)) {
          window.location.reload();
          return;
        }

        if (!vm.id && vm.perfil === 'recursos humanos' && (+vm.codigoEmpleadoOrigen === +vm.codigoEmpleado || +vm.codigoEmpleadoReemplazante === +vm.codigoEmpleado)) {
          window.location.reload();
          return;
        }

        if (vm.isCreatingSelf) {
          window.location.reload();
        }
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    seleccionarEmpleadoOrigen: function seleccionarEmpleadoOrigen(o) {
      this.codigoEmpleadoOrigen = o.codigo;
    },
    seleccionarEmpleadoReemplazante: function seleccionarEmpleadoReemplazante(o) {
      this.codigoEmpleadoReemplazante = o.codigo;
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'solicitud_vacaciones_component',
  components: {
    'upload-image': __WEBPACK_IMPORTED_MODULE_1__Component_Upload_Image___default.a
  },
  props: ['id'],
  data: function data() {
    return {
      orden: 100,
      descripcion: '',
      activo: true,
      ruta: '',
      isSaving: false,
      mostrarModalAdjuntar: false,
      isLoading: false,
      fechaVencimiento: ''
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.id) {
      vm.fetch();
    }
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        id: vm.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-importantes/' + vm.id, obj, function (data) {
        vm.orden = data.data.orden;
        vm.descripcion = data.data.descripcion;
        vm.activo = data.data.activo;
        vm.ruta = data.data.ruta;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardar: function guardar() {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        orden: vm.orden,
        descripcion: vm.descripcion,
        activo: vm.activo,
        ruta: vm.ruta
      };

      if (vm.id) {
        obj.id = vm.id;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/documentos-importantes', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.codigoEmpleado = o.codigo;
      this.empleadoExcepcion = {};
      this.asignarEmpleadoExcepcion();
    },
    asignarEmpleadoExcepcion: function asignarEmpleadoExcepcion() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/vacaciones/empleado/uno/' + this.codigoEmpleado, obj, function (data) {
        vm.empleadoExcepcion = data.data;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      vm.closeModalAdjuntar();
      vm.ruta = fileSubido.file.ruta;
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_gestion_links_importantes_editar',
  props: ['id'],
  data: function data() {
    return {
      orden: 100,
      descripcion: '',
      activo: true,
      ruta: '',
      isSaving: false,
      isLoading: false
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.id) {
      vm.fetch();
    }
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        id: vm.id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/links-importantes/' + vm.id, obj, function (data) {
        vm.orden = data.data.orden;
        vm.descripcion = data.data.descripcion;
        vm.activo = data.data.activo;
        vm.ruta = data.data.ruta;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardar: function guardar() {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        orden: vm.orden,
        descripcion: vm.descripcion,
        activo: vm.activo,
        ruta: vm.ruta
      };

      if (vm.id) {
        obj.id = vm.id;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/links-importantes', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.$emit('closeRefresh');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sala_editar',
  props: ['sala'],
  data: function data() {
    return {
      isSaving: false,
      titulo: '',
      descripcion: '',
      id: '',
      activo: 1
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.sala) {
      vm.titulo = vm.sala.titulo;
      vm.id = +vm.sala.id;
      vm.descripcion = vm.sala.descripcion;
      vm.activo = vm.sala.activo;
    }
  },

  methods: {
    guardar: function guardar() {
      var vm = this;
      // validacion titulo
      if (!vm.titulo) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un título.');
      if (vm.isSaving) return;
      vm.isSaving = true;
      var obj = {
        idSala: vm.id,
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        activo: vm.activo
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (vm.id) {
          return vm.actualizar(vm, obj);
        } else {
          return vm.insertar(vm, obj);
        }
      }).then(function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.$emit('closeRefresh');
      }).catch(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    insertar: function insertar(vm, obj) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, '/reunion/sala/gestion', obj, function (data) {
          resolve(data);
        }, function (error) {
          reject(error);
        }, function () {
          vm.isSaving = false;
        });
      });
    },
    actualizar: function actualizar(vm, obj) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["d" /* apiPut */])(vm, '/reunion/sala/gestion', obj, function (data) {
          resolve(data);
        }, function (error) {
          reject(error);
        }, function () {
          vm.isSaving = false;
        });
      });
    },
    closeModalAdd: function closeModalAdd() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_materiales_lista',
  props: {
    type: {
      type: String,
      required: true
    },
    modulo: {
      type: String,
      required: false,
      default: 'gestion'
    },
    fetchURL: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      localPath: '',
      id: '',
      titulo: '',
      descripcion: '',
      pathDoc: '',
      extension: '',
      showModalEditar: false,
      mostrarModalAdjuntar: false,
      isSaving: false,
      mostrarConfirmacionEliminar: false,
      icons: {
        pdf: { i: 'fa-file-pdf-o', bg: 'is-danger' },
        doc: { i: 'fa-file-word-o', bg: 'is-primary' },
        docx: { i: 'fa-file-word-o', bg: 'is-primary' },
        xls: { i: 'fa-file-excel-o', bg: 'is-success' },
        xlsx: { i: 'fa-file-excel-o', bg: 'is-success' },
        jpg: { i: 'fa-file-image-o', bg: 'is-warning' },
        jpeg: { i: 'fa-file-image-o', bg: 'is-warning' },
        png: { i: 'fa-file-image-o', bg: 'is-warning' },
        gif: { i: 'fa-file-image-o', bg: 'is-warning' },
        bmp: { i: 'fa-file-image-o', bg: 'is-warning' },
        tiff: { i: 'fa-file-image-o', bg: 'is-warning' },
        mp4: { i: 'fa-file-video-o', bg: 'is-link' },
        avi: { i: 'fa-file-video-o', bg: 'is-link' },
        mov: { i: 'fa-file-video-o', bg: 'is-link' },
        wmv: { i: 'fa-file-video-o', bg: 'is-link' },
        mp3: { i: 'fa-file-audio-o', bg: 'is-info' },
        wav: { i: 'fa-file-audio-o', bg: 'is-info' },
        ogg: { i: 'fa-file-audio-o', bg: 'is-info' },
        flac: { i: 'fa-file-audio-o', bg: 'is-info' },
        zip: { i: 'fa-file-archive-o', bg: 'is-dark' },
        rar: { i: 'fa-file-archive-o', bg: 'is-dark' },
        '7z': { i: 'fa-file-archive-o', bg: 'is-dark' },
        tar: { i: 'fa-file-archive-o', bg: 'is-dark' },
        gz: { i: 'fa-file-archive-o', bg: 'is-dark' }
      },
      isSendingEliminar: false,
      confirmacionEliminarId: '',
      confirmacionEliminarTitulo: '',
      confirmacionEliminarDescripcion: ''
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.id || +this.$route.params.idCurso;
    },
    idClase: function idClase() {
      return +this.$route.params.idClase;
    },
    baseURL: function baseURL() {
      return '/curso/gestion/' + this.idCurso + '/clase/' + this.idClase + '/material';
    }
  },
  components: {
    'upload-image': __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    var vm = this;
    if (vm.type === 'curso' && vm.idCurso || vm.type === 'clase' && vm.idClase) {
      vm.fetch();
    }
  },

  methods: {
    convertirSaltosDeLinea: function convertirSaltosDeLinea(texto) {
      return texto ? texto.replace(/\n/g, '<br>') : '';
    },
    getFileIcon: function getFileIcon(extension) {
      // Devuelve el ícono si existe en el objeto `icons`, de lo contrario un valor por defecto
      return this.icons[extension] || { i: 'fa-download', bg: 'is-primary' };
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var vm = this;
      vm.confirmacionEliminarId = o.id;
      vm.confirmacionEliminarTitulo = 'Eliminar material';
      vm.confirmacionEliminarDescripcion = '¿Estás seguro de eliminar el material ' + o.titulo + '?';

      vm.mostrarConfirmacionEliminar = true;
    },
    eliminar: function eliminar() {
      var vm = this;
      var url = '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/material/' + vm.confirmacionEliminarId;
      vm.isSendingEliminar = true;
      console.log('url :>> ', url);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["g" /* apiDelete */])(vm, url, {}, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Material eliminado con éxito.');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSendingEliminar = false;
        vm.mostrarConfirmacionEliminar = false;
        vm.fetch();
      });
    },
    setear: function setear(obj) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this, obj);
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, vm.fetchURL || vm.baseURL, { tipo: vm.type, modulo: vm.modulo }, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        if (vm.lista.length === 0) vm.$emit('close');
      });
    },
    fetchMaterial: function fetchMaterial(showModalEditar) {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/material/' + vm.id, { tipo: vm.type }, function (data) {
        vm.setear(data.material);
        if (showModalEditar) vm.showModalEditar = true;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      vm.closeModalAdjuntar();
      vm.pathDoc = fileSubido.file.ruta;
      vm.extension = fileSubido.file.extension.substring(1);
      vm.localPath = fileSubido.file.localPath;
    },
    abrirModalEditar: function abrirModalEditar(idMaterial) {
      var vm = this;
      if (vm.modulo === 'alumno') return;
      if (vm.type === 'curso' && !vm.idCurso || vm.type === 'clase' && !vm.idClase) {
        vm.closeModalAdd();
        vm.$emit('save');
        return;
      }
      if (idMaterial) {
        vm.id = idMaterial;
        vm.fetchMaterial(true);
      } else {
        vm.showModalEditar = true;
      }
    },
    closeModalAdd: function closeModalAdd() {
      if (!this.id && this.localPath) {
        this.borrarArchivosNoUtilizados();
      }
      this.showModalEditar = false;
      this.limpiarDatos();
    },
    guardar: function guardar() {
      if (this.id) {
        this.actualizar();
      } else {
        this.insertar();
      }
    },
    insertar: function insertar() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        pathDoc: vm.pathDoc,
        extension: vm.extension,
        tipo: vm.type
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/material/0', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Creado correctamente');
        vm.fetch();
        vm.limpiarDatos();
        vm.showModalEditar = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    actualizar: function actualizar() {
      var vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        pathDoc: vm.pathDoc,
        extension: vm.extension,
        tipo: vm.type
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiPut */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.idClase + '/material/' + vm.id, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Actualizado correctamente');
        vm.fetch();
        vm.limpiarDatos();
        vm.showModalEditar = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    },
    limpiarDatos: function limpiarDatos() {
      var vm = this;
      vm.id = '';
      vm.titulo = '';
      vm.descripcion = '';
      vm.pathDoc = '';
      vm.extension = '';
      vm.localPath = '';
    },
    borrarArchivo: function borrarArchivo() {
      var vm = this;
      if (!vm.id && vm.localPath) {
        vm.borrarArchivosNoUtilizados();
      } else {
        vm.pathDoc = '';
        vm.extension = '';
        vm.localPath = '';
      }
    }
    // borrarArchivosNoUtilizados () {
    //   var vm = this
    //   var obj = {
    //     archivos: [vm.localPath]
    //   }
    //   deleteFilesServer(vm, obj, function (data) {
    //     notify(vm, 'success', 'Éxito', 'borrado correctamente')
    //     vm.pathDoc = ''
    //     vm.extension = ''
    //     vm.localPath = ''
    //   }, function (error) {
    //     notify(vm, 'error', 'Error', error.message)
    //   })
    // }

  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModalTrabajadoresArea',

  props: {
    trabajadores: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    seleccionados: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    nombreArea: {
      type: String,
      default: ''
    },

    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      textoBusqueda: '',
      seleccionTemporal: []
    };
  },


  computed: {
    trabajadoresFiltrados: function trabajadoresFiltrados() {
      var texto = this.textoBusqueda.toLowerCase();

      if (!texto) {
        return this.trabajadores;
      }

      return this.trabajadores.filter(function (trabajador) {
        var codigo = String(trabajador.codigo || '').toLowerCase();
        var nombre = String(trabajador.nombre || '').toLowerCase();
        var cargo = String(trabajador.cargo || '').toLowerCase();

        return codigo.includes(texto) || nombre.includes(texto) || cargo.includes(texto);
      });
    },
    todosSeleccionados: function todosSeleccionados() {
      var _this = this;

      if (this.trabajadoresFiltrados.length === 0) {
        return false;
      }

      return this.trabajadoresFiltrados.every(function (trabajador) {
        return _this.seleccionTemporal.includes(trabajador.codigo);
      });
    }
  },

  watch: {
    seleccionados: {
      immediate: true,
      handler: function handler(valor) {
        this.seleccionTemporal = valor.map(function (trabajador) {
          return (typeof trabajador === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(trabajador)) === 'object' ? trabajador.codigo : trabajador;
        });
      }
    }
  },

  methods: {
    estaSeleccionado: function estaSeleccionado(trabajador) {
      return this.seleccionTemporal.includes(trabajador.codigo);
    },
    seleccionarTodos: function seleccionarTodos(event) {
      var marcar = event.target.checked;
      var codigosFiltrados = this.trabajadoresFiltrados.map(function (trabajador) {
        return trabajador.codigo;
      });

      if (marcar) {
        this.seleccionTemporal = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.seleccionTemporal), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(codigosFiltrados)))));

        return;
      }

      this.seleccionTemporal = this.seleccionTemporal.filter(function (codigo) {
        return !codigosFiltrados.includes(codigo);
      });
    },
    aceptar: function aceptar() {
      var _this2 = this;

      var trabajadoresSeleccionados = this.trabajadores.filter(function (trabajador) {
        return _this2.seleccionTemporal.includes(trabajador.codigo);
      });

      this.$emit('aceptar', trabajadoresSeleccionados);
    },
    cerrar: function cerrar() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_contratos_terminados_component',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      filtros: {
        idCurso: '',
        codigoEmpleado: ''
      },
      cursos: [],
      isProcessing: false,
      disabledScrollExecute: true,
      isScroll: false,
      skip: 0,
      noMore: false,
      isSaving: false,
      isLoadingCursos: false,
      mostrarConfirmacionTerminar: false,
      confirmacionTerminarTitulo: '¿Está seguro de terminar el curso?',
      confirmacionTerminarDescripcion: 'Esta acción no se puede deshacer',
      idCurso: '',
      codigoEmpleado: ''
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_1__Component_Lookup_Small_Empleado___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.fetch();
    this.fetchCursos();
  },

  methods: {
    changeFiltro: function changeFiltro() {
      this.fetch();
    },
    changeFiltroCurso: function changeFiltroCurso() {
      this.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetchCursos: function fetchCursos() {
      var vm = this;
      if (vm.isLoadingCursos) return;
      vm.isLoadingCursos = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/curso/', {}, function (data) {
        vm.cursos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingCursos = false;
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.filtros);
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/curso/reporte/cursos-terminado-alumno', obj, function (data) {
        for (var index = 0; index < data.lista.length; index++) {
          var element = data.lista[index];
          vm.lista.push(element);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtros.codigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtros = {
        idCurso: '',
        codigoEmpleado: ''
      };
      this.fetch();
    },
    confirmarTerminar: function confirmarTerminar(o) {
      var vm = this;
      vm.idCurso = o.idCurso;
      vm.codigoEmpleado = o.codigoEmpleado;
      vm.mostrarConfirmacionTerminar = true;
    },
    terminar: function terminar() {
      var vm = this;
      if (vm.isProcessing) return;
      vm.isProcessing = true;
      var obj = {
        idCurso: vm.idCurso,
        codigoEmpleado: vm.codigoEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/curso/marcar-terminado-rrhh', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.idCurso = '';
        vm.codigoEmpleado = '';
        vm.isProcessing = false;
        vm.fetch();
        vm.mostrarConfirmacionTerminar = false;
      });
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_contratos_component',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      filtros: {
        idCurso: '',
        idClase: '',
        codigoEmpleado: '',
        estadoClaseAlumno: '',
        estadoCursoAlumno: '',
        desdeFechaTermino: '',
        hastaFechaTermino: '',
        desdeInicioCurso: '',
        hastaInicioCurso: '',
        desdeVerCurso: '',
        hastaVerCurso: '',
        activoCurso: '1',
        activoClase: '1'
      },
      cursos: [],
      clases: [],
      isProcessing: false,
      disabledScrollExecute: true,
      isScroll: false,
      skip: 0,
      noMore: false,
      isSaving: false,
      fetchClaseEP: '',
      isLoadingCursos: false,
      isLoadingClases: false,
      disable: true
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_2__Component_Lookup_Small_Empleado___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {
    this.fetch();
    this.fetchCursos();
    this.fetchClases();
  },

  methods: {
    changeFiltro: function changeFiltro() {
      this.fetch();
    },
    changeFiltroCurso: function changeFiltroCurso() {
      var _this = this;

      if (this.filtros.idCurso) {
        this.fetchClaseEP = '/curso/gestion/' + this.filtros.idCurso + '/clase';
        this.fetchClases().then(function () {
          return _this.fetch();
        });
        return;
      }
      this.fetchClaseEP = '';
      this.fetch();
      this.fetchClases();
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetchCursos: function fetchCursos() {
      var vm = this;
      if (vm.isLoadingCursos) return;
      vm.isLoadingCursos = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/curso/', {}, function (data) {
        vm.cursos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingCursos = false;
      });
    },
    fetchClases: function fetchClases() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var vm = _this2;
        if (vm.isLoadingClases) return;
        vm.isLoadingClases = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, vm.fetchClaseEP || '/curso/gestion/0/clase', { skipIdCurso: true }, function (data) {
          vm.clases = data.lista;
          if (vm.filtros.idClase) {
            var element = data.lista.find(function (o) {
              return o.id === vm.filtros.idClase;
            });
            vm.filtros.idClase = element ? element.id : '';
          }
          resolve(null);
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          reject(error);
        }, function () {
          vm.isLoadingClases = false;
        });
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.filtros);
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/curso/reporte/curso-clase-alumno', obj, function (data) {
        for (var index = 0; index < data.lista.length; index++) {
          var element = data.lista[index];
          vm.lista.push(element);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtros.codigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtros = {
        idCurso: '',
        idClase: '',
        codigoEmpleado: '',
        estadoClaseAlumno: '',
        estadoCursoAlumno: '',
        desdeFechaTermino: '',
        hastaFechaTermino: '',
        desdeInicioCurso: '',
        hastaInicioCurso: '',
        desdeVerCurso: '',
        hastaVerCurso: '',
        activoCurso: '1',
        activoClase: '1'
      };
      this.fetch();
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upload_component',
  props: ['url', 'name', 'isSaving', 'isSaved', 'observations', 'folder', 'onlyPdf'],
  data: function data() {
    return {
      files: [],
      filesUploads: [],
      isUploading: false,
      apiRoute: "https://api-selfservice.datacont.com",
      extensions: ['pdf']
    };
  },

  computed: {
    _meta: function _meta() {
      var vm = this;
      return this.$upload.meta(vm.name);
    },
    _file: function _file() {
      var vm = this;
      return vm.$upload.file(vm.name);
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.create();
    vm.$forceUpdate();
  },
  beforeDestroy: function beforeDestroy() {
    var vm = this;
    vm.$upload.off(vm.name);
  },

  methods: {
    create: function create() {
      var _this = this;

      var vm = this;
      if (vm.onlyPdf) {
        vm.extensions = ['pdf'];
      }
      vm.$upload.on(vm.name, {
        extensions: vm.extensions,
        maxSizePerFile: 1024 * 1024 * 5,
        dropzoneId: 'dropzone',
        startOnSelect: false,
        multiple: true,
        http: function http(data) {},
        onSelect: function onSelect(files, res) {
          var hasExtensionError = false;
          for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var extension = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
            if (!vm.extensions.includes(extension)) {
              hasExtensionError = true;
            } else {
              vm.files.push(files[i]);
            }
          }
          if (hasExtensionError) {
            vm.$upload.reset(vm.name);
            vm.files = [];
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Solo se permiten archivos ' + vm.extensions.join(', '));
          }
        },
        onProgress: function onProgress(file, res) {},

        onSuccess: function onSuccess(file, res) {
          _this.file.push(res.data.data);
        },
        onError: function onError(file, res) {},
        onEnd: function onEnd(files, res) {}
      });
    },
    select: function select() {
      var vm = this;
      vm.$upload.select(vm.name);
    },
    start: function start() {
      var vm = this;
      vm.$upload.start(vm.name);
    },
    reset: function reset() {
      var vm = this;
      this.$upload.reset(vm.name);
    },
    limpiar: function limpiar() {
      var vm = this;
      this.$upload.reset(vm.name);
    },
    update: function update() {
      var vm = this;
      vm.$upload.reset(vm.name);
    },
    uploadFile: function uploadFile(file, callback) {
      var vm = this;

      if (vm.$upload.errors(vm.name).length > 0) {
        callback(new Error('Por favor corrija los errores del archivo adjunto'));
        return;
      }

      var fd = new FormData();
      fd.append('file', file);
      var params = {
        carpeta: vm.folder,
        usuario: localStorage.getItem('usuario')
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["f" /* apiUploadWithParams */])(vm, '/upload', fd, params, function (res) {
        callback(null, res);
      }, function (err) {
        console.error(err);
        callback(err);
      });
    },
    fileUploadRecursivo: function fileUploadRecursivo(index, callback) {
      var _this2 = this;

      var vm = this;
      vm.uploadFile(vm.files[index], function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(err, response) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (err) {
                    callback(err);
                  } else {
                    vm.filesUploads.push(response);
                    index++;
                    if (index === vm.files.length) callback(null);else vm.fileUploadRecursivo(index, callback);
                  }

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    UploadsMultiFiles: function UploadsMultiFiles() {
      var vm = this;
      vm.isUploading = true;

      vm.fileUploadRecursivo(0, function (err) {
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
          vm.isUploading = false;
          return;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Se adjuntaron los archivos correctamente');
        vm.$emit('save', vm.filesUploads);
        vm.files = [];
        vm.filesUploads = [];
        vm.isUploading = false;
      });
    },
    close: function close() {
      var vm = this;
      vm.$emit('close');
    },
    removeFile: function removeFile(index) {
      var vm = this;
      vm.files.splice(index, 1);
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_chart_bar',
  components: {
    apexchart: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
  },
  props: {
    series: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    yAxisTitle: {
      type: String,
      default: ''
    },
    xAxisTitle: {
      type: String,
      default: ''
    },
    tooltipFormatter: {
      type: Function,
      default: function _default(val) {
        return '' + val;
      }
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    isOneSeries: {
      type: Boolean,
      default: true
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Mi titulo'
    },
    showXlabels: {
      type: Boolean,
      default: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    chartOptions: function chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: '1000px'
        },
        plotOptions: {
          bar: {
            horizontal: this.isHorizontal,
            columnWidth: '55%',
            endingShape: 'rounded',
            distributed: this.isOneSeries
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.categories,
          labels: {
            show: this.showXlabels
          },
          title: {
            text: this.xAxisTitle
          }
        },
        yaxis: {
          title: {
            text: this.yAxisTitle
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: this.tooltipFormatter
          }
        },
        theme: {
          monochrome: {
            enabled: false
          },
          palette: 'palette1'
        },
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        legend: {
          show: this.showLegend
        }
      };
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c_chart_line',
  components: {
    apexchart: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
  },
  props: {
    series: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    yAxisTitle: {
      type: String,
      default: 'Valor y'
    },
    xAxisTitle: {
      type: String,
      default: 'Valor x'
    },
    tooltipFormatter: {
      type: Function,
      default: function _default(val) {
        return '' + val;
      }
    },
    title: {
      type: String,
      default: 'El titulo'
    },
    isDonut: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    chartOptions: function chartOptions() {
      return {
        chart: {
          height: 350
        },
        theme: {
          palette: 'palette1'
        },
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        labels: this.categories
      };
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Infocuadro',
  props: {
    title: {
      type: String,
      required: true
    },
    number: {
      type: [String, Number],
      required: true
    },
    iconClass: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cantidad_permisos_sin_aprobar_rrhh',
  components: {
    'info-card': __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default.a
  },
  data: function data() {
    return {
      o: {
        cantidad: '',
        titulo: 'Boletas sin visualizar',
        iconClass: 'fa-money'
      },
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/cantidad-boletas-sin-visualizar', {}, function (data) {
        if (data.cantidad === 0) {
          vm.$emit('close');
          return;
        }
        vm.o.cantidad = data.cantidad;
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cantidad_contratos_sin_firmar',
  components: {
    'info-card': __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default.a
  },
  data: function data() {
    return {
      o: {
        cantidad: '',
        titulo: 'Contratos sin firmar',
        iconClass: 'fa-pencil'
      },
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/cantidad-contratos-sin-firmar', {}, function (data) {
        if (data.cantidad === 0) {
          vm.$emit('close');
          return;
        }
        vm.o.cantidad = data.cantidad;
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cantidad_documentos_sin_firmar',
  components: {
    'info-card': __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default.a
  },
  data: function data() {
    return {
      o: {
        cantidad: '',
        titulo: 'Documentos sin firmar',
        iconClass: 'fa-pencil'
      },
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/cantidad-documentos-sin-firmar', {}, function (data) {
        if (data.cantidad === 0) {
          vm.$emit('close');
          return;
        }
        vm.o.cantidad = data.cantidad;
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cantidad_mis_boletas_sin_ver',
  components: {
    'info-card': __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default.a
  },
  data: function data() {
    return {
      o: {
        cantidad: '',
        titulo: 'Mis boletas sin ver',
        iconClass: 'fa-pencil'
      },
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      // 2018 tiene 1
      var obj = {
        periodo: new Date().getFullYear()
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/boleta/empleado', obj, function (data) {
        // to do corregir
        var cantidad = data.lista.filter(function (a) {
          return !a.fechaVisto;
        }).length;
        if (cantidad === 0) {
          vm.$emit('close');
          return;
        }
        vm.o.cantidad = cantidad;
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cantidad_mis_documentos_sin_firmar',
  components: {
    'info-card': __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default.a
  },
  data: function data() {
    return {
      o: {
        cantidad: '',
        titulo: 'Mis contratos sin firmar',
        iconClass: 'fa-pencil'
      },
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
        // to do corregir
        var cantidad = data.lista.filter(function (a) {
          return !a.firmado;
        }).length;
        if (cantidad === 0) {
          vm.$emit('close');
          return;
        }
        vm.o.cantidad = cantidad;
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cantidad_mis_documentos_sin_firmar',
  components: {
    'info-card': __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default.a
  },
  data: function data() {
    return {
      o: {
        cantidad: '',
        titulo: 'Mis documentos sin firmar',
        iconClass: 'fa-pencil'
      },
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
        // to do corregir
        var cantidad = data.lista.length;
        if (cantidad === 0) {
          vm.$emit('close');
          return;
        }
        vm.o.cantidad = cantidad;
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_info_card__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cantidad_permisos_sin_aprobar_rrhh',
  components: {
    'info-card': __WEBPACK_IMPORTED_MODULE_1__charts_c_info_card___default.a
  },
  data: function data() {
    return {
      o: {
        cantidad: '',
        titulo: 'Permisos sin aprobar por RRHH',
        iconClass: 'fa-check'
      },
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/cantidad-permisos-sin-aprobar-rrhh', {}, function (data) {
        if (data.cantidad === 0) {
          vm.$emit('close');
          return;
        }
        vm.o.cantidad = data.cantidad;
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KpiCumpleanos',
  data: function data() {
    return {
      lista: [],
      mes: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month() + 1,
      isLoading: false,
      disabledScrollExecute: false,
      noMore: false,
      isScroll: false,
      skip: 0
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }

      var obj = {
        mes: vm.mes,
        skip: vm.skip
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/empleado/cumpleanios', obj, function (data) {
        console.log('data.lista >>>>>>', data.lista);
        for (var i = 0; i < data.lista.length; i++) {
          if (data.lista[i].esCumpleanios) {
            vm.lista.push(data.lista[i]);
          }
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.isLoading = false;
      });
    },
    imagenDefault: function imagenDefault(event) {
      event.target.src = '/img/avatar-default.png';
    },
    saludar: function saludar(empleado) {
      this.$emit('saludar', empleado);
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KpiCursos',
  props: {
    cursos: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      lista: [],
      mes: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month() + 1,
      isLoading: false,
      disabledScrollExecute: false,
      noMore: false,
      isScroll: false,
      skip: 0
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }

      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/lista', obj, function (data) {
        console.log('data.lista cursos >>>>>>', data.lista);
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.isLoading = false;
      });
    },
    estado: function estado(avance) {
      if (avance === 100) {
        return 'Completado';
      }
      if (avance >= 50) {
        return 'En progreso';
      }

      return 'Pendiente';
    },
    estadoClass: function estadoClass(avance) {
      if (avance === 100) {
        return 'verde';
      }
      if (avance >= 50) {
        return 'amarillo';
      }
      return 'rojo';
    },
    continuar: function continuar(id) {
      var vm = this;
      vm.$router.push('/mis-cursos/' + id + '/clases');
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_c_chart_pie_vue__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_c_chart_pie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__charts_c_chart_pie_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empleados_por_area',
  components: {
    'bar-chart': __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar___default.a,
    'pie-chart': __WEBPACK_IMPORTED_MODULE_2__charts_c_chart_pie_vue___default.a
  },
  props: {
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // Datos para el gráfico de empleados por área
      areas: [],
      empleadosSeries: [{
        name: 'Cantidad de Empleados',
        data: []
      }],
      seriesPie: [],
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    tooltipFormatter: function tooltipFormatter(val) {
      return val + ' empleados';
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/empleados-por-area', {}, function (data) {
        vm.areas = [];
        vm.empleadosSeries[0].data = [];
        for (var index = 0; index < data.lista.length; index++) {
          var element = data.lista[index];
          vm.areas.push(element.area);
          vm.empleadosSeries[0].data.push(element.cantidadEmpleados);
          vm.seriesPie.push(element.cantidadEmpleados);
        }
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'solicitudes_v_pendiente_aprobar_jefe',
  components: {
    'bar-chart': __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar___default.a
  },
  data: function data() {
    return {
      // Datos para el gráfico de empleados por área
      categories: [],
      series: [{
        name: 'Cantidad de solicitudes pendientes',
        data: []
      }],
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    tooltipFormatter: function tooltipFormatter(val) {
      return '' + val;
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/solicitudes-vacaciones-pendientes-aprobar-jefe', {}, function (data) {
        vm.categories = [];
        vm.series[0].data = [];
        for (var index = 0; index < data.lista.length; index++) {
          var element = data.lista[index];
          vm.categories.push(element.nombre);
          vm.series[0].data.push(element.cantidad);
        }
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top_empleados_mas_dias_disponibles',
  components: {
    'bar-chart': __WEBPACK_IMPORTED_MODULE_1__charts_c_chart_bar___default.a
  },
  data: function data() {
    return {
      // Datos para el gráfico de empleados por área
      categories: [],
      series: [{
        name: 'Cantidad de dias disponibles',
        data: []
      }],
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    tooltipFormatter: function tooltipFormatter(val) {
      return '' + val;
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/top-empleados-mas-dias-disponibles', {}, function (data) {
        vm.categories = [];
        vm.series[0].data = [];
        for (var index = 0; index < data.lista.length; index++) {
          var element = data.lista[index];
          vm.categories.push(element.nombre);
          vm.series[0].data.push(element.cantidad);
        }
      }, function (error) {
        console.error('error', error);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CumpleaniosHoy',
  data: function data() {
    return {
      lista: [],
      mes: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month() + 1,
      isLoading: false,
      disabledScrollExecute: false,
      noMore: false,
      isScroll: false,
      skip: 0
    };
  },
  mounted: function mounted() {
    this.obtenerNuevoEmpleado(false);
  },

  methods: {
    handleScroll: function handleScroll(event) {
      var element = event.target;
      if (this.isLoading || this.isScroll || this.noMore || this.disabledScrollExecute) {
        return;
      }
      var scrollTop = element.scrollTop;
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;
      /*
       * Carga cuando faltan aproximadamente
       * 80px para llegar al final.
       */
      var distanciaFinal = scrollHeight - (scrollTop + clientHeight);
      if (distanciaFinal <= 80) {
        this.obtenerNuevoEmpleado(true);
      }
    },
    obtenerNuevoEmpleado: function obtenerNuevoEmpleado(esScroll) {
      var vm = this;
      if (vm.noMore || vm.disabledScrollExecute) {
        return;
      }
      vm.disabledScrollExecute = true;
      if (esScroll) {
        vm.isScroll = true;
      } else {
        vm.isLoading = true;
      }
      var obj = {
        mes: vm.mes,
        skip: vm.skip
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/empleado/cumpleanios', obj, function (data) {
        console.log('data.lista >>>>>>', data.lista);
        var lista = data && data.lista ? data.lista : [];
        for (var i = 0; i < lista.length; i++) {
          if (data.lista[i].esCumpleanios) {
            vm.lista.push(data.lista[i]);
          }
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.skip;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        vm.disabledScrollExecute = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.isLoading = false;
      });
    },
    imagenDefault: function imagenDefault(event) {
      event.target.src = '/img/avatar-default.png';
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardHeader',
  props: {
    nombre: {
      type: String,
      default: ''
    },
    totalPendientes: {
      type: Number,
      default: 0
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MisCursos',
  data: function data() {
    return {
      lista: [],
      mes: __WEBPACK_IMPORTED_MODULE_1_moment___default()().month() + 1,
      isLoading: false,
      disabledScrollExecute: false,
      noMore: false,
      isScroll: false,
      numeroRecnum: 0
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    handleScroll: function handleScroll(event) {
      var vm = this;
      var element = event.target;

      if (vm.isLoading || vm.isScroll || vm.noMore || vm.disabledScrollExecute) {
        return;
      }

      var scrollTop = element.scrollTop;
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;

      var distanciaFinal = scrollHeight - (scrollTop + clientHeight);

      console.log('scrollTop >>>', scrollTop);
      console.log('scrollHeight >>>', scrollHeight);
      console.log('clientHeight >>>', clientHeight);
      console.log('distanciaFinal >>>', distanciaFinal);

      if (distanciaFinal <= 80) {
        vm.cargarMas();
      }
    },
    fetch: function fetch() {
      var vm = this;

      vm.lista = [];
      vm.numeroRecnum = 0;
      vm.noMore = false;
      vm.isLoading = true;

      vm.obtenerCursos();
    },
    cargarMas: function cargarMas() {
      var vm = this;

      if (vm.noMore || vm.disabledScrollExecute || vm.isScroll) {
        return;
      }

      vm.isScroll = true;

      vm.obtenerCursos();
    },
    obtenerCursos: function obtenerCursos() {
      var vm = this;

      if (vm.noMore || vm.disabledScrollExecute) {
        return;
      }

      vm.disabledScrollExecute = true;

      var obj = {
        numeroRecnum: vm.numeroRecnum
      };

      console.log('Consultando cursos numeroRecnum >>>', vm.numeroRecnum);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/lista', obj, function (data) {
        var lista = data && data.lista ? data.lista : [];

        console.log('Cursos recibidos >>>', lista);
        console.log('noMore >>>', data.noMore);

        for (var i = 0; i < lista.length; i++) {
          vm.lista.push(lista[i]);
        }

        vm.numeroRecnum += lista.length;

        if (data.noMore || lista.length === 0) {
          vm.noMore = true;
        }

        vm.disabledScrollExecute = false;

        /*
        * Esperamos a que Vue renderice los nuevos cursos.
        */
        vm.$nextTick(function () {
          vm.verificarScroll();
        });
      }, function (error) {
        vm.disabledScrollExecute = false;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    verificarScroll: function verificarScroll() {
      var vm = this;

      if (vm.noMore) {
        return;
      }

      vm.$nextTick(function () {
        var element = vm.$refs.courses;

        if (!element) {
          return;
        }

        console.log('scrollHeight >>>', element.scrollHeight);

        console.log('clientHeight >>>', element.clientHeight);

        /*
        * Si todavía NO existe scroll,
        * solicitamos automáticamente otra página.
        */
        if (element.scrollHeight <= element.clientHeight) {
          vm.cargarMas();
        }
      });
    },
    estado: function estado(avance) {
      if (avance === 100) {
        return 'Completado';
      }

      if (avance >= 50) {
        return 'En progreso';
      }

      return 'Pendiente';
    },
    estadoClass: function estadoClass(avance) {
      if (avance === 100) {
        return 'verde';
      }

      if (avance >= 50) {
        return 'amarillo';
      }

      return 'rojo';
    },
    continuar: function continuar(id) {
      var vm = this;

      vm.$router.push('/mis-cursos/' + id + '/clases');
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_statCard__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_statCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_statCard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MisPendientes',
  components: {
    StatCard: __WEBPACK_IMPORTED_MODULE_1__c_statCard___default.a
  },
  data: function data() {
    return {
      lista: [{
        id: 1,
        titulo: 'Documentos sin firmar',
        cantidad: 5,
        ruta: '/mis-documentos-firmar'
      }, {
        id: 2,
        titulo: 'Contratos sin firmar',
        cantidad: 3,
        ruta: '/mis-contratos'
      }, {
        id: 3,
        titulo: 'Boletas sin revisar',
        cantidad: 7,
        ruta: '/boletas'
      }],
      isLoading: true
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
        vm.lista[0].cantidad = data.lista.length;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          var cantidad = data.lista.filter(function (a) {
            return !a.firmado;
          }).length;
          vm.lista[1].cantidad = cantidad;
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        }, function () {
          var obj = {
            periodo: new Date().getFullYear()
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/boleta/empleado', obj, function (data) {
            var cantidad1 = data.lista.filter(function (a) {
              return !a.fechaVisto;
            }).length;
            vm.lista[2].cantidad = cantidad1;
          }, function (error) {
            console.error('error', error);
          }, function () {
            vm.isLoading = false;
          });
        });
      });
    },
    redirigir: function redirigir(to) {
      this.$router.push(to);
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MisCursos',
  data: function data() {
    return {
      lista: [],
      noticias: [],
      noticiasVisibles: [],

      paginaNoticias: 1,
      limiteNoticias: 6,

      cargandoNoticias: false,
      hayMasNoticias: true,

      showModalArchivo: false,
      archivoSeleccionado: null,
      isloading: false,
      isScroll: false,
      numeroRecnum: 0,
      disabledScrollExcecute: true,
      noMore: false
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    esPdf: function esPdf(url) {
      if (!url) return false;

      return url.split('?')[0].toLowerCase().endsWith('.pdf');
    },
    abrirArchivo: function abrirArchivo(item) {
      this.archivoSeleccionado = item.foto;
      this.showModalArchivo = true;
    },
    cerrarArchivo: function cerrarArchivo() {
      this.showModalArchivo = false;
      this.archivoSeleccionado = null;
    },
    onNewsScroll: function onNewsScroll() {
      var contenedor = this.$refs.newsScroll;

      if (!contenedor) return;

      // Evita llamadas mientras ya se está consultando
      if (this.cargandoNoticias) return;

      // Ya no existen más registros
      if (this.noMore) return;

      var distanciaFinal = contenedor.scrollHeight - contenedor.scrollTop - contenedor.clientHeight;

      if (distanciaFinal <= 100) {
        this.isScroll = true;
        this.fetch();
      }
    },
    fetch: function fetch() {
      var vm = this;
      if (vm.cargandoNoticias) {
        return;
      }

      vm.cargandoNoticias = true;

      if (!vm.isScroll) {
        vm.noticiasVisibles = [];
        vm.numeroRecnum = 0;
        vm.noMore = false;
      }

      vm.disabledScrollExcecute = true;
      vm.noMore = false;

      var url = '/administrador-noticias/obtener';
      var obj = {
        estado: 1,
        isTodo: true,
        numeroRecnum: vm.numeroRecnum
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        var _vm$noticiasVisibles;

        var nuevasNoticias = data.lista || [];
        var idsExistentes = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(vm.noticiasVisibles.map(function (item) {
          return item.id;
        }));
        var noticiasSinDuplicar = nuevasNoticias.filter(function (item) {
          return !idsExistentes.has(item.id);
        });
        (_vm$noticiasVisibles = vm.noticiasVisibles).push.apply(_vm$noticiasVisibles, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(noticiasSinDuplicar));

        if (data.numeroRecnum !== undefined && data.numeroRecnum !== null) {
          vm.numeroRecnum = data.numeroRecnum;
        }

        vm.noMore = Boolean(data.noMore);
      }, function (err) {
        vm.disabledScrollExcecute = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isScroll = false;
        vm.cargandoNoticias = false;
      });
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NuevosEmpleados',
  data: function data() {
    return {
      lista: [],
      numeroRecnum: 0,
      noMore: false,
      disabledScrollExecute: false,
      isScroll: false,
      isLoading: false
    };
  },
  mounted: function mounted() {
    this.obtenerNuevoEmpleado(false);
  },

  methods: {
    handleScroll: function handleScroll(event) {
      var element = event.target;
      if (this.isLoading || this.isScroll || this.noMore || this.disabledScrollExecute) {
        return;
      }
      var scrollTop = element.scrollTop;
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;
      /*
       * Carga cuando faltan aproximadamente
       * 80px para llegar al final.
       */
      var distanciaFinal = scrollHeight - (scrollTop + clientHeight);
      if (distanciaFinal <= 80) {
        this.obtenerNuevoEmpleado(true);
      }
    },
    obtenerNuevoEmpleado: function obtenerNuevoEmpleado(esScroll) {
      var vm = this;
      if (vm.noMore || vm.disabledScrollExecute) {
        return;
      }
      vm.disabledScrollExecute = true;
      if (esScroll) {
        vm.isScroll = true;
      } else {
        vm.isLoading = true;
      }
      var obj = {
        numeroRecnum: vm.numeroRecnum
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/empleado/obtenerNuevoEmpleado', obj, function (data) {
        console.log('data.lista >>>>>>', data.lista);
        var lista = data && data.lista ? data.lista : [];
        for (var i = 0; i < lista.length; i++) {
          vm.lista.push(lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.numeroRecnum += data.numeroRecnum;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        vm.disabledScrollExecute = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_statCard__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__c_statCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__c_statCard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PendientesJefe',
  components: {
    StatCard: __WEBPACK_IMPORTED_MODULE_1__c_statCard___default.a
  },
  data: function data() {
    return {
      lista: [{
        id: 1,
        titulo: 'Contratos por vencer',
        descripcion: 'Requieren revisión',
        cantidad: 0,
        tipo: 'danger',
        ruta: '/contratos-equipo'
      }, {
        id: 2,
        titulo: 'Vacaciones sin aprobar',
        descripcion: 'Solicitudes pendientes',
        cantidad: 0,
        tipo: 'warning',
        ruta: '/vacaciones-equipo'
      }, {
        id: 3,
        titulo: 'Permisos sin aprobar',
        descripcion: 'Solicitudes pendientes',
        cantidad: 0,
        tipo: 'info',
        ruta: '/permisos-equipo'
      }],
      isLoading: true
    };
  },

  computed: {
    total: function total() {
      return this.items.reduce(function (total, item) {
        return total + item.cantidad;
      }, 0);
    }
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/cantidad-contratos-vencer-jefe', {}, function (data) {
        vm.lista[0].cantidad = data.cantidad;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/cantidad-solicitudes-v-pendientes-aprobar', {}, function (data) {
          vm.lista[1].cantidad = data.cantidad;
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        }, function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/kpi/cantidad-permisos-sin-aprobar-jefe', {}, function (data) {
            vm.lista[2].cantidad = data.cantidad;
          }, function (error) {
            console.error('error', error);
          }, function () {
            vm.isLoading = false;
          });
        });
      });
    },
    redirigir: function redirigir(to) {
      this.$router.push(to);
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatCard',
  props: {

    titulo: String,

    descripcion: String,

    cantidad: {
      type: Number,
      default: 0
    },

    tipo: {
      type: String,
      default: 'primary'
    },

    centrado: {
      type: Boolean,
      default: false
    }

  },
  computed: {
    cardClass: function cardClass() {
      return 'stat-' + this.tipo;
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lookup_actividades_accion',
  data: function data() {
    return {
      filtro: '',
      isLoading: false,
      lista: []
    };
  },

  computed: {
    listaFiltrada: function listaFiltrada() {
      var vm = this;
      if (vm.filtro) {
        return vm.lista.filter(function (o) {
          return o.accion.toLowerCase().includes(vm.filtro.toLowerCase());
        });
      } else {
        return vm.lista;
      }
    }
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/auditoria/acciones', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    selectFirst: function selectFirst() {
      if (this.listaFiltrada.length === 0) {
        this.$emit('close');
      } else {
        this.$emit('selected', this.listaFiltrada[0]);
        this.$emit('close');
      }
    },
    seleccionarClick: function seleccionarClick(o) {
      this.$emit('selected', o);
      this.$emit('close');
    },
    close: function close() {
      this.$emit('close', this.listaFiltrada[0]);
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lookup_actividades_modulo',
  data: function data() {
    return {
      filtro: '',
      isLoading: false,
      lista: []
    };
  },

  computed: {
    listaFiltrada: function listaFiltrada() {
      var vm = this;
      if (vm.filtro) {
        return vm.lista.filter(function (o) {
          return o.modulo.toLowerCase().includes(vm.filtro.toLowerCase());
        });
      } else {
        return vm.lista;
      }
    }
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/auditoria/modulos', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    selectFirst: function selectFirst() {
      if (this.listaFiltrada.length === 0) {
        this.$emit('close');
      } else {
        this.$emit('selected', this.listaFiltrada[0]);
        this.$emit('close');
      }
    },
    seleccionarClick: function seleccionarClick(o) {
      this.$emit('selected', o);
      this.$emit('close');
    },
    close: function close() {
      this.$emit('close', this.listaFiltrada[0]);
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lookup_area',
  data: function data() {
    return {
      filtro: '',
      isLoading: false,
      lista: []
    };
  },

  computed: {
    listaFiltrada: function listaFiltrada() {
      var vm = this;
      if (vm.filtro) {
        return vm.lista.filter(function (o) {
          return o.nombreArea.toLowerCase().includes(vm.filtro.toLowerCase()) || o.nombreGerencia.toLowerCase().includes(vm.filtro.toLowerCase());
        });
      } else {
        return vm.lista;
      }
    }
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/area', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    selectFirst: function selectFirst() {
      if (this.listaFiltrada.length === 0) {
        this.$emit('close');
      } else {
        this.$emit('selected', this.listaFiltrada[0]);
        this.$emit('close');
      }
    },
    seleccionarClick: function seleccionarClick(o) {
      this.$emit('selected', o);
      this.$emit('close');
    },
    close: function close() {
      this.$emit('close', this.listaFiltrada[0]);
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Area__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empleados_multiple',
  props: {
    fetchEndpoint: { type: String, required: true }, // Se pasan como prop los empleados previamente seleccionados
    asignarEmpleadosEndpoint: { type: String, required: true },
    desasignarTodosEndpoint: { type: String, required: true },
    asignarTodosEndpoint: { type: String, required: true },
    filtroProp: { type: String, required: false, default: '' },
    objAux: { type: Object, required: true }
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_2__Component_Confirmar_Accion_Overlay___default.a,
    'lookup-area': __WEBPACK_IMPORTED_MODULE_3__Area___default.a
  },
  data: function data() {
    return {
      filteredEmpleados: [],
      empleadosAuxiliar: [],
      filtro: '',
      propFiltro: this.filtroProp,
      isLoading: false,
      isScroll: false,
      isSaving: false,
      disabledScrollExecute: true,
      numeroRecnum: 0,
      noMore: false,
      mostrarModalEmpleadosConDocumentos: false,
      mostrarConfirmacionModal: false,
      mensajeRespuesta: '',
      listaEmpleadosRespuesta: [],
      tipoConfirmacion: {},
      nombreArea: '',
      nombreGerencia: '',
      area: {
        idArea: '',
        idGerencia: '',
        nombreArea: '',
        nombreGerencia: ''
      },
      mostrarBusquedaArea: false,
      empresa: "datacont"
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.$refs.busqueda.focus();
    if (this.propFiltro) {
      this.filtro = this.propFiltro;
    }
    this.fetch();
  },

  methods: {
    borrarArea: function borrarArea() {
      var vm = this;
      vm.area = {};
      vm.fetch();
    },
    seleccionarArea: function seleccionarArea(o) {
      var vm = this;
      vm.area = o;
      vm.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },

    fetchSearch: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function (value) {
      var vm = this;
      vm.fetch();
    }, 300),
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      if (!vm.isScroll) {
        vm.filteredEmpleados = [];
        vm.numeroRecnum = 0;
      }
      var obj = {
        filtro: vm.filtro,
        numeroRecnum: vm.numeroRecnum
      };

      if (vm.area.idArea) {
        obj.area = vm.area;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, vm.fetchEndpoint, obj, function (data) {
        var _loop = function _loop() {
          var empleado = data.lista[i];
          // Verifico en los empleados auxiliar si esta seleccionado o no (esta logica es para que este visualmente seleccionado o no)
          var empleadoAux = vm.empleadosAuxiliar.find(function (e) {
            return e.codigo === empleado.codigo;
          });
          if (empleadoAux) {
            empleado.seleccionado = empleadoAux.seleccionado;
          }
          // Aqui pusheo el empleado debido al scroll infinito
          vm.filteredEmpleados.push(empleado);
        };

        for (var i = 0; i < data.lista.length; i++) {
          _loop();
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExecute = false;
        }
        vm.isLoading = false;
        vm.isScroll = false;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExecute = true;
        vm.isScroll = false;
      });
    },
    toggleSelection: function toggleSelection(employee) {
      // Actualiza el estado seleccionado del empleado en filteredEmpleados
      employee.seleccionado = !employee.seleccionado;

      // Actualiza el estado seleccionado en empleadosAuxiliar
      var index = this.empleadosAuxiliar.findIndex(function (e) {
        return e.codigo === employee.codigo;
      });
      if (index !== -1) {
        // Actualiza el estado seleccionado sin modificar otras propiedades
        this.empleadosAuxiliar[index].seleccionado = employee.seleccionado;
      } else {
        // Solo guarda el codigo y seleccionado
        this.empleadosAuxiliar.push({
          codigo: employee.codigo,
          seleccionado: employee.seleccionado,
          nombre: employee.nombre
        });
      }
    },
    close: function close() {
      this.$emit('close');
    },
    selectFirst: function selectFirst() {
      if (this.filteredEmpleados.length >= 1) {
        this.toggleSelection(this.filteredEmpleados[0]);
      }
    },
    asignarEmpleados: function asignarEmpleados(eliminarForzado) {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        empleados: vm.empleadosAuxiliar
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(obj, vm.objAux);
      if (eliminarForzado) {
        obj.eliminarForzado = true;
      } else {
        obj.eliminarForzado = false;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, vm.asignarEmpleadosEndpoint, obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message;
          vm.listaEmpleadosRespuesta = data.lista;
          vm.mostrarModalEmpleadosConDocumentos = true;
          return;
        }
        if (obj.eliminarForzado) {
          vm.cerrarModalEmpleadosForzar();
        }
        vm.empleadosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
        // vm.fetch()
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    cerrarModalEmpleadosForzar: function cerrarModalEmpleadosForzar() {
      this.mostrarModalEmpleadosConDocumentos = false;
      this.listaEmpleadosRespuesta = [];
      this.tipoConfirmacion.tipo = '';
    },
    abrirModalConfirmacion: function abrirModalConfirmacion(tipo) {
      this.tipoConfirmacion.tipo = tipo;
      this.tipoConfirmacion.descripcion = tipo === 'asignarTodos' ? 'asignar a todos los empleados' : 'desasignar a todos los empleados';
      this.mostrarConfirmacionModal = true;
    },
    validarModalEmpleadoForzar: function validarModalEmpleadoForzar() {
      if (this.tipoConfirmacion.tipo === 'desasignarTodos') {
        this.desasignarTodos(true);
      } else {
        this.asignarEmpleados(true);
      }
    },
    validarConfirmacion: function validarConfirmacion() {
      if (this.tipoConfirmacion.tipo === 'asignarTodos') {
        this.asignarTodos();
      } else {
        this.desasignarTodos(false);
      }
      this.mostrarConfirmacionModal = false;
    },
    desasignarTodos: function desasignarTodos(_desasignarTodos) {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(obj, vm.objAux);

      if (_desasignarTodos) {
        obj.desasignarForzado = true;
      } else {
        obj.desasignarForzado = false;
      }
      if (vm.area.idArea) {
        obj.area = vm.area;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["g" /* apiDelete */])(vm, vm.desasignarTodosEndpoint, obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message;
          vm.listaEmpleadosRespuesta = data.lista;
          vm.mostrarModalEmpleadosConDocumentos = true;
          return;
        }
        if (obj.desasignarForzado) {
          vm.cerrarModalEmpleadosForzar();
        }
        vm.empleadosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    asignarTodos: function asignarTodos() {
      var vm = this;

      if (vm.isSaving) return;

      vm.isSaving = true;

      var obj = {
        // idDocumentoFirmar: vm.idDocumentoFirmar
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(obj, vm.objAux);
      if (vm.area.idArea) {
        obj.area = vm.area;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["a" /* apiPost */])(vm, vm.asignarTodosEndpoint, obj, function (data) {
        vm.empleadosAuxiliar = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.close();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSaving = false;
      });
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lookup_gerencia',
  data: function data() {
    return {
      filtro: '',
      isLoading: false,
      lista: []
    };
  },

  computed: {
    listaFiltrada: function listaFiltrada() {
      var vm = this;
      if (vm.filtro) {
        return vm.lista.filter(function (o) {
          return o.nombre.toLowerCase().includes(vm.filtro.toLowerCase());
        });
      } else {
        return vm.lista;
      }
    }
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    this.$refs.busqueda.focus();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/gerencia', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    selectFirst: function selectFirst() {
      if (this.listaFiltrada.length === 0) {
        this.$emit('close');
      } else {
        this.$emit('selected', this.listaFiltrada[0]);
        this.$emit('close');
      }
    },
    seleccionarClick: function seleccionarClick(o) {
      this.$emit('selected', o);
      this.$emit('close');
    },
    close: function close() {
      this.$emit('close', this.listaFiltrada[0]);
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'loading-global-sil': __WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      perfil: localStorage.getItem('perfil'),
      isloading: false,
      showModalAdd: false,
      isDialogActivarFeriado: false,
      isDialogResetearFeriado: false,
      lista: [],
      isDialogDesactivarFeriado: false,
      periodos: ['2026', '2027', '2028'],
      periodo: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'),
      formulario: {
        titulo: '',
        descripcion: '',
        fechaVencimiento: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'week').format('YYYY-MM-DD')
      },
      titulo: '',
      isScroll: false,
      numeroRecnum: 0,
      noMore: false,
      disabledScrollExcecute: true,
      previewFoto: null,
      isDialogActivarDesactivar: false,
      tipo: '',
      formDesactiva: {},
      estado: ''
    };
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },

  filters: {
    formatoFecha: function formatoFecha(fecha) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(fecha).format('DD/MM/YYYY');
    },
    formatoFechaText: function formatoFechaText(fecha) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(fecha).locale('es').format('LL');
    }
  },
  methods: {
    closeModalAdd: function closeModalAdd() {
      var vm = this;
      vm.showModalAdd = false;
    },
    openModalAdd: function openModalAdd() {
      var vm = this;
      vm.formulario.id = 0;
      vm.formulario.titulo = '';
      vm.formulario.descripcion = '';
      vm.formulario.foto = '';
      vm.formulario.fechaVencimiento = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'week').format('YYYY-MM-DD');
      vm.previewFoto = '';
      vm.showModalAdd = true;
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isloading = true;

      if (!vm.isScroll) {
        vm.lista = [];
        vm.numeroRecnum = 0;
      }
      vm.disabledScrollExcecute = true;
      vm.noMore = false;

      var url = '/administrador-noticias/obtener';
      var obj = {
        titulo: vm.titulo,
        estado: vm.estado,
        numeroRecnum: vm.numeroRecnum
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExcecute = true;
        } else {
          vm.numeroRecnum = data.numeroRecnum;
          vm.disabledScrollExcecute = false;
        }
      }, function (err) {
        vm.disabledScrollExcecute = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isScroll = false;
        vm.isloading = false;
      });
    },
    fetchGuardar: function fetchGuardar() {
      var vm = this;
      if (!vm.formulario.titulo) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', 'El campo Titulo es obligatorio.');
        return;
      }

      if (!vm.formulario.descripcion) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', 'El campo Descripción es obligatorio.');
        return;
      }

      if (!vm.formulario.fechaVencimiento) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', 'El campo Fecha Vencimiento es obligatorio.');
        return;
      }

      var url = '/administrador-noticias/guardar';
      var obj = {
        form: vm.formulario
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.');
        vm.fetch();
        vm.closeModalAdd();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isloading = false;
      });
    },
    fetchActivarDesactivar: function fetchActivarDesactivar() {
      var vm = this;
      var url = '/administrador-noticias/activaDesactiva';
      var obj = {
        form: vm.formDesactiva
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.');
        vm.fetch();
        vm.closeDialogActivaDesactiva();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    editarForm: function editarForm(item) {
      var vm = this;
      console.log('item >>>>>', item);
      vm.formulario.id = item.id;
      vm.formulario.fechaVencimiento = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.fechaVencimiento).format('YYYY-MM-DD');
      vm.formulario.titulo = item.titulo;
      vm.formulario.descripcion = item.descripcion;
      vm.previewFoto = item.foto;
      vm.formulario.foto = item.foto;
      vm.showModalAdd = true;
    },
    abrirSelectorFoto: function abrirSelectorFoto() {
      this.$refs.inputFoto.click();
    },
    seleccionarFoto: function seleccionarFoto(event) {
      var _this = this;

      var vm = this;
      var archivo = event.target.files[0];

      if (!archivo) {
        return;
      }

      var tiposPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

      if (!tiposPermitidos.includes(archivo.type)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(this, 'error', 'Error', 'Solo se permiten imágenes JPG, PNG o WEBP.');

        event.target.value = '';
        return;
      }

      // this.formulario.foto = archivo

      var reader = new FileReader();

      reader.onload = function (e) {
        _this.previewFoto = e.target.result;
      };
      vm.uploadFile(archivo, function (err, response) {
        console.log('response >>>>>>>>', response);
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
        } else {
          vm.formulario.foto = response.file.ruta;
          reader.readAsDataURL(archivo);
        }
      });
    },
    eliminarFoto: function eliminarFoto() {
      this.formulario.foto = null;
      this.previewFoto = null;

      if (this.$refs.inputFoto) {
        this.$refs.inputFoto.value = '';
      }
    },
    uploadFile: function uploadFile(file, callback) {
      var vm = this;
      var url = '/upload';
      var fd = new FormData();
      fd.append('file', file);
      var params = {
        carpeta: 'administrador-noticias',
        usuario: localStorage.getItem('usuario')
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["f" /* apiUploadWithParams */])(vm, url, fd, params, function (res) {
        callback && callback(null, res);
      }, function (err) {
        callback && callback(err);
      });
    },
    openDialogActivaDesactiva: function openDialogActivaDesactiva(item) {
      var vm = this;
      vm.formDesactiva = item;
      vm.formDesactiva.estadoDescripcion = +item.estado === 0 ? 'Activar' : 'Desactivar';
      vm.isDialogActivarDesactivar = true;
    },
    closeDialogActivaDesactiva: function closeDialogActivaDesactiva() {
      var vm = this;
      vm.isDialogActivarDesactivar = false;
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lookups_Actividades_Modulo__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lookups_Actividades_Modulo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_lookups_Actividades_Modulo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_lookups_Actividades_Acciones__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_lookups_Actividades_Acciones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_lookups_Actividades_Acciones__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auditoria',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      tipoIcon: {
        'guardar': 'fa fa-save',
        'enviar': 'fa fa-check',
        'aprobar': 'fa fa-check',
        'rechazar': 'fa fa-times',
        'desactivar': 'fa fa-times',
        'no lo tomo': 'fa fa-times',
        'notificar': 'fa fa-envelope',
        'editar': 'fa fa-edit',
        'adjuntar': 'fa fa-paperclip',
        'ver': 'fa fa-eye',
        'firmar': 'fa fa-pencil'
      },
      mostrarFiltros: true,
      mostrarBusquedaEmpleado: false,
      mostrarBusquedaModulo: false,
      mostrarBusquedaAccion: false,
      filtroModulo: '',
      filtroAccion: '',
      filtroCodigoEmpleado: '',
      desde: '',
      hasta: '',
      perfiles: ['usuario', 'jefe', 'recursos humanos'],
      isScroll: false,
      disabledScrollExecute: true,
      skip: 0,
      noMore: false
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado___default.a,
    LookupActividadesModulo: __WEBPACK_IMPORTED_MODULE_1__components_lookups_Actividades_Modulo___default.a,
    LookupActividadesAcciones: __WEBPACK_IMPORTED_MODULE_2__components_lookups_Actividades_Acciones___default.a
  },
  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  mounted: function mounted() {
    this.hasta = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    this.desde = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'day').format('YYYY-MM-DD');
    this.fetch();
  },

  methods: {
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      var obj = {};
      if (vm.filtroCodigoEmpleado) obj.codigoEmpleado = vm.filtroCodigoEmpleado;
      if (vm.filtroModulo) obj.modulo = vm.filtroModulo;
      if (vm.filtroAccion) obj.accion = vm.filtroAccion;
      if (vm.desde && vm.hasta) {
        obj.desde = vm.desde;
        obj.hasta = vm.hasta;
      }
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["c" /* apiGet */])(vm, '/auditoria', obj, function (data) {
        // poner a las fechas este formato 2018-01-01 00:00:00 con moment
        data.lista.forEach(function (o) {
          // o.fecha = moment(o.fecha).format('DD/MM/YYYY HH:mm:ss')
          o.datos = JSON.parse(o.datos);
          vm.lista.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip += data.lista.length;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
      this.fetch();
    },
    seleccionarModulo: function seleccionarModulo(o) {
      this.filtroModulo = o.modulo;
      this.fetch();
    },
    seleccionarAccion: function seleccionarAccion(o) {
      this.filtroAccion = o.accion;
      this.fetch();
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroCodigoEmpleado = '';
      this.filtroModulo = '';
      this.filtroAccion = '';
      this.hasta = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      this.desde = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'day').format('YYYY-MM-DD');
      this.fetch();
    },
    limpiarEmpleado: function limpiarEmpleado() {
      this.filtroCodigoEmpleado = '';
      this.fetch();
    },
    limpiarModulo: function limpiarModulo() {
      this.filtroModulo = '';
      this.fetch();
    },
    limpiarAccion: function limpiarAccion() {
      this.filtroAccion = '';
      this.fetch();
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import VueCircle from 'vue2-circle-progress'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boletas-carga-manual',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalAdjuntar: false,
      idSeleccionado: null,
      cantidadAvance: 0,
      cantidadTotal: 0,
      filesAdjuntos: [],
      isVerifying: false,
      mostrarConfirmacionEliminarTodo: false,
      mostrarConfirmacionGenerarBoletas: false,
      periodo: '',
      mes: '',
      tipo: '',
      descripcionTipo: '',
      isProcessing: false,
      tipos: []
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'upload-multi-file': __WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_4_vue_simple_spinner___default.a,
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado_vue___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_3__components_Component_Confirmar_Accion_Overlay___default.a
  },
  mounted: function mounted() {
    this.fetch();
    this.fetchTipos();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/boleta/manual/archivos/temporal', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          data.lista[i].isRemoving = false;
        }
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    recursivoGuardarAdjunto: function recursivoGuardarAdjunto(index, callback) {
      var vm = this;
      var obj = {
        file: vm.filesAdjuntos[index]
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/boleta/manual/archivos/temporal', obj, function (data) {
        if (data.status === 2) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'warning', 'Advertencia', data.message);
        }

        index++;
        vm.cantidadAvance = index;
        if (index === vm.filesAdjuntos.length) callback(null);else vm.recursivoGuardarAdjunto(index, callback);
      }, function (error) {
        callback(error);
      }, function () {});
    },
    guardarAdjuntos: function guardarAdjuntos(files) {
      var vm = this;

      vm.filesAdjuntos = [];
      for (var i = 0; i < files.length; i++) {
        vm.filesAdjuntos.push(files[i]);
      }

      vm.cantidadTotal = vm.filesAdjuntos.length;

      vm.closeModalAdjuntar();
      // Enviar metodo recursivo para ir al server, buscar empleado e insertar en la tabla temporal
      vm.isVerifying = true;
      vm.recursivoGuardarAdjunto(0, function (err) {
        vm.isVerifying = false;
        if (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
          return;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Verificados correctamente');
        vm.fetch();
      });
    },
    eliminar: function eliminar(id, o) {
      var vm = this;
      if (o.isRemoving) return;

      o.isRemoving = true;

      var obj = {
        id: id
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/boleta/manual/archivos/temporal', obj, function (data) {
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        o.isRemoving = false;
      });
    },
    asignarEmpleadoABoletaManual: function asignarEmpleadoABoletaManual(o, empleado) {
      o.codigoEmpleadoReemplazante = empleado.codigo;
      var vm = this;
      var obj = {
        id: o.id,
        codigo: empleado.codigo,
        nombre: empleado.nombre
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/boleta/manual/archivos/empleado/asignar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se asigno el empleado de reemplazo correctamente');
        o.codigo = empleado.codigo;
        o.nombre = empleado.nombre;
        o.dniObtenido = empleado.dni;
        o.codigoEmpleadoReemplazante = '';
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    desasignarEmpleadoABoletaManual: function desasignarEmpleadoABoletaManual(o) {
      var vm = this;
      var obj = {
        id: o.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/boleta/manual/archivos/empleado/desasignar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se desasigno el empleado correctamente');
        o.codigo = '';
        o.nombre = '';
        o.dniObtenido = '';
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    eliminarTodasLasBoletasManuales: function eliminarTodasLasBoletasManuales(o) {
      var vm = this;

      if (!vm.isProcessing) {
        vm.isProcessing = true;
        var obj = {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/boleta/manual/archivos/temporal/todo', obj, function (data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se eliminaron todas las boletas de la carga manual');
          vm.isProcessing = false;
          vm.mostrarConfirmacionEliminarTodo = false;
          vm.fetch();
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          vm.isProcessing = false;
          vm.mostrarConfirmacionEliminarTodo = false;
        });
      }
    },
    generarBoletaRecursivo: function generarBoletaRecursivo(callback) {
      var vm = this;

      var obj = {
        periodo: vm.periodo,
        mes: vm.mes,
        tipo: vm.tipo,
        descripcionTipo: vm.descripcionTipo,
        cantidadAvance: vm.cantidadAvance
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/boleta/manual/generar', obj, function (data) {
        vm.cantidadAvance++;
        if (data.noMore) {
          // Ya no hay mas que generar
          callback(null, null);
        } else {
          // Aun hay boletas que generar
          vm.generarBoletaRecursivo(callback);
        }
      }, function (error) {
        callback(error);
      });
    },
    generarBoletasManuales: function generarBoletasManuales() {
      var vm = this;

      if (!vm.isProcessing) {
        vm.isProcessing = true;
        var obj = {
          periodo: vm.periodo,
          mes: vm.mes,
          tipo: vm.tipo
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/boleta/manual/generar/verificar', obj, function (data) {
          // Si entra aca es porque todo esta oka, empecemos a generar
          // Debe retornar tambien la cantidad total de documentos para mostrarlo como total
          vm.cantidadAvance = 0;
          vm.cantidadTotal = data.cantidadTotal;
          vm.descripcionTipo = data.descripcionTipo;
          vm.generarBoletaRecursivo(function (err, data) {
            if (err) {
              console.error('Error');
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
              vm.isProcessing = false;
              return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Se generaron las boletas');
            vm.mostrarConfirmacionGenerarBoletas = false;
            vm.fetch();
            vm.isProcessing = false;
          });
        }, function (error) {
          vm.isProcessing = false;
          vm.mostrarConfirmacionGenerarBoletas = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        });
      }
    },
    fetchTipos: function fetchTipos() {
      var vm = this;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/boleta/tipos', obj, function (data) {
        vm.tipos = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Errores_Multiples__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Component_Errores_Multiples___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Component_Errores_Multiples__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contratos-carga-manual',
  data: function data() {
    return {
      lista: [],
      messages: [],
      isLoading: false,
      mostrarModalAdjuntar: false,
      cantidadAvance: 0,
      cantidadTotal: 0,
      filesAdjuntos: [],
      isVerifying: false,
      isSaving: false,
      mostrarConfirmacionEliminar: false,
      mostrarConfirmacionEliminarTodo: false,
      mostrarConfirmacionEnviarContratos: false,
      mostrarModalPosicionFirma: false,
      periodo: '',
      mes: '',
      tipo: '',
      descripcionTipo: '',
      isProcessing: false,
      tipos: [],
      mostrarErroresMultiples: false,
      contrato: {
        index: '',
        pagina_auxiliar: '',
        x_auxiliar: '',
        y_auxiliar: '',
        posicion_firma: []
      }
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'upload-multi-file': __WEBPACK_IMPORTED_MODULE_0__components_c_upload_multi_files___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner___default.a,
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_1__components_Component_Lookup_Small_Empleado___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_4__components_Component_Confirmar_Accion_Overlay___default.a,
    'errores-multiples': __WEBPACK_IMPORTED_MODULE_3__components_Component_Errores_Multiples___default.a
  },
  destroyed: function destroyed() {
    // Remover el event listener cuando el componente se destruya
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    this.fetch();
    // Agregar el event listener cuando el componente se monte
    window.addEventListener('resize', this.handleResize);
    // Llamar al método por si ya está en tamaño menor a 800px al cargar
    this.handleResize();
  },

  methods: {
    verVistaPrevia: function verVistaPrevia(o) {
      var vm = this;
      var obj = {
        id: o.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/contratos/auxiliar/vista-previa', obj, function (data) {
        window.open(data.ruta, '_blank').focus();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    handleResize: function handleResize() {
      if (window.innerWidth <= 820) {
        this.$store.dispatch('setSidebarDesktop', true);
        localStorage.setItem('sidebar-show', true);
      } else if (window.innerWidth < 1140) {
        this.$store.dispatch('setSidebarDesktop', false);
        localStorage.setItem('sidebar-show', false);
      }
    },
    checkDates: function checkDates(o) {
      if (o.fechaFin && o.fechaInicio) {
        this.handleBothDatesSet(o);
      }
    },
    handleBothDatesSet: function handleBothDatesSet(o) {
      var vm = this;
      // valido que o.fechaInicio sea menor a o.fechaFin
      if (o.fechaInicio > o.fechaFin) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(this, 'warning', 'Advertencia', 'La fecha de inicio debe ser menor a la fecha de fin');
        o.fechaInicio = '';
        o.fechaFin = '';
        o.isBGRed = true;
        return;
      } else if (o.fechaInicio === o.fechaFin) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(this, 'warning', 'Advertencia', 'La fecha de inicio no puede ser igual a la fecha de fin');
        o.fechaInicio = '';
        o.fechaFin = '';
        o.isBGRed = true;
        return;
      }
      o.isBGRed = false;
      vm.asignarDatosContrato(o);
    },
    check: function check(o) {
      var vm = this;
      o.indeterminado = !o.indeterminado;
      o.isBGRed = !o.indeterminado;
      if (o.indeterminado === true) {
        o.fechaInicio = '';
        o.fechaFin = '';
      }
      vm.asignarDatosContrato(o);
    },
    fetch: function fetch() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/contratos/auxiliar', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    guardarAdjuntos: function guardarAdjuntos(files) {
      var vm = this;
      var obj = {
        archivos: files.map(function (file) {
          if (file.status === 1) {
            return file.file;
          }
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/contratos/auxiliar', obj, function (data) {
        if (data.status === 2) {
          // mostrar errores multiples
          vm.mostrarErroresMultiples = true;
          vm.messages = data.messages;
        } else if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.fetch();
        vm.closeModalAdjuntar();
      });
    },
    confirmarEliminar: function confirmarEliminar(id, o) {
      var vm = this;
      vm.mostrarConfirmacionEliminar = true;
      vm.contrato = o;
    },
    eliminar: function eliminar(id, o) {
      var isTodos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var vm = this;
      if (!isTodos && o.isRemoving) return;else if (isTodos && vm.isLoading) return;

      var obj = { ids: [] };

      if (isTodos) {
        obj.ids = vm.lista.map(function (item) {
          return +item.id;
        });
        vm.isLoading = true;
      } else {
        obj.ids = [+id];
        o.isRemoving = true;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/contratos/auxiliar', obj, function (data) {
        if (data.status === 2) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'warning', 'Advertencia', data.messageError);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'warning', 'Advertencia', data.message);
        } else if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        if (!isTodos) o.isRemoving = false;else vm.isLoading = false;
        vm.mostrarConfirmacionEliminarTodo = false;
        vm.mostrarConfirmacionEliminar = false;
        vm.fetch();
      });
    },
    asignarEmpleadoContratoAuxiliar: function asignarEmpleadoContratoAuxiliar(o, empleado) {
      var vm = this;
      var obj = {
        id: o.id,
        codigoEmpleado: empleado.codigo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["d" /* apiPut */])(vm, '/contratos/auxiliar/asignarEmpleado', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        o.codigoEmpleado = empleado.codigo;
        o.nombre = empleado.nombre;
        o.dniObtenido = empleado.dni;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.fetch();
      });
    },
    deasignarEmpleadoContratoAuxiliar: function deasignarEmpleadoContratoAuxiliar(o) {
      var vm = this;
      var obj = {
        id: o.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["d" /* apiPut */])(vm, '/contratos/auxiliar/deasignarEmpleado', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        o.codigoEmpleado = '';
        o.nombre = '';
        o.dniObtenido = '';
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.fetch();
      });
    },
    asignarDatosContrato: function asignarDatosContrato(o) {
      var vm = this;
      var obj = {
        indeterminado: o.indeterminado,
        fechaInicio: o.fechaInicio,
        fechaFin: o.fechaFin,
        id: o.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["d" /* apiPut */])(vm, '/contratos/auxiliar/asignarDatosContrato', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        if (vm.isSaving) vm.cerrarModalPosicionFirma();
        vm.fetch();
      });
    },
    enviarContratos: function enviarContratos() {
      var vm = this;
      // notify(vm, 'warning', 'Advertencia', 'Exitos')
      var obj = { ids: [] };
      obj.ids = vm.lista.map(function (item) {
        return +item.id;
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/contratos/auxiliar/enviar', obj, function (data) {
        if (data.status === 2) {
          // mostrar errores multiples
          vm.mostrarErroresMultiples = true;
          vm.messages = data.messages;
        } else if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.fetch();
        vm.mostrarConfirmacionEnviarContratos = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(function (a) {
            return !a.firmado;
          }).length);
        });
      });
    },
    confirmacionEnviarContratos: function confirmacionEnviarContratos() {
      var vm = this;
      // verificamos que tengan todos los datos llenos
      for (var i = 0; i < vm.lista.length; i++) {
        if (!vm.lista[i].codigoEmpleado) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'warning', 'Advertencia', 'Debe asignar un empleado a todos los contratos');
          return;
        } else if (vm.lista[i].isBGRed) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'warning', 'Advertencia', 'Debe asignar una duracion a todos los contrato');
          return;
        }
      }
      vm.mostrarConfirmacionEnviarContratos = true;
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_lista__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_lista__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista-cursos-virtuales',
  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'c-lista-cursos-virtuales': __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_lista___default.a
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_clase_lista__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_clase_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_clase_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista-cursos-virtuales_clases',
  data: function data() {
    return {
      showMateriales: true,
      showEvaluaciones: true,
      titulo: '',
      descripcion: '',
      fechaInicio: ''
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.idCurso;
    },
    fetchURLMaterial: function fetchURLMaterial() {
      return '/curso/virtual/alumno/lista/' + this.idCurso + '/material';
    },
    fetchURLEvaluacion: function fetchURLEvaluacion() {
      return '/curso/virtual/alumno/lista/' + this.idCurso + '/evaluacion';
    }
  },
  components: {
    'c-lista-cursos-virtuales-clases': __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_clase_lista___default.a,
    'evaluaciones-clase-lista': __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista___default.a,
    'materiales-clase-lista': __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista___default.a
  },
  mounted: function mounted() {
    this.fetchCurso();
  },

  methods: {
    convertirSaltosDeLinea: function convertirSaltosDeLinea(texto) {
      return texto ? texto.replace(/\n/g, '<br>') : '';
    },
    volver: function volver() {
      var vm = this;
      vm.$router.push('/mis-cursos');
    },
    close: function close(prop) {
      this[prop] = false;
    },
    fetchCurso: function fetchCurso() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/curso/virtual/alumno/lista/' + vm.idCurso, {}, function (data) {
        vm.titulo = data.curso.titulo;
        vm.descripcion = data.curso.descripcion;
        vm.fechaInicio = data.curso.fechaInicio;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    iniciarCurso: function iniciarCurso() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/curso/virtual/alumno/lista/' + vm.idCurso + '/iniciar-curso', {}, function (data) {
        vm.fechaInicio = data.fechaInicio;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_video__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cursos_virtuales_video',
  data: function data() {
    return {
      showMateriales: true,
      showEvaluaciones: true
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.idCurso;
    },
    idClase: function idClase() {
      return +this.$route.params.idClase;
    },
    fetchURLMaterial: function fetchURLMaterial() {
      return '/curso/virtual/alumno/lista/' + this.idCurso + '/clase/lista/' + this.idClase + '/material';
    },
    fetchURLEvaluacion: function fetchURLEvaluacion() {
      return '/curso/virtual/alumno/lista/' + this.idCurso + '/clase/lista/' + this.idClase + '/evaluacion';
    }
  },
  components: {
    'c-lista-cursos-virtuales-clases': __WEBPACK_IMPORTED_MODULE_0__components_c_cursos_virtuales_video___default.a,
    'evaluaciones-clase-lista': __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista___default.a,
    'materiales-clase-lista': __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista___default.a
  },
  mounted: function mounted() {},

  methods: {
    volver: function volver() {
      var vm = this;
      vm.$router.push('/mis-cursos/' + vm.idCurso + '/clases');
    },
    cfetch: function cfetch() {
      var vm = this;
      this.$nextTick(function () {
        if (vm.showEvaluaciones) vm.$refs.evaluaciones.fetch();
        if (vm.showMateriales) vm.$refs.materiales.fetch();
      });
    },
    close: function close(prop) {
      this[prop] = false;
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'loading-global-sil': __WEBPACK_IMPORTED_MODULE_1__components_Component_Cargando___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      perfil: localStorage.getItem('perfil'),
      isloading: false,
      showModalAdd: false,
      isDialogActivarFeriado: false,
      isDialogResetearFeriado: false,
      lista: [],
      isDialogDesactivarFeriado: false,
      periodos: ['2026', '2027', '2028'],
      periodo: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'),
      nuevoFeriado: {
        id: 0,
        fecha: new Date(),
        nombre: '',
        activo: true
      }
    };
  },
  created: function created() {
    var vm = this;
    vm.setearPeriodos();
    vm.fetch();
  },

  filters: {
    formatoFecha: function formatoFecha(fecha) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(fecha).format('DD/MM/YYYY');
    },
    formatoFechaText: function formatoFechaText(fecha) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(fecha).locale('es').format('LL');
    }
  },
  methods: {
    setearPeriodos: function setearPeriodos() {
      var vm = this;
      vm.periodos = [];
      var anioActual = __WEBPACK_IMPORTED_MODULE_0_moment___default()().year();
      for (var i = anioActual - 1; i <= anioActual + 1; i++) {
        vm.periodos.push(i.toString());
      }
    },
    openDialogResetearFeriado: function openDialogResetearFeriado() {
      var vm = this;
      vm.isDialogResetearFeriado = true;
    },
    closeDialogResetearFeriado: function closeDialogResetearFeriado() {
      var vm = this;
      vm.isDialogResetearFeriado = false;
    },
    closeModalAdd: function closeModalAdd() {
      var vm = this;
      vm.showModalAdd = false;
    },
    openDialogDesactivarFeriado: function openDialogDesactivarFeriado(item) {
      var vm = this;
      vm.nuevoFeriado.id = item.id;
      vm.nuevoFeriado.fecha = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.fecha).format('YYYY-MM-DD');
      vm.nuevoFeriado.nombre = item.nombre;
      vm.nuevoFeriado.activo = item.activo;
      vm.isDialogDesactivarFeriado = true;
    },
    openDialogActivarFeriado: function openDialogActivarFeriado(item) {
      var vm = this;
      vm.nuevoFeriado.id = item.id;
      vm.nuevoFeriado.fecha = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.fecha).format('YYYY-MM-DD');
      vm.nuevoFeriado.nombre = item.nombre;
      vm.nuevoFeriado.activo = item.activo;
      vm.isDialogActivarFeriado = true;
    },
    closeDialogDesactivarFeriado: function closeDialogDesactivarFeriado() {
      var vm = this;
      vm.nuevoFeriado.id = 0;
      vm.nuevoFeriado.fecha = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
      vm.nuevoFeriado.nombre = '';
      vm.nuevoFeriado.activo = false;
      vm.isDialogDesactivarFeriado = false;
    },
    closeDialogActivarFeriado: function closeDialogActivarFeriado() {
      var vm = this;
      vm.nuevoFeriado.id = 0;
      vm.nuevoFeriado.fecha = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
      vm.nuevoFeriado.nombre = '';
      vm.nuevoFeriado.activo = false;
      vm.isDialogActivarFeriado = false;
    },
    openModalAdd: function openModalAdd() {
      var vm = this;
      vm.nuevoFeriado.id = 0;
      vm.nuevoFeriado.fecha = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
      vm.nuevoFeriado.nombre = '';
      vm.nuevoFeriado.activo = true;
      vm.showModalAdd = true;
    },
    fetch: function fetch() {
      var vm = this;
      vm.lista = [];
      vm.isLoading = true;
      var url = '/dias-festivos/obtener/' + vm.periodo;
      var obj = {
        octopus: true,
        activo: 'all'
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.data;
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    fetchGuardar: function fetchGuardar() {
      var vm = this;
      if (!vm.nuevoFeriado.fecha) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', 'El campo Fecha es obligatorio.');
        return;
      }

      if (!vm.nuevoFeriado.nombre) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', 'El campo Descripción es obligatorio.');
        return;
      }

      var url = '/dias-festivos/agregar';
      var obj = {
        form: vm.nuevoFeriado,
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.');
        vm.fetch();
        vm.closeModalAdd();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    fetchDesactivarFeriado: function fetchDesactivarFeriado() {
      var vm = this;
      var url = '/dias-festivos/desactivar';
      var obj = {
        form: vm.nuevoFeriado,
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.');
        vm.fetch();
        vm.closeDialogDesactivarFeriado();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    fetchActivarFeriado: function fetchActivarFeriado() {
      var vm = this;
      var url = '/dias-festivos/activar';
      var obj = {
        form: vm.nuevoFeriado,
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.');
        vm.fetch();
        vm.closeDialogActivarFeriado();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    fetchResetear: function fetchResetear() {
      var vm = this;
      var url = '/dias-festivos/resetear';
      var obj = {
        periodo: vm.periodo,
        octopus: true
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["a" /* apiPost */])(vm, url, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'success', 'Exito', 'Proceso de reseteo se ha ejecutado correctamente.');
        vm.fetch();
        vm.closeDialogResetearFeriado();
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general_js__["b" /* notify */])(vm, 'error', 'Error', err.message);
      });
    },
    editarForm: function editarForm(item) {
      var vm = this;
      vm.nuevoFeriado.id = item.id;
      vm.nuevoFeriado.fecha = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.fecha).format('YYYY-MM-DD');
      vm.nuevoFeriado.nombre = item.nombre;
      vm.nuevoFeriado.activo = item.activo;
      vm.showModalAdd = true;
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_documentos_firmar_editar__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_documentos_firmar_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_documentos_firmar_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-documentos-importantes',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      idSeleccionado: null,
      mostrarConfirmacionEliminar: false,
      documentoSeleccionado: null,
      mostrarModalEmpleadosConDocumentos: false,
      mensajeRespuesta: '',
      listaEmpleadosRespuesta: [],
      isSaving: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'editar-documento-importante': __WEBPACK_IMPORTED_MODULE_0__components_c_documentos_firmar_editar___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    changeId: function changeId(id) {
      this.idSeleccionado = id;
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalEditar: function openModalEditar(id) {
      var vm = this;
      if (id) vm.idSeleccionado = id;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.idSeleccionado = null;
      if (refresh) vm.fetch();
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var vm = this;
      vm.documentoSeleccionado = {
        id: o.id,
        descripcion: o.descripcion
      };
      vm.mostrarConfirmacionEliminar = true;
    },
    cerrarModalEmpleadosConDocumentos: function cerrarModalEmpleadosConDocumentos() {
      var vm = this;
      vm.mostrarModalEmpleadosConDocumentos = false;
      vm.mensajeRespuesta = '';
      vm.listaEmpleadosRespuesta = [];
    },
    eliminarDocumento: function eliminarDocumento(eliminarForzado) {
      var vm = this;
      var obj = {
        idDocumentoFirmar: vm.documentoSeleccionado.id
      };
      if (eliminarForzado) {
        obj.eliminarForzado = true;
      } else {
        obj.eliminarForzado = false;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/documentos-firmar', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message;
          vm.listaEmpleadosRespuesta = data.lista;
          vm.mostrarModalEmpleadosConDocumentos = true;
          return;
        }
        vm.mostrarModalEmpleadosConDocumentos = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Documento eliminado correctamente');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.mostrarConfirmacionEliminar = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'documentos-importantes',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      idSeleccionado: null,
      rutaSeleccionada: null
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var obj = {
        activo: 1
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-importantes', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.idSeleccionado = o.id;
      vm.rutaSeleccionada = o.ruta;
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view_empleado_sin_nacimiento',
  data: function data() {
    return {
      lista: []
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/empleado/sin-cumpleanios', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    guardarFechaNacimiento: function guardarFechaNacimiento(empleado) {
      var vm = this;
      var obj = {
        codigo: empleado.codigo,
        fechaNacimiento: empleado.fechaNacimiento
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["d" /* apiPut */])(vm, '/empleado/cumpleanios', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Fecha de nacimiento actualizada');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    guardarFechaNacimientoMasivo: function guardarFechaNacimientoMasivo() {
      var vm = this;
      var obj = {
        lista: vm.lista.map(function (o) {
          if (o.fechaNacimiento !== '') {
            return {
              codigo: o.codigo,
              fechaNacimiento: o.fechaNacimiento
            };
          }
        })
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["d" /* apiPut */])(vm, '/empleado/cumpleanios', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Exito', 'Fecha de nacimiento actualizada');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_boletas_tipo_editar__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_boletas_tipo_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_gestion_boletas_tipo_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-boletas-tipo',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      codigoSeleccionado: null
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'editar-boleta-tipo': __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_boletas_tipo_editar___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/boleta/tipos', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalEditar: function openModalEditar(codigo) {
      var vm = this;
      if (codigo) vm.codigoSeleccionado = codigo;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.codigoSeleccionado = null;
      if (refresh) vm.fetch();
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_materiales_lista__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_materiales_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_materiales_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_evaluaciones_lista__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_evaluaciones_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_evaluaciones_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-clases-virtuales-editar',
  data: function data() {
    return {
      lista: [],
      isLoadingClase: false,
      titulo: '',
      descripcion: '',
      orden: '',
      linkYT: '',
      duracion: '00:00:00',
      activo: 0
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idCurso: function idCurso() {
      return +this.$route.params.id;
    },
    id: function id() {
      return +this.$route.params.idClase;
    }
  },
  components: {
    'materiales-curso-lista': __WEBPACK_IMPORTED_MODULE_0__components_c_materiales_lista___default.a,
    'evaluaciones-curso-lista': __WEBPACK_IMPORTED_MODULE_1__components_c_evaluaciones_lista___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.id) {
      this.fetchClase();
    } else {
      this.fetchUltimoOrden();
    }
  },

  methods: {
    volver: function volver() {
      var vm = this;
      vm.$router.push('/gestion-cursos/' + vm.idCurso);
    },
    fetchClase: function fetchClase() {
      var vm = this;
      vm.isLoadingClase = true;
      var idCurso = vm.idCurso;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/curso/gestion/' + idCurso + '/clase/' + vm.id, {}, function (data) {
        var _data$clase = data.clase,
            titulo = _data$clase.titulo,
            descripcion = _data$clase.descripcion,
            orden = _data$clase.orden,
            linkYT = _data$clase.linkYT,
            duracion = _data$clase.duracion,
            activo = _data$clase.activo;

        vm.titulo = titulo;
        vm.descripcion = descripcion;
        vm.orden = orden;
        vm.linkYT = linkYT;
        vm.duracion = duracion;
        vm.activo = activo;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.volver();
      }, function () {
        vm.isLoadingClase = false;
      });
    },
    fetchUltimoOrden: function fetchUltimoOrden() {
      var vm = this;
      vm.isLoadingClase = true;
      var idCurso = vm.idCurso;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/curso/gestion/' + idCurso + '/clase/' + vm.id + '/ultimo-orden', {}, function (data) {
        vm.orden = data.orden;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.volver();
      }, function () {
        vm.isLoadingClase = false;
      });
    },
    saveMaterial: function saveMaterial() {
      this.guardarClase(true);
    },
    saveEvaluacion: function saveEvaluacion() {
      this.guardarClase(null, true);
    },
    guardarClase: function guardarClase(toMaterial, toEvaluacion) {
      if (this.linkYT) {
        if (!this.isValidYouTubeURL(this.linkYT)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(this, 'error', 'Error', 'No es un link válido.');
          return;
        }
        if (!this.duracion) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(this, 'error', 'Error', 'Debe escribir la duración del video.');
          return;
        }
      }
      if (!this.titulo) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(this, 'error', 'Error', 'Ingrese el título de la clase.');
        return;
      }
      if (this.id) {
        this.actualizarClase();
      } else {
        this.insertarClase(toMaterial, toEvaluacion);
      }
    },
    insertarClase: function insertarClase(toMaterial, toEvaluacion) {
      var vm = this;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        orden: vm.orden,
        linkYT: vm.linkYT,
        duracion: vm.duracion,
        activo: vm.activo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/0', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Nueva clase guardado correctamente');
        vm.$router.push('/gestion-cursos/' + vm.idCurso + '/gestion-clases/' + data.id);
        vm.fetchClase();
        if (toMaterial) vm.$refs.materialesRef.abrirModalEditar();
        if (toEvaluacion) vm.$refs.evaluacionesRef.abrirModalEditar();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    actualizarClase: function actualizarClase() {
      var vm = this;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        orden: vm.orden,
        linkYT: vm.linkYT,
        duracion: vm.duracion,
        activo: vm.activo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["d" /* apiPut */])(vm, '/curso/gestion/' + vm.idCurso + '/clase/' + vm.id, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Clase actualizada correctamente');
        vm.fetchClase();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    isValidYouTubeURL: function isValidYouTubeURL() {
      var regex = /^(https?:\/\/)?(www\.|m\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|playlist\?list=|.+\?v=)?([a-zA-Z0-9_-]{11})?(\S*)?$/;
      // const regex = /^(https?:\/\/)?(www\.|m\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|playlist\?list=|.+\?v=)?([a-zA-Z0-9_-]{11})(\S*)?$|^(https?:\/\/)?(drive\.google\.com)\/(file\/d\/|open\?id=)([a-zA-Z0-9_-]+)(\/view)?(\S*)?$/;
      return regex.test(this.linkYT);
    }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_cursos_virtuales_lista__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_cursos_virtuales_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_gestion_cursos_virtuales_lista__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-cursos-virtuales',
  data: function data() {
    return {};
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'lista-cursos-virtuales': __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_cursos_virtuales_lista___default.a
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_alumnos_lista__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_alumnos_lista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_alumnos_lista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Component_Upload_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-cursos-virtuales-editar',
  data: function data() {
    return {
      lista: [],
      isLoadingCurso: false,
      isLoadingClase: false,
      id: '',
      titulo: '',
      descripcion: '',
      imagen: '',
      localPath: '',
      confirmacionEliminarId: '',
      confirmacionEliminarTitulo: '',
      confirmacionEliminarDescripcion: '',
      mostrarConfirmacionEliminar: false,
      isSendingEliminar: '',
      activo: 0,
      mostrarModalAdjuntar: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'materiales-curso-lista': __WEBPACK_IMPORTED_MODULE_1__components_c_materiales_lista___default.a,
    'evaluaciones-curso-lista': __WEBPACK_IMPORTED_MODULE_2__components_c_evaluaciones_lista___default.a,
    'upload-image': __WEBPACK_IMPORTED_MODULE_4__components_Component_Upload_Image___default.a,
    'alumnos-curso-lista': __WEBPACK_IMPORTED_MODULE_3__components_c_alumnos_lista___default.a,
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    this.id = +this.$route.params.id;
    if (this.id) {
      this.fetchCurso();
      this.fetchClases();
    }
  },

  methods: {
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      vm.closeModalAdjuntar();
      vm.imagen = fileSubido.file.ruta;
      vm.localPath = fileSubido.file.localPath;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = false;
    },
    openModalAdjuntar: function openModalAdjuntar() {
      var vm = this;
      vm.mostrarModalAdjuntar = true;
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var vm = this;
      vm.confirmacionEliminarId = o.id;
      vm.confirmacionEliminarTitulo = 'Eliminar clase';
      vm.confirmacionEliminarDescripcion = 'Al eliminar la clase, eliminará las evaluaciones y materiales.';

      vm.mostrarConfirmacionEliminar = true;
    },
    eliminar: function eliminar() {
      var vm = this;
      vm.isSendingEliminar = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["g" /* apiDelete */])(vm, '/curso/gestion/' + vm.id + '/clase/' + vm.confirmacionEliminarId, {}, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Clase eliminada con éxito.');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSendingEliminar = false;
        vm.mostrarConfirmacionEliminar = false;
        vm.fetchClases();
      });
    },
    volver: function volver() {
      var vm = this;
      vm.$router.push('/gestion-cursos');
    },
    redirigir: function redirigir(idClase) {
      var vm = this;
      if (!vm.id) {
        // dentor de insertar hará la redireccion
        vm.guardarCurso(true);
        return;
      }
      vm.$router.push(vm.id + '/gestion-clases/' + idClase);
    },
    fetchCurso: function fetchCurso() {
      var vm = this;
      vm.isLoadingCurso = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["c" /* apiGet */])(vm, '/curso/gestion/' + vm.id, {}, function (data) {
        var _data$curso = data.curso,
            titulo = _data$curso.titulo,
            descripcion = _data$curso.descripcion,
            imagen = _data$curso.imagen,
            activo = _data$curso.activo;

        vm.titulo = titulo;
        vm.imagen = imagen;
        vm.activo = activo;
        vm.descripcion = descripcion;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.$router.push('/gestion-cursos');
      }, function () {
        vm.isLoadingCurso = false;
      });
    },
    fetchClases: function fetchClases() {
      var vm = this;
      vm.isLoadingClase = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["c" /* apiGet */])(vm, '/curso/gestion/' + vm.id + '/clase', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingClase = false;
      });
    },
    saveMaterial: function saveMaterial() {
      this.guardarCurso(null, true);
    },
    saveEvaluacion: function saveEvaluacion() {
      this.guardarCurso(null, null, true);
    },
    saveAlumno: function saveAlumno() {
      this.guardarCurso(null, null, null, true);
    },
    guardarCurso: function guardarCurso(toClase, toMaterial, toEvaluacion, toAsignarEmpleados) {
      if (!this.titulo) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(this, 'error', 'Error', 'Debe escribir un título para el curso.');
        return;
      }
      if (this.id) {
        this.actualizarCurso();
      } else {
        this.insertarCurso(toClase, toMaterial, toEvaluacion, toAsignarEmpleados);
      }
    },
    insertarCurso: function insertarCurso(toClase, toMaterial, toEvaluacion, toAsignarEmpleados) {
      var vm = this;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        imagen: vm.imagen,
        activo: vm.activo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["a" /* apiPost */])(vm, '/curso', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Nuevo curso guardado correctamente');
        vm.id = data.id;
        vm.$router.push('/gestion-cursos/' + vm.id);
        vm.fetchCurso();
        if (toClase) vm.$router.push(vm.id + '/gestion-clases/0');else if (toMaterial) vm.$refs.materialesRef.abrirModalEditar();else if (toEvaluacion) vm.$refs.evaluacionesRef.abrirModalEditar();else if (toAsignarEmpleados) vm.$refs.alumnosRef.abrirModalAsignarEmpleados();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    actualizarCurso: function actualizarCurso() {
      var vm = this;
      var obj = {
        titulo: vm.titulo,
        descripcion: vm.descripcion,
        imagen: vm.imagen,
        activo: vm.activo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["d" /* apiPut */])(vm, '/curso/gestion/' + vm.id, obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Curso actualizado correctamente');
        vm.fetchCurso();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_gestion_documentos_importantes_editar__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_gestion_documentos_importantes_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_gestion_documentos_importantes_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-documentos-importantes',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      idSeleccionado: null,
      notificar: {},
      mostrarModalNotificar: false,
      isSaving: false,
      fechaVencimiento: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'week').format('YYYY-MM-DD')
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'editar-documento-importante': __WEBPACK_IMPORTED_MODULE_1__components_c_gestion_documentos_importantes_editar___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/documentos-importantes', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalEditar: function openModalEditar(id) {
      var vm = this;
      if (id) vm.idSeleccionado = id;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.idSeleccionado = null;
      if (refresh) vm.fetch();
    },
    openModalNotificar: function openModalNotificar(item) {
      var vm = this;
      vm.notificar = item;
      vm.mostrarModalNotificar = true;
    },
    closeModalNotificar: function closeModalNotificar() {
      var vm = this;
      vm.notificar = {};
      vm.mostrarModalNotificar = false;
    },
    guardarNotificacion: function guardarNotificacion() {
      var vm = this;
      if (!vm.fechaVencimiento) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Fecha vencimiento es obligatorio');
        return;
      }

      vm.isLoading = true;
      var obj = {
        idDocumento: vm.notificar.id,
        fechaVencimiento: vm.fechaVencimiento
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["a" /* apiPost */])(vm, '/documentos-importantes/notificar', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');
        vm.closeModalNotificar();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Empleado_Editar_vue__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Empleado_Editar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Empleado_Editar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empleado-gestion',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      lista: [],
      listaFiltrada: [],
      codigoLogueadoJefe: localStorage.getItem('codigo') + '',
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      mostrarConfirmacionNoLoTomo: false,
      mostrarModalEditarEmpleado: false,
      mostrarModalDarDeBajaEmpleadoEmpleado: false,
      mostrarModalImportarPlantillaEmpleado: false,
      mostrarObservaciones: false,
      mostrarProcesandoPlantilla: false,
      disabledScrollExcecute: false,
      noMore: false,
      isScroll: false,
      empleadoSeleccionado: {},
      filtroCodigoEmpleado: '',
      filtroUrgencia: 'white',
      codigoEmpleado: 0,
      nombreEmpleado: '',
      isSavedAdjunto: false,
      observaciones: [],
      numeroRecnum: 0,
      name: 'plantilla_empleados',
      mensajeProcesoPlantilla: '',
      filtrosUrgencia: ['white', 'green', 'yellow', 'red']
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado_vue___default.a,
    editarEmpleado: __WEBPACK_IMPORTED_MODULE_1__components_Component_Empleado_Editar_vue___default.a,
    'upload-image': __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.fetch();
  },

  watch: {
    filtroCodigoEmpleado: function filtroCodigoEmpleado(value) {
      return this.fetch();
    },
    filtroUrgencia: function filtroUrgencia(value) {
      return this.filtrarUrgencia();
    }
  },
  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExcecute = true;
      vm.noMore = false;
      vm.listaFiltrada = [];

      if (!vm.isScroll) {
        vm.lista = [];
        vm.numeroRecnum = 0;
      }

      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado
      };

      var obj = {
        filtros: filtros,
        numeroRecnum: vm.numeroRecnum
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["c" /* apiGet */])(vm, '/empleado/obtener', obj, function (data) {
        vm.numeroRecnum = data.numeroRecnum;
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }
        if (data.noMore) {
          vm.noMore = true;
        } else {
          vm.disabledScrollExcecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isScroll = false;
        vm.isLoading = false;
      });
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroCodigoEmpleado = '';
      this.filtroUrgencia = 'white';
    },
    filtrarUrgencia: function filtrarUrgencia() {
      var vm = this;
      // Hacemos el filtro local
      if (vm.filtroUrgencia === 'white') {
        vm.listaFiltrada = vm.lista;
      } else {
        if (vm.filtroUrgencia === 'green') {
          vm.listaFiltrada = vm.lista.filter(function (e) {
            return e.diasDisponibles < 35;
          });
        } else if (vm.filtroUrgencia === 'yellow') {
          vm.listaFiltrada = vm.lista.filter(function (e) {
            return e.diasDisponibles >= 35 && e.diasDisponibles <= 40;
          });
        } else if (vm.filtroUrgencia === 'red') {
          vm.listaFiltrada = vm.lista.filter(function (e) {
            return e.diasDisponibles > 40;
          });
        }
      }
    },
    openModalEditarEmpleado: function openModalEditarEmpleado(o) {
      var vm = this;
      vm.mostrarModalEditarEmpleado = true;
      vm.codigoEmpleado = o.codigo;
    },
    closeModalEditarEmpleado: function closeModalEditarEmpleado(o) {
      var vm = this;
      vm.mostrarModalEditarEmpleado = false;
    },
    desactivarEmpleado: function desactivarEmpleado() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        codigo: vm.codigoEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["a" /* apiPost */])(vm, '/empleado/baja', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se dio de baja correctamente');
        vm.closeModalDarBajaEmpleado();
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    nuevoEmpleado: function nuevoEmpleado() {
      var vm = this;
      vm.codigoEmpleado = 0;
      vm.mostrarModalEditarEmpleado = true;
    },
    openModalDarBajaEmpleado: function openModalDarBajaEmpleado(o) {
      var vm = this;
      vm.codigoEmpleado = o.codigo;
      vm.nombreEmpleado = o.nombre;
      vm.mostrarModalDarDeBajaEmpleadoEmpleado = true;
    },
    closeModalDarBajaEmpleado: function closeModalDarBajaEmpleado() {
      var vm = this;
      vm.codigoEmpleado = 0;
      vm.nombreEmpleado = '';
      vm.mostrarModalDarDeBajaEmpleadoEmpleado = false;
    },
    closeModalObservaciones: function closeModalObservaciones() {
      var vm = this;
      vm.observaciones = [];
      vm.mostrarObservaciones = false;
    },
    openModalImportarEmpleados: function openModalImportarEmpleados() {
      var vm = this;
      vm.mostrarModalImportarPlantillaEmpleado = true;
    },
    descargarPlantillaEmpleados: function descargarPlantillaEmpleados() {
      var vm = this;
      var url = 'empleado/plantilla/excel';
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["e" /* apiGetExcel */])(vm, url, obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = vm.name + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        console.error('Error:' + error.message);
      }, function () {});
    },
    closeAdjuntar: function closeAdjuntar() {
      this.mostrarModalImportarPlantillaEmpleado = false;
    },
    validarArchivoExcel: function validarArchivoExcel(fileSubido, callback) {
      var vm = this;
      var obj = {
        fileSubido: fileSubido

        // return
      };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["a" /* apiPost */])(vm, '/empleado/validar/plantilla/excel', obj, function (data) {
        callback(null, data.observaciones);
      }, function (err) {
        callback(err);
      });
    },
    guardarArchivoExcel: function guardarArchivoExcel(fileSubido, callback) {
      var vm = this;
      var obj = {
        fileSubido: fileSubido

        // return
      };__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["a" /* apiPost */])(vm, '/empleado/guardar/plantilla/excel', obj, function (data) {
        callback(null);
      }, function (err) {
        callback(err);
      });
    },
    procesoPlantilla: function procesoPlantilla(fileSubido) {
      var vm = this;
      vm.observaciones = [];
      vm.mostrarModalImportarPlantillaEmpleado = false;
      vm.mostrarProcesandoPlantilla = true;
      vm.mensajeProcesoPlantilla = 'Validando datos...';
      vm.validarArchivoExcel(fileSubido.file.localPath, function (err, observaciones) {
        if (err) {
          vm.mostrarProcesandoPlantilla = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
        } else {
          if (observaciones.length > 0) {
            vm.observaciones = observaciones;
            // vm.mostrarModalImportarPlantillaEmpleado = false
            vm.mostrarObservaciones = true;
            vm.mostrarProcesandoPlantilla = false;
          } else {
            vm.mensajeProcesoPlantilla = 'Guardando plantilla...';
            vm.guardarArchivoExcel(fileSubido.file.localPath, function (err) {
              if (err) {
                vm.mostrarProcesandoPlantilla = false;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
              } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se proceso correctame el archivo excel.');
                // vm.mostrarModalImportarPlantillaEmpleado = false
                vm.mostrarProcesandoPlantilla = false;
                vm.fetch();
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_links_importantes_editar__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_links_importantes_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_gestion_links_importantes_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-links-importantes',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      idSeleccionado: null
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  components: {
    'editar-link-importante': __WEBPACK_IMPORTED_MODULE_0__components_c_gestion_links_importantes_editar___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var obj = {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/links-importantes', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalEditar: function openModalEditar(id) {
      var vm = this;
      if (id) vm.idSeleccionado = id;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.idSeleccionado = null;
      if (refresh) vm.fetch();
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_gestion_salas_reuniones_editar__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_gestion_salas_reuniones_editar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_gestion_salas_reuniones_editar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_scroll__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'administrador-salas-reuniones',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarModalEditar: false,
      filtro: '',
      salaSeleccionada: null,
      mostrarConfirmacionEliminar: false,
      isSending: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    shadowList: function shadowList() {
      var _this = this;

      if (!this.filtro) return this.lista;else {
        return this.lista.filter(function (o) {
          return o.nombre.toLowerCase().includes(_this.filtro.toLowerCase());
        });
      }
    }
  },
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_0__components_Component_Confirmar_Accion_Overlay___default.a,
    'gestion-salas-reuniones-editar': __WEBPACK_IMPORTED_MODULE_1__components_c_gestion_salas_reuniones_editar___default.a
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/reunion/sala/gestion', {}, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    openModalEditar: function openModalEditar(salaSeleccionada) {
      var vm = this;
      if (salaSeleccionada) vm.salaSeleccionada = salaSeleccionada;
      vm.mostrarModalEditar = true;
    },
    closeModalEditar: function closeModalEditar(refresh) {
      var vm = this;
      vm.mostrarModalEditar = false;
      vm.salaSeleccionada = null;
      if (refresh) vm.fetch();
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var _this2 = this;

      this.salaSeleccionada = o;
      this.mostrarConfirmacionEliminar = true;
      var contenedor = document.getElementsByClassName('contenedor')[0];
      if (window.getComputedStyle(contenedor).overflow !== 'auto') {
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_scroll__["a" /* scrollTo */])({
            vm: _this2,
            ref: _this2.$refs.confirmarEliminar.$el,
            mobile: 0,
            desktop: -400,
            hasOverlay: false
          });
        });
      }
    },
    eliminar: function eliminar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;

      var obj = {
        idSala: vm.salaSeleccionada.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/reunion/sala/gestion', obj, function (data) {
        vm.mostrarConfirmacionEliminar = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
      });
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_horas_extras_component',
  data: function data() {
    return {
      horas: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      mostrarConfirmacionNoLoTomo: false,
      solicitudSeleccionada: {},
      filtroCodigoEmpleado: '',
      desde: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format('YYYY-MM-DD'),
      hasta: __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format('YYYY-MM-DD')
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.fetch();
  },

  methods: {
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        desde: vm.desde,
        hasta: vm.hasta
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/empleado/obtener/hora-extra', filtros, function (data) {
        vm.horas = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroCodigoEmpleado = '';
      this.desde = __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format('YYYY-MM-DD');
      this.hasta = __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format('YYYY-MM-DD');
      this.fetch();
    },
    exportarExcel: function exportarExcel() {
      var vm = this;
      vm.isLoading = true;
      var obj = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        desde: vm.desde,
        hasta: vm.hasta
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiGetExcel */])(vm, '/empleado/obtener/hora-extra/excel', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'horasExtras' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    exportarNuevoExcel: function exportarNuevoExcel() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        desde: vm.desde,
        hasta: vm.hasta
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiGetExcel */])(vm, '/empleado/obtener/hora-extra/excel-nuevo-reporte', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'reporteVacacionesEmpleado' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'links-importantes',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      idSeleccionado: null,
      rutaSeleccionada: null
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;

      var obj = {
        activo: 1
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/links-importantes', obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.idSeleccionado = o.id;
      vm.rutaSeleccionada = o.ruta;
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default.a
  },
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarConfirmacionFirmar: false,
      mostrarModalConfirmacionToken: false,
      correoServer: null,
      tokenCliente: null,
      fechaObjetivo: new Date(),
      cuentaRegresiva: null,
      esVer: false,
      contrato: null,
      isSending: false
    };
  },
  created: function created() {
    this.fetch();
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    actualizarCuentaRegresiva: function actualizarCuentaRegresiva() {
      var ahora = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      var duracion = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(this.fechaObjetivo.diff(ahora));

      // const dias = Math.floor(duracion.asDays());
      // const horas = duracion.hours();
      var minutos = duracion.minutes();
      var segundos = duracion.seconds();

      // Actualiza la cuenta regresiva en formato 'X días, XX:XX:XX'
      this.cuentaRegresiva = this.formatearTiempo(minutos) + ':' + this.formatearTiempo(segundos);

      // Detener la cuenta regresiva si se alcanza la fecha objetivo
      if (duracion.asSeconds() <= 0) {
        this.cuentaRegresiva = '¡El tiempo ha llegado!';
        clearInterval(this.intervalo);
      }
    },
    formatearTiempo: function formatearTiempo(valor) {
      return valor < 10 ? '0' + valor : valor;
    },
    fetch: function fetch() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/mis-contratos', obj, function (data) {
        if (data.status === 1) {
          vm.lista = data.lista;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    verContrato: function verContrato(o) {
      this.contrato = o;
      if (o.primera_visualizacion) {
        this.obtenerLinkContrato();
        return;
      }
      this.generarTokenVer();
    },
    confirmacionFirmar: function confirmacionFirmar(o) {
      this.mostrarConfirmacionFirmar = true;
      this.contrato = o;
    },
    firmar: function firmar() {
      var vm = this;
      if (vm.isSending) return;
      vm.isSending = true;
      var obj = {
        id: vm.contrato.id,
        tokenContrato: vm.tokenCliente
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/contratos/firmar', obj, function (data) {
        if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
          vm.fetch();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSending = false;
        vm.mostrarConfirmacionFirmar = false;
        vm.mostrarModalConfirmacionToken = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(function (a) {
            return !a.firmado;
          }).length);
        });
      });
    },
    generarTokenVer: function generarTokenVer() {
      var vm = this;
      var obj = {
        id: vm.contrato.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/contratos/firmar/generar-token/ver', obj, function (data) {
        if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
          vm.correoServer = data.correo;
          vm.mostrarConfirmacionFirmar = false;
          vm.mostrarModalConfirmacionToken = true;
          vm.esVer = true;
          vm.fechaObjetivo = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.duracionVerTokenContrato);
          vm.actualizarCuentaRegresiva();
          vm.intervalo = setInterval(vm.actualizarCuentaRegresiva, 1000);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.mostrarConfirmacionFirmar = false;
        vm.tokenCliente = null;
      });
    },
    generarToken: function generarToken() {
      var vm = this;
      var obj = {
        id: vm.contrato.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/contratos/firmar/generar-token', obj, function (data) {
        if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
          vm.correoServer = data.correo;
          vm.mostrarConfirmacionFirmar = false;
          vm.mostrarModalConfirmacionToken = true;
          vm.fechaObjetivo = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.duracionTokenContrato);
          vm.actualizarCuentaRegresiva();
          vm.intervalo = setInterval(vm.actualizarCuentaRegresiva, 1000);
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.mostrarConfirmacionFirmar = false;
        vm.tokenCliente = null;
      });
    },
    guardarGenerarToken: function guardarGenerarToken() {
      var vm = this;
      if (vm.esVer) {
        vm.obtenerLinkContrato();
        return;
      }
      vm.firmar();
      clearInterval(this.intervalo);
    },
    obtenerLinkContrato: function obtenerLinkContrato() {
      var vm = this;
      var obj = { id: vm.contrato.id };
      if (!vm.contrato.primera_visualizacion) {
        obj.tokenContrato = vm.tokenCliente;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/contratos/obtener/path-contrato', obj, function (data) {
        vm.fetch();
        if (data.status === 1) {
          window.open(data.pathContrato, '_blank');
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.mostrarModalConfirmacionToken = false;
        vm.contrato = null;
        vm.tokenCliente = null;
        vm.esVer = false;
      });
    },
    cerrarModalConfirmacionToken: function cerrarModalConfirmacionToken() {
      this.mostrarModalConfirmacionToken = false;
      this.tokenCliente = null;
      clearInterval(this.intervalo);
    }
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default.a,
    'upload-image': __WEBPACK_IMPORTED_MODULE_2__components_Component_Upload_Image___default.a
  },
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarConfirmacionEliminar: false,
      isSending: false,
      codigoEmpleado: +localStorage.getItem('codigo'),
      mostrarModalAdjuntar: false,
      documento: {},
      downloading: false
    };
  },
  created: function created() {
    this.fetch();
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        codigoEmpleado: vm.codigoEmpleado
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/mis-documentos', obj, function (data) {
        if (data.status === 1) {
          vm.lista = data.lista;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    confirmacionSubirPdf: function confirmacionSubirPdf(row) {
      this.documento = row;
      this.mostrarModalAdjuntar = true;
    },
    confirmacionEliminarPdf: function confirmacionEliminarPdf(row) {
      this.documento = row;
      this.mostrarConfirmacionEliminar = true;
    },
    guardarDocumentoSubido: function guardarDocumentoSubido(fileSubido) {
      var vm = this;
      var obj = {
        id: vm.documento.id,
        codigoEmpleado: vm.documento.codigoEmpleado,
        ruta: fileSubido.file.ruta
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, '/documentos-firmar/subir-pdf', obj, function (data) {
        if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
          vm.fetch();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.closeModalAdjuntar();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    eliminarDocumento: function eliminarDocumento() {
      var vm = this;
      var obj = {
        id: vm.documento.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["g" /* apiDelete */])(vm, '/documentos-firmar/mi-pdf', obj, function (data) {
        if (data.status === 1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
          vm.fetch();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.closeModalEliminar();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length);
        });
      });
    },
    closeModalEliminar: function closeModalEliminar() {
      this.mostrarConfirmacionEliminar = false;
      this.documento = null;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      this.mostrarModalAdjuntar = false;
      this.documento = null;
    },
    descargarDocumento: function descargarDocumento(row) {
      var vm = this;
      if (vm.downloading) return;
      vm.downloading = true;

      var obj = { id: row.idDetalle };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, '/documentos-firmar/mis-documentos/descargar', obj, function (data) {
        if (data.status === 1) {
          vm.fetch();
          window.open(data.ruta, '_blank').focus();
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.downloading = false;
      });
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Contratos__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Contratos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Contratos__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contratos-reporte',
  components: {
    'reporte-contratos': __WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Contratos___default.a
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_terminado_alumnos__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_terminado_alumnos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_terminado_alumnos__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view_reporte_cursos_virtuales',
  components: {
    'reporte-cursos-virtuales-terminados': __WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_terminado_alumnos___default.a
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_virtuales__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_virtuales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_virtuales__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view_reporte_cursos_virtuales',
  components: {
    'reporte-cursos-virtuales': __WEBPACK_IMPORTED_MODULE_0__components_c_reporte_cursos_virtuales___default.a
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Documentos_Firmar__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Documentos_Firmar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Documentos_Firmar__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view_reporte_cdocumentos_firmar',
  components: {
    'reporte-documentos-firmar': __WEBPACK_IMPORTED_MODULE_0__components_Component_Reporte_Documentos_Firmar___default.a
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reporte_vacaciones_component',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      mostrarBusquedaEmpleado: false,
      mostrarFiltros: true,
      mostrarConfirmacionNoLoTomo: false,
      solicitudSeleccionada: {},
      filtroCodigoEmpleado: '',
      desde: __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format('YYYY-MM-DD'),
      hasta: __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format('YYYY-MM-DD'),
      empleadosInactivos: 'all',
      modoFiltroVacaciones: 'rango' // rango | laboral
    };
  },

  components: {
    LookupSmallEmpleado: __WEBPACK_IMPORTED_MODULE_0__components_Component_Lookup_Small_Empleado___default.a
  },
  created: function created() {
    this.limpiarFiltros();
    this.fetch();
  },

  methods: {
    borrarEmpleado: function borrarEmpleado() {
      this.filtroCodigoEmpleado = '';
      this.fetch();
    },
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      this.filtroCodigoEmpleado = o.codigo;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;

      var filtros = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        desde: vm.desde,
        hasta: vm.hasta,
        empleadosInactivos: vm.empleadosInactivos,
        modoFiltroVacaciones: vm.modoFiltroVacaciones
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/vacaciones/reporte-sap', filtros, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    exportarExcel: function exportarExcel() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        desde: vm.desde,
        hasta: vm.hasta,
        codigoEmpleado: vm.filtroCodigoEmpleado,
        modoFiltroVacaciones: vm.modoFiltroVacaciones
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiGetExcel */])(vm, '/vacaciones/reporte-sap/excel', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'reporteVacaciones' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    limpiarFiltros: function limpiarFiltros() {
      this.filtroCodigoEmpleado = '';
      this.desde = __WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('month').format('YYYY-MM-DD');
      this.hasta = __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('month').format('YYYY-MM-DD');
      this.fetch();
    },
    exportarNuevoExcel: function exportarNuevoExcel() {
      var vm = this;
      if (vm.isLoading) return;
      vm.isLoading = true;
      var obj = {
        codigoEmpleado: vm.filtroCodigoEmpleado,
        desde: vm.desde,
        hasta: vm.hasta,
        modoFiltroVacaciones: vm.modoFiltroVacaciones
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["e" /* apiGetExcel */])(vm, '/vacaciones/empleado/vacacionesNuevoReporte', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'reporteVacacionesEmpleado' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reunion-vista-detallada',
  data: function data() {
    return {
      titulo: '',
      descripcion: '',
      nombreCreador: '',
      estado: 0,
      tipo: '',
      modalidad: '',
      link: '',
      sala: '',
      fecha: '',
      horaDesde: '',
      horaHasta: '',
      minutaDescripcion: '',
      minutaLink: '',
      salaTitulo: '',
      salaDescripcion: '',
      asistio: null,
      fechaMarcaAsistio: '',
      codigoCreador: '',
      asistentes: [],
      codigo: +localStorage.getItem('codigo')
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idReunion: function idReunion() {
      return +this.$route.params.idReunion;
    }
  },
  components: {},
  mounted: function mounted() {
    this.fetch();
    this.fetchAsistentes();
  },

  methods: {
    convertirSaltosDeLinea: function convertirSaltosDeLinea(texto) {
      return texto ? texto.replace(/\n/g, '<br>') : '';
    },
    volver: function volver() {
      var vm = this;
      vm.$router.push('/mis-reuniones');
    },
    close: function close(prop) {
      this[prop] = false;
    },
    fetchAsistentes: function fetchAsistentes() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/reunion/gestion/' + vm.idReunion + '/asistente', {}, function (data) {
        vm.asistentes = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["c" /* apiGet */])(vm, '/reunion/gestion/' + vm.idReunion, { esVistaDetallada: true }, function (data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vm).forEach(function (key) {
          if (data.reunion[key]) vm[key] = data.reunion[key];
        });
        if (data.reunion.asistio === 1 || data.reunion.asistio === 0) {
          vm.asistio = data.reunion.asistio;
        } else {
          vm.asistio = null;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    marcarAsitencia: function marcarAsitencia(asisti) {
      var vm = this;
      vm.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["d" /* apiPut */])(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/marcar-asistencia/mi-asistencia', { asisti: asisti }, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha marcado la asistencia correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.fetch();
      });
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_general__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-reuniones',
  data: function data() {
    return {
      lista: [],
      isLoading: false,
      isScroll: false,
      disabledScrollExecute: true,
      skip: 0,
      noMore: false,
      codigo: +localStorage.getItem('codigo'),
      mostrarConfirmacionEliminar: false,
      confirmacionEliminarTitulo: '',
      confirmacionEliminarDescripcion: '',
      confirmacionEliminarId: '',
      isSendingEliminar: false,
      mostrarFiltros: true,
      filtros: {
        estado: null,
        creadoPorMi: false
      }
    };
  },

  components: {
    'confirmar-accion-overlay': __WEBPACK_IMPORTED_MODULE_1__components_Component_Confirmar_Accion_Overlay___default.a
  },
  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    }
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    changeFiltro: function changeFiltro() {
      this.fetch();
    },
    eliminar: function eliminar() {
      var vm = this;
      if (vm.isSendingEliminar) return;
      vm.isSendingEliminar = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["g" /* apiDelete */])(vm, '/reunion/gestion/' + vm.confirmacionEliminarId, {}, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'success', 'Éxitoso', 'Reunión eliminada.');
        vm.fetch();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isSendingEliminar = false;
      });
    },
    confirmarEliminar: function confirmarEliminar(o) {
      var vm = this;

      vm.confirmacionEliminarId = o.id;
      vm.confirmacionEliminarTitulo = 'Eliminar reunión';
      vm.confirmacionEliminarDescripcion = '¿Estás seguro de eliminar la reunión ' + o.titulo + '?';

      vm.mostrarConfirmacionEliminar = true;
    },
    redirigir: function redirigir(idReunion) {
      var vm = this;
      vm.$router.push('/gestion-reuniones/' + idReunion);
    },
    verDetalle: function verDetalle(idReunion) {
      var vm = this;
      vm.$router.push('/reunion-vista-detallada/' + idReunion);
    },
    fetchByScroll: function fetchByScroll() {
      var vm = this;
      vm.isScroll = true;
      vm.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      vm.disabledScrollExecute = true;
      vm.noMore = false;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, vm.filtros);
      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }
      obj.skip = vm.skip;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["c" /* apiGet */])(vm, '/reunion/lista', obj, function (data) {
        // poner a las fechas este formato 2018-01-01 00:00:00 con moment
        data.lista.forEach(function (o) {
          // o.fecha = moment(o.fecha).format('DD/MM/YYYY HH:mm:ss')
          vm.lista.push(o);
        });
        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip = +data.numeroRecnum;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
        vm.isScroll = false;
      });
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Lista_Asistentes_Empleados_Multiple__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Lista_Asistentes_Empleados_Multiple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Lista_Asistentes_Empleados_Multiple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component_Upload_Image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Component_Upload_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Component_Upload_Image__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gestion-reuniones-editar',
  data: function data() {
    return {
      salas: [],
      isLoadingReunion: false,
      isLoadingSalas: false,
      form: {
        titulo: null,
        descripcion: null,
        estado: null,
        tipo: 'reunion',
        modalidad: 'presencial',
        link: null,
        idSala: null,
        fecha: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        horaDesde: null,
        horaHasta: null,
        minutaDescripcion: null,
        minutaLink: null,
        minutaOpcion: 'texto',
        codigoCreador: null,
        nombreCapacitador: ''
      },
      mostrarAsistentes: true,
      showModalAdjuntar: false,
      esReunionTerminada: false,
      esReunionAnulada: false,
      API_ROUTE: "https://api-selfservice.datacont.com",
      EMPRESA: "datacont",
      token: localStorage.getItem('token'),
      codigo: localStorage.getItem('codigo'),
      isExporting: false
    };
  },

  computed: {
    showSidebarDesktop: function showSidebarDesktop() {
      return this.$store.getters.showSidebarDesktop;
    },
    idReunion: function idReunion() {
      return +this.$route.params.idReunion;
    }
  },
  components: {
    'asistentes-lista': __WEBPACK_IMPORTED_MODULE_4__components_Lista_Asistentes_Empleados_Multiple___default.a,
    'upload-image': __WEBPACK_IMPORTED_MODULE_5__components_Component_Upload_Image___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchSalas();
    if (this.idReunion) {
      this.fetchReunion();
    }
  },

  watch: {
    // Observa los cambios en el parámetro "id" de la ruta
    '$route.params.idReunion': function $routeParamsIdReunion(id) {
      if (this.idReunion) {
        this.fetchReunion();
      } else {
        this.limpiarDatos();
        this.fetchSalas();
      }
    }
  },
  methods: {
    notificar: function notificar() {
      var vm = this;
      if (!vm.form.titulo) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un título.');
      if (!vm.form.descripcion) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una descripción.');
      if (!vm.form.fecha) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una fecha.');
      if (!vm.form.horaDesde) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una hora de desde.');
      if (!vm.form.horaHasta) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una hora de hasta.');
      if (vm.form.modalidad === 'presencial' && !vm.form.idSala) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escoja una sala.');
      if (vm.form.modalidad === 'virtual' && !vm.form.link) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un link para la reunión o capacitación.');
      vm.isLoadingReunion = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/reunion/gestion/' + vm.idReunion + '/notificar', vm.form, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha notificado la reunión correctamente');
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingReunion = false;
      });
    },
    guardarAdjunto: function guardarAdjunto(fileSubido) {
      var vm = this;
      vm.closeModalAdjuntar();
      vm.form.minutaLink = fileSubido.file.ruta;
    },
    abrirModalAdjuntar: function abrirModalAdjuntar() {
      var vm = this;
      vm.showModalAdjuntar = true;
    },
    closeModalAdjuntar: function closeModalAdjuntar() {
      var vm = this;
      vm.showModalAdjuntar = false;
    },
    borrarAdjunto: function borrarAdjunto() {
      var vm = this;
      if (vm.esReunionAnulada) return;
      vm.form.minutaLink = '';
    },
    limpiarDatos: function limpiarDatos() {
      var _this = this;

      this.isLoadingSalas = false;
      this.isLoadingReunion = false;
      this.showModalAdjuntar = false;
      this.form = {
        titulo: null,
        descripcion: null,
        estado: null,
        tipo: 'reunion',
        modalidad: 'presencial',
        link: null,
        idSala: null,
        fecha: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        horaDesde: null,
        horaHasta: null,
        minutaDescripcion: null,
        minutaLink: null,
        codigoCreador: null,
        minutaOpcion: 'texto'
      };
      this.mostrarAsistentes = false;
      this.$nextTick(function () {
        _this.mostrarAsistentes = true;
      });
      this.esReunionTerminada = false;
      this.esReunionAnulada = false;
      this.salas = [];
    },
    volver: function volver() {
      var vm = this;
      vm.$router.push('/mis-reuniones');
    },
    handlerMinuta: function handlerMinuta() {
      var vm = this;
      if (vm.form.minutaOpcion === 'texto') {
        vm.form.minutaLink = null;
      } else {
        vm.form.minutaDescripcion = null;
      }
    },
    handlerModalidad: function handlerModalidad() {
      var vm = this;
      if (vm.form.modalidad === 'presencial') {
        vm.form.link = null;
      } else {
        vm.form.idSala = null;
      }
    },
    fetchReunion: function fetchReunion() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var vm = _this2;
        vm.isLoadingReunion = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/reunion/gestion/' + vm.idReunion, {}, function (data) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vm.form).forEach(function (key) {
            vm.form[key] = data.reunion[key];
          });
          if (data.reunion.estado === 1) {
            vm.esReunionTerminada = true;
          } else if (data.reunion.estado === 2) {
            vm.esReunionAnulada = true;
          }
          resolve(null);
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
          vm.$router.push('/gestion-reuniones');
        }, function () {
          vm.isLoadingReunion = false;
        });
      });
    },
    fetchSalas: function fetchSalas() {
      var vm = this;
      vm.isLoadingSalas = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, '/reunion/sala/gestion', { activo: 1 }, function (data) {
        vm.salas = data.lista;
        if (vm.salas.length > 0) {
          vm.isLoadingSalas = false;
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'warning', '¡Cuidado!', 'No se encontraron salas');
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {});
    },
    saveAsistente: function saveAsistente() {
      this.guardar({ toAsignarEmpleados: true });
    },
    cambiarEstado: function cambiarEstado(estado) {
      var vm = this;
      if (estado === 1) {
        vm.terminar();
      } else if (estado === 2) {
        vm.anular();
      }
    },
    anular: function anular() {
      var vm = this;
      vm.isLoadingReunion = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiPut */])(vm, '/reunion/gestion/' + vm.idReunion + '/anular', vm.form, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha anulado la reunión correctamente');
        vm.fetchReunion();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingReunion = false;
      });
    },
    terminar: function terminar() {
      var vm = this;
      if (!vm.form.titulo) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un título.');
      if (!vm.form.descripcion) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una descripción.');
      if (!vm.form.fecha) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una fecha.');
      if (!vm.form.horaDesde) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una hora de desde.');
      if (!vm.form.horaHasta) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba una hora de hasta.');
      if (vm.form.modalidad === 'presencial' && !vm.form.idSala) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escoja una sala.');
      if (vm.form.modalidad === 'virtual' && !vm.form.link) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un link para la reunión o capacitación.');
      vm.isLoadingReunion = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiPut */])(vm, '/reunion/gestion/' + vm.idReunion + '/terminar', vm.form, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Se ha terminado la reunión correctamente');
        vm.fetchReunion();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoadingReunion = false;
      });
    },
    guardar: function guardar() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          toAsignarEmpleados = _ref.toAsignarEmpleados;

      var vm = this;
      if (vm.isLoadingReunion) return;
      if (!vm.form.titulo) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Escriba un título.');
      // if (!vm.form.fecha) return notify(vm, 'error', 'Error', 'Escriba una fecha.')
      // if (!vm.form.horaDesde) return notify(vm, 'error', 'Error', 'Escriba una hora de desde.')
      // if (!vm.form.horaHasta) return notify(vm, 'error', 'Error', 'Escriba una hora de hasta.')
      vm.isLoadingReunion = true;
      if (vm.form.estado === 1) {
        vm.$refs.asistenteRef.guardarAsistentes();
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (vm.idReunion) {
          return vm.actualizar(vm, vm.form);
        } else {
          return vm.insertar(vm, vm.form);
        }
      }).then(function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', data.message);
        if (!vm.idReunion) vm.$router.push('/gestion-reuniones/' + data.idReunion);
        vm.fetchReunion().then(function () {
          vm.$refs.asistenteRef.fetch();
        });
      }).catch(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }).finally(function () {
        vm.isLoadingReunion = false;
        if (toAsignarEmpleados) {
          vm.$nextTick(function () {
            vm.$refs.asistenteRef.abrirModalAsignarEmpleados();
          });
        }
      });
    },
    insertar: function insertar(vm, obj) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/reunion/gestion/0', obj, function (data) {
          resolve(data);
        }, function (error) {
          reject(error);
        }, function () {
          vm.isSaving = false;
        });
      });
    },
    actualizar: function actualizar(vm, obj) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiPut */])(vm, '/reunion/gestion/' + vm.idReunion, obj, function (data) {
          resolve(data);
        }, function (error) {
          reject(error);
        }, function () {
          vm.isSaving = false;
        });
      });
    },
    exportarPdf: function exportarPdf() {
      var vm = this;
      window.open(vm.API_ROUTE + '/reunion/imprimir/pdf?empresa=' + vm.EMPRESA + '&numero=' + vm.idReunion + '&token=' + vm.token + '&codigo=' + vm.codigo, '_blank');
    },
    exportarExcel: function exportarExcel() {
      var vm = this;
      vm.isExporting = true;
      var obj = {
        reunion: vm.idReunion
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["e" /* apiGetExcel */])(vm, '/reunion/exportarExcel', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'Asistencias_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        console.error('Error:' + error.message);
      }, function () {
        vm.isExporting = false;
      });
    }
  }
});

/***/ }),
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */,
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 102,
	"./af.js": 102,
	"./ar": 109,
	"./ar-dz": 103,
	"./ar-dz.js": 103,
	"./ar-kw": 104,
	"./ar-kw.js": 104,
	"./ar-ly": 105,
	"./ar-ly.js": 105,
	"./ar-ma": 106,
	"./ar-ma.js": 106,
	"./ar-sa": 107,
	"./ar-sa.js": 107,
	"./ar-tn": 108,
	"./ar-tn.js": 108,
	"./ar.js": 109,
	"./az": 110,
	"./az.js": 110,
	"./be": 111,
	"./be.js": 111,
	"./bg": 112,
	"./bg.js": 112,
	"./bm": 113,
	"./bm.js": 113,
	"./bn": 115,
	"./bn-bd": 114,
	"./bn-bd.js": 114,
	"./bn.js": 115,
	"./bo": 116,
	"./bo.js": 116,
	"./br": 117,
	"./br.js": 117,
	"./bs": 118,
	"./bs.js": 118,
	"./ca": 119,
	"./ca.js": 119,
	"./cs": 120,
	"./cs.js": 120,
	"./cv": 121,
	"./cv.js": 121,
	"./cy": 122,
	"./cy.js": 122,
	"./da": 123,
	"./da.js": 123,
	"./de": 126,
	"./de-at": 124,
	"./de-at.js": 124,
	"./de-ch": 125,
	"./de-ch.js": 125,
	"./de.js": 126,
	"./dv": 127,
	"./dv.js": 127,
	"./el": 128,
	"./el.js": 128,
	"./en-au": 129,
	"./en-au.js": 129,
	"./en-ca": 130,
	"./en-ca.js": 130,
	"./en-gb": 131,
	"./en-gb.js": 131,
	"./en-ie": 132,
	"./en-ie.js": 132,
	"./en-il": 133,
	"./en-il.js": 133,
	"./en-in": 134,
	"./en-in.js": 134,
	"./en-nz": 135,
	"./en-nz.js": 135,
	"./en-sg": 136,
	"./en-sg.js": 136,
	"./eo": 137,
	"./eo.js": 137,
	"./es": 46,
	"./es-do": 138,
	"./es-do.js": 138,
	"./es-mx": 139,
	"./es-mx.js": 139,
	"./es-us": 140,
	"./es-us.js": 140,
	"./es.js": 46,
	"./et": 141,
	"./et.js": 141,
	"./eu": 142,
	"./eu.js": 142,
	"./fa": 143,
	"./fa.js": 143,
	"./fi": 144,
	"./fi.js": 144,
	"./fil": 145,
	"./fil.js": 145,
	"./fo": 146,
	"./fo.js": 146,
	"./fr": 149,
	"./fr-ca": 147,
	"./fr-ca.js": 147,
	"./fr-ch": 148,
	"./fr-ch.js": 148,
	"./fr.js": 149,
	"./fy": 150,
	"./fy.js": 150,
	"./ga": 151,
	"./ga.js": 151,
	"./gd": 152,
	"./gd.js": 152,
	"./gl": 153,
	"./gl.js": 153,
	"./gom-deva": 154,
	"./gom-deva.js": 154,
	"./gom-latn": 155,
	"./gom-latn.js": 155,
	"./gu": 156,
	"./gu.js": 156,
	"./he": 157,
	"./he.js": 157,
	"./hi": 158,
	"./hi.js": 158,
	"./hr": 159,
	"./hr.js": 159,
	"./hu": 160,
	"./hu.js": 160,
	"./hy-am": 161,
	"./hy-am.js": 161,
	"./id": 162,
	"./id.js": 162,
	"./is": 163,
	"./is.js": 163,
	"./it": 165,
	"./it-ch": 164,
	"./it-ch.js": 164,
	"./it.js": 165,
	"./ja": 166,
	"./ja.js": 166,
	"./jv": 167,
	"./jv.js": 167,
	"./ka": 168,
	"./ka.js": 168,
	"./kk": 169,
	"./kk.js": 169,
	"./km": 170,
	"./km.js": 170,
	"./kn": 171,
	"./kn.js": 171,
	"./ko": 172,
	"./ko.js": 172,
	"./ku": 173,
	"./ku.js": 173,
	"./ky": 174,
	"./ky.js": 174,
	"./lb": 175,
	"./lb.js": 175,
	"./lo": 176,
	"./lo.js": 176,
	"./lt": 177,
	"./lt.js": 177,
	"./lv": 178,
	"./lv.js": 178,
	"./me": 179,
	"./me.js": 179,
	"./mi": 180,
	"./mi.js": 180,
	"./mk": 181,
	"./mk.js": 181,
	"./ml": 182,
	"./ml.js": 182,
	"./mn": 183,
	"./mn.js": 183,
	"./mr": 184,
	"./mr.js": 184,
	"./ms": 186,
	"./ms-my": 185,
	"./ms-my.js": 185,
	"./ms.js": 186,
	"./mt": 187,
	"./mt.js": 187,
	"./my": 188,
	"./my.js": 188,
	"./nb": 189,
	"./nb.js": 189,
	"./ne": 190,
	"./ne.js": 190,
	"./nl": 192,
	"./nl-be": 191,
	"./nl-be.js": 191,
	"./nl.js": 192,
	"./nn": 193,
	"./nn.js": 193,
	"./oc-lnc": 194,
	"./oc-lnc.js": 194,
	"./pa-in": 195,
	"./pa-in.js": 195,
	"./pl": 196,
	"./pl.js": 196,
	"./pt": 198,
	"./pt-br": 197,
	"./pt-br.js": 197,
	"./pt.js": 198,
	"./ro": 199,
	"./ro.js": 199,
	"./ru": 200,
	"./ru.js": 200,
	"./sd": 201,
	"./sd.js": 201,
	"./se": 202,
	"./se.js": 202,
	"./si": 203,
	"./si.js": 203,
	"./sk": 204,
	"./sk.js": 204,
	"./sl": 205,
	"./sl.js": 205,
	"./sq": 206,
	"./sq.js": 206,
	"./sr": 208,
	"./sr-cyrl": 207,
	"./sr-cyrl.js": 207,
	"./sr.js": 208,
	"./ss": 209,
	"./ss.js": 209,
	"./sv": 210,
	"./sv.js": 210,
	"./sw": 211,
	"./sw.js": 211,
	"./ta": 212,
	"./ta.js": 212,
	"./te": 213,
	"./te.js": 213,
	"./tet": 214,
	"./tet.js": 214,
	"./tg": 215,
	"./tg.js": 215,
	"./th": 216,
	"./th.js": 216,
	"./tk": 217,
	"./tk.js": 217,
	"./tl-ph": 218,
	"./tl-ph.js": 218,
	"./tlh": 219,
	"./tlh.js": 219,
	"./tr": 220,
	"./tr.js": 220,
	"./tzl": 221,
	"./tzl.js": 221,
	"./tzm": 223,
	"./tzm-latn": 222,
	"./tzm-latn.js": 222,
	"./tzm.js": 223,
	"./ug-cn": 224,
	"./ug-cn.js": 224,
	"./uk": 225,
	"./uk.js": 225,
	"./ur": 226,
	"./ur.js": 226,
	"./uz": 228,
	"./uz-latn": 227,
	"./uz-latn.js": 227,
	"./uz.js": 228,
	"./vi": 229,
	"./vi.js": 229,
	"./x-pseudo": 230,
	"./x-pseudo.js": 230,
	"./yo": 231,
	"./yo.js": 231,
	"./zh-cn": 232,
	"./zh-cn.js": 232,
	"./zh-hk": 233,
	"./zh-hk.js": 233,
	"./zh-mo": 234,
	"./zh-mo.js": 234,
	"./zh-tw": 235,
	"./zh-tw.js": 235
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 657;

/***/ }),
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(890),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-646183cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(807),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(925),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8be8cace",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(945),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b1e4191e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ecb8cd44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(928),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8fd62446",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(874),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43d50e80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(930),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-91aa56f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(880),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bcd55c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(939),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a8cd3ab4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(935),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6800236",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d663e24a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(898),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e5fcf6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(650)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(966),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e70b8266",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(816),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0be24f46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bce7ddde",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(860),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35d26762",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(828),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14802068",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(905),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72b607d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(909),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76c3cd1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(832),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-179e10aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(855),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3091949a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fbc6437e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(915),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78f8b02c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dfbac6ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(848),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ca04e98",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(573)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(888),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63b2c303",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(893),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66fcebf1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(557)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(872),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42a3ea4b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(887),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f705c02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(839),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24005d6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(914),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78756d14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(918),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-799f91c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(858),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35c36f7f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d1c0dce8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(838),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-235f73ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(829),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14b0fa6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(861),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3650b498",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(912),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7833f592",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(836),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-221aa8d7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(884),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-581ef49c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(941),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b0944ace",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79709f32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c0634b2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(947),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b7e349f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(882),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-544249e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(889),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63e1a4a7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(835),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e25cf63",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d52252be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(908),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73c4ecbf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(847),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a99b16a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(940),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ab169f18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(560)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(875),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43fb2d14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d8636180",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(879),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b89ea72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(885),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-599f29d3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(964),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e37bc1e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e45c6ec6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(891),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65f65f3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(929),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-91648cce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(554)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(869),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4151eab0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(812),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06bfe8ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(577)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(892),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66d2e90c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(897),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b3aba1d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(911),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(852),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2de3bc1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(900),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f0d94c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(628)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(944),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b1360344",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(617)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(933),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a04e7fd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(942),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b0e97578",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(934),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a1533eb4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(895),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67b347f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(813),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08d50790",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(962),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dd0d0916",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(845),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29b5ea6d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(833),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b7257c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(844),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-285f1573",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(926),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8d07693c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(830),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14c301e1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c0f04a94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(863),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37e34fae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(878),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45ed3cac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(817),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e1f4f40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(824),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-114a5fcc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(814),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a443f63",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(901),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f96f0f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(907),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73b5ba36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(837),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-228225cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(849),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cc39c9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(820),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f1a0a80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(854),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3053f54c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(906),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7360519a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(868),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e20beae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(931),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-973b748a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(948),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bb3bceca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(902),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ff31c11",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(810),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05ce3753",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(866),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c0d8745",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(881),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54330afe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(841),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24c10d8e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(954),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c6fb64f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(946),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b3b1dc5e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(956),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d0b4ba0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(904),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71599ef3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(886),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d53935a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ca15d9fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(919),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7abdeae5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(818),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e933060",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a6b6367",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(809),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04b8f6ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(932),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99395978",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(851),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d840fb6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(568)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(883),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-580d1a4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(910),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77282e55",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(620)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(936),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6d6427e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(826),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13246f5b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(865),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a4648f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(870),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-420ed3d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(850),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d15eee2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(821),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1011f8f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(604)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(920),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d098b78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(815),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ba32dba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(916),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78fd7715",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(842),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2612fcff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(921),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7df851a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(938),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a795bc74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(924),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8b9dec1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(864),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39f38410",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(857),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-328dd44b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(819),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0eed6eb4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8f3dfa42",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(831),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-170fa610",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(922),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e0137ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d5156c56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(903),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70bcf60c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(896),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a7e0f9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(811),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0644ed58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(856),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-310d3a9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(808),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-015cdf04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(859),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35c8028c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(825),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12553ce2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(943),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b10f4334",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(913),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-786d9e55",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(873),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-434f8435",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex height-100"
  }, [_c('div', {
    staticClass: "margin-auto"
  }, [_c('div', {
    staticClass: "half-width margin-auto margin-top-10"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Boletines Mensuales")]), _c('p'), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Esta opcion se encuentra en desarrollo")])])])])
}]}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "reporte_documentos_firmar",
    staticClass: "box position-relative"
  }, [_c('reporte-cursos-virtuales')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-section"
  }, [_vm._m(0), _c('div', {
    staticClass: "cards-grid"
  }, _vm._l((_vm.lista), function(item) {
    return _c('StatCard', {
      key: item.id,
      attrs: {
        "titulo": item.titulo,
        "descripcion": item.descripcion,
        "cantidad": item.cantidad,
        "tipo": item.tipo,
        "centrado": true
      },
      on: {
        "click": function($event) {
          return _vm.redirigir(item.ruta)
        }
      }
    })
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Pendientes como jefe")]), _c('p', [_vm._v("Solicitudes que necesitan revisión o aprobación.")])])])
}]}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "reporte_boletas",
    staticClass: "box position-relative"
  }, [_c('reporte-contratos')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de contratos de mi equipo")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesPorAprobar) ? _c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('lista-solicitudes-por-aprobar', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesPorAprobar = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaEquipo) ? _c('div', {
    key: "lista_equipo",
    staticClass: "box position-relative"
  }, [_c('lista-equipo-contratos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaEquipo = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de permisos aprobados")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesPorAprobar) ? _c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('lista-solicitud-permisos-por-aprobar', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesPorAprobar = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_documento_importante",
      "folder": "documentos_importantes"
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la imagen que sustenta tu permiso")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar documento importante")]) : _c('span', [_vm._v("Crear documento importante")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Orden")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orden),
      expression: "orden"
    }],
    staticClass: "input w-90",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.orden)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orden = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoading
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripcion")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "display-flex text-center jc-center"
  }, [
    [(_vm.ruta) ? _c('div', [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": _vm.ruta,
        "target": "_blank"
      }
    }, [_vm._m(0), _c('span', [_vm._v("Ver adjunto")])])]) : _c('div', [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": _vm.openModalAdjuntar
      }
    }, [_vm._m(1), _c('span', [_vm._v("Adjuntar")])])])], (_vm.ruta) ? _c('span', {
      staticClass: "icon color-red margin-left-5 cursor-pointer",
      attrs: {
        "tittle": "Borrar adjunto"
      },
      on: {
        "click": function($event) {
          _vm.ruta = ''
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()
  ], 2)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
}]}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('editar-documento-importante', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "id": _vm.idSeleccionado
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      },
      "refresh": _vm.fetch,
      "changeId": _vm.changeId
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalEmpleadosConDocumentos) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("¿SEGURO QUE DESEA CONTINUAR?")])]), _c('div', {
    staticClass: "card-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.mensajeRespuesta))]), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.listaEmpleadosRespuesta), function(nombre, index) {
    return _c('li', {
      key: index,
      staticClass: "tal"
    }, [_c('span', [_vm._v(_vm._s(nombre))])])
  }), 0)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.eliminarDocumento(true)
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Continuar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.cerrarModalEmpleadosConDocumentos()
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e()]), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminarDocumento(false)
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el documento " + _vm._s(_vm.documentoSeleccionado.descripcion) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestion de documentos para firmar")])]), _c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Los documentos cargados en esta pantalla, apareceran para todos los empleados activos de la plataforma")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripción")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      },
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Orden: ' + o.orden
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion))])]), _c('div', {
      staticClass: "d-initial mt-5"
    }, [_c('strong', [_vm._v("Modificado: ")]), _c('span', [_vm._v(_vm._s(o.modificado))])])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.rutaSinLlenar) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.rutaSinLlenar,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e(), _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])], 2)])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay documentos importantes ingresados")])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes por aprobar")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [_vm._v("Aprobar")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [_vm._v("Rechazar")])])], 1) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('loading') : _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-2"
  }, [_vm._v("Tipo renovación")]), _c('th', [_vm._v("Estado")]), _c('th', {
    staticClass: "hide-break-2"
  }, [_vm._v("Creado por")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: o.id + '-tabla',
      staticClass: "row-table",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "td-wrapper hint--right",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_c('div', {
      staticClass: "dates-wrapper hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.nombre) + " ")])]), _c('div', {
      staticClass: "show-break-2 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Renovacion:")]), (o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])]), _c('div', {
      staticClass: "show-break-2 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Creador:")]), _c('span', [_vm._v(_vm._s(o.creadoPor))])])])])]), _c('td', {
      staticClass: "hide-break-2"
    }, [(o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])]), _c('td', [_vm._v(_vm._s(o.descripcionEstado))]), _c('td', {
      staticClass: "hide-break-2"
    }, [_vm._v(_vm._s(o.creadoPor))]), _c('td', [(o.estado === 1) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-o-up"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()])])
  }), 0)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.codigo) ? _c('span', [_vm._v("Editar tipo de boleta")]) : _c('span', [_vm._v("Crear tipo de boleta")])]), _c('span', {
    staticClass: "icon cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Código")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigo),
      expression: "codigo"
    }],
    staticClass: "input w-90 disabled",
    attrs: {
      "type": "number",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripcion")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModalArchivo) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.cerrarArchivo
    }
  }), _c('div', {
    staticClass: "modal-card modal-archivo"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_vm._m(0), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.cerrarArchivo
    }
  })]), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.archivoSeleccionado && !_vm.esPdf(_vm.archivoSeleccionado)) ? _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.archivoSeleccionado
    }
  }) : _vm._e(), (_vm.archivoSeleccionado && _vm.esPdf(_vm.archivoSeleccionado)) ? _c('iframe', {
    staticClass: "preview-pdf",
    attrs: {
      "src": _vm.archivoSeleccionado
    }
  }) : _vm._e()]), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.cerrarArchivo
    }
  }, [_vm._v("Cerrar")])])])]) : _vm._e(), _c('div', {
    staticClass: "section-news"
  }, [_vm._m(1), _c('div', {
    ref: "newsScroll",
    staticClass: "news-scroll",
    on: {
      "scroll": _vm.onNewsScroll
    }
  }, [_c('div', {
    staticClass: "news-grid"
  }, _vm._l((_vm.noticiasVisibles), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "news-card"
    }, [_c('div', {
      staticClass: "news-card-header"
    }, [(item.foto) ? _c('div', {
      staticClass: "news-file-type"
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.esPdf(item.foto) ? 'fa-file-pdf-o' : 'fa-image'
    }), _c('span', [_vm._v(_vm._s(_vm.esPdf(item.foto) ? 'PDF' : 'Imagen'))])]) : _vm._e(), _c('span', {
      staticClass: "news-badge",
      class: item.tipo
    }, [_vm._v(_vm._s(item.tipo))])]), _c('div', {
      staticClass: "news-content"
    }, [_c('h3', [_vm._v(_vm._s(item.titulo))]), _c('p', {
      staticClass: "news-description"
    }, [_vm._v(_vm._s(item.descripcion))])]), _c('div', {
      staticClass: "news-actions"
    }, [(item.foto) ? _c('button', {
      staticClass: "btn-view-file",
      on: {
        "click": function($event) {
          return _vm.abrirArchivo(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _c('span', [_vm._v("Ver archivo")])]) : _c('span', {
      staticClass: "no-file"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }), _vm._v("Sin archivo adjunto")])])])
  }), 0), (_vm.cargandoNoticias) ? _c('div', {
    staticClass: "news-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v("Cargando noticias...")])]) : _vm._e(), (_vm.noMore && _vm.noticiasVisibles.length) ? _c('div', {
    staticClass: "news-end"
  }, [_vm._v("No hay más noticias")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "modal-card-title"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _c('span', [_vm._v("Archivo adjunto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-header"
  }, [_c('div', [_c('h2', [_vm._v("Últimas noticias")]), _c('p', [_vm._v("Mantente informado de comunicados, capacitaciones y novedades importantes.")])])])
}]}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalImportarPlantillaEmpleado) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-image', {
    attrs: {
      "name": "name",
      "folder": "empleados",
      "is-saved": _vm.isSavedAdjunto
    },
    on: {
      "close": _vm.closeAdjuntar,
      "save": _vm.procesoPlantilla
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Plantilla de Empleados")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la plantilla de empleados")])])], 1) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno position-relative"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestión de empleados")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarFiltros) ? _c('div', {
    key: "input-filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado,
      "empleadosInactivos": 'all'
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)])]) : _vm._e(), _c('div', {
    key: "boton-filtro",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.nuevoEmpleado
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-fw fa-lg"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openModalImportarEmpleados
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Excel")])]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.descargarPlantillaEmpleados
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw fa-lg"
  })]), _c('span', [_vm._v("Descargar plantilla")])])])])], 1), _c('div', {
    staticClass: "information"
  }, [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }],
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha de Ingreso")]), _c('th', [_vm._v("DNI")]), _c('th', [_vm._v("Jefe")]), _c('th')]), _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "table-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "tbody",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: ("index_" + (index + 1)),
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('span', [_vm._v(_vm._s(o.nombre))]), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.email))]), _c('br'), (!o.activo && o.fechaInactivo) ? _c('span', {
      staticClass: "name seen has-text-bold"
    }, [_vm._v("Inactivo desde " + _vm._s(o.fechaInactivo))]) : _vm._e()]), _c('td', [_c('div', {
      staticClass: "wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaIngreso))]), (!o.contratoIndeterminado) ? [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]] : _vm._e()], 2)]), _c('td', [_vm._v(_vm._s(o.dni))]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.emailJefe))])]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.activo) ? _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Ver")])]), (o.activo) ? _c('button', {
      staticClass: "button is-small margin-left-5 is-danger",
      on: {
        "click": function($event) {
          return _vm.openModalDarBajaEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-down"
    })]), _c('span', [_vm._v("Desactivar")])]) : _vm._e()])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left",
      class: {
        'is-close': !o.activo
      }
    }, [_c('div', {
      staticClass: "mt-10"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dni))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(o.email))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), (!o.contratoIndeterminado) ? _c('div', [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]], 2) : _vm._e(), (_vm.codigoLogueadoJefe !== (o.codigoJefe + '')) ? [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', [_vm._v(_vm._s(o.nombreJefe))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email jefe: ")]), _c('span', [_vm._v(_vm._s(o.emailJefe))])])] : _vm._e(), (!o.activo && o.fechaInactivo) ? _c('div', {
      staticClass: "mt-5"
    }, [_c('span', {
      staticClass: "name seen has-text-bold"
    }, [_vm._v("Inactivo desde " + _vm._s(o.fechaInactivo))])]) : _vm._e(), _c('div', {
      staticClass: "contenedor-acciones mt-10"
    }, [(o.activo) ? _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditarEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Ver")])]), (o.activo) ? _c('button', {
      staticClass: "button is-small margin-left-5 is-danger",
      on: {
        "click": function($event) {
          return _vm.openModalDarBajaEmpleado(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-down"
    })]), _c('span', [_vm._v("Desactivar")])]) : _vm._e()])], 2)
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])])])])]), (_vm.mostrarModalDarDeBajaEmpleadoEmpleado) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarModalDarDeBajaEmpleadoEmpleado, 'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalDarBajaEmpleado),
      expression: "closeModalDarBajaEmpleado"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Dar de baja empleado")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalDarBajaEmpleado
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("¿ Esta seguro de dar baja al empleado")]), _c('strong', [_vm._v(" " + _vm._s(_vm.codigoEmpleado) + " - " + _vm._s(_vm.nombreEmpleado))]), _c('span', [_vm._v("?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.desactivarEmpleado()
      }
    }
  }, [_c('span', [_vm._v("Dar de baja")])]), _c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalDarBajaEmpleado
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarObservaciones) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarObservaciones
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalObservaciones),
      expression: "closeModalObservaciones"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Observaciones encontradas")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalObservaciones
    }
  })])])]), _c('div', {
    staticClass: "card-content card-content-observaciones-max-height"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, _vm._l((_vm.observaciones), function(o) {
    return (_vm.observaciones.length > 0) ? _c('div', [_c('strong', [_vm._v(_vm._s(o))])]) : _vm._e()
  }), 0)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalObservaciones
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarProcesandoPlantilla) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarProcesandoPlantilla
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Procesando")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', [_vm._v(_vm._s(_vm.mensajeProcesoPlantilla))])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    class: {
      'is-loading': _vm.mostrarProcesandoPlantilla
    },
    attrs: {
      "disabled": _vm.mostrarProcesandoPlantilla
    }
  }, [_c('span')])])])])]) : _vm._e(), (_vm.mostrarModalEditarEmpleado) ? _c('editar-empleado', {
    attrs: {
      "codigoEmpleado": _vm.codigoEmpleado
    },
    on: {
      "close": _vm.closeModalEditarEmpleado
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "columns is-multiline display-flex"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Alumno")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigoEmpleado),
      expression: "filtros.codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtros.codigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigoEmpleado", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtros.codigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtros.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Curso")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idCurso),
      expression: "filtros.idCurso"
    }],
    staticClass: "flex-1",
    attrs: {
      "disabled": _vm.isLoadingCursos
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "idCurso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltroCurso]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.cursos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])
  })], 2)])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Clase")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idClase),
      expression: "filtros.idClase"
    }],
    staticClass: "flex-1",
    attrs: {
      "disabled": _vm.isLoadingClases || _vm.isLoadingCursos
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "idClase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.clases), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])
  })], 2)])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v(_vm._s('Activo(curso)'))])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.activoCurso),
      expression: "filtros.activoCurso"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "activoCurso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Sí")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("No")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v(_vm._s('Activo(clase)'))])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.activoClase),
      expression: "filtros.activoClase"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "activoClase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Sí")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("No")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde termino clase")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desdeFechaTermino),
      expression: "filtros.desdeFechaTermino"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desdeFechaTermino)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desdeFechaTermino", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta termino clase")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hastaFechaTermino),
      expression: "filtros.hastaFechaTermino"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hastaFechaTermino)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hastaFechaTermino", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde inicio curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desdeInicioCurso),
      expression: "filtros.desdeInicioCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desdeInicioCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desdeInicioCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta inicio curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hastaInicioCurso),
      expression: "filtros.hastaInicioCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hastaInicioCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hastaInicioCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde ver curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desdeVerCurso),
      expression: "filtros.desdeVerCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desdeVerCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desdeVerCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta ver curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hastaVerCurso),
      expression: "filtros.hastaVerCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hastaVerCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hastaVerCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado del curso del alumno")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estadoCursoAlumno),
      expression: "filtros.estadoCursoAlumno"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estadoCursoAlumno", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Terminado")]), _c('option', {
    domProps: {
      "value": '2'
    }
  }, [_vm._v("En progreso")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Sin empezar")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado de la clase del alumno")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estadoClaseAlumno),
      expression: "filtros.estadoClaseAlumno"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estadoClaseAlumno", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Sin empezar")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Terminado")])])])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Curso")]), _c('th', [_vm._v("Clase")]), _c('th', [_vm._v("Alumno")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', {
      class: {
        'is-close': !o.activoCurso
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'id: ' + o.idCurso
      }
    }, [_vm._v(_vm._s(o.tituloCurso)), (o.fechaVerCurso) ? _c('div', {
      staticClass: "chip ver-curso"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Visto " + _vm._s(_vm._f("formatDateHour")(o.fechaVerCurso)))])]) : _vm._e(), (o.fechaInicioAlumno) ? _c('div', {
      staticClass: "chip iniciado"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Iniciado " + _vm._s(_vm._f("formatDateHour")(o.fechaInicioAlumno)))])]) : _vm._e(), (o.fechaTerminoCursoAlumno) ? _c('div', {
      staticClass: "chip terminado"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Terminado " + _vm._s(_vm._f("formatDateHour")(o.fechaTerminoCursoAlumno)))])]) : _vm._e()])]), _c('td', {
      class: {
        'is-close': !o.activoClase
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'id: ' + o.idClase
      }
    }, [_vm._v(_vm._s(o.tituloClase)), (o.fechaTerminoClaseAlumno) ? _c('div', {
      staticClass: "chip terminado"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Terminado " + _vm._s(_vm._f("formatDateHour")(o.fechaTerminoClaseAlumno)))])]) : _vm._e()])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])])
  }), 0)], 1) : _vm._e()])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de cursos virtuales")])])
}]}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Volver")])])])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('c-lista-cursos-virtuales-clases', {
    on: {
      "volver": function($event) {
        return _vm.volver()
      },
      "cfetch": function($event) {
        return _vm.cfetch()
      }
    }
  })], 1), (_vm.showMateriales || _vm.showEvaluaciones) ? _c('div', {
    key: "box-cajas",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [(_vm.showMateriales || _vm.showEvaluaciones) ? _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showMateriales) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-clase-lista', {
    ref: "materiales",
    attrs: {
      "modulo": 'alumno',
      "type": 'clase',
      "fetchURL": _vm.fetchURLMaterial
    },
    on: {
      "close": function($event) {
        return _vm.close('showMateriales')
      }
    }
  })], 1) : _vm._e(), (_vm.showEvaluaciones) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-clase-lista', {
    ref: "evaluaciones",
    attrs: {
      "type": 'clase',
      "modulo": 'alumno',
      "fetchURL": _vm.fetchURLEvaluacion
    },
    on: {
      "close": function($event) {
        return _vm.close('showEvaluaciones')
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar cargos..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }, _vm.fetchSearch]
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredLista), function(o, index) {
    return _c('div', {
      key: 'cargo_lookup_' + index,
      staticClass: "usuario",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', {
      staticClass: "nombre"
    }, [_vm._v(" " + _vm._s(o.cargo))])])
  }), 0), (!_vm.isLoading & _vm.filteredLista.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading text-center"
  }, [_vm._m(1)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Cargos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])
}]}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('i', {
    staticClass: "fa fa-video-camera",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  }), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.redirigir(0)
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._m(2), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(3)]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(4), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])]), _c('td', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion, 30)))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "display-flex flex-wrap space-around"
    }, [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_vm._m(5, true), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger m-2",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_vm._m(6, true), _c('span', [_vm._v("Eliminar")])])])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo))])]), (o.descripcion) ? _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.descripcion))])])]) : _vm._e(), _c('div', {
      staticClass: "botones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_vm._m(7, true), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_vm._m(8, true), _c('span', [_vm._v("Eliminar")])])])])
  }), 0)] : _c('div', [_vm._m(9)])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestión de cursos virtuales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Título")]), _c('th', [_vm._v("Descripción")]), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay cursos registrados")])])
}]}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Reporte de vacaciones")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitudes",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de vacaciones SAP")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarEmpleado
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado,
      "empleadosInactivos": 'all'
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Tipo de búsqueda")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modoFiltroVacaciones),
      expression: "modoFiltroVacaciones"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.modoFiltroVacaciones = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetch]
    }
  }, [_c('option', {
    attrs: {
      "value": "rango"
    }
  }, [_vm._v("Por rango de fechas")]), _c('option', {
    attrs: {
      "value": "laboral"
    }
  }, [_vm._v("Por rango de fechas laborales L-V")])])])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Desde")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desde),
      expression: "desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.desde)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desde = $event.target.value
      }
    }
  })])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Hasta")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasta),
      expression: "hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.hasta)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hasta = $event.target.value
      }
    }
  })])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Excel")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarNuevoExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Nuevo reporte")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length > 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Desde")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Hasta")]), _c('th', {
    staticClass: "show-break-1"
  }, [_vm._v("Fecha")]), _c('th', [_vm._v("Dias")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('span', [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.fechaDesde))]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.fechaHasta))]), _c('td', {
      staticClass: "show-break-1"
    }, [_vm._v(_vm._s(o.fechaDesde === o.fechaHasta ? o.fechaDesde : o.fechaDesde + ' ' + o.fechaHasta))]), _c('td', [_vm._v(_vm._s(o.cantidadDeDias))]), _c('td', [_vm._v(_vm._s(o.tipoAlgoritmo))]), _c('td', [_vm._v(_vm._s(o.motivo))])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: o + index + '',
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('span', {
      staticClass: "fs-18"
    }, [_vm._v(_vm._s(o.nombreEmpleado))])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.tipoAlgoritmo))])]), (o.motivo) ? _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.motivo))])])]) : _vm._e(), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Fecha")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.fechaDesde === o.fechaHasta ? o.fechaDesde : o.fechaDesde + ' - ' + o.fechaHasta) + " |"), _c('strong', [_vm._v(" " + _vm._s(o.cantidadDeDias) + " dias")])])])])])
  }), 0)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay informacion que cumplan con los siguientes filtros")])])])], 2)])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-multi-file', {
    attrs: {
      "name": "adjuntar_boletas_manuales",
      "folder": "boletas-manuales"
    },
    on: {
      "save": _vm.guardarAdjuntos,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjunte los pdf de las boletas")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Recuerda que los archivos deben tener el DNI al inicio del nombre del archivo")])])], 1) : _vm._e()]), (_vm.mostrarConfirmacionEliminarTodo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = false
      },
      "do": _vm.eliminarTodasLasBoletasManuales
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar todas las boletas cargadas?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar todo")])]), _c('strong', [_vm._v("Solo se eliminaran las boletas de la carga manual actual, no las generadas")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionGenerarBoletas) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionGenerarBoletas = false
      },
      "do": _vm.generarBoletasManuales
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea generar las boletas cargadas?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Generando...")]) : _c('span', [_vm._v("Generar")])]), _c('strong', [_vm._v("No cierre la pestaña del navegador mientras se están generando las boletas")]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProcessing),
      expression: "isProcessing"
    }],
    staticClass: "margin-top-10 margin-bottom-10"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s((_vm.cantidadAvance / _vm.cantidadTotal * 100).toFixed(2)) + "%")]), _c('span', {
    staticClass: "small ml-5"
  }, [_vm._v(_vm._s(_vm.cantidadAvance) + " / " + _vm._s(_vm.cantidadTotal))])])])], 1)], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Carga manual de boletas")])]), _c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('ul', [_c('li', [_vm._v("Solo se pueden trabajar simultaneamente, boletas de un mismo periodo, mes y tipo")]), _c('li', [_vm._v("Los archivos pdf deben tener el DNI al inicio, seguido de un \"_\", para obtener el empleado automáticamente, sino se deberá hacer la asignación manualmente.")])])])]), _c('div', {
    staticClass: "display-flex ai-c filtros-completos"
  }, [_c('div', {
    staticClass: "display-flex flex-1 filtro-input"
  }, [_c('div', {
    staticClass: "flex-1 px-20"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Periodo")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodo),
      expression: "periodo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodo = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "flex-1 px-20"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Mes")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mes),
      expression: "mes"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.mes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mes = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "flex-1 px-20"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Tipo")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo),
      expression: "tipo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.tipos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])])])]), _c('div', {
    staticClass: "text-right media-pt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload fs-12"
  })]), _c('span', [_vm._v("Adjuntar")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "mt-20"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    attrs: {
      "disabled": _vm.lista.length === 0 || _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionGenerarBoletas = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-fw fa-lg"
  })]), _c('span', [_vm._v("Generar boletas")])]), _c('button', {
    staticClass: "button is-small is-danger ml-5",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times fa-fw fa-lg"
  })]), _c('span', [_vm._v("Eliminar todo")])])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVerifying),
      expression: "isVerifying"
    }],
    staticClass: "margin-top-10 margin-bottom-10"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s((_vm.cantidadAvance / _vm.cantidadTotal * 100).toFixed(2)) + "%")]), _c('span', {
    staticClass: "small ml-5"
  }, [_vm._v(_vm._s(_vm.cantidadAvance) + " / " + _vm._s(_vm.cantidadTotal))])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("DNI obtenido")]), _c('th', [_vm._v("Nombre de archivo")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Fecha de modificación")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.codigo
      }
    }, [_c('td', [(o.codigo) ? [_c('div', {
      staticClass: "show-break-1"
    }, [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "display-flex hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigo
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.desasignarEmpleadoABoletaManual(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleadoReemplazante),
        expression: "o.codigoEmpleadoReemplazante"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleadoReemplazante)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleadoReemplazante", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleadoReemplazante
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoABoletaManual(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)]], 2), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.dniObtenido))]), _c('td', [_c('div', [_vm._v(_vm._s(o.namefile))]), _c('div', {
      staticClass: "show-break-1 mt-10"
    }, [_c('strong', [_vm._v("Modificado: ")]), _c('span', [_vm._v(_vm._s(o.modificado))])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.modificado))]), _c('td', {
      staticClass: "text-center"
    }, [(o.ruta) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', {
      staticClass: "no-accion"
    }, [_vm._v("Sin adjunto")])], _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger ml-5",
      class: {
        'is-loading': o.isRemoving
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])], 2)])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'bg-red': !o.codigo
      }
    }, [(o.codigo) ? [_c('div', [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "descripcion-tipo display-flex"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.desasignarEmpleadoABoletaManual(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "mb-10"
    }, [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleadoReemplazante),
        expression: "o.codigoEmpleadoReemplazante"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleadoReemplazante)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleadoReemplazante", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleadoReemplazante
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoABoletaManual(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)])], _c('div', {
      staticClass: "motivo"
    }, [_c('span', [_vm._v(_vm._s(o.namefile))])]), _c('div', {
      staticClass: "dias-pedidos mt-5"
    }, [_c('strong', [_vm._v("Fecha de modificación: ")]), _c('div', [_vm._v(_vm._s(o.modificado))])]), _c('div', {
      staticClass: "botones"
    }, [(o.ruta) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', {
      staticClass: "no-accion"
    }, [_vm._v("Sin adjunto")])], _c('button', {
      staticClass: "button is-small is-danger ml-5",
      class: {
        'is-loading': o.isRemoving
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])], 2)], 2)
  })], 2)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay documentos importantes ingresados")])])])], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apex"
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page"
  }, [_c('DashboardHeader', {
    attrs: {
      "nombre": _vm.nombreUsuario
    }
  }), _c('Noticias'), _c('br'), _c('div', {
    staticClass: "dashboard-info-grid"
  }, [_c('NuevosEmpleados'), _c('CumpleaniosHoy')], 1), _c('MisCursos'), _c('br'), (_vm.perfilVacaciones !== 'usuario') ? _c('PendientesJefe') : _vm._e(), _c('MisPendientes')], 1)
},staticRenderFns: []}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis solicitudes de permisos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (!_vm.isEditing) ? _c('div', {
    staticClass: "show-closed-text"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showClosed = !_vm.showClosed
      }
    }
  }, [(_vm.showClosed) ? [_vm._v("Mostrando todas las solicitudes")] : [_vm._v("Mostrando solo las solicitudes abiertas")]], 2)]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isEditing) ? _c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [(_vm.isMostrandoAdjuntar) ? _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('div', {
    ref: "adjuntarSolicitud",
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_solicitud_permiso",
      "folder": "permiso",
      "is-saved": _vm.isSavedAdjunto
    },
    on: {
      "close": _vm.closeAdjuntar,
      "save": _vm.guardarAdjunto
    }
  }, [_c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la imagen que sustenta tu permiso")])])], 1)]) : _vm._e(), (_vm.mostrarConfirmacionEnviar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEnviar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEnviar = false
      },
      "do": _vm.enviarJefe
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea enviar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Enviando...")] : [_vm._v("Enviar")]], 2)]), _c('span', [_vm._v("Luego de enviar la notificación a su jefe, no podrá modificarlo")])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), _c('div', {
    staticClass: "is-desktop"
  }, [(_vm.isLoading) ? _c('loading') : _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return (_vm.showClosed || (!_vm.showClosed && o.estadoData.abierto)) ? _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.estadoData.abierto
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcionTipo))])]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2)], 2), _c('td', [_vm._v(_vm._s(o.estadoData.descripcion))]), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirAdjuntar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-upload fs-12"
    })]), _c('span', [_vm._v("Adjuntar")])])], (o.estado === 1) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.enterEditMode(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarEnviar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Enviar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado === 2) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado === 3) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', [_vm._v("No hay acciones")])]) : _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', [_vm._v("No hay acciones")])])], 2)]) : _vm._e()
  }), 0)], 1)], 1), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.solicitudes), function(o, index) {
    return (_vm.showClosed || (!_vm.showClosed && o.estadoData.abierto)) ? _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('span', [_vm._v(_vm._s(o.estadoData.descripcion))])]), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, _vm._l((o.motivoLista), function(m) {
      return _c('div', [_c('span', [_vm._v(_vm._s(m))])])
    }), 0), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirAdjuntar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-upload fs-12"
    })]), _c('span', [_vm._v("Adjuntar")])])], (o.estado === 1) ? [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.enterEditMode(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarEnviar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Enviar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : (o.estado === 2) ? [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : _vm._e()], 2)]) : _vm._e()
  })], 2)], 1) : _c('div', {
    key: "edit-solicitud"
  }, [_c('nueva-solicitud', {
    ref: "editarSolicitud",
    attrs: {
      "is-editing": true,
      "solicitud": _vm.solicitudSeleccionada
    },
    on: {
      "close": function($event) {
        _vm.isEditing = false
      },
      "closeRefresh": function($event) {
        _vm.isEditing = false;
        _vm.fetch();
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [_vm._m(0), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "clase-item"
    }, [(o && o.idYT) ? _c('img', {
      staticClass: "clase-imagen",
      attrs: {
        "src": 'https://img.youtube.com/vi/' + o.idYT + '/hqdefault.jpg',
        "alt": o.titulo
      }
    }) : _vm._e(), _c('div', {
      staticClass: "clase-detalles"
    }, [_c('div', {
      staticClass: "clase-header"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))]), (o.descripcion) ? _c('div', {
      staticClass: "descripcion"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion, 30)))])]) : _vm._e()]), _c('div', {
      staticClass: "clase-info"
    }, [_c('span', [_vm._v("Duración: " + _vm._s(o.duracion))])])]), _c('div', {
      staticClass: "clase-botones"
    }, [(o.estado === 0) ? _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.verClase(o.id, o.estado)
        }
      }
    }, [_vm._v("Ver clase")]) : _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.verClase(o.id, o.estado)
        }
      }
    }, [_vm._v("Volver a ver")])])])
  }) : _vm._e()], 2), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', [_vm._m(1)]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis clases")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay clases registrados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('gestion-salas-reuniones-editar', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "sala": _vm.salaSeleccionada
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.eliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar la sala " + _vm._s(_vm.salaSeleccionada.nombre) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Administrador de Salas")])]), _c('div', {
    staticClass: "filtros-container"
  }, [_c('div', {
    staticClass: "text-right acciones"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "table-lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Sala")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.shadowList), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      },
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'sala: ' + o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])])])
  }), 0)], 1) : _vm._e()]), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No hay registros")])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Datos personales para consulta")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.isLoading) ? [_c('loading')] : [_c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.codigo,
      "title": "Codigo interno"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.dni,
      "title": "DNI"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.cargo,
      "title": "Cargo"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.email,
      "title": "Email de la empresa"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.fechaIngreso,
      "title": "Fecha de ingreso"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": ((_vm.empleadoPersonal.sueldoCuenta) + " " + (_vm.empleadoPersonal.sueldoNombreBanco) + " " + (_vm.empleadoPersonal.sueldoMoneda)),
      "title": "Cuenta Sueldo",
      "dangerMessage": "Recursos humanos debe especificar el dato"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": ((_vm.empleadoPersonal.ctsCuenta) + " " + (_vm.empleadoPersonal.ctsNombreBanco) + " " + (_vm.empleadoPersonal.ctsMoneda)),
      "title": "Cuenta CTS",
      "dangerMessage": "Recursos humanos debe especificar el dato"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleadoPersonal.tipoPension,
      "title": "Tipo pension",
      "dangerMessage": "Recursos humanos debe especificar el dato"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.regimen,
      "title": "Régimen",
      "capitalize": "capitalize",
      "dangerMessage": "General"
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de excepciones de vacaciones")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud position-relative"
  }, [_c('nueva-solicitud-vacaciones', {
    attrs: {
      "is-excepcion": true
    },
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarCambioDias) ? _c('div', {
    key: "cambio_dias_solicitud",
    staticClass: "box nueva-solicitud position-relative"
  }, [_c('cambio-dias-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarCambioDias = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-overlay loading"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title")], 2), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._t("topIcon", [_c('i', {
    staticClass: "fa fa-thumbs-up"
  })])], 2)])]), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("default", [_c('small', [_vm._v("Esta operación")]), _c('strong', [_vm._v(" no se puede ")]), _c('small', [_vm._v("revertir")]), _c('br')]), _vm._t("information")], 2), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    class: {
      'is-disabled': _vm.loading
    },
    on: {
      "click": _vm.emitDo
    }
  }, [_vm._t("primaryAction")], 2), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancelar")])])])])
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalEmpleadosConDocumentos) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("¿SEGURO QUE DESEA CONTINUAR?")])]), _c('div', {
    staticClass: "card-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.mensajeRespuesta))]), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.listaEmpleadosRespuesta), function(nombre, index) {
    return _c('li', {
      key: index,
      staticClass: "tal"
    }, [_c('span', [_vm._v(_vm._s(nombre))])])
  }), 0)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.validarModalEmpleadoConDocumentos()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Continuar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.cerrarModalEmpleadosConDocumentos()
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e()]), (_vm.mostrarConfirmacionModal) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionModal = false
      },
      "do": _vm.validarConfirmacion
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro de " + _vm._s(_vm.tipoConfirmacion.descripcion) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSaving) ? [_vm._v("Guardando...")] : [_vm._v("Guardar")]], 2)])], 1) : _vm._e(), _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title", [_vm._v("Seleccione los empleados")])], 2), _c('div', {
    staticClass: "contenedor-acciones"
  }, [_c('div', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('asignarTodos')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Asignar Todos")])]), _c('div', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('desasignarTodos')
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Desasignar Todos")])])])]), _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaArea) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-area', {
    on: {
      "selected": _vm.seleccionarArea,
      "close": function($event) {
        _vm.mostrarBusquedaArea = false
      }
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar empleados..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }, _vm.fetchSearch]
    }
  })]), (_vm.empresa !== 'raymisa') ? _c('div', {
    staticClass: "control pt-5"
  }, [_c('div', {
    staticClass: "input-container"
  }, [(!_vm.area.idArea) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area.idArea),
      expression: "area.idArea"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "placeholder": "Buscar Area",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.area.idArea)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.area, "idArea", $event.target.value)
      }
    }
  }) : _c('div', {
    staticClass: "item fdc flex-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.area.nombreArea)))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.area.nombreGerencia))])]), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarArea
    }
  }, [_vm._m(2)])])]) : _vm._e()]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredEmpleados), function(employee, index) {
    return _c('div', {
      key: 'empleado_lookup_' + employee.codigo,
      staticClass: "usuario",
      class: {
        'selected': employee.nuevoSeleccionado || employee.seleccionado
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelection(employee)
        }
      }
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('span', {
      staticClass: "codigo"
    }, [_vm._v(_vm._s(employee.dni) + ":")]), _c('span', {
      staticClass: "nombre"
    }, [_vm._v(" " + _vm._s(employee.nombre))])]), (!employee.activo && employee.fechaInactivoString) ? _c('div', {
      staticClass: "mt-5"
    }, [_c('span', {
      staticClass: "name seen has-text-bold"
    }, [_vm._v("Inactivo desde " + _vm._s(employee.fechaInactivoString))])]) : _vm._e()])
  }), 0), (!_vm.isLoading & _vm.filteredEmpleados.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron empleados activos")])]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(3)]) : _vm._e()], 1)], 1), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.asignarEmpleados(false)
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de permisos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Tipo")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroTipo),
      expression: "filtroTipo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroTipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.tipos), function(o, key) {
    return _c('option', {
      domProps: {
        "value": +o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Código de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroMes),
      expression: "filtroMes"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtroMes)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroMes = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroYear),
      expression: "filtroYear"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtroYear)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroYear = $event.target.value
      }
    }
  })])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Excel")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarNuevoExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Nuevo reporte")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.solicitudes.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Adjunto")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_c('span', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Fecha")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + "-" + _vm._s(o.horaHasta))])])])], 2), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', [_vm._v("Sin adjunto")])]], 2)])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return _c('div', {
      key: o + index + '',
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_c('span', {
      staticClass: "is-bold hint--right",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])]], 2)]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Fecha")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + "-" + _vm._s(o.horaHasta))])])]), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e()], 2)])
  }), 0)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay permisos que cumplan con los siguientes filtros")])])])], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', [_c('h3', [_vm._v("Seleccionar trabajadores")]), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.nombreArea))])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": _vm.cerrar
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "busqueda"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.textoBusqueda),
      expression: "textoBusqueda",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre o código..."
    },
    domProps: {
      "value": (_vm.textoBusqueda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textoBusqueda = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "seleccionar-todos"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.todosSeleccionados
    },
    on: {
      "change": _vm.seleccionarTodos
    }
  }), _c('span', [_vm._v("Seleccionar todos")])]), _c('span', {
    staticClass: "contador"
  }, [_vm._v(_vm._s(_vm.seleccionTemporal.length) + " de\n" + _vm._s(_vm.trabajadoresFiltrados.length) + " seleccionados")])]), (_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _c('span', [_vm._v("Cargando trabajadores...")])]) : (_vm.trabajadoresFiltrados.length === 0) ? _c('div', {
    staticClass: "sin-resultados"
  }, [_c('span', [_vm._v("No se encontraron trabajadores en esta área.")])]) : _c('div', {
    staticClass: "lista-trabajadores"
  }, _vm._l((_vm.trabajadoresFiltrados), function(trabajador) {
    return _c('label', {
      key: trabajador.codigo,
      staticClass: "trabajador",
      class: {
        'seleccionado': _vm.estaSeleccionado(trabajador)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.seleccionTemporal),
        expression: "seleccionTemporal"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": trabajador.codigo,
        "checked": Array.isArray(_vm.seleccionTemporal) ? _vm._i(_vm.seleccionTemporal, trabajador.codigo) > -1 : (_vm.seleccionTemporal)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.seleccionTemporal,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = trabajador.codigo,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.seleccionTemporal = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.seleccionTemporal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.seleccionTemporal = $$c
          }
        }
      }
    }), _c('div', {
      staticClass: "datos-trabajador"
    }, [_c('span', {
      staticClass: "nombre"
    }, [_vm._v(_vm._s(trabajador.nombre))]), _c('span', {
      staticClass: "detalle"
    }, [_vm._v("Código: " + _vm._s(trabajador.codigo)), (trabajador.cargo) ? _c('span', [_vm._v(" - " + _vm._s(trabajador.cargo))]) : _vm._e()])])])
  }), 0)]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "button button-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cerrar
    }
  }, [_c('span', [_vm._v("Cancelar")])]), _c('button', {
    staticClass: "button button-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.seleccionTemporal.length === 0
    },
    on: {
      "click": _vm.aceptar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v("Aceptar"), (_vm.seleccionTemporal.length) ? [_vm._v(" (" + _vm._s(_vm.seleccionTemporal.length) + ")")] : _vm._e()], 2)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis permisos generados")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "is-desktop"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_vm._v(_vm._s(o.descripcionTipo))])]), _c('td', [_vm._v(_vm._s(o.motivo))]), _c('td', [_c('div', {
      staticClass: "detalle"
    }, [_c('div', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.desde === o.hasta ? o.desde : ((o.desde) + " - " + (o.hasta))) + " ")]), _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.horaDesde) + " - " + _vm._s(o.horaHasta))])])]), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_vm._m(1, true), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', [_vm._v("Sin adjunto")])]], 2)])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.idSolicitud
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.motivo))])])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.desde === o.hasta ? o.desde : ((o.desde) + " - " + (o.hasta))) + "   " + _vm._s(o.horaDesde) + "-" + _vm._s(o.horaHasta))])])]), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_vm._m(2, true), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e()], 2)])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Fecha")]), _c('th', [_vm._v("Adjunto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small fs-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small fs-12"
  })])
}]}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mi equipo")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isShowingJefeDirecto) ? _c('div', {
    staticClass: "message is-info"
  }, [_vm._m(0)]) : _vm._e(), _c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha Ingreso")]), (_vm.isShowingJefeDirecto) ? _c('th', [_vm._v("Jefe directo")]) : _vm._e(), _c('th', [_vm._v("Días por tomar / programar")]), _c('th', {
    staticClass: "td-status"
  })]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('tr', {
      key: index + '-desktop',
      staticClass: "row-table",
      class: {
        directo: o.directo, 'row-info': o.esDeDelegacion, 'fw-bold': o.codigoJefe === +_vm.codigoLogueadoJefe
      }
    }, [_c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Equipo Delegado'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")])])])]), _c('td', [_vm._v(_vm._s(o.fechaIngreso))]), (_vm.isShowingJefeDirecto) ? _c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e(), _c('td', [_vm._v(_vm._s(o.diasReales) + " / " + _vm._s(o.diasDisponibles))]), _c('td', {
      staticClass: "td-status"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasReales >= 35 && o.diasReales <= 40,
          'red': o.diasReales > 40
      }
    })])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left",
      class: {
        directo: o.directo, 'row-info': o.esDeDelegacion, 'fw-bold': o.codigoJefe === +_vm.codigoLogueadoJefe
      }
    }, [_c('div', {
      staticClass: "dias"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(o.diasReales) + " ")]), _c('span', [_vm._v("por tomar / ")]), _c('strong', [_vm._v(_vm._s(o.diasDisponibles) + " ")]), _c('span', [_vm._v("por programar ")])]), _c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasReales >= 35 && o.diasReales <= 40,
          'red': o.diasReales > 40
      }
    })])]), _c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Equipo Delegado'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "mt-10 hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), (_vm.codigoLogueadoJefe !== (o.codigoJefe + '')) ? _c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e()])
  }), 0), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v("*")]), _c('span', [_vm._v("Los empleados con texto resaltado son empleados directos, es decir, es tu responsabilidad aprobar las solicitudes ")]), _c('span', [_vm._v("de vacaciones de ellos.")])])
}]}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro"
  }, [_c('div', {
    staticClass: "cuadro-content"
  }, [_c('div', {
    staticClass: "cuadro-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "cuadro-number"
  }, [_vm._v(_vm._s(_vm.number))])])])
},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cursos"
  }, [_vm._m(0), _c('div', {
    staticClass: "contenedor-scroll"
  }, _vm._l((_vm.lista), function(curso) {
    return _c('div', {
      key: curso.id,
      staticClass: "curso"
    }, [_c('div', {
      staticClass: "cabecera"
    }, [_c('div', {
      staticClass: "nombre"
    }, [_c('strong', [_vm._v(_vm._s(curso.titulo))])]), _c('div', {
      staticClass: "porcentaje"
    }, [_c('strong', [_vm._v(_vm._s(curso.progreso) + "%")])])]), _c('div', {
      staticClass: "barra"
    }, [_c('div', {
      staticClass: "avance",
      style: ({
        width: curso.progreso + '%'
      })
    })]), _c('div', {
      staticClass: "detalle"
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-book"
    }), _vm._v(" " + _vm._s(curso.NumeroClases) + " Clases")]), _c('span', {
      class: _vm.estadoClass(curso.progreso)
    }, [_vm._v(_vm._s(_vm.estado(curso.progreso)))])]), _c('div', {
      staticClass: "detalle margin-top-6"
    }, [_vm._m(1, true), _c('span', [_vm._v(_vm._s(curso.DuracionTotal))])]), _c('button', {
      staticClass: "btn-continuar",
      on: {
        "click": function($event) {
          return _vm.continuar(curso.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play"
    }), _vm._v("Continuar")])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo"
  }, [_c('span', [_vm._v("📚 Mis cursos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Duracion")])
}]}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.validarEliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro de guardar la fecha de nacimiento?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2), _c('div', {
    staticClass: "info-validar-eliminar",
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [(_vm.empleadosValidados.length > 0) ? [_c('span', [_vm._v("No se puede eliminar el cargo ya que tiene empleados asociados:")]), _c('ul', _vm._l((_vm.empleadosValidados), function(o, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(o.nombre))])])
  }), 0)] : _vm._e()], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitudes",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Empleados sin Fecha de Nacimiento")])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length > 0) ? [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha de Nacimiento")]), _c('th', {
    staticClass: "hide-break-1"
  })]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', [_c('span', [_vm._v(_vm._s(o.nombre))])]), _c('td', [_c('div', {
      staticClass: "flex fdc"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaNacimiento),
        expression: "o.fechaNacimiento"
      }],
      staticClass: "input",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (o.fechaNacimiento)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaNacimiento", $event.target.value)
        }
      }
    }), _c('div', {
      staticClass: "show-break-1 text-center mt-5"
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          return _vm.guardarFechaNacimiento(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-save is-small"
    })]), _c('span', [_vm._v("Guardar")])])])])]), _c('td', {
      staticClass: "text-center hide-break-1"
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          return _vm.guardarFechaNacimiento(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-save is-small"
    })]), _c('span', [_vm._v("Guardar")])])])])
  }), 0)], 1)] : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No existen empleados sin fecha de nacimiento")])])]) : _vm._e()], 2)])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar empleados..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }, _vm.fetchSearch]
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredEmpleados), function(o, index) {
    return _c('div', {
      key: 'empleado_lookup_' + index,
      staticClass: "usuario",
      class: {
        'is-close': !o.activo
      },
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('span', {
      staticClass: "codigo"
    }, [_vm._v(_vm._s(o.dni) + ":")]), _c('span', {
      staticClass: "nombre"
    }, [_vm._v(" " + _vm._s(o.nombre))])]), (!o.activo && o.fechaInactivoString) ? _c('div', {
      staticClass: "mt-5"
    }, [_c('span', {
      staticClass: "name seen has-text-bold"
    }, [_vm._v("Inactivo desde " + _vm._s(o.fechaInactivoString))])]) : _vm._e()])
  }), 0), (!_vm.isLoading & _vm.filteredEmpleados.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading text-center"
  }, [_vm._m(1)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Empleados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])
}]}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Reportes de vacaciones")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitudes",
    staticClass: "box position-relative"
  }, [_c('lista-solicitud-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaEmpleados) ? _c('div', {
    key: "lista_empleados",
    staticClass: "box"
  }, [_c('lista-empleados-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaEmpleados = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de vacaciones de mi equipo")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesPorAprobar) ? _c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('lista-solicitud-vacaciones-por-aprobar', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesPorAprobar = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaEquipoVacaciones) ? _c('div', {
    key: "lista_vacaciones_equipo",
    staticClass: "box position-relative"
  }, [_c('lista-equipo-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaEquipoVacaciones = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card"
  }, [_vm._m(0), _c('div', {
    ref: "employeesScroll",
    staticClass: "employees-scroll",
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [(_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "initial-loading"
  }, [_c('span', {
    staticClass: "loader"
  }), _c('span', [_vm._v("Cargando empleados...")])]) : (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._m(1), _vm._m(2)]) : [_vm._l((_vm.lista), function(empleado, index) {
    return _c('div', {
      key: empleado.id || empleado.numeroDocumento || index,
      staticClass: "employee"
    }, [_c('div', {
      staticClass: "employee-avatar"
    }, [_vm._v(_vm._s(empleado.usuario))]), _c('div', {
      staticClass: "employee-info"
    }, [_c('strong', [_vm._v(_vm._s(empleado.nombre))]), _c('span', {
      staticClass: "employee-position"
    }, [_vm._v(_vm._s(empleado.cargo || 'Sin cargo registrado'))]), _c('span', {
      staticClass: "employee-area"
    }, [_vm._v(_vm._s(empleado.area || 'Sin área registrada'))])]), _c('div', {
      staticClass: "employee-entry"
    }, [_c('small', [_vm._v("Fecha de ingreso")]), _c('strong', [_vm._v(_vm._s(empleado.fechaIngreso))])])])
  }), (_vm.isScroll) ? _c('div', {
    staticClass: "scroll-loading"
  }, [_c('span', {
    staticClass: "loader loader-small"
  }), _c('span', [_vm._v("Cargando más empleados...")])]) : _vm._e(), (_vm.noMore && _vm.lista.length > 0) ? _c('div', {
    staticClass: "scroll-end"
  }, [_c('span', [_vm._v("No hay más empleados nuevos")])]) : _vm._e()]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Nuevos empleados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-info"
  }, [_c('strong', [_vm._v("No hay empleados nuevos")]), _c('span', [_vm._v("No se encontraron nuevas incorporaciones.")])])
}]}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logo.png",
      "alt": "logo"
    }
  }), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Self Service")])])])])
}]}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalSeleccionarDocumentosFirmar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('seleccionar-documentos-firmar', {
    attrs: {
      "idEmpleado": +_vm.codigoEmpleadoInterno
    },
    on: {
      "close": _vm.closeModalSeleccionarDocumentosFirmar
    }
  })], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalListaLibrosVacaciones) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "box position-relative"
  }, [_c('component-lista-libros-vacaciones', {
    attrs: {
      "codigoEmpleado": +_vm.codigoEmpleadoInterno
    },
    on: {
      "close": _vm.closeModalListaLibrosVacaciones
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "modal-card card w-942"
  }, [_c('div', {
    staticClass: "modal-card-head flex"
  }, [_vm._m(0), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.close
    }
  })]), _c('div', {
    staticClass: "card-content card-content-max"
  }, [_c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex datos-empleado-container"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "flex fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Codigo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.codigo),
      expression: "empleado.codigo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.empleado.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "codigo", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Nombre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombre),
      expression: "empleado.nombre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombre", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Perfil")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.perfilVacaciones),
      expression: "empleado.perfilVacaciones"
    }],
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.empleado, "perfilVacaciones", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "usuario"
    }
  }, [_vm._v("Usuario")]), _c('option', {
    attrs: {
      "value": "jefe"
    }
  }, [_vm._v("Jefe")]), _c('option', {
    attrs: {
      "value": "recursos humanos"
    }
  }, [_vm._v("Recursos Humanos")])])])])]), _c('div', {
    staticClass: "flex fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Usuario")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.usuario),
      expression: "empleado.usuario"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "usuario", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Cargo")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.cargo),
      expression: "empleado.cargo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.empleado.cargo)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaCargo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "cargo", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaCargo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.empleado.cargo = ''
      }
    }
  }, [_vm._m(1)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaCargo) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-cargo', {
    on: {
      "selected": _vm.seleccionarCargo,
      "close": function($event) {
        _vm.mostrarBusquedaCargo = false
      }
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.email),
      expression: "empleado.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "email", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "flex position-relative fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Codigo Jefe")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.codigoJefe),
      expression: "empleado.codigoJefe"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.codigoJefe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "codigoJefe", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaJefe = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.empleado.codigoJefe = ''
      }
    }
  }, [_vm._m(2)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaJefe) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.empleado.codigoJefe,
      "tipo": 'jefe'
    },
    on: {
      "selected": _vm.seleccionarJefe,
      "close": function($event) {
        _vm.mostrarBusquedaJefe = false
      }
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("DNI")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.dni),
      expression: "empleado.dni"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "dni", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Régimen")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.regimen),
      expression: "empleado.regimen"
    }],
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.empleado, "regimen", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "general"
    }
  }, [_vm._v("General")]), _c('option', {
    attrs: {
      "value": "pyme"
    }
  }, [_vm._v("PYME")])])])])]), _c('div', {
    staticClass: "flex position-relative fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Fecha Nacimiento")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaNacimiento),
      expression: "empleado.fechaNacimiento"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.fechaNacimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaNacimiento", $event.target.value)
      }
    }
  })])]), (_vm.empresa !== 'raymisa') ? _c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Area")]), _c('div', {
    staticClass: "input-container"
  }, [(!_vm.empleado.idArea) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.idArea),
      expression: "empleado.idArea"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.empleado.idArea)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "idArea", $event.target.value)
      }
    }
  }) : _c('div', {
    staticClass: "item fdc flex-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.nombreArea)))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.nombreGerencia))])]), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarArea
    }
  }, [_vm._m(3)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaArea) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-area', {
    on: {
      "selected": _vm.seleccionarArea,
      "close": function($event) {
        _vm.mostrarBusquedaArea = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _c('div', {
    staticClass: "control flex title-singular fdc space-evenly"
  }, [_c('button', {
    staticClass: "button is-small is-primary m-5 select-doc",
    on: {
      "click": _vm.openModalSeleccionarDocumentosFirmar
    }
  }, [_vm._m(4), _vm._m(5)])])])]), _c('div', {
    staticClass: "foto-perfil-container"
  }, [_c('p', [_vm._v("Foto de perfil")]), _c('div', {
    staticClass: "foto-preview"
  }, [(_vm.fotoPreview) ? _c('img', {
    attrs: {
      "src": _vm.fotoPreview,
      "alt": "Foto de perfil"
    }
  }) : _c('i', {
    staticClass: "fa fa-user-circle"
  })]), _c('input', {
    ref: "inputFoto",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/png,image/webp"
    },
    on: {
      "change": _vm.seleccionarFoto
    }
  }), _c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputFoto.click()
      }
    }
  }, [_vm._m(6), _c('span', [_vm._v("  Seleccionar foto")])]), (_vm.fotoPreview) ? _c('button', {
    staticClass: "button is-small is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.eliminarFoto
    }
  }, [_vm._m(7)]) : _vm._e()])]), _c('div', {
    staticClass: "flex position-relative fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex title-singular fdc space-evenly"
  }, [_c('button', {
    staticClass: "button is-small is-success has-text-bold m-5",
    on: {
      "click": _vm.verLibroDeVacaciones
    }
  }, [_vm._m(8), _c('span', [_vm._v("Ver libro de vacaciones")])])])])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Contrato")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-contrato"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Fecha Ingreso")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaIngreso),
      expression: "empleado.fechaIngreso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": _vm.codigoEmpleadoInterno > 0
    },
    domProps: {
      "value": (_vm.empleado.fechaIngreso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaIngreso", $event.target.value)
      }
    }
  })]), _c('div', {
    key: "tiene-contrato-indefinido",
    staticClass: "control"
  }, [_c('p', [_vm._v("¿Contrato indefinido?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.contratoIndeterminado === 1
    },
    on: {
      "click": function($event) {
        _vm.empleado.contratoIndeterminado = 1
      }
    }
  }, [_c('span', [_vm._v("Si")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.contratoIndeterminado === 0
    },
    on: {
      "click": function($event) {
        _vm.empleado.contratoIndeterminado = 0
      }
    }
  }, [_c('span', [_vm._v("No")])])])]), (_vm.empleado.contratoIndeterminado === 0) ? _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Fecha fin contrato")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaFinContrato),
      expression: "empleado.fechaFinContrato"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.fechaFinContrato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaFinContrato", $event.target.value)
      }
    }
  })]) : _vm._e()])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pensión")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-pension"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Tipo Pension")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.tipoPension),
      expression: "empleado.tipoPension"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.tipoPension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "tipoPension", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("AFP Codigo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.afpCodigo),
      expression: "empleado.afpCodigo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.afpCodigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "afpCodigo", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("AFP Nombre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.afpNombre),
      expression: "empleado.afpNombre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.afpNombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "afpNombre", $event.target.value)
      }
    }
  })])])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Sueldo")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-sueldo"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Cuenta Sueldo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.sueldoCuenta),
      expression: "empleado.sueldoCuenta"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.sueldoCuenta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "sueldoCuenta", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Codigo Banco Sueldo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.sueldoCodigoBanco),
      expression: "empleado.sueldoCodigoBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.sueldoCodigoBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "sueldoCodigoBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Banco Sueldo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.sueldoNombreBanco),
      expression: "empleado.sueldoNombreBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.sueldoNombreBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "sueldoNombreBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    key: "moneda-sueldo",
    staticClass: "control"
  }, [_c('p', [_vm._v("Moneda sueldo")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.sueldoMoneda === 'soles'
    },
    on: {
      "click": function($event) {
        _vm.empleado.sueldoMoneda = 'soles'
      }
    }
  }, [_c('span', [_vm._v("S/")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.sueldoMoneda === 'dolares'
    },
    on: {
      "click": function($event) {
        _vm.empleado.sueldoMoneda = 'dolares'
      }
    }
  }, [_c('span', [_vm._v("USD")])])])])])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("CTS")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-cts"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("CTS cuenta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.ctsCuenta),
      expression: "empleado.ctsCuenta"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.ctsCuenta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "ctsCuenta", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Codigo Banco CTS")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.ctsCodigoBanco),
      expression: "empleado.ctsCodigoBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.ctsCodigoBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "ctsCodigoBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Banco CTS")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.ctsNombreBanco),
      expression: "empleado.ctsNombreBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.ctsNombreBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "ctsNombreBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    key: "moneda-cts",
    staticClass: "control"
  }, [_c('p', [_vm._v("Moneda CTS")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.ctsMoneda === 'soles'
    },
    on: {
      "click": function($event) {
        _vm.empleado.ctsMoneda = 'soles'
      }
    }
  }, [_c('span', [_vm._v("S/")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.ctsMoneda === 'dolares'
    },
    on: {
      "click": function($event) {
        _vm.empleado.ctsMoneda = 'dolares'
      }
    }
  }, [_c('span', [_vm._v("USD")])])])])])])])]), _c('footer', {
    staticClass: "modal-card-foot flex padding-5"
  }, [(_vm.codigoEmpleadoInterno === 0 || (_vm.empleado.codigo > 0 && _vm.empleado.activo === 1)) ? _c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardarEmpleado
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]) : _vm._e(), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])]), (_vm.mostrarObservaciones) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarObservaciones
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalObservaciones),
      expression: "closeModalObservaciones"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Observaciones encontradas")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalObservaciones
    }
  })])])]), _c('div', {
    staticClass: "card-content card-content-observaciones-max-height"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, _vm._l((_vm.observaciones), function(o) {
    return (_vm.observaciones.length > 0) ? _c('div', [_c('strong', [_vm._v(_vm._s(o))])]) : _vm._e()
  }), 0)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalObservaciones
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos del Empleado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._v("Seleccionar")]), _c('br'), _c('span', [_vm._v("documentos")]), _c('br'), _c('span', [_vm._v("por firmar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye is-small"
  })])
}]}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [(_vm.mostrarConfirmacionTerminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionTerminar = false
      },
      "do": function($event) {
        return _vm.terminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionTerminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionTerminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingTerminar) ? [_vm._v("Terminando...")] : [_vm._v("Terminar")]], 2)])], 1)], 1) : _vm._e(), _vm._m(0), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "columns is-multiline display-flex"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Alumno")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigoEmpleado),
      expression: "filtros.codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtros.codigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigoEmpleado", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtros.codigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtros.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Curso")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idCurso),
      expression: "filtros.idCurso"
    }],
    staticClass: "flex-1",
    attrs: {
      "disabled": _vm.isLoadingCursos
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "idCurso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.cursos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])
  })], 2)])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Curso")]), _c('th', [_vm._v("Alumno")]), _c('th', [_vm._v("Fecha terminado")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'id: ' + o.idCurso
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_vm._v(_vm._s(o.nombre))])])]), _c('td', [_c('span', [_vm._v(_vm._s(o.fechaTerminado))])]), _c('td', [(!o.marcaTerminadoRRHH) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          return _vm.confirmarTerminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _c('span', [_vm._v("Terminar")])])]) : _vm._e()])])
  }), 0)], 1) : _vm._e()])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de cursos virtuales")])])
}]}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Volver")])])])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-cajas",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "contenedor-glosa"
  }, [_c('strong', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.titulo))]), _c('br'), _c('p', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.descripcion))
    }
  })]), _c('div', {
    staticClass: "display-flex jcc aic"
  }, [(!_vm.fechaInicio) ? _c('button', {
    staticClass: "button is-primary m-5",
    on: {
      "click": function($event) {
        return _vm.iniciarCurso()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check is-small"
  })]), _c('span', [_vm._v("Iniciar curso")])]) : _vm._e()]), (_vm.showMateriales || _vm.showEvaluaciones) ? _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showMateriales) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-clase-lista', {
    attrs: {
      "modulo": 'alumno',
      "type": 'curso',
      "fetchURL": _vm.fetchURLMaterial
    },
    on: {
      "close": function($event) {
        return _vm.close('showMateriales')
      }
    }
  })], 1) : _vm._e(), (_vm.showEvaluaciones) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-clase-lista', {
    attrs: {
      "modulo": 'alumno',
      "type": 'curso',
      "fetchURL": _vm.fetchURLEvaluacion
    },
    on: {
      "close": function($event) {
        return _vm.close('showEvaluaciones')
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]), _c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('c-lista-cursos-virtuales-clases')], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar modulos..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    staticClass: "contenedor-data",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('div', {
      key: 'modulo_lookup_' + index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(o.modulo)))])])
  }), 0), (!_vm.isLoading && _vm.listaFiltrada.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('loading', {
    staticClass: "center-lookup"
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Módulos")])])
}]}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "half-width margin-auto"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("¿Olvidaste tu contraseña?")]), _vm._m(0), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "DNI"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.restablecer($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._m(1)])]), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Ir al login")]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.restablecer
    }
  }, [_vm._v("Restablecer contraseña")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorMessage) ? _c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Ingresa tu DNI y te enviaremos un email para restrablecer tu contraseña ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
}]}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), (_vm.showModalEditar) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "materiales_",
      "folder": "curso_virtual_material"
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar archivo")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo  deseado")]), _c('i', {
    staticClass: "fa fa-file",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar material")]) : _c('span', [_vm._v("Crear material")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "100",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    attrs: {
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "text-center"
  }, [
    [(_vm.pathDoc) ? _c('div', {
      staticClass: "mb-5 mt-5 adjunto"
    }, [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": _vm.pathDoc,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small"
    })]), _c('span', [_vm._v("Ver adjunto")])]), _c('span', {
      staticClass: "icon color-red margin-left-5 cursor-pointer",
      attrs: {
        "tittle": "Borrar adjunto"
      },
      on: {
        "click": function($event) {
          return _vm.borrarArchivo()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _c('div', [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": _vm.openModalAdjuntar
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-upload is-small"
    })]), _c('span', [_vm._v("Adjuntar")])])])]
  ], 2)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": function($event) {
        return _vm.guardar()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])], 1)]) : _vm._e(), _vm._m(0), (_vm.modulo !== 'alumno') ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.abrirModalEditar()
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Nuevo")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "information"
  }, [_c('div', {
    staticClass: "is-mobile"
  }, [_c('div', {
    staticClass: "data"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "usuario",
      on: {
        "dblclick": function($event) {
          return _vm.abrirModalEditar(o.id)
        }
      }
    }, [_c('div', {
      staticClass: "display-flex aic"
    }, [_c('div', {
      staticClass: "display-flex fdc flex-1"
    }, [(_vm.modulo !== 'alumno') ? _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))]) : _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.titulo))]), (o.descripcion) ? _c('div', {
      staticClass: "subtitle"
    }, [(_vm.modulo !== 'alumno') ? _c('span', {
      staticClass: "italic flex"
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion)))]) : _c('span', {
      staticClass: "italic flex",
      domProps: {
        "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(o.descripcion))
      }
    })]) : _vm._e()]), (o.pathDoc || _vm.modulo !== 'alumno') ? _c('div', {
      staticClass: "contenedor-acciones display-flex aic"
    }, [(o.pathDoc) ? _c('a', {
      staticClass: "button is-small m-2",
      attrs: {
        "href": o.pathDoc,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa is-small",
      class: [_vm.getFileIcon(o.extension).i]
    })])]) : _vm._e(), (_vm.modulo !== 'alumno') ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.abrirModalEditar(o.id)
        }
      }
    }, [_vm._m(3, true)]), _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_vm._m(4, true)])] : _vm._e()], 2) : _vm._e()])])
  }), 0)]), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', [_vm._m(5)]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', [_vm._v("Materiales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay materiales registradas")])])
}]}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('apexchart', {
    attrs: {
      "type": _vm.isDonut ? 'donut' : 'pie',
      "options": _vm.chartOptions,
      "series": _vm.series
    },
    on: {
      "click": function($event) {}
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Mis datos editables")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos personales")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Apellido paterno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.apellidoPaterno),
      expression: "empleado.apellidoPaterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.apellidoPaterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "apellidoPaterno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Apellido materno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.apellidoMaterno),
      expression: "empleado.apellidoMaterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.apellidoMaterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "apellidoMaterno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Nombres")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombres),
      expression: "empleado.nombres"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.nombres)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombres", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Genero")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.genero === 'F'
    },
    on: {
      "click": function($event) {
        _vm.empleado.genero = 'F'
      }
    }
  }, [_c('span', [_vm._v("F")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.genero === 'M'
    },
    on: {
      "click": function($event) {
        _vm.empleado.genero = 'M'
      }
    }
  }, [_c('span', [_vm._v("M")])])])])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Fecha de nacimiento")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaNacimiento),
      expression: "empleado.fechaNacimiento"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.empleado.fechaNacimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaNacimiento", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Teléfono personal")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.telefonoPersonal),
      expression: "empleado.telefonoPersonal"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.telefonoPersonal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "telefonoPersonal", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Email personal")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.emailPersonal),
      expression: "empleado.emailPersonal"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.emailPersonal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "emailPersonal", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Grado académico")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.gradoAcademico),
      expression: "empleado.gradoAcademico"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.gradoAcademico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "gradoAcademico", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("DNI")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.dni),
      expression: "empleado.dni"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.empleado.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "dni", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Dirección actual de residencia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.direccion),
      expression: "empleado.direccion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.direccion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "direccion", $event.target.value)
      }
    }
  })])])])], 1), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos salud y emergencia")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Tipo de Sangre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.tipoSangre),
      expression: "empleado.tipoSangre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.tipoSangre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "tipoSangre", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Nombre contacto de emergencia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombreEmergencia),
      expression: "empleado.nombreEmergencia"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.nombreEmergencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombreEmergencia", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Telefono contacto de emergencia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.telefonoEmergencia),
      expression: "empleado.telefonoEmergencia"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.telefonoEmergencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "telefonoEmergencia", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Alergias a algun medicamento")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.alergiasMedicamento),
      expression: "empleado.alergiasMedicamento"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.empleado.alergiasMedicamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "alergiasMedicamento", $event.target.value)
      }
    }
  })])])], 1), _c('section', {
    staticClass: "section-familia"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos de familia")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "flex contenedor-transition contenedor-familia",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('div', {
    key: "tiene-conyugue",
    staticClass: "control"
  }, [_c('p', [_vm._v("¿Tiene conyugue?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.estaCasado
    },
    on: {
      "click": function($event) {
        _vm.empleado.estaCasado = true
      }
    }
  }, [_c('span', [_vm._v("Si")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': !_vm.empleado.estaCasado
    },
    on: {
      "click": function($event) {
        _vm.empleado.estaCasado = false
      }
    }
  }, [_c('span', [_vm._v("No")])])])]), (_vm.empleado.estaCasado) ? _c('div', {
    key: "datos-conyugue",
    staticClass: "flex flex-1 contenedor-conyugue"
  }, [_c('div', {
    staticClass: "flex flex-1"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Nombre de conyugue")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombreConyugue),
      expression: "empleado.nombreConyugue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.nombreConyugue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombreConyugue", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("DNI/CE conyugue")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.dniConyugue),
      expression: "empleado.dniConyugue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.dniConyugue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "dniConyugue", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Fecha de nacimiento conyugue")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaNacimientoConyugue),
      expression: "empleado.fechaNacimientoConyugue"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.empleado.fechaNacimientoConyugue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaNacimientoConyugue", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _c('transition-group', {
    staticClass: "flex contenedor-transition contenedor-familia",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('div', {
    key: "tiene-hijos",
    staticClass: "control"
  }, [_c('p', [_vm._v("¿Tiene hijos?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.tieneHijos
    },
    on: {
      "click": function($event) {
        _vm.empleado.tieneHijos = true
      }
    }
  }, [_c('span', [_vm._v("Si")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': !_vm.empleado.tieneHijos
    },
    on: {
      "click": function($event) {
        _vm.empleado.tieneHijos = false
      }
    }
  }, [_c('span', [_vm._v("No")])])])]), (_vm.empleado.tieneHijos) ? _c('transition-group', {
    key: "contenedor-hijos",
    staticClass: "flex flex-1 contenedor-transition contenedor-hijos",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_vm._l((_vm.hijos), function(o, index) {
    return _c('div', {
      key: 'hijos_' + index,
      staticClass: "flex-1 contenedor-hijo"
    }, [_c('div', {
      staticClass: "flex contenedor-hijo-break-1"
    }, [_c('div', {
      staticClass: "flex flex-1"
    }, [_c('div', {
      staticClass: "control flex-1"
    }, [_c('p', [_vm._v("Nombre hijo")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.nombre),
        expression: "o.nombre"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (o.nombre)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "nombre", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [_c('p', [_vm._v("DNI/CE hijo")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.dni),
        expression: "o.dni"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (o.dni)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "dni", $event.target.value)
        }
      }
    })])]), _c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "control flex-1"
    }, [_c('p', [_vm._v("Fecha de nacimiento hijo")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaNacimiento),
        expression: "o.fechaNacimiento"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
      },
      domProps: {
        "value": (o.fechaNacimiento)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaNacimiento", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "flex contenedor-genero"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('p', [_vm._v("Genero")]), _c('div', {
      staticClass: "opciones"
    }, [_c('div', {
      staticClass: "opcion",
      class: {
        'active': o.genero === 'F'
      },
      on: {
        "click": function($event) {
          o.genero = 'F'
        }
      }
    }, [_c('span', [_vm._v("F")])]), _c('div', {
      staticClass: "opcion",
      class: {
        'active': o.genero === 'M'
      },
      on: {
        "click": function($event) {
          o.genero = 'M'
        }
      }
    }, [_c('span', [_vm._v("M")])])])]), _c('div', {
      staticClass: "button button-quitar-hijo",
      on: {
        "click": function($event) {
          return _vm.quitarHijo(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])])])])])
  }), (_vm.empleado.tieneHijos) ? _c('div', {
    key: "agregar-hijo",
    staticClass: "contenedor-boton-agregar-hijo",
    attrs: {
      "name": "Agregar hijo"
    },
    on: {
      "click": _vm.agregarHijoVacio
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Agregar")])])]) : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos del trabajo")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Anexo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.anexo),
      expression: "empleado.anexo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.empleado.anexo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "anexo", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Celular de trabajo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.celularTrabajo),
      expression: "empleado.celularTrabajo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.empleado.celularTrabajo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "celularTrabajo", $event.target.value)
      }
    }
  })])])])], 1), _c('section', {
    staticClass: "contenedor-guardar"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": _vm.guardar
    }
  }, [_vm._m(0), _c('span', [_vm._v("Guardar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save fa-fw fa-lg"
  })])
}]}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "reporte_documentos_firmar",
    staticClass: "box position-relative"
  }, [_c('reporte-cursos-virtuales-terminados')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('editar-documento-importante', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "id": _vm.idSeleccionado
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalNotificar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalNotificar()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Notificar")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.closeModalNotificar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Fecha Vencimiento para el anuncio")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaVencimiento),
      expression: "fechaVencimiento"
    }],
    staticClass: "input w-200",
    attrs: {
      "type": "date",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.fechaVencimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaVencimiento = $event.target.value
      }
    }
  })])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardarNotificacion
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Enviando...")]) : _c('span', [_vm._v("Enviar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.closeModalNotificar()
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestion de documentos importantes")])]), _c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Los documentos cargados en esta pantalla, apareceran para todos los empleados activos de la plataforma")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Fecha de modificación")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      },
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Orden: ' + o.orden
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion))])])]), _c('td', [_vm._v(_vm._s(o.modificado))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.ruta) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e(), _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalNotificar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-send"
    })]), _c('span', [_vm._v("Notificar")])])], 2)])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay documentos importantes ingresados")])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    staticClass: "contenedor-data",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filtered), function(o, i) {
    return (!_vm.isLoading) ? _c('div', {
      key: o.codigo,
      staticClass: "usuario",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', {
      staticClass: "codigo"
    }, [_vm._v(_vm._s(o.codigo) + " :")]), _c('span', {
      staticClass: "descripcion"
    }, [_vm._v(_vm._s(o.descripcion))])]) : _vm._e()
  }), 0), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading text-center"
  }, [_vm._m(1)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Tipos de permiso")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])
}]}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "reporte_documentos_firmar",
    staticClass: "box position-relative"
  }, [_c('reporte-documentos-firmar')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padre"
  }, [_vm._m(0), _c('div', {
    staticClass: "display-flex fdc"
  }, [(_vm.perfilVacaciones === 'recursos humanos') ? _c('div', {
    staticClass: "rrhh display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showCantidadPermisosSinAprobarRRHH) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('permisos-aprobar-rrhh')
      }
    }
  }, [_c('cantidad-permisos-sin-aprobar-rrhh', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadPermisosSinAprobarRRHH')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadContratosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('reporte-contratos', true)
      }
    }
  }, [_c('cantidad-contratos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadContratosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadDocumentosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('reporte-documentos-firmar', true)
      }
    }
  }, [_c('cantidad-documentos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadDocumentosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadBoletasSinVisualizar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('boletas-reporte', true)
      }
    }
  }, [_c('cantidad-boletas-sin-visualizar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadBoletasSinVisualizar')
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]), (_vm.perfilVacaciones === 'recursos humanos') ? _c('div', {
    staticClass: "contenedor-chart"
  }, [_c('top-empleados-mas-dias-disponibles', {
    staticClass: "flex-1"
  }), _c('cantidad-solicitudes-v-pendiente-aprobar-jefe', {
    staticClass: "flex-1"
  })], 1) : _vm._e(), (_vm.perfilVacaciones === 'recursos humanos') ? [_c('empleados-por-areas', {
    staticClass: "flex-1",
    attrs: {
      "isHorizontal": true
    }
  })] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("KPIs de recursos humanos")])])
}]}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes de permiso por aprobar")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "aprobarSolicitud",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazarMasiva = false
      },
      "do": _vm.rechazarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionAprobarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobarMasiva = false
      },
      "do": _vm.aprobarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_vm._m(0), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_vm._m(1), _c('span', [_vm._v("Rechazar")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    key: "mensaje_no_solicitudes",
    staticClass: "mensaje-informacion"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No hay solicitudes de permisos de su equipo por aprobar")])])])]) : _vm._e(), _c('div', {
    key: "div-table-solicitud-por-aprobar",
    staticClass: "is-desktop"
  }, [(_vm.lista.length > 0) ? _c('table', {
    key: "table-solicitud-por-aprobar",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "solicitud"
    },
    domProps: {
      "checked": _vm.seleccionadosTodos
    },
    on: {
      "change": function($event) {
        return _vm.check('all')
      }
    }
  })]), _c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: o.id + 'id',
      staticClass: "row-table",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('td', {
      staticClass: "ta-center"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde) + _vm._s(i.desde === i.hasta ? '' : ' - ' + i.hasta) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2)], 2), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', {
      staticClass: "no-accion"
    }, [_vm._v("Sin adjunto")])], (o.estado === 2 && !_vm.isSeleccionMasiva) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "div-card-solicitud-por-aprobar",
    staticClass: "is-mobile"
  }, [_vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: o.id + 'id',
      staticClass: "box",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('div', {
      staticClass: "empleado hint--right",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('span', [_vm._v(_vm._s(o.motivo))])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e(), (o.estado === 2 && !_vm.isSeleccionMasiva) ? [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : _vm._e()], 2)])
  }), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)]), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.codigoEmpleado ? 'Libros de vacaciones' : 'Mis libros de vacaciones'))]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.libros), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        active: o.activo
      },
      on: {
        "click": function($event) {
          return _vm.mostrarHojas(o)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(o.periodo))]), _c('td', [_c('div', {
      staticClass: "td-wrapper hint--top",
      attrs: {
        "aria-label": 'Libro: ' + o.id
      }
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicio))]), _c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.fechaFin))])])])]), _c('td', [_vm._v(_vm._s(o.diasPorTomar))]), _c('td', [_vm._v(_vm._s(o.diasTomados))])])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.periodoSeleccionado) ? _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Detalle del libro " + _vm._s(_vm.periodoSeleccionado))])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loadingHojas) ? _c('div', {
    key: "loading",
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])]) : _c('div', {
    key: "list-hojas",
    staticClass: "hojas"
  }, [(_vm.hojas.length === 0) ? _c('article', {
    key: "message-not-hojas",
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay hojas en este libro")])]) : _c('div', {
    key: "table-hojas",
    style: (_vm.codigoEmpleado ? 'overflow-y: auto; height:10em;' : '')
  }, [_c('table', {
    staticClass: "table is-striped is-bordered detalle-wrapper"
  }, [_c('thead', [_c('th', [_vm._v("Fecha")]), _c('th', [_vm._v("Dias tomados")]), _c('th', [_vm._v("Motivo")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.hojas), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        resta: o.signo === '-', suma: o.signo === '+'
      }
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper hint--top",
      attrs: {
        "aria-label": 'Vacaciones: ' + o.idVacaciones
      }
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicio))]), _c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.fechaFin))])])])]), _c('td', [_vm._v(_vm._s(o.diasTomados))]), _c('td', [_vm._v(_vm._s(o.motivo))])])
  }), 0)], 1)])])])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Periodo")]), _c('th', [_vm._v("Inicio - Fin")]), _c('th', [_vm._v("Dias por tomar")]), _c('th', [_vm._v("Dias tomados")])])
}]}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [(_vm.iframe) ? _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "iframe",
    domProps: {
      "innerHTML": _vm._s(_vm.iframe)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "display-flex fdr space-evenly margin-top-10"
  }, [(!_vm.estado) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.acabarClase
    }
  }, [_vm._v("Terminar")]) : _vm._e(), (!_vm.esUltimaClase) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.acabarClase
    }
  }, [_vm._v("Siguiente")]) : _vm._e()]), _c('div', {
    staticClass: "contenedor-glosa"
  }, [_c('strong', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.titulo))]), _c('br'), _c('P', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.descripcion))
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-image', {
    attrs: {
      "name": "curso_virtual",
      "folder": "curso_virtual_portada",
      "onlyImg": true
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar archivo")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo  deseado")]), _c('i', {
    staticClass: "fa fa-file",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "fw-400"
  }, [_vm._v(_vm._s(_vm.id ? 'Editar' : 'Nuevo') + " curso virtual")])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _c('span', [_vm._v("Volver")])])]), _c('button', {
    staticClass: "button is-small is-primary",
    on: {
      "click": function($event) {
        return _vm.guardarCurso()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('span', [_vm._v("Guardar")])])]), _c('div', {
    staticClass: "body pt-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingCurso
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoadingCurso
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingCurso
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [(!_vm.imagen) ? _c('button', {
    staticClass: "button is-small is-primary",
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })]), _c('span', {
    staticClass: "is-small"
  }, [_vm._v("Adjuntar portada")])]) : _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        _vm.imagen = ''
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash is-small"
  })]), _c('span', [_vm._v("Borrar Portada")])])]), (_vm.imagen) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imagen,
      "alt": "portada_curso"
    }
  })]) : _vm._e()])]), _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap pt-10"
  }, [_c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-curso-lista', {
    ref: "materialesRef",
    attrs: {
      "type": "curso"
    },
    on: {
      "save": function($event) {
        return _vm.saveMaterial()
      }
    }
  })], 1), _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-curso-lista', {
    ref: "evaluacionesRef",
    attrs: {
      "type": "curso"
    },
    on: {
      "save": function($event) {
        return _vm.saveEvaluacion()
      }
    }
  })], 1), _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('alumnos-curso-lista', {
    ref: "alumnosRef",
    on: {
      "save": function($event) {
        return _vm.saveAlumno()
      }
    }
  })], 1)])]), _c('div', {
    key: "box-clases",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "clase"
  }, [_vm._v("Clases")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.redirigir(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), (_vm.lista.length !== 0) ? _c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.fetchClases()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])]) : _vm._e()]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoadingClase) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Orden")]), _c('th', [_vm._v("Título")]), _c('th', [_vm._v("Descripción")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_vm._v(_vm._s(o.orden))]), _c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo))])]), _c('td', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion)))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mr-5",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'is-close': !o.activo
      }
    }, [_c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo))])]), (o.descripcion) ? _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion)))])])]) : _vm._e(), (o.orden) ? _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Orden: " + _vm._s(o.orden))])]) : _vm._e(), _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mr-5",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])
  }), 0)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay clases registradas")])])])], 2)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-multi-file', {
    attrs: {
      "name": "adjuntar_contratos_manuales",
      "folder": "contratos-sin-firmar",
      "onlyPdf": true
    },
    on: {
      "save": _vm.guardarAdjuntos,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjunte los pdf de las contratos")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Recuerda que los archivos deben tener el DNI al inicio del nombre del archivo")])])], 1) : _vm._e()]), (_vm.mostrarConfirmacionEliminarTodo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = false
      },
      "do": function($event) {
        return _vm.eliminar(null, null, true)
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar todas los contratos cargados?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar todo")])]), _c('strong', [_vm._v("Solo se eliminaran los contratos de la carga manual actual, no las generadas")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar(_vm.contrato.id, _vm.contrato)
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro que desea eliminar?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar")])])])], 1) : _vm._e(), (_vm.mostrarConfirmacionEnviarContratos) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEnviarContratos = false
      },
      "do": _vm.enviarContratos
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea enviar los contratos cargados?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Enviando...")]) : _c('span', [_vm._v("Enviar")])])])], 1) : _vm._e(), (_vm.mostrarErroresMultiples) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('errores-multiples', {
    attrs: {
      "errores": _vm.messages
    },
    on: {
      "close": function($event) {
        _vm.mostrarErroresMultiples = false
      }
    }
  })], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Carga manual de contratos")])]), _c('div', {
    staticClass: "display-flex filtros-completos jce"
  }, [_c('div', {
    staticClass: "text-right media-pt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload fs-12"
  })]), _c('span', [_vm._v("Adjuntar")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "mt-15"
  }, [_c('div', {
    staticClass: "text-right acciones-superior"
  }, [_c('button', {
    staticClass: "button is-small ml-5 mt-5 is-primary",
    attrs: {
      "disabled": _vm.lista.length === 0 || _vm.isLoading
    },
    on: {
      "click": _vm.confirmacionEnviarContratos
    }
  }, [_c('span', {
    staticClass: "icon is-small fs-13"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Enviar contratos")])]), _c('button', {
    staticClass: "button is-small is-danger ml-5 mt-5",
    attrs: {
      "disabled": _vm.lista.length === 0 || _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times fa-fw fa-lg"
  })]), _c('span', [_vm._v("Eliminar todo")])])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Nombre de archivo")]), _c('th', [_vm._v("Datos Contratos")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': o.isBGRed
      }
    }, [_c('td', [(o.codigoEmpleado) ? [_c('div', {
      staticClass: "d-initial"
    }, [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "display-flex hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.deasignarEmpleadoContratoAuxiliar(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleado),
        expression: "o.codigoEmpleado"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleado)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleado", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleado
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoContratoAuxiliar(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)]], 2), _c('td', [_c('div', [_vm._v(_vm._s(o.namefile))]), _c('div', {
      staticClass: "d-initial mt-10"
    }, [_c('strong', [_vm._v("Modificado: ")]), _c('span', [_vm._v(_vm._s(o.modificado))])])]), _c('td', [_c('div', {
      staticClass: "flex fdc"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": o.indeterminado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    }), _c('label', [_vm._v(" Indeterminado")])]), _c('hr', {
      staticClass: "margin-05-rem"
    }), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Inicio")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaInicio),
        expression: "o.fechaInicio"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaInicio)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaInicio", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Fin")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaFin),
        expression: "o.fechaFin"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaFin)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaFin", $event.target.value)
        }
      }
    })])])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones fdc"
    }, [(o.ruta) ? _c('a', {
      staticClass: "margin-acciones button is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]) : _vm._e(), _c('button', {
      staticClass: "margin-acciones button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])]), _c('button', {
      staticClass: "margin-acciones button is-small",
      on: {
        "click": function($event) {
          return _vm.verVistaPrevia(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Vista previa")])])])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'is-close': !o.codigoEmpleado || o.isBGRed
      }
    }, [(o.codigoEmpleado) ? [_c('div', [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "descripcion-tipo display-flex"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.deasignarEmpleadoContratoAuxiliar(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "mb-10"
    }, [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleado),
        expression: "o.codigoEmpleado"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleado)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleado", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleado
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoContratoAuxiliar(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)])], _c('div', {
      staticClass: "motivo"
    }, [_c('span', [_vm._v(_vm._s(o.namefile))])]), _c('div', {
      staticClass: "dias-pedidos mt-5"
    }, [_c('strong', [_vm._v("Fecha de modificación: ")]), _c('div', [_vm._v(_vm._s(o.modificado))]), _c('div', {
      staticClass: "flex fdc"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": o.indeterminado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    }), _c('label', [_vm._v(" Indeterminado")])]), _c('hr', {
      staticClass: "margin-05-rem"
    }), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Inicio")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaInicio),
        expression: "o.fechaInicio"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaInicio)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaInicio", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Fin")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaFin),
        expression: "o.fechaFin"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaFin)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaFin", $event.target.value)
        }
      }
    })])])]), _c('div', {
      staticClass: "botones"
    }, [(o.ruta) ? _c('a', {
      staticClass: "button margin-acciones is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]) : _vm._e(), _c('button', {
      staticClass: "button is-small is-danger margin-acciones",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])]), _c('button', {
      staticClass: "margin-acciones button is-small",
      on: {
        "click": function($event) {
          return _vm.verVistaPrevia(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Vista previa")])])])], 2)
  })], 2)] : _vm._e()], 2)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-global-sil-container"
  }, [_c('div', {
    staticClass: "loading-global-sil"
  }), _c('div', {
    staticClass: "cargando-text",
    attrs: {
      "id": "loading-global-sil-text"
    }
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('gestion-gerencias-editar', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "gerencia": _vm.gerenciaSeleccionada
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.eliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar la gerencia " + _vm._s(_vm.gerenciaSeleccionada.nombre) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Administrador de gerencias")])]), _c('div', {
    staticClass: "filtros-container"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Gerencia")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "text-right acciones"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "table-lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Gerencia")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.shadowList), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Gerencia: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombre))])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])])])
  }), 0)], 1) : _vm._e()]), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No hay registros")])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('c-lista-cursos-virtuales')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title", [_vm._v("Adjunta una imagen o pdf")])], 2), _vm._m(0)]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "upload-container w-64",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.UploadsMultiFiles($event)
      }
    }
  }, [_c('p', {
    staticClass: "has-text-left"
  }, [_c('span', [_vm._t("explanation", [_vm._v("Adjunta una imagen o pdf")])], 2)]), _c('div', {
    staticClass: "dropzone",
    attrs: {
      "id": "dropzone"
    },
    on: {
      "click": _vm.select
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$upload.dropzone(_vm.name).active),
      expression: "$upload.dropzone(name).active"
    }],
    staticClass: "overlay"
  }, [_c('span', [_vm._v("Suelta el archivo para cargarlo")])])]), _vm._m(1), _c('span', {
    staticClass: "margin-bottom-10"
  }, [_vm._v("Arrastra el archivo que desees cargar o dale click al recuadro para buscar en tus archivos")])], 1), (_vm.$upload.errors(_vm.name).length > 0) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.$upload.errors(_vm.name)[0].msg))]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.files.length > 0) ? _c('div', [_c('div', {
    staticClass: "contenedor-files-prev overflow-y-pretty mb-10 text-left"
  }, _vm._l((_vm.files), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "display-flex p-2"
    }, [_c('span', {
      staticClass: "file-name mb-4 text-purple-500 font-bold flex-1"
    }, [_vm._v(_vm._s(o.name))]), _c('span', {
      staticClass: "icon color-red margin-left-5 cursor-pointer",
      attrs: {
        "tittle": "Borrar adjunto"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  }), 0), _c('div', {
    staticClass: "buttons-container"
  }, [
    [_c('button', {
      staticClass: "button flex-1 margin-left-5 is-primary",
      attrs: {
        "type": "submit",
        "disabled": _vm.isUploading
      }
    }, [(_vm.isUploading) ? _c('span', [_vm._v("Adjuntando...")]) : _c('span', [_vm._v("Adjuntar archivos")])])]
  ], 2)]) : _vm._e()])], 1)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  })])
}]}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalInforme) ? _c('delegaciones-informe', {
    attrs: {
      "id": _vm.informe.id
    },
    on: {
      "close": _vm.closeModalInforme
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('gestion-delegaciones-rrhh-guardar', {
    attrs: {
      "info": _vm.info
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  })], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalConfirmacionInactivar) ? _c('div', {
    key: "modal-inactivar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Inactivar delegación")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.modalConfirmacionInactivar = false
      }
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("¿Estás seguro de inactivar la delegación?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.inactivar
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Inactivando...")]) : _c('span', [_vm._v("Inactivar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        _vm.modalConfirmacionInactivar = false
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestion de delegaciones RRHH")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("Ver inactivas")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verInactivas),
      expression: "verInactivas"
    }],
    staticClass: "mr-8",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.verInactivas) ? _vm._i(_vm.verInactivas, null) > -1 : (_vm.verInactivas)
    },
    on: {
      "input": _vm.handlerVerInactivas,
      "change": function($event) {
        var $$a = _vm.verInactivas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.verInactivas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.verInactivas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.verInactivas = $$c
        }
      }
    }
  }), _c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "table-delegaciones-rrhh",
    staticClass: "tabla"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Reemplazante")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Creación")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleadoOrigen
      }
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.nombreEmpleadoOrigen))]), _c('strong', {
      staticClass: "show-break-1"
    }, [_vm._v("Reemplazo:")]), _c('span', {
      staticClass: "show-break-1 hint--bottom",
      attrs: {
        "aria-label": 'Reemplazante: ' + o.dniEmpleadoReemplazante
      }
    }, [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Reemplazante: ' + o.dniEmpleadoReemplazante
      }
    }, [_c('span', [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [(o.fechaInicioString == o.fechaFinString) ? _c('span', [_vm._v(_vm._s(o.fechaInicioString))]) : _c('div', {
      staticClass: "fechas"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicioString))]), _c('span', {
      staticClass: "hide-break-guion"
    }, [_vm._v("-")]), _c('span', [_vm._v(_vm._s(o.fechaFinString))])]), _c('strong', {
      staticClass: "show-break-1"
    }, [_vm._v("Creado:")]), _c('span', {
      staticClass: "show-break-1"
    }, [_vm._v(_vm._s(o.creado))])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.creado))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.activo) ? _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _vm._e(), _c('button', {
      staticClass: "button is-small is-danger mt-10",
      on: {
        "click": function($event) {
          return _vm.abrirModalInactivar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Inactivar")])]), _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.abrirModalInforme(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Informe")])])])])])])
  }), 0)], 1) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    key: "message",
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.showModalAdjuntar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdjuntar()
      }
    }
  }), _c('upload-image', {
    attrs: {
      "name": "reunion_capacitacion",
      "folder": "reunion"
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar archivo")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo deseado")]), _c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "fw-400"
  }, [_vm._v(_vm._s(_vm.idReunion ? 'Editar' : 'Nuevo'))])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _c('span', [_vm._v("Volver")])])]), (_vm.form.estado !== 2) ? _c('button', {
    staticClass: "button is-small mr-5",
    on: {
      "click": function($event) {
        return _vm.guardar()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('span', [_vm._v("Guardar")])]) : _vm._e(), (_vm.form.estado === 0) ? _c('button', {
    staticClass: "button is-small is-primary mr-5",
    on: {
      "click": function($event) {
        return _vm.cambiarEstado(1)
      }
    }
  }, [_c('span', [_vm._v("Terminar")])]) : _vm._e(), (_vm.form.estado === 0) ? _c('button', {
    staticClass: "button is-small is-danger mr-5",
    on: {
      "click": function($event) {
        return _vm.cambiarEstado(2)
      }
    }
  }, [_c('span', [_vm._v("No se realizó")])]) : _vm._e(), (_vm.form.estado === 0) ? _c('button', {
    staticClass: "button is-small is-success mr-5",
    on: {
      "click": function($event) {
        return _vm.notificar()
      }
    }
  }, [_c('span', [_vm._v("Notificar")])]) : _vm._e(), (_vm.form.estado === 1 && _vm.form.tipo === 'capacitacion') ? _c('button', {
    staticClass: "button is-small is-primary mr-5",
    on: {
      "click": function($event) {
        return _vm.exportarPdf()
      }
    }
  }, [_c('span', [_vm._v("Exportar PDF")])]) : _vm._e(), (_vm.form.estado === 1) ? _c('button', {
    staticClass: "button is-small is-success",
    class: {
      'is-loading': _vm.isExporting
    },
    on: {
      "click": function($event) {
        return _vm.exportarExcel()
      }
    }
  }, [_c('span', [_vm._v("Exportar Excel")])]) : _vm._e()]), _c('div', {
    staticClass: "body pt-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tipo),
      expression: "form.tipo"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "reunion",
      "value": "reunion",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.tipo, "reunion")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "tipo", "reunion")
      }
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Reunión")])]), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tipo),
      expression: "form.tipo"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "reunion",
      "value": "capacitacion",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.tipo, "capacitacion")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "tipo", "capacitacion")
      }
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Capacitación")])])])]), _c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.titulo),
      expression: "form.titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "titulo", $event.target.value)
      }
    }
  })])]), (_vm.form.tipo === 'capacitacion') ? _c('div', {
    staticClass: "control margin-bottom-10 mt-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Nombre del capacitador")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nombreCapacitador),
      expression: "form.nombreCapacitador"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.nombreCapacitador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nombreCapacitador", $event.target.value)
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "control margin-bottom-10 mt-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.descripcion),
      expression: "form.descripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "descripcion", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.modalidad),
      expression: "form.modalidad"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "modalidad",
      "value": "presencial",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.modalidad, "presencial")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "modalidad", "presencial")
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Presencial")])]), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.modalidad),
      expression: "form.modalidad"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "modalidad",
      "value": "virtual",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.modalidad, "virtual")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "modalidad", "virtual")
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Virtual")])])])]), _c('div', {
    staticClass: "display-flex"
  }, [(_vm.form.modalidad === 'presencial') ? _c('div', {
    staticClass: "control margin-bottom-10 m-2"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Sala")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.idSala),
      expression: "form.idSala"
    }],
    attrs: {
      "disabled": _vm.isLoadingReunion || _vm.isLoadingSalas || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "idSala", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.salas), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])
  }), 0)])]) : _vm._e(), (_vm.form.modalidad === 'virtual') ? _c('div', {
    staticClass: "control margin-bottom-10 flex-1 mt-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link),
      expression: "form.link"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link", $event.target.value)
      }
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "display-flex mt-5"
  }, [_c('div', {
    staticClass: "control mr-5"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Fecha")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fecha),
      expression: "form.fecha"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "date",
      "step": "1",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fecha", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control mr-5"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.horaDesde),
      expression: "form.horaDesde"
    }],
    staticClass: "input w-80",
    attrs: {
      "type": "time",
      "step": "60",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.horaDesde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "horaDesde", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.horaHasta),
      expression: "form.horaHasta"
    }],
    staticClass: "input w-80",
    attrs: {
      "type": "time",
      "step": "60",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.horaHasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "horaHasta", $event.target.value)
      }
    }
  })])]), (_vm.mostrarAsistentes) ? _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap pt-10"
  }, [_c('asistentes-lista', {
    ref: "asistenteRef",
    attrs: {
      "codigoCreador": _vm.form.codigoCreador,
      "esReunionTerminada": _vm.esReunionTerminada,
      "esReunionAnulada": _vm.esReunionAnulada
    },
    on: {
      "save": function($event) {
        return _vm.saveAsistente()
      }
    }
  })], 1) : _vm._e(), (_vm.esReunionTerminada || _vm.esReunionAnulada) ? [_c('div', {
    staticClass: "field mt-5 text-align-left"
  }, [_c('strong', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Minuta")]), _c('div', {
    staticClass: "control margin-top-10 flex-1"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.minutaOpcion),
      expression: "form.minutaOpcion"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "minuta",
      "value": "texto",
      "disabled": _vm.isLoadingReunion || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.minutaOpcion, "texto")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "minutaOpcion", "texto")
      }, _vm.handlerMinuta]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Texto")])]), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.minutaOpcion),
      expression: "form.minutaOpcion"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "minuta",
      "value": "link",
      "disabled": _vm.isLoadingReunion || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.minutaOpcion, "link")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "minutaOpcion", "link")
      }, _vm.handlerMinuta]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Archivo adjunto")])])])]), (_vm.form.minutaOpcion === 'texto') ? _c('div', {
    staticClass: "control margin-bottom-10 mt-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.minutaDescripcion),
      expression: "form.minutaDescripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingReunion || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.minutaDescripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "minutaDescripcion", $event.target.value)
      }
    }
  })]) : _vm._e(), (_vm.form.minutaOpcion === 'link') ? _c('div', {
    staticClass: "control margin-bottom-10 flex-1 mt-10"
  }, [(_vm.form.minutaLink) ? _c('div', {
    staticClass: "mb-5 mt-5 adjunto"
  }, [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "href": _vm.form.minutaLink,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small"
  })]), _c('span', [_vm._v("Ver adjunto")])]), _c('span', {
    staticClass: "icon color-red margin-left-5 cursor-pointer",
    style: ({
      'pointer-events': _vm.esReunionAnulada ? 'none' : 'auto'
    }),
    attrs: {
      "tittle": "Borrar adjunto"
    },
    on: {
      "click": function($event) {
        return _vm.borrarAdjunto()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]) : _c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "disabled": _vm.esReunionAnulada
    },
    on: {
      "click": _vm.abrirModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })]), _c('span', [_vm._v("Adjuntar")])])]) : _vm._e()] : _vm._e()], 2)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boleta"
  }, [_c('div', {
    staticClass: "datos"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "up"
  }, [_c('div', {
    staticClass: "big"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.boleta.nombreMes) + " " + _vm._s(_vm.boleta.periodo))]), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.boleta.descripcionTipo))])]), _c('div', {
    staticClass: "big"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v(_vm._s(_vm.boleta.codigo))]), _c('span', [_vm._v(_vm._s(_vm.boleta.nombre))])])]), _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('span', [_vm._v("Dias trabajados:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.diasTrabajados))]), _c('br'), _c('span', [_vm._v("Dias vacaciones:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.diasVacaciones))]), _c('br'), _c('span', [_vm._v("Dias subsidio:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.diasSubsidio))])]), _c('div', [_c('span', [_vm._v("Horas trabajadas:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.horasTrabajadas))]), _c('br'), _c('span', [_vm._v("Horas extra:")]), _c('strong', [_vm._v(_vm._s(_vm.boleta.horasExtras))])])])]), _c('div', {
    staticClass: "down"
  }, [_c('table', {
    staticClass: "table table-mini is-bordered"
  }, [_vm._m(0), _c('tbody', [_vm._l((_vm.boleta.detalle), function(o) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(o.codigoRubro) + "  " + _vm._s(o.descripcionRubro))]), _c('td', {
      staticClass: "text-align-right"
    }, [(o.signo === '+') ? [_vm._v(_vm._s(o.monto.toFixed(2)))] : void 0], 2), _c('td', {
      staticClass: "text-align-right"
    }, [(o.signo === '-') ? [_vm._v(_vm._s(o.monto.toFixed(2)))] : void 0], 2), _c('td', {
      staticClass: "text-align-right"
    }, [(o.signo === '') ? [_vm._v(_vm._s(o.monto.toFixed(2)))] : void 0], 2)])
  }), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("Totales")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.totalIngresos.toFixed(2)))]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.totalEgresos.toFixed(2)))]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.totalAportes.toFixed(2)))])]), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("Neto a pagar")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }), _c('td', {
    staticClass: "font-bold text-align-right"
  }), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.montoAPagar.toFixed(2)))])]), _vm._m(1), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("C.C. Soles")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.cuentaCorrienteSoles.toFixed(2)))])]), _c('tr', [_c('td', {
    staticClass: "font-bold"
  }, [_vm._v("C.C. Dólares")]), _c('td', {
    staticClass: "font-bold text-align-right"
  }, [_vm._v(_vm._s(_vm.boleta.cuentaCorrienteDolares.toFixed(2)))])])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Rubro")]), _c('th', [_vm._v("Ingreso")]), _c('th', [_vm._v("Descuento")]), _c('th', [_vm._v("Aporte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td'), _c('td')])
}]}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis solicitudes de vacaciones")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isEditing) ? _c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [(_vm.mostrarConfirmacionEnviar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEnviar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea enviar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Enviando...")] : [_vm._v("Enviar")]], 2), _c('span', [_vm._v("Luego de enviar la notificación a su jefe, no podrá modificarlo")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), _c('div', {
    staticClass: "show-closed-text"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showClosed = !_vm.showClosed
      }
    }
  }, [(_vm.showClosed) ? [_vm._v("Mostrando todas las solicitudes")] : [_vm._v("Mostrando solo las solicitudes abiertas")]], 2)]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Retorno")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return (_vm.showClosed || (!_vm.showClosed && o.estadoData.abierto)) ? _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.estadoData.abierto
      }
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "dates-wrapper hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), _c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Retorno:")]), _c('span', [_vm._v(_vm._s(o.retorno))]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.estadoData.descripcion))])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [(o.estado === 1 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.enterEditMode(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Enviar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado === 2 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado > 2) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', [_vm._v("No hay acciones")])]) : _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', {
      staticClass: "has-text-danger"
    }, [_vm._v("Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe")])])])])]) : _vm._e()
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)], 1) : _c('div', {
    key: "edit-solicitud"
  }, [_c('nueva-solicitud-vacaciones', {
    ref: "editarSolicitud",
    attrs: {
      "is-editing": true,
      "solicitud": _vm.solicitudSeleccionada
    },
    on: {
      "close": function($event) {
        _vm.isEditing = false
      },
      "closeRefresh": function($event) {
        _vm.isEditing = false;
        _vm.fetch();
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar areas..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    staticClass: "contenedor-data",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('div', {
      key: 'area_lookup_' + index,
      staticClass: "item fdc",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(o.nombreArea)))]), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombreGerencia))])])
  }), 0), (!_vm.isLoading && _vm.listaFiltrada.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('loading', {
    staticClass: "center-lookup"
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Area")])])
}]}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), (_vm.showModalEditar) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar evaluación")]) : _c('span', [_vm._v("Crear evaluación")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    attrs: {
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "focus": function (e) { return e.target.select(); },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": function($event) {
        return _vm.guardar()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])]) : _vm._e(), _vm._m(0), (_vm.modulo !== 'alumno') ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.abrirModalEditar()
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Nuevo")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "information"
  }, [(_vm.idCurso && _vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-mobile"
  }, [_c('div', {
    staticClass: "data"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "usuario",
      on: {
        "dblclick": function($event) {
          return _vm.abrirModalEditar(o.id)
        }
      }
    }, [_c('div', {
      staticClass: "display-flex aic"
    }, [_c('div', {
      staticClass: "display-flex fdc flex-1"
    }, [(_vm.modulo !== 'alumno') ? _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))]) : _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.titulo))]), (o.descripcion) ? _c('div', {
      staticClass: "subtitle"
    }, [(_vm.modulo !== 'alumno') ? _c('span', {
      staticClass: "italic flex"
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion)))]) : _c('span', {
      staticClass: "italic flex",
      domProps: {
        "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(o.descripcion))
      }
    })]) : _vm._e()]), _c('div', {
      staticClass: "contenedor-acciones display-flex aic"
    }, [(o.link && _vm.modulo === 'alumno') ? _c('a', {
      staticClass: "button is-small m-2",
      attrs: {
        "href": o.link,
        "target": "_blank"
      }
    }, [_vm._m(3, true)]) : _vm._e(), (_vm.modulo !== 'alumno') ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.abrirModalEditar(o.id)
        }
      }
    }, [_vm._m(4, true)]), _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_vm._m(5, true)])] : _vm._e()], 2)])])
  }), 0)])] : _c('div', [_vm._m(6)])], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', [_vm._v("Evaluaciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa is-small fa-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay evaluaciones registradas")])])
}]}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_documento_importante",
      "onlyWord": "true",
      "folder": "documentos_firmar"
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar archivo word")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo word deseado")]), _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalSeleccionarEmpleado) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('seleccionar-empleado', {
    attrs: {
      "idDocumentoFirmar": +_vm.id
    },
    on: {
      "close": _vm.closeModalSeleccionarEmpleado,
      "save": _vm.guardarSeleccion
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar documento")]) : _c('span', [_vm._v("Crear documento")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Orden")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orden),
      expression: "orden"
    }],
    staticClass: "input w-90",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.orden)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orden = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoading
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripcion")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "text-center"
  }, [
    [(_vm.ruta) ? _c('div', {
      staticClass: "mb-5 mt-5 adjunto"
    }, [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": _vm.ruta,
        "target": "_blank"
      }
    }, [_vm._m(0), _c('span', [_vm._v("Ver adjunto")])]), _c('span', {
      staticClass: "icon color-red margin-left-5 cursor-pointer",
      attrs: {
        "tittle": "Borrar adjunto"
      },
      on: {
        "click": function($event) {
          _vm.ruta = ''
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _c('div', [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": _vm.openModalAdjuntar
      }
    }, [_vm._m(1), _c('span', [_vm._v("Adjuntar")])])])], _c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": _vm.openModalSeleccionarEmpleado
      }
    }, [_vm._m(2), _c('span', [_vm._v("Asignar Empleados")])])
  ], 2)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": function($event) {
        return _vm.guardar(false)
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users is-small"
  })])
}]}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar overflow-hidden",
    class: {
      'hide-sidebar': !_vm.showSidebarDesktop && !_vm.showSidebarMobile, 'is-mobile': _vm.showSidebarMobile
    }
  }, [_c('div', {
    staticClass: "menu-label"
  }, [(!_vm.showSidebarDesktop && !_vm.showSidebarMobile) ? _c('span', [_vm._v("SS")]) : [(_vm.pathFoto) ? _c('div', {
    staticClass: "flex fdc aic"
  }, [_c('div', {
    staticClass: "avatar mb-10"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathFoto
    }
  })]), _c('span', {
    staticClass: "fs-14"
  }, [_vm._v("Self Service")])]) : _c('span', [_vm._v("Self Service")])]], 2), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isLoadingMenu) ? _c('ul', {
    staticClass: "menu-list overflow-y-scroll"
  }, [_c('transition-group', {
    staticClass: "contenedor-sidebar",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: 'menu_item_' + index,
      attrs: {
        "title": item.name
      }
    }, [(item.path) ? [_c('router-link', {
      staticClass: "has-text-left router-link ai-center",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'router-item' : '',
      attrs: {
        "to": item.path
      }
    }, [_c('span', {
      staticClass: "icon is-small",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'margin-right-0' : ''
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    })]), (_vm.showSidebarDesktop || _vm.showSidebarMobile) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), (item.key === 'vacaciones') ? [(_vm.datos.diasVacaciones) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.datos.diasVacaciones + ' dias por tomar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.datos.diasVacaciones))])]) : _vm._e()] : _vm._e(), (item.key === 'mis-documentos-firmar') ? [(_vm.documentosPorFirmar) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.documentosPorFirmar + ' documentos sin firmar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.documentosPorFirmar))])]) : _vm._e()] : _vm._e(), (item.key === 'mis-contratos') ? [(_vm.contratosPorFirmar) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.contratosPorFirmar + ' contratos sin firmar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.contratosPorFirmar))])]) : _vm._e()] : _vm._e(), (item.key === 'mis-cursos') ? [(_vm.cursosSinTerminar) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.cursosSinTerminar + ' cursos sin terminar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.cursosSinTerminar))])]) : _vm._e()] : _vm._e()], 2), (!_vm.showSidebarDesktop) ? _c('hr', {
      staticClass: "margin-0"
    }) : _vm._e()] : [_c('a', {
      staticClass: "has-text-left ai-center position-relative",
      class: {
        open: item.showChildren, 'router-item': !_vm.showSidebarDesktop && !_vm.showSidebarMobile
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          item.showChildren = !item.showChildren
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'margin-left-20' : ''
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    })]), (_vm.showSidebarDesktop) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _c('span', {
      staticClass: "icon is-small is-angle left-85",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'margin-right--4' : ''
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-smooth"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showChildren),
        expression: "item.showChildren"
      }],
      staticClass: "children"
    }, [_c('ul', {
      staticClass: "menu-list",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'menu-list-hide' : ''
    }, _vm._l((item.children), function(itemChildren, indexChildren) {
      return _c('li', [_c('router-link', {
        key: itemChildren.key,
        staticClass: "has-text-left router-link",
        class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'router-item' : '',
        attrs: {
          "to": itemChildren.path
        }
      }, [(!_vm.showSidebarDesktop && !_vm.showSidebarMobile) ? _c('span', {
        staticClass: "icon is-small",
        attrs: {
          "title": itemChildren.name
        }
      }, [_c('i', {
        staticClass: "fa",
        class: itemChildren.icon
      })]) : _vm._e(), (_vm.showSidebarDesktop) ? _c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(itemChildren.name))]) : _vm._e(), (itemChildren.key === 'vacaciones') ? [(_vm.datos.diasVacaciones) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.datos.diasVacaciones + ' dias para gozar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.datos.diasVacaciones))])]) : _vm._e()] : _vm._e(), (itemChildren.key === 'mis-documentos-firmar') ? [(_vm.documentosPorFirmar) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.documentosPorFirmar + ' documentos sin cargar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.documentosPorFirmar))])]) : _vm._e()] : _vm._e(), (itemChildren.key === 'mis-contratos') ? [(_vm.contratosPorFirmar) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.contratosPorFirmar + ' contratos sin cargar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.contratosPorFirmar))])]) : _vm._e()] : _vm._e(), (itemChildren.key === 'mis-cursos') ? [(_vm.cursosSinTerminar) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.cursosSinTerminar + ' cursos sin terminar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.cursosSinTerminar))])]) : _vm._e()] : _vm._e()], 2)], 1)
    }), 0)])]), (!_vm.showSidebarDesktop && !_vm.showSidebarMobile) ? _c('hr', {
      staticClass: "margin-0"
    }) : _vm._e()]], 2)
  }), 0)], 1) : _c('div', {
    staticClass: "loading-short"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v("Cargando el menu")])]), ((!(_vm.estoyReemplazando || _vm.estoySiendoReemplazado) && (_vm.perfilUsuario === 'jefe' || _vm.perfilUsuario === 'recursos humanos'))) ? _c('div', {
    staticClass: "menu-label-bgcolor button-delegacion",
    on: {
      "click": _vm.abrirDelegacion
    }
  }, [_c('span', [_vm._v("Definir Reemplazo")]), _c('i', {
    staticClass: "fa fa-plane"
  })]) : _vm._e(), (_vm.isUserBirthday) ? _c('div', {
    staticClass: "menu-label-bgcolor"
  }, [_c('span', [_vm._v("¡Feliz cumpleaños! ")]), _c('i', {
    staticClass: "fa fa-birthday-cake ml-5s"
  })]) : _vm._e(), ((_vm.estoyReemplazando || _vm.estoySiendoReemplazado) && _vm.showSidebarMobile) ? _c('div', {
    staticClass: "delegaciones"
  }, [_c('delegaciones-mostrar-reemplazo', {
    attrs: {
      "isMobile": _vm.showSidebarMobile
    }
  })], 1) : _vm._e(), (_vm.showSidebarDesktop || _vm.showSidebarMobile) ? _c('div', {
    staticClass: "menu-label-name"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.datos.nombre))])])]) : _vm._e(), (_vm.showSidebarMobile) ? _c('div', {
    staticClass: "menu-label-name salir",
    on: {
      "click": _vm.logout
    }
  }, [_c('span', [_c('strong', [(_vm.isSaliendo) ? [_vm._v("Saliendo "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })] : [_vm._v("Salir")]], 2)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activateFrame) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cerrarFrame),
      expression: "cerrarFrame"
    }],
    staticClass: "contenedor-frame"
  }, [_c('div', {
    staticClass: "titulo"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v(_vm._s(_vm.tituloFrame))]), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.cerrarFrame
    }
  }, [_c('span', [_vm._v("Cerrar")])])]), _c('iframe', {
    attrs: {
      "src": _vm.path
    }
  }, [_vm._v("Oops! an error has occurred.")])]) : _vm._e()]), (_vm.mostrarModalEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": _vm.closeModalEliminar,
      "do": _vm.eliminarBoleta
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar la boleta con periodo " + _vm._s(_vm.boletaEliminar.periodo) + ", mes " + _vm._s(_vm.boletaEliminar.mes) + ", tipo " + _vm._s(_vm.boletaEliminar.tipo) + ", codigo " + _vm._s(_vm.boletaEliminar.codigo) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Año")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroPeriodo),
      expression: "filtroPeriodo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroPeriodo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.periodos), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Mes")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroMes),
      expression: "filtroMes"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroMes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.meses), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Tipo")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroTipo),
      expression: "filtroTipo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroTipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.tipos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Visto?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroVisto),
      expression: "filtroVisto"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroVisto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("No vistas")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Vistas")])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button is-primary margin-button-top",
    on: {
      "click": _vm.openModalNotificacionMasiva
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Notificar a todos los filtrados")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Periodo")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Mes")]), _c('th', [_vm._v("Tipo")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Visto")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Periodo: ")]), _c('span', [_vm._v(_vm._s(o.periodo) + " - " + _vm._s(o.nombreMes))])]), (o.visto) ? [_c('div', {
      staticClass: "show-break-1 seen"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Visto")]), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check fs-12"
    })])])] : _vm._e()], 2)]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.periodo))]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.nombreMes))]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', {
      staticClass: "text-align-center hide-break-1"
    }, [(o.visto) ? [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])] : [_c('span')]], 2), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.verPdf(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye fs-12"
    })]), _c('span', [_vm._v("Ver pdf")])]), (!o.visto) ? _c('button', {
      staticClass: "button is-small margin-left-5",
      attrs: {
        "title": "'Enviar mail al empleado para que vea su boleta'"
      },
      on: {
        "click": function($event) {
          return _vm.notificar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-envelope fs-12"
    })]), _c('span', [_vm._v("Notificar")])]) : _vm._e(), _c('button', {
      staticClass: "button is-small is-danger ml-5",
      on: {
        "click": function($event) {
          return _vm.confirmacionEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash fs-12"
    })]), _c('span', [_vm._v("Eliminar")])])])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay boletas que cumplan con los siguientes filtros")])])])])])]), (_vm.mostrarNotificacionMasiva) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarNotificacionMasiva
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalNotificacionMasiva),
      expression: "closeModalNotificacionMasiva"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Notificacion")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalNotificacionMasiva
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("¿ Esta seguro de notificar a todos los empleados filtrados?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.notificacionMasiva()
      }
    }
  }, [_c('span', [_vm._v("Notificar a todos los filtrados")])]), _c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalNotificacionMasiva
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarObservaciones) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarObservaciones
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Observaciones encontradas")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalObservaciones
    }
  })])])]), _c('div', {
    staticClass: "card-content card-content-observaciones-max-height"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, _vm._l((_vm.observaciones), function(o) {
    return (_vm.observaciones.length > 0) ? _c('div', [_c('strong', [_vm._v(_vm._s(o))])]) : _vm._e()
  }), 0)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalObservaciones
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de boletas")])])
}]}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cumpleanos"
  }, [_vm._m(0), (_vm.lista.length) ? _c('div', {
    staticClass: "contenedor-scroll"
  }, _vm._l((_vm.lista), function(o) {
    return _c('div', {
      key: o.codigo,
      staticClass: "empleado"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": o.pathFoto
      },
      on: {
        "error": _vm.imagenDefault
      }
    })]), _c('div', {
      staticClass: "datos"
    }, [_c('div', {
      staticClass: "nombre"
    }, [_c('strong', [_vm._v(_vm._s(o.nombre))])]), _c('div', {
      staticClass: "cargo"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("customDate")(o.fechaNacimiento)))])]), _c('div', {
      staticClass: "area"
    }, [_c('span', [_vm._v(_vm._s(o.nombreArea))])])])])
  }), 0) : _c('div', {
    staticClass: "sin-datos"
  }, [_c('span', [_vm._v("No hay cumpleaños hoy 🎈")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo"
  }, [_c('span', [_vm._v("🎂 Cumpleaños de hoy")])])
}]}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.perfilUsuario === 'recursos humanos') ? _c('span', [_vm._v("Solicitudes de vacaciones")]) : _c('span', [_vm._v("Solicitudes de vacaciones de mi equipo")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret",
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [(_vm.perfilUsuario === 'recursos humanos') ? _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroEstado),
      expression: "filtroEstado"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroEstado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.estados), function(value, key) {
    return _c('option', {
      domProps: {
        "value": +key
      }
    }, [_vm._v(_vm._s(value.descripcion))])
  })], 2)])]) : _vm._e(), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarEmpleado
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Mes")]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroMes),
      expression: "filtroMes"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroMes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.meses), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.codigo === 'all' ? 'Todos' : o.descripcion))])
  }), 0)])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Año")]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroYear),
      expression: "filtroYear"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.years), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o === 'all' ? 'Todos' : o))])
  }), 0)])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    key: "body-scroll",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.mostrarConfirmacionNoLoTomo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarNoLoTomo",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionNoLoTomo = false
      },
      "do": _vm.noLoTomo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea indicar que la solicitud no se tomó?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])] : [_c('span', [_vm._v("No lo tomó")])]], 2)])], 1) : _vm._e()], 1), (_vm.solicitudes.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Retorno")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Reemplazante")]), (_vm.perfilUsuario === 'recursos humanos') ? _c('th', {
    staticClass: "hide-break-2"
  }) : _vm._e()]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o) {
    return _c('tr', {
      key: o.id,
      staticClass: "row-table",
      class: {
        'is-close': !o.abierto
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), (o.desde !== o.hasta) ? [_c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])] : _vm._e()], 2), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Retorno:")]), _c('span', [_vm._v(_vm._s(o.retorno))]), _c('span', {
      staticClass: "dias"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "dias"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])]), _c('td', [_vm._v(_vm._s(o.estadoData.descripcion))]), _c('td', [(o.codigoEmpleadoReemplazante) ? [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Reemplazante: ' + o.dniReemplazante
      }
    }, [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))])] : [_c('span', [_vm._v("No definido")])], (_vm.perfilUsuario === 'recursos humanos') ? _c('div', {
      staticClass: "contenedor-acciones show-break-2"
    }, [(o.estado === 3) ? _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarNoLoTomo(o)
        }
      }
    }, [_c('span', [_vm._v("No lo tomó")])]) : _vm._e()]) : _vm._e()], 2), (_vm.perfilUsuario === 'recursos humanos') ? _c('td', {
      staticClass: "hide-break-2"
    }, [(o.estado === 3) ? _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarNoLoTomo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("No lo tomó")])]) : _vm._e()]) : _vm._e()])
  }), 0)], 1) : _vm._e(), (_vm.isLoading) ? _c('loading') : _vm._e(), (_vm.solicitudes.length === 0 && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay solicitudes de vacaciones que cumplan con los siguientes filtros")])])]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar gerencias..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    staticClass: "contenedor-data",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('div', {
      key: 'gerencia_lookup_' + index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(o.nombre)))])])
  }), 0), (!_vm.isLoading && _vm.listaFiltrada.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('loading', {
    staticClass: "center-lookup"
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gerencia")])])
}]}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes de permiso " + _vm._s(_vm.perfilVacaciones === 'jefe' ? 'de mi equipo' : ''))]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroEstado),
      expression: "filtroEstado"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroEstado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.estados), function(value, key) {
    return _c('option', {
      domProps: {
        "value": +key
      }
    }, [_vm._v(_vm._s(value.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Tipo")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroTipo),
      expression: "filtroTipo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroTipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.tipos), function(o, key) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    key: "body-scroll",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('div', {
    key: "is-desktop",
    staticClass: "is-desktop"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Adjunto")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table",
      class: {
        'is-close': !o.abierto
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2)], 2), _c('td', [_vm._v(_vm._s(o.estadoData.descripcion))]), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', [_vm._v("Sin adjunto")])]], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "is-mobile",
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: o + index + '',
      staticClass: "box"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('span', [_vm._v(_vm._s(o.estadoData.descripcion))])]), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('span', {
      staticClass: "is-bold hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.motivo))])])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e()], 2)])
  }), 0)]), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de mis vacaciones")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarMensajeDeSolicitud) ? _c('div', {
    key: "mensaje_no_dias",
    staticClass: "mensaje-informacion"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        _vm.mostrarMensajeDeSolicitud = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _c('span', [_vm._v("No puede realizar solicitudes de vacaciones porque cuentas con ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.diasDisponibles))]), _c('span', [_vm._v(" días disponibles.")]), _c('br'), _c('span', [_vm._v("Debes acumular al menos 1 día para hacerlo.")])])])]) : _vm._e(), (_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud"
  }, [_c('nueva-solicitud-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      },
      "successNew": _vm.recargarListaSolicitudes
    }
  })], 1) : _vm._e(), (_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitud",
    staticClass: "box lista-solicitud"
  }, [_c('lista-solicitud-vacaciones', {
    ref: "listasolicitudes",
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaLibrosVacaciones) ? _c('div', {
    key: "lista_libros_vacaciones",
    staticClass: "box lista-solicitud"
  }, [_c('lista-libros-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaLibrosVacaciones = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaVacaciones) ? _c('div', {
    key: "lista_vacaciones",
    staticClass: "box lista-solicitud"
  }, [_c('lista-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaVacaciones = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-label"
  }, [_vm._v("PANEL PRINCIPAL")]), _c('h1', [_vm._v("Buenos días, " + _vm._s(_vm.nombre))]), _c('p', [_vm._v("Aquí tienes el resumen de tus actividades y pendientes.")])])])
},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.gerencia && _vm.gerencia.id) ? _c('span', [_vm._v("Editar Gerencia")]) : _c('span', [_vm._v("Crear Gerencia")])]), _c('span', {
    staticClass: "icon close pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Gerencia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombre),
      expression: "nombre"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombre = $event.target.value
      }
    }
  })])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.emitClose
    }
  }), _c('div', {
    staticClass: "card margin-5em-sides"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_vm._m(0), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.emitClose
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.errores), function(error, index) {
    return _c('li', {
      key: index,
      staticClass: "tal"
    }, [_c('span', [_vm._v(_vm._s(error))])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Errores encontrados")])])
}]}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalEmpleadosConDocumentos) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("¿SEGURO QUE DESEA CONTINUAR?")])]), _c('div', {
    staticClass: "card-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.mensajeRespuesta))]), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.listaEmpleadosRespuesta), function(nombre, index) {
    return _c('li', {
      key: index,
      staticClass: "tal"
    }, [_c('span', [_vm._v(_vm._s(nombre))])])
  }), 0)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.validarModalEmpleadoConDocumentos()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Continuar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.cerrarModalEmpleadosConDocumentos()
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e()]), (_vm.mostrarConfirmacionModal) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionModal = false
      },
      "do": _vm.validarConfirmacion
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro de " + _vm._s(_vm.tipoConfirmacion.descripcion) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSaving) ? [_vm._v("Guardando...")] : [_vm._v("Guardar")]], 2)])], 1) : _vm._e(), _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("Seleccionar los documentos")]), _c('div', {
    staticClass: "contenedor-acciones"
  }, [_c('div', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('asignarTodos')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Asignar Todos")])]), _c('div', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('desasignarTodos')
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Desasignar Todos")])])])]), _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar documentos..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }, _vm.fetchSearch]
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredDocumentos), function(doc, index) {
    return _c('div', {
      key: 'doc_lookup_' + doc.codigo,
      staticClass: "usuario",
      class: {
        'selected': doc.nuevoSeleccionado || doc.seleccionado
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelection(doc)
        }
      }
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('span', {
      staticClass: "nombre"
    }, [_vm._v(" " + _vm._s(doc.descripcion))])])])
  }), 0), (!_vm.isLoading & _vm.filteredDocumentos.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron empleados activos")])]) : _vm._e()], 1)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.asignarDocumentos(false)
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "kpi_jefe",
    staticClass: "box position-relative"
  }, [_c('component-dashboard-kpi-jefe', {
    on: {
      "close": function($event) {
        return _vm.close('showKpiJefe')
      }
    }
  })], 1), (_vm.perfilVacaciones === 'recursos humanos' && _vm.showKpiRRHH) ? _c('div', {
    key: "kpi_rrhh",
    staticClass: "box position-relative"
  }, [_c('component-dashboard-kpi')], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Boletas transferidas"), (_vm.boletas.length > 0) ? _c('span', {
    staticClass: "litle"
  }, [_vm._v(" (" + _vm._s(_vm.boletas.length) + " para generar)")]) : _vm._e()])]), _c('div', {
    staticClass: "center margin-top-10"
  }, [_c('div', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isExporting
    },
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', [_vm._v("Exportar a Excel")])]), _c('div', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isGenerating
    },
    on: {
      "click": _vm.empezarAGenerar
    }
  }, [_c('span', [_vm._v("Generar")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isGenerating) ? _c('p', {
    staticClass: "margin-top-10"
  }, [_c('vue-circle', {
    ref: "progressCircle",
    attrs: {
      "progress": 0.0,
      "size": 100,
      "insert-mode": "append",
      "fill": _vm.fillCircle
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.boletasGeneradas) + " / " + _vm._s(_vm.cantidadBoletas))])])], 1) : _vm._e()]), _c('p', {
    staticClass: "margin-bottom-10"
  }), (_vm.isFetching) ? _c('spinner', {
    attrs: {
      "size": "60",
      "line-fg-color": "#3a4dc7",
      "line-size": 7
    }
  }) : _c('div', [(_vm.boletas.length === 0) ? _c('div', {
    staticClass: "article message is-info"
  }, [_c('section', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No hay boletas para transferir")])])]) : _vm._e(), _c('div', {
    staticClass: "contenedor-transferidas"
  }, _vm._l((_vm.boletas), function(o) {
    return (_vm.boletas.length > 0) ? _c('div', {
      staticClass: "box"
    }, [_c('boleta-item-transferidos', {
      attrs: {
        "boleta": o
      }
    })], 1) : _vm._e()
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de contratos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesAprobadas) ? _c('div', {
    key: "lista_solicitudes_aprobadas",
    staticClass: "box position-relative"
  }, [_c('lista-solicitudes-aprobadas', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesAprobadas = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.area && _vm.area.idArea) ? _c('span', [_vm._v("Editar Area")]) : _c('span', [_vm._v("Crear area")])]), _c('span', {
    staticClass: "icon close pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Area")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombre),
      expression: "nombre"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombre = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Gerencia")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreGerencia),
      expression: "nombreGerencia"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.nombreGerencia)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaGerencia = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreGerencia = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaGerencia = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarGerencia
    }
  }, [_vm._m(0)])]), _c('p'), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaGerencia) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('gerencia', {
    on: {
      "selected": _vm.seleccionarGerencia,
      "close": function($event) {
        _vm.mostrarBusquedaGerencia = false
      }
    }
  })], 1) : _vm._e()])], 1)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
}]}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalEmpleadosConDocumentos) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("¿SEGURO QUE DESEA CONTINUAR?")])]), _c('div', {
    staticClass: "card-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.mensajeRespuesta))]), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.listaEmpleadosRespuesta), function(nombre, index) {
    return _c('li', {
      key: index,
      staticClass: "tal"
    }, [_c('span', [_vm._v(_vm._s(nombre))])])
  }), 0)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.validarModalEmpleadoForzar()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Continuar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.cerrarModalEmpleadosForzar()
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e()]), (_vm.mostrarConfirmacionModal) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionModal = false
      },
      "do": _vm.validarConfirmacion
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro de " + _vm._s(_vm.tipoConfirmacion.descripcion) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSaving) ? [_vm._v("Guardando...")] : [_vm._v("Guardar")]], 2)])], 1) : _vm._e(), _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title", [_vm._v("Seleccione los empleados")])], 2), _c('div', {
    staticClass: "contenedor-acciones"
  }, [_c('div', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('asignarTodos')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Asignar Todos")])]), _c('div', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        return _vm.abrirModalConfirmacion('desasignarTodos')
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Desasignar Todos")])])])]), _c('div', {
    staticClass: "contenedor-interno"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaArea) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-area', {
    on: {
      "selected": _vm.seleccionarArea,
      "close": function($event) {
        _vm.mostrarBusquedaArea = false
      }
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar empleados..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }, _vm.fetchSearch]
    }
  })]), (_vm.empresa !== 'raymisa') ? _c('div', {
    staticClass: "control pt-5"
  }, [_c('div', {
    staticClass: "input-container"
  }, [(!_vm.area.idArea) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area.idArea),
      expression: "area.idArea"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "placeholder": "Buscar Area",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.area.idArea)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.area, "idArea", $event.target.value)
      }
    }
  }) : _c('div', {
    staticClass: "item fdc flex-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.area.nombreArea)))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.area.nombreGerencia))])]), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarArea
    }
  }, [_vm._m(2)])])]) : _vm._e()]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredEmpleados), function(employee, index) {
    return _c('div', {
      key: 'alumno_lookup_' + employee.codigo,
      staticClass: "usuario",
      class: {
        'selected': employee.nuevoSeleccionado || employee.seleccionado
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelection(employee)
        }
      }
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('span', {
      staticClass: "codigo"
    }, [_vm._v(_vm._s(employee.dni) + ":")]), _c('span', {
      staticClass: "nombre"
    }, [_vm._v(" " + _vm._s(employee.nombre))])])])
  }), 0), (!_vm.isLoading & _vm.filteredEmpleados.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron empleados activos")])]) : _vm._e()], 1)], 1), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.asignarEmpleados(false)
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
}]}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de mis permisos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud"
  }, [_c('nueva-solicitud-permiso', {
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      },
      "successNew": _vm.recargarListaSolicitudes
    }
  })], 1) : _vm._e(), (_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitud",
    staticClass: "box lista-solicitud"
  }, [_c('lista-solicitud-permiso', {
    ref: "listasolicitudes",
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaMisPermisos) ? _c('div', {
    key: "lista_mis_permisos",
    staticClass: "box lista-solicitud"
  }, [_c('lista-mis-permisos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaMisPermisos = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis documentos para firmar")])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('upload-image', {
    attrs: {
      "name": "adjuntar_documento_importante",
      "onlyPdf": "true",
      "folder": "documentos_firmar_empleado"
    },
    on: {
      "save": _vm.guardarDocumentoSubido,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjunte un PDF")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_c('strong', [_vm._v("Se agregará el sello de firma digital cuando se suba el archivo.")])]), _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEliminar()
      },
      "do": function($event) {
        return _vm.eliminarDocumento()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el pdf subido?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        return _vm.closeModalEliminar()
      },
      "do": function($event) {
        return _vm.eliminarDocumento()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el pdf subido?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e()]), _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Al subir el pdf se agregará el sello de firma")])]), _c('div', {
    staticClass: "text-right acciones"
  }, [_c('button', {
    staticClass: "button is-small mb-5",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading && _vm.lista.length > 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))]), (o.revisado) ? _c('div', {
      staticClass: "seen name fs-12"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Aprobado por RRHH")])]) : _vm._e()])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(!o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small is-primary",
      class: {
        'is-loading': _vm.downloading
      },
      attrs: {
        "disabled": _vm.downloading
      },
      on: {
        "click": function($event) {
          return _vm.descargarDocumento(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-download is-small fs-12"
    })]), _c('span', [_vm._v("Descargar documento")])]) : _vm._e(), (!o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small",
      attrs: {
        "disabled": !o.fechaDescarga
      },
      on: {
        "click": function($event) {
          return _vm.confirmacionSubirPdf(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    })]), _c('span', [_vm._v("Subir y firmar PDF")])]) : _vm._e(), (o.rutaSubido) ? _c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.rutaSubido,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye is-small fs-12"
    })]), _c('span', [_vm._v("Ver PDF")])]) : _vm._e(), (o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmacionEliminarPdf(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])]) : _vm._e()])])])
  }), 0)], 1) : _vm._e(), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron documentos por firmar")])]) : _vm._e()], 1)], 1)])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno position-relative"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Cumpleaños")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "input-filtros",
    staticClass: "filtros aic"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Mes")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mes),
      expression: "mes"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetch]
    }
  }, _vm._l((_vm.meses), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  }), 0)])])]), _c('div', {
    key: "boton-filtro",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])])])])]), _c('div', {
    staticClass: "information"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }],
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Cumpleaños")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Anexo")])]), _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "table-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "tbody",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: ("index_" + (index + 1)),
      staticClass: "row-table",
      class: {
        'birthday-style': o.esCumpleanios
      }
    }, [_c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.pathFoto) ? _c('div', {
      staticClass: "flex fdc aic"
    }, [_c('div', {
      staticClass: "avatar mr-10"
    }, [_c('img', {
      attrs: {
        "src": o.pathFoto
      }
    })])]) : _vm._e(), (o.esCumpleanios) ? _c('div', {
      staticClass: "margin-right-5"
    }, [_c('i', {
      staticClass: "fa fa-birthday-cake fs-17"
    })]) : _vm._e(), _c('span', [_vm._v(_vm._s(o.nombre))])])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("customDate")(o.fechaNacimiento)))]), _c('br'), (o.anexo) ? _c('span', {
      staticClass: "show-break-1"
    }, [_vm._v("Anexo: " + _vm._s(o.anexo))]) : _vm._e()]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.anexo))])])
  }), 0)], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-equipo contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mi equipo")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isShowingJefeDirecto) ? _c('div', {
    staticClass: "message is-info"
  }, [_vm._m(0)]) : _vm._e(), (_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha Ingreso")]), (_vm.isShowingJefeDirecto) ? _c('th', [_vm._v("Jefe directo")]) : _vm._e(), _c('th', [_vm._v("Fecha de fin de contrato")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('tr', {
      key: index + '-desktop',
      staticClass: "row-table",
      class: {
        directo: o.directo, 'row-info': o.esDeDelegacion
      }
    }, [_c('td', [_c('span', {
      staticClass: "name hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")])]), _c('td', [_c('div', {
      staticClass: "wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaIngreso))]), (!o.contratoIndeterminado) ? [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]] : _vm._e()], 2)]), (_vm.isShowingJefeDirecto) ? _c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e(), _c('td', {
      staticClass: "contrato"
    }, [(o.contratoIndeterminado === 1) ? _c('div', [_c('span', [_vm._v("Contrato indeterminado")])]) : _vm._e(), (o.contratoIndeterminado === -1) ? _c('div', [_c('span', [_vm._v("Se indico que no se debe renovar")])]) : _vm._e(), (o.contratoIndeterminado === 0) ? _c('div', [(o.fechaFinContrato) ? _c('div', [_c('span', [_vm._v(_vm._s(o.fechaFinContrato))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v("Faltan "), _c('strong', [_vm._v(_vm._s(o.diasVencimientoContrato) + " ")]), _vm._v("días para el vencimiento del contrato")]), ((o.directo || o.codigoJefe === +_vm.codigoLogueadoJefe) && o.diasVencimientoContrato <= 15 && _vm.mostrarRenovacion) ? _c('pedir-una-renovacion', {
      attrs: {
        "codigo": o.codigo,
        "nombre": o.nombre,
        "idSolicitud": o.idSolicitudRenovacion,
        "descripcionEstado": o.solicitudEstadoDescripcion
      },
      on: {
        "closeRefresh": _vm.refreshRenovar
      }
    }) : _vm._e()], 1) : _c('span', [_vm._v("No se ha enviado la información desde planillas")])]) : _vm._e()])])
  }), 0)], 1)]) : _vm._e(), (!_vm.isLoading) ? _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left bg-white"
    }, [_c('div', {
      staticClass: "mt-10 hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), (!o.contratoIndeterminado) ? _c('div', [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]], 2) : _vm._e(), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fin de Contrato: ")]), (o.contratoIndeterminado === 1) ? _c('span', [_vm._v("Contrato indeterminado")]) : _vm._e(), (o.contratoIndeterminado === -1) ? _c('span', [_vm._v("Se indico que no se debe renovar")]) : _vm._e(), (o.contratoIndeterminado === 0) ? [(o.fechaFinContrato) ? [_c('span', [_vm._v(_vm._s(o.fechaFinContrato))]), _c('br'), _c('span', {
      staticClass: "text-small"
    }, [_vm._v("Faltan "), _c('strong', [_vm._v(_vm._s(o.diasVencimientoContrato) + " ")]), _vm._v("días para el vencimiento del contrato")])] : _c('span', [_vm._v("No se ha enviado la información desde planillas")])] : _vm._e()], 2), (_vm.codigoLogueadoJefe !== (o.codigoJefe + '')) ? _c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e(), (o.contratoIndeterminado === 0) ? _c('div', [(o.fechaFinContrato) ? [(o.directo && o.diasVencimientoContrato <= 15 && _vm.mostrarRenovacion) ? _c('pedir-una-renovacion', {
      attrs: {
        "codigo": o.codigo,
        "nombre": o.nombre,
        "idSolicitud": o.idSolicitudRenovacion,
        "descripcionEstado": o.solicitudEstadoDescripcion
      },
      on: {
        "closeRefresh": _vm.refreshRenovar
      }
    }) : _vm._e()] : _vm._e()], 2) : _vm._e()])
  }), 0) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v("*")]), _c('span', [_vm._v("Los empleados con texto resaltado son empleados directos, es decir, es tu responsabilidad solicitar la renovación")]), _c('span', [_vm._v("del contrato de ellos.")])])
}]}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-component'), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _c('notifications')], 1)
},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Mis Boletas")]), _c('p'), _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Selecciona un año")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterPeriodo),
      expression: "filterPeriodo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterPeriodo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.periodos), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }), 0)])])])]), (!_vm.isLoading) ? _c('div', {
    staticClass: "center"
  }, [(_vm.boletas.length === 0) ? _c('div', {
    staticClass: "article message is-info margin-top-10"
  }, [_vm._m(0)]) : _vm._e(), _vm._l((_vm.boletas), function(o) {
    return (_vm.boletas.length > 0) ? _c('div', {
      staticClass: "box"
    }, [_c('boleta-item-lista', {
      attrs: {
        "boleta": o
      },
      on: {
        "ver": _vm.verPdf,
        "refresh": _vm.fetch
      }
    })], 1) : _vm._e()
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activateFrame) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cerrarFrame),
      expression: "cerrarFrame"
    }],
    staticClass: "contenedor-frame"
  }, [_c('div', {
    staticClass: "titulo"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v(_vm._s(_vm.tituloFrame))]), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.cerrarFrame
    }
  }, [_c('span', [_vm._v("Cerrar")])])]), _c('iframe', {
    attrs: {
      "src": _vm.path
    }
  }, [_vm._v("Oops! an error has occurred.")])]) : _vm._e()])], 2) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "center"
  }, [_c('loading')], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No tiene boletas generadas")])])
}]}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar link importante")]) : _c('span', [_vm._v("Crear link importante")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Orden")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orden),
      expression: "orden"
    }],
    staticClass: "input w-90",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.orden)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orden = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoading
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripcion")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Ruta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruta),
      expression: "ruta"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.ruta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ruta = $event.target.value
      }
    }
  })])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis contratos")])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [(_vm.mostrarConfirmacionFirmar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('confirmar-accion-overlay', {
    ref: "firmarContrato",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionFirmar = false
      },
      "do": function($event) {
        return _vm.generarToken()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea firmar su contrato?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("cargando...")] : [_vm._v("Firmar")]], 2)])], 1) : _vm._e(), (_vm.mostrarModalConfirmacionToken) ? _c('div', {
    key: "modal-posicion-token",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Le ha llegado el token de validacion a su correo: ")]), _c('strong', [_vm._v(_vm._s(_vm.correoServer))])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("Dispone de " + _vm._s(_vm.cuentaRegresiva) + " para utilizar el token enviado.")]), _c('div', {
    staticClass: "contenedor-datos fdc"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Token"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenCliente),
      expression: "tokenCliente"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tokenCliente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenCliente = $event.target.value
      }
    }
  })])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardarGenerarToken
    }
  }, [_c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.cerrarModalConfirmacionToken
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])]) : _vm._e(), _c('div', [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading && _vm.lista.length > 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Duración")]), _c('th', [_vm._v("Creación")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Contrato: ' + o.id
      }
    }, [(!o.indeterminado) ? _c('span', [_vm._v(_vm._s(o.fechaInicio) + " - " + _vm._s(o.fechaFin))]) : _c('span', [_vm._v("Indeterminado")])])]), _c('td', [_vm._v(_vm._s(o.creado))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones fdc"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.verContrato(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]), (!o.firmado) ? [(!o.primera_visualizacion) ? _c('div', {
      staticClass: "hint--top d-flex",
      attrs: {
        "aria-label": "Debe visualizar su contrato antes de firmarlo"
      }
    }, [_c('button', {
      staticClass: "button is-small",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _c('span', [_vm._v("Firmar")])])]) : _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmacionFirmar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _c('span', [_vm._v("Firmar")])])] : _c('div', {
      staticClass: "firmado fs-12"
    }, [_c('span', [_vm._v("Firmado: ")]), _c('span', [_vm._v(_vm._s(o.fechaFirma))])])], 2)])])
  }), 0)], 1) : _vm._e(), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron contratos")])]) : _vm._e()], 1)])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card"
  }, [_vm._m(0), _c('div', {
    ref: "birthdayScroll",
    staticClass: "birthday-scroll",
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [(_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "initial-loading"
  }, [_c('div', {
    staticClass: "loader"
  }), _c('span', [_vm._v("Cargando cumpleaños...")])]) : (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._m(1), _vm._m(2)]) : [_vm._l((_vm.lista), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "birthday"
    }, [_c('div', {
      staticClass: "birthday-avatar"
    }, [_c('img', {
      attrs: {
        "src": o.pathFoto
      },
      on: {
        "error": _vm.imagenDefault
      }
    })]), _c('div', {
      staticClass: "birthday-info"
    }, [_c('strong', [_vm._v(_vm._s(o.nombre))]), _c('span', [_vm._v(_vm._s(o.nombreArea))])])])
  }), (_vm.isScroll) ? _c('div', {
    staticClass: "scroll-loading"
  }, [_c('div', {
    staticClass: "loader loader-small"
  }), _c('span', [_vm._v("Cargando más cumpleaños...")])]) : _vm._e(), (_vm.noMore && _vm.lista.length > 0) ? _c('div', {
    staticClass: "scroll-end"
  }, [_c('span', [_vm._v("No hay más cumpleaños")])]) : _vm._e()]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("🎂 Cumpleaños de hoy")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-circle"
  }, [_c('span', [_vm._v("🎂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-info"
  }, [_c('strong', [_vm._v("Sin cumpleaños hoy")]), _c('p', [_vm._v("No existen colaboradores cumpliendo años.")])])
}]}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padre"
  }, [_vm._m(0), (_vm.closeComponentUsuario) ? _c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v("No tiene pendientes")])]) : _vm._e(), _c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "usuario display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showCantidadMisDocumentosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('mis-documentos-firmar')
      }
    }
  }, [_c('cantidad-mis-documentos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadMisDocumentosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadMisContratosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('mis-contratos')
      }
    }
  }, [_c('cantidad-mis-contratos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadMisContratosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadMisBoletasSinVisualizar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('boletas')
      }
    }
  }, [_c('cantidad-mis-boletas-sin-visualizar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadMisBoletasSinVisualizar')
      }
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "display-flex space-evenly flex-wrap"
  }, [_c('kpi-cumpleanos'), _c('kpi-cursos')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis pendientes")])])
}]}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.sala && _vm.sala.id) ? _c('span', [_vm._v("Editar sala")]) : _c('span', [_vm._v("Crear sala")])]), _c('span', {
    staticClass: "icon close pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Sala")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar"
  }, [(_vm.estoySiendoReemplazado || _vm.estoyReemplazando) ? _c('div', {
    staticClass: "delegaciones-mostrar"
  }, [_c('delegaciones-mostrar-reemplazo')], 1) : _vm._e(), _c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": _vm.empresa_full
    }
  })])]), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Salir")])])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showLogOutModal) ? _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Cerrando sesión  "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conjunto-datos"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "body"
  }, [(_vm.model) ? _c('strong', [_vm._v(_vm._s(_vm.formattedValue))]) : _c('strong', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.dangerMessage))])])])
},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isDialogActivarDesactivar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeDialogActivaDesactiva()
      }
    }
  }), _c('div', {
    staticClass: "card width-350"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.formDesactiva.estadoDescripcion) + " noticia")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [
    [_c('span', {
      staticClass: "bold"
    }, [_vm._v("¿Realmente deseas " + _vm._s(_vm.formDesactiva.estadoDescripcion) + " la noticia")]), _c('strong', {
      staticClass: "bold has-text-primary"
    }, [_vm._v("   " + _vm._s(_vm.formDesactiva.titulo) + "   ")]), _c('span', [_vm._v("?")])]
  ], 2)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogActivaDesactiva()
      }
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "button card-footer-item info-box-button",
    class: {
      'is-success': _vm.formDesactiva.estadoDescripcion === 'Activar', 'is-danger': _vm.formDesactiva.estadoDescripcion === 'Desactivar', 'is-loading': _vm.isloading
    },
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivarDesactivar()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formDesactiva.estadoDescripcion))])])])])]) : _vm._e(), (_vm.showModalAdd) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalAdd
    }
  }), _c('div', {
    staticClass: "card w-750"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.formulario.id ? 'Editar' : 'Nueva') + " Noticia")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Título")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formulario.titulo),
      expression: "formulario.titulo"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Ingrese el título de la noticia",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.formulario.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formulario, "titulo", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "d-flex form-row margin-bottom-20"
  }, [_c('div', {
    staticClass: "flex-1 margin-right-15"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Descripción")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formulario.descripcion),
      expression: "formulario.descripcion"
    }],
    staticClass: "textarea is-small",
    attrs: {
      "rows": "5",
      "placeholder": "Ingrese la descripción de la noticia",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.formulario.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formulario, "descripcion", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "fecha-vencimiento"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Fecha Vencimiento")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formulario.fechaVencimiento),
      expression: "formulario.fechaVencimiento"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "date",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.formulario.fechaVencimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formulario, "fechaVencimiento", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Imagen de la noticia")]), _c('input', {
    ref: "inputFoto",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/jpg,image/webp"
    },
    on: {
      "change": _vm.seleccionarFoto
    }
  }), (!_vm.previewFoto) ? _c('div', {
    staticClass: "upload-image",
    on: {
      "click": _vm.abrirSelectorFoto
    }
  }, [_vm._m(0), _vm._m(1), _c('span', {
    staticClass: "upload-formats"
  }, [_vm._v("JPG, PNG o WEBP")])]) : _c('div', {
    staticClass: "image-preview-container"
  }, [_c('img', {
    staticClass: "image-preview",
    attrs: {
      "src": _vm.previewFoto,
      "alt": "Vista previa de la noticia"
    }
  }), _c('div', {
    staticClass: "image-preview-overlay"
  }, [_c('div', {
    staticClass: "preview-actions"
  }, [_c('button', {
    staticClass: "button is-small is-info",
    attrs: {
      "type": "button",
      "disabled": _vm.isloading
    },
    on: {
      "click": _vm.abrirSelectorFoto
    }
  }, [_vm._m(2), _c('span', [_vm._v("Cambiar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isloading
    },
    on: {
      "click": _vm.eliminarFoto
    }
  }, [_vm._m(3), _c('span', [_vm._v("Eliminar")])])])])])]), _c('div', {
    staticClass: "d-flex justify-content-flex-end margin-top-20px"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-small is-light",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }, [_c('span', [_vm._v("Cancelar")])])]), _c('p', {
    staticClass: "control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-success",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardar()
      }
    }
  }, [_vm._m(4), _c('span', [_vm._v("Guardar cambios")])])])])])])])]) : _vm._e(), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex d-flex jc-center fd-column"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Titulo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "change": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "flex d-flex jc-center fd-column margin-left-10"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Estado")]), _c('div', {
    staticClass: "d-flex width-100"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "select is-small d-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estado),
      expression: "estado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetch]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Activo")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Inactivo")])])])])])]), _c('div', {
    staticClass: "flex-1 d-flex justify-content-flex-end"
  }, [_c('p', {
    staticClass: "control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-success",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.openModalAdd()
      }
    }
  }, [_vm._m(5), _c('span', [_vm._v("Nuevo")])])]), _c('p', {
    staticClass: "control control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_vm._m(6), _c('span', [_vm._v("Actualizar")])])])])])])]), _c('div', {
    staticClass: "card margin-top-5"
  }, [_c('div', {
    staticClass: "position-relative",
    attrs: {
      "id": "data-table"
    }
  }, [(_vm.lista.length === 0 && !_vm.isloading) ? _c('div', {
    staticClass: "empty-list"
  }, [_c('i', {
    staticClass: "fa fa-address-card fa-6x"
  }), _vm._m(7)]) : _vm._e(), (_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table table is-full-width is-responsive"
  }, [_vm._m(8), _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "table-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "tbody",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('tr', {
      key: ("index_" + (index + 1)),
      class: {
        'bd-desactivado': !item.estado
      }
    }, [_c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(_vm._s(item.titulo))])]), _c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(_vm._s(item.descripcion))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [_c('strong', {
      staticClass: "has-text-info"
    }, [_vm._v(_vm._s(_vm._f("formatoFechaText")(item.fechaVencimiento)))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [_c('strong', {
      staticClass: "has-text-info"
    }, [_vm._v(_vm._s(item.modulo))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [_c('strong', {
      staticClass: "chip tag",
      class: {
        'is-success': item.estado, 'is-danger': !item.estado
      }
    }, [_vm._v(_vm._s(item.estado ? 'Activo' : 'Inactivo'))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [(item.modulo !== 'documentos_importantes') ? _c('button', {
      staticClass: "button is-small margin-left-5",
      attrs: {
        "disabled": _vm.isloading || !item.estado
      },
      on: {
        "click": function($event) {
          return _vm.editarForm(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _vm._e(), (item.estado) ? _c('button', {
      staticClass: "button is-small is-danger margin-left-5",
      attrs: {
        "disabled": _vm.isloading
      },
      on: {
        "click": function($event) {
          return _vm.openDialogActivaDesactiva(item)
        }
      }
    }, [_c('span', [_vm._v("Desactivar")])]) : _c('button', {
      staticClass: "button is-small is-success margin-left-5",
      attrs: {
        "disabled": _vm.isloading
      },
      on: {
        "click": function($event) {
          return _vm.openDialogActivaDesactiva(item)
        }
      }
    }, [_c('span', [_vm._v("  Activar   ")])])])])
  }), 0)], 1) : _vm._e(), (_vm.isloading) ? _c('loading-global-sil', {
    attrs: {
      "message": 'Cargando'
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-image-icon"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-image-text"
  }, [_c('strong', [_vm._v("Seleccionar imagen")]), _c('span', [_vm._v("Haz clic para adjuntar una fotografía")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encuentran registros para esta búsqueda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("#")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Titulo")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Descripcion")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Fecha Vencimiento")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Modulo")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Estado")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Accion")])])])
}]}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "half-width margin-auto"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Cambiar contraseña")]), _vm._m(0), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Nueva contraseña"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.restablecer($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._m(1)])]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatNewPassword),
      expression: "repeatNewPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Repita la nueva contraseña"
    },
    domProps: {
      "value": (_vm.repeatNewPassword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.restablecer($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatNewPassword = $event.target.value
      }
    }
  }), _vm._m(2)])]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.restablecer
    }
  }, [_vm._v("Restablecer contraseña")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorMessage) ? _c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Ingresa tu nueva contraseña")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes de permiso por aprobar Recursos Humanos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2), _c('strong', [_vm._v("Al aprobar, se crearan los permisos y no se podrán hacer cambios.")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazarMasiva = false
      },
      "do": _vm.rechazarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionAprobarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobarMasiva = false
      },
      "do": _vm.aprobarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_vm._m(0), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_vm._m(1), _c('span', [_vm._v("Rechazar")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.isLoading) ? _c('loading', {
    key: "loading"
  }) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading && _vm.mostrarMensajeDeNoSolicitudes) ? _c('div', {
    key: "mensaje_no_solicitudes",
    staticClass: "mensaje-informacion"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No hay solicitudes para aprobar")])])])]) : _vm._e(), _c('div', {
    key: "table-solicitud-por-aprobar",
    staticClass: "is-desktop"
  }, [(_vm.lista.length > 0) ? _c('table', {
    key: "table-solicitud-por-aprobar",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead'), _c('thead', [_c('th', [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "solicitud"
    },
    domProps: {
      "checked": _vm.seleccionadosTodos
    },
    on: {
      "change": function($event) {
        return _vm.check('all')
      }
    }
  })]), _c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index + o.id + '',
      staticClass: "row-table"
    }, [_c('td', {
      staticClass: "ta-center"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2)], 2), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', [_vm._v("Sin adjunto")])], (!_vm.isSeleccionMasiva) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "mobile-solicitud-por-aprobar",
    staticClass: "is-mobile"
  }, [_vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_c('span', {
      staticClass: "is-bold hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.motivo))])])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e(), (!_vm.isSeleccionMasiva) ? [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : _vm._e()], 2)])
  }), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10 mt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando..."), _c('span', {
    staticClass: "icon is-small ml-5"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "columns is-multiline display-flex"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estado),
      expression: "filtros.estado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Terminado")]), _c('option', {
    domProps: {
      "value": '2'
    }
  }, [_vm._v("Anulado")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Pendiente")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro display-flex"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Creadas por mi")])]), _c('div', {
    staticClass: "display-flex mt-5 mb-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.creadoPorMi),
      expression: "filtros.creadoPorMi"
    }],
    staticClass: "checkbox flex-1",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.creadoPorMi) ? _vm._i(_vm.filtros.creadoPorMi, null) > -1 : (_vm.filtros.creadoPorMi)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.filtros.creadoPorMi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "creadoPorMi", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "creadoPorMi", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "creadoPorMi", $$c)
        }
      }, _vm.changeFiltro]
    }
  })])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "is-desktop",
    staticClass: "is-desktop"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Título")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Asistentes")]), _c('th', [_vm._v("Fecha")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: 'desktop-table-row-' + index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top inline",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo) + " ")])]), _c('td', [_c('span', [_vm._v(_vm._s(o.tipo === 'capacitacion' ? 'Capacitación' : 'Reunión') + " " + _vm._s(o.modalidad))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.numeroAsistentes))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + " - " + _vm._s(o.horaHasta))])]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones display-flex aic"
    }, [(o.codigoCreador === _vm.codigo) ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), (o.estado !== 1) ? _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _c('span', [_vm._v("Eliminar")])]) : _vm._e()] : _vm._e(), _c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.verDetalle(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Ver")])])], 2)])])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "is-mobile",
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: 'mobile-table-row-' + index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('span', [_vm._v("ASISTENTES: " + _vm._s(o.numeroAsistentes))])]), _c('div', {
      staticClass: "perfil"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.tipo === 'capacitacion' ? 'Capacitación' : 'Reunión') + " " + _vm._s(o.modalidad))])]), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }), _c('div', {
      staticClass: "motivo hint--bottom",
      attrs: {
        "aria-label": 'Log: ' + o.id
      }
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.titulo))]), _c('div', {
      staticClass: "has-text-lef datos-auditoria"
    }), _c('div', {
      staticClass: "fecha"
    }, [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + " " + _vm._s(o.horaHasta ? ("- " + (o.horaHasta)) : ''))])]), _c('div', {
      staticClass: "botones"
    }, [(o.codigoCreador === _vm.codigo) ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), (o.estado !== 1) ? _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _c('span', [_vm._v("Eliminar")])]) : _vm._e()] : _vm._e(), _c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.verDetalle(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Ver")])])], 2)])
  }), 0)])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe reuniones")])])]) : _vm._e()])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis reuniones")])])
}]}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes por aprobar")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.modalEditar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalEditar
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Solicitud de " + _vm._s(_vm.solicitud.nombreEmpleado))])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "fechas"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitud.desde),
      expression: "solicitud.desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.solicitud.desde)
    },
    on: {
      "blur": _vm.calcRetorno,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitud, "desde", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitud.hasta),
      expression: "solicitud.hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.solicitud.hasta)
    },
    on: {
      "blur": _vm.calcRetorno,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitud, "hasta", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Retorno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitud.retorno),
      expression: "solicitud.retorno"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.solicitud.retorno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitud, "retorno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control mt-5 email text-align-center"
  }, [_c('label', [_vm._v("Cuenta con  "), _c('strong', [_vm._v(_vm._s(_vm.diasDisponiblesCambiosSolicitud))]), _vm._v("  días disponibles")])])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardarEditarFechas
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.closeModalEditar
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isApproving) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isApproving) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return _c('tr', {
      key: index + '-tabla',
      staticClass: "row-table",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), (o.hasta !== o.desde) ? [_c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])] : _vm._e()], 2), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Retorno:")]), _c('span', [_vm._v(_vm._s(o.retorno))]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])]), _c('td', [(!o.esSolicitudPasada) ? [(o.codigoEmpleadoReemplazante) ? [_c('span', [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))]), _c('div', {
      staticClass: "icon quitar"
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          o.codigoEmpleadoReemplazante = null
        }
      }
    })])] : _c('div', {
      staticClass: "pop-over-container"
    }, [(_vm.isLoadingReemplazante && index === _vm.trIndex) ? _c('loading') : _c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleadoReemplazante),
        expression: "o.codigoEmpleadoReemplazante"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleadoReemplazante)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleadoReemplazante", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleadoReemplazante
      },
      on: {
        "selected": function($event) {
          return _vm.seleccionarEmpleadoParaReemplazo(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)] : _vm._e(), (o.estado === 2 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones show-break-2"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_vm._m(1, true), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_vm._m(2, true), _c('span', [_vm._v("Rechazar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirModalEditar(o)
        }
      }
    }, [_vm._m(3, true), _c('span', [_vm._v("Editar fechas")])])]) : _vm._e(), (o.esSolicitudPasada) ? _c('span', {
      staticClass: "has-text-danger show-break-2"
    }, [_vm._v("Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe")]) : _vm._e()], 2), _c('td', {
      staticClass: "hide-break-2"
    }, [(o.estado === 2 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_vm._m(4, true), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_vm._m(5, true), _c('span', [_vm._v("Rechazar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.abrirModalEditar(o)
        }
      }
    }, [_vm._m(6, true), _c('span', [_vm._v("Editar fechas")])])]) : _vm._e(), (o.esSolicitudPasada) ? _c('span', {
      staticClass: "has-text-danger"
    }, [_vm._v("Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe")]) : _vm._e()])])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Retorno")]), _c('th', [_vm._v("Reemplazante")]), _c('th', {
    staticClass: "hide-break-2"
  }, [_vm._v("Acciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])
}]}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Mis datos de seguridad y notificación")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.isLoading) ? _c('loading') : [_c('section', {
    staticClass: "body flex",
    class: {
      'flex-direction-column': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "flex flex-direction-column flex-1"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Ingresa tu nueva contraseña")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Ingresa nuevamente la contraseña")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatNewPassword),
      expression: "repeatNewPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatNewPassword = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Email de notificaciones")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Ingrese su contraseña actual")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('section', {
    staticClass: "contenedor-guardar"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": _vm.guardar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save fa-fw fa-lg"
  })]), _c('span', [_vm._v("Guardar")])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Documentos importantes")]), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', [_vm._m(0)]) : (_vm.isLoading) ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "documentos-importantes"
  }, [_c('div', {
    staticClass: "p-10 pt-20"
  }, [_c('ol', _vm._l((_vm.lista), function(o, index) {
    return _c('li', {
      staticClass: "cursor-pointer text-left transition-quick",
      class: {
        selected: o.id === _vm.idSeleccionado
      },
      on: {
        "click": function($event) {
          return _vm.seleccionar(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  }), 0)]), _c('div', {
    staticClass: "flex-1 p-10 height-calculado"
  }, [(!_vm.rutaSeleccionada) ? _c('div', {
    staticClass: "article message is-info margin-top-10 w-fit margin-auto"
  }, [_vm._m(1)]) : _vm._e(), _c('iframe', {
    staticClass: "full-width height-100",
    attrs: {
      "src": _vm.rutaSeleccionada
    }
  }, [_vm._v("Oops! an error has occurred.")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay documentos importantes ingresados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No ha seleccionado ningún documento")])])
}]}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), (_vm.mostrarModalEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": _vm.closeModalEliminar,
      "do": _vm.eliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el contrato?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), (_vm.mostrarModalNotificar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarNotificar",
    on: {
      "close": _vm.closeModalNotificar,
      "do": _vm.notificar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea notificar a todos los empleados que no hayan firmado?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Notificando...")]) : _c('span', [_vm._v("Notificar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [(_vm.perfil === 'recursos humanos') ? _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigoEmpleado),
      expression: "filtros.codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtros.codigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigoEmpleado", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtros.codigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtros.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Fecha finalización desde")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desde),
      expression: "filtros.desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desde)
    },
    on: {
      "blur": _vm.changeFecha,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desde", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Fecha finalización hasta")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hasta),
      expression: "filtros.hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hasta)
    },
    on: {
      "blur": _vm.changeFecha,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hasta", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Firmado?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.firmado),
      expression: "filtros.firmado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "firmado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Si")]), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("No")])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Indeterminado?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.indeterminado),
      expression: "filtros.indeterminado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "indeterminado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeIndeterminado]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Si")]), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("No")])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button is-primary margin-button-top",
    on: {
      "click": _vm.openModalNotificacionMasiva
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Notificar a todos los filtrados")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Duracion")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Firmado")]), (_vm.perfil === 'recursos humanos') ? _c('th') : _vm._e()]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper hint--bottom",
      attrs: {
        "aria-label": 'Contrato: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Duracion: ")]), _c('span', [_vm._v(_vm._s(o.indeterminado ? 'Indeterminado' : o.fechaInicio + ' - ' + o.fechaFin))])]), (o.pathFirmado) ? [_c('div', {
      staticClass: "show-break-1 seen"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Firmado")]), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check fs-12"
    })])]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Fecha de firma: ")]), _c('span', [_vm._v(_vm._s(o.fechaFirma))])])] : _vm._e()], 2)]), _c('td', {
      staticClass: "hide-break-1"
    }, [(o.indeterminado) ? _c('span', [_vm._v("Indeterminado")]) : _vm._e(), (!o.indeterminado) ? _c('div', {
      staticClass: "wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicio) + " - " + _vm._s(o.fechaFin))])]) : _vm._e(), (o.fechaFirma) ? _c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Fecha de firma: ")]), _c('span', [_vm._v(_vm._s(o.fechaFirma))])]) : _vm._e()]), _c('td', {
      staticClass: "text-align-center hide-break-1"
    }, [(o.pathFirmado) ? [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])] : [_c('span')]], 2), (_vm.perfil === 'recursos humanos') ? _c('td', {
      staticClass: "text-center flex fdc"
    }, [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.pathContrato,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]), _c('button', {
      staticClass: "button is-small is-danger mt-5",
      on: {
        "click": function($event) {
          return _vm.confirmacionEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash fs-12"
    })]), _c('span', [_vm._v("Eliminar")])])]) : _vm._e()])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay contratos que cumplan con los siguientes filtros")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de contratos")])])
}]}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis vacaciones tomadas")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.vacaciones), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper hint--top",
      attrs: {
        "aria-label": 'Vacaciones: ' + o.id
      }
    }, [_c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), _c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])]), _c('td', [_vm._v(_vm._s(o.idSolicitud))])])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Fecha")]), _c('th', [_vm._v("Retorno")]), _c('th', [_vm._v("De la solicitud")])])
}]}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-section"
  }, [_vm._m(0), _c('div', {
    staticClass: "cards-grid"
  }, _vm._l((_vm.lista), function(item) {
    return _c('StatCard', {
      key: item.id,
      attrs: {
        "titulo": item.titulo,
        "cantidad": item.cantidad,
        "tipo": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.redirigir(item.ruta)
        }
      }
    })
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Mis pendientes")]), _c('p', [_vm._v("Actividades personales que todavía tienes por completar.")])])])
}]}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isDialogDesactivarFeriado) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeDialogDesactivarFeriado()
      }
    }
  }), _c('div', {
    staticClass: "card width-350"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [
    [_c('span', {
      staticClass: "bold"
    }, [_vm._v("¿Realmente deseas desactivar el dia festivo")]), _c('strong', {
      staticClass: "bold has-text-primary"
    }, [_vm._v("   " + _vm._s(_vm.nuevoFeriado.nombre) + "   ")]), _c('span', [_vm._v("?")])]
  ], 2)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogDesactivarFeriado()
      }
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "button card-footer-item is-danger info-box-button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchDesactivarFeriado()
      }
    }
  }, [_c('span', [_vm._v("Desactivar")])])])])]) : _vm._e(), (_vm.isDialogActivarFeriado) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeDialogActivarFeriado()
      }
    }
  }), _c('div', {
    staticClass: "card width-350"
  }, [_vm._m(1), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [
    [_c('span', {
      staticClass: "bold"
    }, [_vm._v("¿Realmente deseas activar el dia festivo")]), _c('strong', {
      staticClass: "bold has-text-primary"
    }, [_vm._v("   " + _vm._s(_vm.nuevoFeriado.nombre) + "   ")]), _c('span', [_vm._v("?")])]
  ], 2)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogActivarFeriado()
      }
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "button card-footer-item is-success info-box-button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivarFeriado()
      }
    }
  }, [_c('span', [_vm._v("Activar")])])])])]) : _vm._e(), (_vm.isDialogResetearFeriado) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeDialogResetearFeriado()
      }
    }
  }), _c('div', {
    staticClass: "card width-350"
  }, [_vm._m(2), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [
    [_c('strong', {
      staticClass: "bold"
    }, [_vm._v("¿Realmente deseas resetear los dias festivos?")]), _c('strong', {
      staticClass: "has-text-danger"
    }, [_vm._v("Este proceso eliminará los feriados registrados por el usuario y dejará solo los feriados por defecto para el periodo " + _vm._s(_vm.periodo))])]
  ], 2)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogResetearFeriado()
      }
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "button card-footer-item is-primary info-box-button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchResetear()
      }
    }
  }, [_c('span', [_vm._v("Resetear")])])])])]) : _vm._e(), (_vm.showModalAdd) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalAdd
    }
  }), _c('div', {
    staticClass: "card w-350"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.nuevoFeriado.id ? 'Editar' : 'Nuevo') + "  dia festivo")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content d-flex fd-column"
  }, [_c('div', {
    staticClass: "flex-1 margin-bottom-20"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Fecha")]), _c('div', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevoFeriado.fecha),
      expression: "nuevoFeriado.fecha"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "date",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.nuevoFeriado.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevoFeriado, "fecha", $event.target.value)
      }
    }
  }), _vm._m(3)])]), _c('div', {
    staticClass: "flex-1 margin-bottom-20"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Descripcion del dia festivo")]), _c('div', {
    staticClass: "control has-icons-left"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevoFeriado.nombre),
      expression: "nuevoFeriado.nombre"
    }],
    staticClass: "textarea input is-small",
    attrs: {
      "rows": "2",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.nuevoFeriado.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevoFeriado, "nombre", $event.target.value)
      }
    }
  }), _vm._m(4)])]), _c('div', {
    staticClass: "flex-1 d-flex justify-content-flex-end margin-top-20px"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-small is-light",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }), _c('span', [_vm._v("Cancelar")])])]), _c('p', {
    staticClass: "control control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-success",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardar()
      }
    }
  }, [_vm._m(5), _c('span', [_vm._v("Guardar cambios")])])])])])])])]) : _vm._e(), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex d-flex jc-center fd-column"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Periodo")]), _c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodo),
      expression: "periodo"
    }],
    staticClass: "select-width",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.fetch()
      }]
    }
  }, _vm._l((_vm.periodos), function(p, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0)])]), _c('div', {
    staticClass: "flex-1 d-flex justify-content-flex-end"
  }, [_c('p', {
    staticClass: "control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-success",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.openModalAdd()
      }
    }
  }, [_vm._m(6), _c('span', [_vm._v("Nuevo feriado")])])]), _c('p', {
    staticClass: "control control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.openDialogResetearFeriado()
      }
    }
  }, [_vm._m(7), _c('span', [_vm._v("Resetear feriados")])])]), _c('p', {
    staticClass: "control control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_vm._m(8), _c('span', [_vm._v("Actualizar")])])])])])])]), _c('div', {
    staticClass: "card margin-top-5"
  }, [_c('div', {
    staticClass: "position-relative data-table-full"
  }, [(!_vm.lista.length && !_vm.isLoading) ? _c('div', {
    staticClass: "empty-list"
  }, [_c('i', {
    staticClass: "fa fa-address-card fa-6x"
  }), _vm._m(9)]) : _vm._e(), (_vm.lista.length) ? _c('table', {
    staticClass: "table table is-full-width is-responsive"
  }, [_vm._m(10), _c('tbody', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }],
    attrs: {
      "name": "fade-smooth",
      "tag": "tbody"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('tr', {
      key: ("index_" + (index + 1)),
      class: {
        'bd-desactivado': !item.activo
      }
    }, [_c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(" El  ")]), _c('span', [_vm._v(_vm._s(_vm._f("formatoFecha")(item.fechaCreacion)))]), _c('span', [_vm._v(" por  ")]), _c('strong', [_vm._v(_vm._s(item.nombreUsuarioCreador) + "  ")])]), _c('td', {
      staticClass: "center-vertical-align-middle has-text-centered"
    }, [_c('strong', {
      staticClass: "chip tag",
      class: {
        'is-success': item.activo, 'is-danger': !item.activo
      }
    }, [_vm._v(_vm._s(item.activo ? 'Activo' : 'Inactivo'))])]), _c('td', {
      staticClass: "center-vertical-align-middle has-text-centered"
    }, [_c('strong', {
      staticClass: "has-text-info"
    }, [_vm._v(_vm._s(_vm._f("formatoFechaText")(item.fecha)))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [_c('strong', [_vm._v(_vm._s(item.nombre))])]), _c('td', {
      staticClass: "center-vertical-align-middle has-text-centered"
    }, [_c('button', {
      staticClass: "button is-small margin-left-5",
      attrs: {
        "disabled": _vm.isLoading || !item.activo
      },
      on: {
        "click": function($event) {
          return _vm.editarForm(item)
        }
      }
    }, [_vm._m(11, true), _c('span', [_vm._v("Editar")])]), (item.activo) ? _c('button', {
      staticClass: "button is-small is-danger margin-left-5",
      attrs: {
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.openDialogDesactivarFeriado(item)
        }
      }
    }, [_c('span', [_vm._v("Desactivar")])]) : _c('button', {
      staticClass: "button is-small is-success margin-left-5",
      attrs: {
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.openDialogActivarFeriado(item)
        }
      }
    }, [_c('span', [_vm._v("  Activar   ")])])])])
  }), 0)]) : _vm._e(), (_vm.isLoading) ? _c('loading-global-sil', {
    attrs: {
      "message": 'Cargando'
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Desactivar feriado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Activar feriado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Resetear feriados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encuentran registros para esta búsqueda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("#")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Registrado")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Estado")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Fecha")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Descripcion")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Accion")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
}]}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('editar-boleta-tipo', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "codigo": _vm.codigoSeleccionado
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestion de tipos de boletas")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o.codigo)
        }
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Código: ' + o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])]), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.codigo)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay tipos de boleta ingresados")])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Reporte de horas extras")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitudes",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de horas extras")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Desde")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desde),
      expression: "desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.desde)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desde = $event.target.value
      }
    }
  })])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Hasta")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasta),
      expression: "hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.hasta)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hasta = $event.target.value
      }
    }
  })])])])])]) : _vm._e()]), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Excel")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarNuevoExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Nuevo reporte")])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.horas.length > 0) ? [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Concepto")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Desde")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Hasta")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Horas")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.horas), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Permiso: ' + o.idPermiso
      }
    }, [_c('span', [_vm._v(_vm._s(o.nombreEmpleado))])])])]), _c('td', [_vm._v(_vm._s(o.concepto))]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaMovimiento) + " ")]), _c('span', {
      staticClass: "show-break-1"
    }, [_vm._v(_vm._s(o.horaDesde) + "-" + _vm._s(o.horaHasta))]), _c('strong', {
      staticClass: "show-break-1"
    }, [_vm._v("Horas")]), _c('span', {
      staticClass: "show-break-1"
    }, [_vm._v(_vm._s(o.horaMinutos))])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.horaDesde))]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.horaHasta))]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.horaMinutos))])])
  }), 0)], 1)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay informacion que cumplan con los siguientes filtros")])])])], 2)])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-card",
    class: [_vm.cardClass, {
      'stat-centered': _vm.centrado
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "stat-indicator"
  }), _c('div', {
    staticClass: "stat-information"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v(_vm._s(_vm.titulo))]), (_vm.descripcion) ? _c('span', {
    staticClass: "stat-description"
  }, [_vm._v(_vm._s(_vm.descripcion))]) : _vm._e(), _c('div', {
    staticClass: "stat-footer"
  }, [_c('strong', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.cantidad))]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stat-link"
  }, [_vm._v("Ver detalle"), _c('span', {
    staticClass: "arrow"
  }, [_vm._v("→")])])
}]}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('lista-cursos-virtuales')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('editar-administrador-funciones', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "cargo": _vm.cargo
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.validarEliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el cargo " + _vm._s(_vm.solicitudSeleccionada.cargo) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2), _c('div', {
    staticClass: "info-validar-eliminar",
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [(_vm.empleadosValidados.length > 0) ? [_c('span', [_vm._v("No se puede eliminar el cargo ya que tiene empleados asociados:")]), _c('ul', _vm._l((_vm.empleadosValidados), function(o, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(o.nombre))])])
  }), 0)] : _vm._e()], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Administrador de funciones")])]), _c('div', {
    staticClass: "filtros-container"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Cargo")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cargo),
      expression: "cargo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.cargo)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaCargo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cargo = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaCargo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.cargo = '';
        _vm.fetch()
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaCargo) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-cargo', {
    on: {
      "selected": _vm.seleccionarCargo,
      "close": function($event) {
        _vm.mostrarBusquedaCargo = false
      }
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "text-right acciones"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "table-lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Cargo")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o.cargo)
        }
      }
    }, [_c('td', [_c('span', [_vm._v(_vm._s(o.cargo))])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.pathPdf) ? [(o.pathPdf.startsWith('http')) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.pathPdf,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('button', {
      staticClass: "button is-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.verAdjuntoLegacy(o.pathPdf)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small"
    })]), _c('span', [_vm._v("Ver adjunto")])])]] : _vm._e(), _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.cargo)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])], 2)])])])
  }), 0)], 1) : _vm._e()])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No hay registros")])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarModalAsignarEmpleado) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarModalAsignarEmpleado = false
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('seleccionar-empleado', {
    attrs: {
      "fetchEndpoint": _vm.fetchEndpoint,
      "filtroProp": _vm.filtroAsignarEmpleado,
      "asignarEmpleadosEndpoint": _vm.asignarEmpleadosEndpoint,
      "desasignarTodosEndpoint": _vm.desasignarTodosEndpoint,
      "asignarTodosEndpoint": _vm.asignarTodosEndpoint,
      "objAux": _vm.objAux
    },
    on: {
      "close": function($event) {
        return _vm.closeModalAsignarEmpleado()
      }
    }
  })], 1)], 1) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "button is-small is-primary mb-5",
    on: {
      "click": function($event) {
        return _vm.abrirModalAsignarEmpleados()
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Asignar")])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: 'alumno_' + index,
      staticClass: "usuario",
      on: {
        "dblclick": function($event) {
          return _vm.abrirModalAsignarEmpleados(o.dni)
        }
      }
    }, [_c('div', {
      staticClass: "display-flex fdr"
    }, [_c('span', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.nombre))])])])
  }), 0), (_vm.lista.length === 0) ? _c('div', {
    key: "message_warning"
  }, [_vm._m(2)]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    key: "loading_spin",
    staticClass: "is-loading"
  }, [_vm._m(3)]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', [_vm._v("Alumnos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay alumnos registrados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('editar-link-importante', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "id": _vm.idSeleccionado
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestion de links importantes")])]), _c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Los links cargados en esta pantalla, apareceran para todos los empleados activos de la plataforma")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Ruta")]), _c('th', [_vm._v("Fecha de modificación")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      },
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Orden: ' + o.orden
      }
    }, [_c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion))])])]), _c('td', [_vm._v(_vm._s(o.ruta))]), _c('td', [_vm._v(_vm._s(o.modificado))]), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'Orden: ' + o.orden
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.ruta))])])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Fecha de modificación:")]), _c('div', [_c('span', {
      staticClass: "detalle-dias"
    }, [_vm._v(_vm._s(o.modificado))])])]), _c('div', {
      staticClass: "botones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])])])])
  }), 0)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay links importantes ingresados")])])])], 2)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boleta"
  }, [_c('div', {
    staticClass: "datos"
  }, [_vm._m(0), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "up"
  }, [_c('div', {
    staticClass: "big"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.boleta.nombreMes) + " " + _vm._s(_vm.boleta.periodo))]), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.boleta.descripcionTipo))])]), _c('div', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Generado: " + _vm._s(_vm.boleta.fechaGenerado))])])]), _c('div', {
    staticClass: "down"
  }, [_c('div', {
    staticClass: "button",
    class: {
      'is-primary': !_vm.boleta.visto
    },
    on: {
      "click": _vm.ver
    }
  }, [(_vm.boleta.visto) ? _c('div', {
    staticClass: "button-fecha"
  }, [_c('p', [_vm._v("Ver")]), _c('div', {
    staticClass: "fecha"
  }, [_vm._v("Visto en " + _vm._s(_vm.boleta.fechaVisto))])]) : _c('div', [_c('span', [_vm._v("Ver")])])]), (!_vm.boleta.visto) ? _c('p', {
    staticClass: "small has-text-centered"
  }, [_vm._v("Al ver su boleta, acepta la recepción de la misma")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])
}]}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('gestion-areas-editar', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "area": _vm.areaSeleccionada
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.eliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar el area " + _vm._s(_vm.areaSeleccionada.nombreArea) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Administrador de areas")])]), _c('div', {
    staticClass: "filtros-container"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Area o Gerencia")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "text-right acciones"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "table-lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Area")]), _c('th', [_vm._v("Gerencia")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.shadowList), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Area: ' + o.idArea
      }
    }, [_vm._v(_vm._s(o.nombreArea))])]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Gerencia: ' + o.idGerencia
      }
    }, [_vm._v(_vm._s(o.nombreGerencia))])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])])])
  }), 0)], 1) : _vm._e()]), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No hay registros")])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reportes de boletas pendientes de generar")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activateFrame) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cerrarFrame),
      expression: "cerrarFrame"
    }],
    staticClass: "contenedor-frame"
  }, [_c('div', {
    staticClass: "titulo"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v(_vm._s(_vm.tituloFrame))]), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.cerrarFrame
    }
  }, [_c('span', [_vm._v("Cerrar")])])]), _c('iframe', {
    attrs: {
      "src": _vm.path
    }
  }, [_vm._v("Oops! an error has occurred.")])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Año")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroPeriodo),
      expression: "filtroPeriodo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroPeriodo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.periodos), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }), 0)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Mes")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroMes),
      expression: "filtroMes"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroMes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.meses), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  }), 0)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Tipo")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroTipo),
      expression: "filtroTipo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroTipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.tipos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  }), 0)])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha de Ingreso")]), _c('th', [_vm._v("DNI")]), _c('th', [_vm._v("Jefe")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', [_vm._v(_vm._s(o.nombre))]), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.email))])]), _c('td', [_vm._v(_vm._s(o.fechaIngresoString))]), _c('td', [_vm._v(_vm._s(o.dni))]), _c('td', [_c('span', {
      staticClass: "name hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(" " + _vm._s(o.nombreJefe))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.emailJefe))])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left"
    }, [_c('div', {
      staticClass: "mt-10"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dni))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(o.email))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngresoString))])]), (_vm.codigoLogueadoJefe !== (o.codigoJefe + '')) ? [_c('div', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', [_vm._v(_vm._s(o.nombreJefe))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(o.emailJefe))])])])] : _vm._e()], 2)
  }), 0)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay boletas que cumplan con los siguientes filtros")])])])], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar acciones..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    staticClass: "contenedor-data",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('div', {
      key: 'accion_lookup_' + index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(o.accion)))])])
  }), 0), (!_vm.isLoading && _vm.listaFiltrada.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('loading', {
    staticClass: "center-lookup"
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Acción")])])
}]}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lista.length > 1) ? _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Funciones")]), _c('p'), _c('div', {
    staticClass: "contenedor-box"
  }, [_c('div', {
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    key: "mensaje_no_solicitudes",
    staticClass: "mensaje-informacion"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No hay funciones")])])])]) : _vm._e(), _c('div', {
    key: "div-table-solicitud-por-aprobar",
    staticClass: "is-desktop"
  }, [(_vm.lista.length > 0) ? _c('table', {
    key: "table-solicitud-por-aprobar",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Codigo")]), _c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("DNI")]), _c('th', [_vm._v("Cargo")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: o.codigo + 'id',
      staticClass: "row-table",
      class: {
        'row-info': o.isme
      }
    }, [_c('td', [_vm._v(_vm._s(o.codigo))]), _c('td', [_vm._v(_vm._s(o.nombre))]), _c('td', [_vm._v(_vm._s(o.dni))]), _c('td', [_vm._v(_vm._s(o.cargo))]), _c('td', {
      staticClass: "text-center"
    }, [(o.pathPdf) ? [_c('a', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.verAdjunto(o.pathPdf)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', {
      staticClass: "no-accion"
    }, [_vm._v("Sin adjunto")])]], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "div-card-solicitud-por-aprobar",
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: o.id + 'id',
      staticClass: "box",
      class: {
        'row-info': o.isme
      }
    }, [_c('div', {
      staticClass: "empleado hint--right",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', {
      staticClass: "botones"
    }, [(o.pathPdf) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.pathPdf,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e()], 2)])
  }), 0)]), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)])])])]) : _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Mis Funciones")]), _c('p'), (!_vm.isLoading) ? [_c('iframe', {
    attrs: {
      "src": _vm.path
    }
  }, [_vm._v("Oops! an error has occurred.")])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis Funciones y de mi equipo")])])
}]}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de permisos de mi equipo")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesPorAprobar) ? _c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('lista-solicitud-permisos-por-aprobar', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesPorAprobar = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mostrarModalTrabajadores) ? _c('modal-trabajadores-area', {
    attrs: {
      "trabajadores": _vm.trabajadoresArea,
      "seleccionados": _vm.trabajadoresSeleccionados,
      "nombre-area": _vm.nombreArea,
      "is-loading": _vm.isLoadingTrabajadores
    },
    on: {
      "aceptar": _vm.aceptarTrabajadores,
      "close": function($event) {
        _vm.mostrarModalTrabajadores = false
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "cambio-dias"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Cambio de días en vacaciones")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [(_vm.empleado && _vm.empleado.codigo) ? _c('div', {
    key: "indicaciones-cambio-dias",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Ingresando cambio de días para ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombre))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Su jefe es ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombreJefe))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por tomar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleado.diasReales))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por programar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleado.diasDisponibles))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Le llegará un mail de notificación a ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombre) + " ")]), _c('span', [_vm._v("con los días cambiados")])]), _c('hr'), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Va a ")]), (_vm.signo === '-') ? _c('strong', [_vm._v("quitar ")]) : _c('strong', [_vm._v("agregar ")]), _c('strong', [_vm._v(_vm._s(_vm.dias) + " ")]), _c('span', [_vm._v(_vm._s(_vm.dias === 1 ? 'día ' : 'días ') + " a ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombre))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Sus días quedarían de esta manera")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por tomar ")]), (_vm.signo === '-') ? _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasReales - +_vm.dias))]) : _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasReales + +_vm.dias))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por programar ")]), (_vm.signo === '-') ? _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasDisponibles - +_vm.dias))]) : _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasDisponibles + +_vm.dias))])])])]) : _vm._e(), _c('div', {
    key: "transaccion",
    staticClass: "contenedor-transaccion"
  }, [_c('div', {
    staticClass: "flex-data"
  }, [_c('div', {
    staticClass: "flex jcc"
  }, [_c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opcionCambiarDias),
      expression: "opcionCambiarDias"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "opciones",
      "value": "individual"
    },
    domProps: {
      "checked": _vm._q(_vm.opcionCambiarDias, "individual")
    },
    on: {
      "change": [function($event) {
        _vm.opcionCambiarDias = "individual"
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Individual")])]), (_vm.empresa !== 'raymisa') ? _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opcionCambiarDias),
      expression: "opcionCambiarDias"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "opciones",
      "value": "area"
    },
    domProps: {
      "checked": _vm._q(_vm.opcionCambiarDias, "area")
    },
    on: {
      "change": [function($event) {
        _vm.opcionCambiarDias = "area"
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Área")])]) : _vm._e(), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opcionCambiarDias),
      expression: "opcionCambiarDias"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "opciones",
      "value": "todo"
    },
    domProps: {
      "checked": _vm._q(_vm.opcionCambiarDias, "todo")
    },
    on: {
      "change": [function($event) {
        _vm.opcionCambiarDias = "todo"
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Toda la empresa")])])])]), (_vm.empresa !== 'raymisa' && _vm.opcionCambiarDias === 'area') ? _c('div', {
    staticClass: "flex jcc"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Area")]), _c('div', {
    staticClass: "input-container"
  }, [(!_vm.idArea) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idArea),
      expression: "idArea"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.idArea)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idArea = $event.target.value
      }
    }
  }) : _c('div', {
    staticClass: "item fdc flex-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.nombreArea)))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.nombreGerencia))])]), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarArea
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaArea) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-area', {
    on: {
      "selected": _vm.seleccionarArea,
      "close": function($event) {
        _vm.mostrarBusquedaArea = false
      }
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), (_vm.opcionCambiarDias === 'area' && _vm.idArea) ? _c('div', {
    staticClass: "resumen-seleccion"
  }, [(_vm.cantidadTrabajadoresSeleccionados > 0) ? [_c('div', {
    staticClass: "resumen-contenido"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _c('div', {
    staticClass: "resumen-texto"
  }, [_c('strong', [_vm._v(_vm._s(_vm.cantidadTrabajadoresSeleccionados) + "\n" + _vm._s(_vm.cantidadTrabajadoresSeleccionados === 1 ? ' trabajador seleccionado' : ' trabajadores seleccionados'))]), _c('span', [_vm._v("del área " + _vm._s(_vm.nombreArea))])]), _c('button', {
    staticClass: "button button-small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalTrabajadores
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("Modificar selección")])])])] : [_c('div', {
    staticClass: "sin-seleccion"
  }, [_c('span', [_vm._v("No hay trabajadores seleccionados.")]), _c('button', {
    staticClass: "button button-small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalTrabajadores
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Seleccionar trabajadores")])])])]], 2) : _vm._e(), (_vm.opcionCambiarDias === 'individual') ? _c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleado),
      expression: "codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), (_vm.signo === '+') ? _c('div', {
    staticClass: "dias"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Días")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dias),
      expression: "dias"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dias = $event.target.value
      }
    }
  })])]) : _vm._e(), (_vm.signo === '-') ? _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaInicioQuitaDia),
      expression: "fechaInicioQuitaDia"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaInicioQuitaDia)
    },
    on: {
      "change": _vm.calculoDias,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaInicioQuitaDia = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-left-20"
  }, [_c('label', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFinQuitaDia),
      expression: "fechaFinQuitaDia"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFinQuitaDia)
    },
    on: {
      "change": _vm.calculoDias,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFinQuitaDia = $event.target.value
      }
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "signo"
  }, [_c('p', [_vm._v("¿Que acción va a realizar?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'is-selected': _vm.signo === '-'
    },
    on: {
      "click": function($event) {
        return _vm.cambiarSigno('-')
      }
    }
  }, [_c('span', [_vm._v("Quitar días")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'is-selected': _vm.signo === '+'
    },
    on: {
      "click": function($event) {
        return _vm.cambiarSigno('+')
      }
    }
  }, [_c('span', [_vm._v("Agregar días")])])])]), _c('div', {
    staticClass: "motivo"
  }, [_c('div', [_c('p', [_vm._v("Motivo")]), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Puedes seleccionar uno de los siguientes ejemplos y editarlos")]), _c('div', {
    staticClass: "motivos-ejemplo"
  }, _vm._l((_vm.motivosEjemplo), function(o) {
    return _c('span', {
      on: {
        "click": function($event) {
          _vm.motivo = o
        }
      }
    }, [_vm._v(_vm._s(o))])
  }), 0), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivo),
      expression: "motivo"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.motivo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivo = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.cambiar()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('span', [_vm._v("Cambiar días")])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarEmpleado
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Módulo")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroModulo),
      expression: "filtroModulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroModulo)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaModulo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroModulo = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaModulo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarModulo
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaModulo) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-actividades-modulo', {
    attrs: {
      "codigo": _vm.filtroModulo
    },
    on: {
      "selected": _vm.seleccionarModulo,
      "close": function($event) {
        _vm.mostrarBusquedaModulo = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Acciones")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroAccion),
      expression: "filtroAccion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroAccion)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaAccion = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroAccion = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaAccion = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarAccion
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaAccion) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-actividades-acciones', {
    attrs: {
      "codigo": _vm.filtroAccion
    },
    on: {
      "selected": _vm.seleccionarAccion,
      "close": function($event) {
        _vm.mostrarBusquedaAccion = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Desde")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desde),
      expression: "desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.desde)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desde = $event.target.value
      }
    }
  })])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Hasta")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasta),
      expression: "hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.hasta)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hasta = $event.target.value
      }
    }
  })])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "is-desktop",
    staticClass: "is-desktop"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Perfil")]), _c('th', [_vm._v("Módulo")]), _c('th', [_vm._v("Datos")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top inline",
      attrs: {
        "aria-label": 'log: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion || o.accion) + " ")]), _c('span', {
      staticClass: "hint--top has-text-bold",
      attrs: {
        "aria-label": o.fechaString
      }
    }, [_vm._v(_vm._s(_vm._f("fromNow")(o.fecha)))])]), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(o.perfil || o.usuario)))]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(o.modulo)))])]), _c('td', [_c('div', [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Accion: ")]), _c('span', {
      staticClass: "hint--top tipo-icon",
      attrs: {
        "aria-label": o.tipo
      }
    }, [_c('i', {
      class: _vm.tipoIcon[o.tipo]
    })])]), _vm._l((o.datos), function(value, key) {
      return _c('div', [_c('span', {
        staticClass: "has-text-bold"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])
    })], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "is-mobile",
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(o.perfil || o.usuario)))])]), _c('div', {
      staticClass: "perfil"
    }), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.modulo.toUpperCase()))])]), _c('div', {
      staticClass: "motivo hint--bottom",
      attrs: {
        "aria-label": 'Log: ' + o.id
      }
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.descripcion || o.accion) + " " + _vm._s(_vm._f("fromNow")(o.fecha)))]), _c('div', {
      staticClass: "has-text-lef datos-auditoria"
    }, [_c('div', [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Accion: ")]), _c('span', {
      staticClass: "hint--top tipo-icon",
      attrs: {
        "aria-label": o.tipo
      }
    }, [_c('i', {
      class: _vm.tipoIcon[o.tipo]
    })])]), _vm._l((o.datos), function(value, key) {
      return _c('div', [_c('span', {
        staticClass: "has-text-bold"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])
    })], 2), _c('div', {
      staticClass: "fecha"
    }, [_vm._v(_vm._s(o.fechaString))])])])
  }), 0)])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Auditoria")])])
}]}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title", [_vm._v("Adjunta una imagen o pdf")])], 2), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._t("topIcon", [_c('i', {
    staticClass: "fa fa-file-image-o"
  })])], 2)])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "upload-container w-64",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.uploadFile($event)
      }
    }
  }, [_c('p', {
    staticClass: "has-text-left"
  }, [_c('span', [_vm._t("explanation", [_vm._v("Adjunta una imagen o pdf")])], 2)]), (!_vm.filename) ? _c('div', {
    staticClass: "dropzone",
    attrs: {
      "id": "dropzone"
    },
    on: {
      "click": _vm.select
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$upload.dropzone(_vm.name).active),
      expression: "$upload.dropzone(name).active"
    }],
    staticClass: "overlay"
  }, [_c('span', [_vm._v("Suelta el archivo para cargarlo")])])]), _vm._m(0), _c('span', {
    staticClass: "margin-bottom-10"
  }, [_vm._t("dropzoneDescription", [_vm._v("Arrastra el archivo o imagen que desees cargar o dale click al recuadro para buscar en tus archivos")])], 2)], 1) : _vm._e(), (_vm.$upload.errors(_vm.name).length > 0) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.$upload.errors(_vm.name)[0].msg))]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.filename) ? _c('div', {
    staticClass: "uploaded-file"
  }, [
    [_c('h5', {
      staticClass: "file-name mb-4 text-purple-500 font-bold"
    }, [_vm._v(_vm._s(_vm.filename))])], _c('div', {
      staticClass: "buttons-container"
    }, [
      [_c('button', {
        staticClass: "button flex-1 margin-left-5 is-primary",
        attrs: {
          "type": "submit"
        }
      }, [(_vm.isSaving) ? _c('i', {
        staticClass: "fa fa-spinner fa-spin"
      }) : [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fa fa-save fa-fw fa-lg"
      })]), _c('span', [_vm._v("Guardar archivo")])]], 2)]
    ], 2)
  ], 2) : _vm._e()])], 1)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  })])
}]}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "fw-400"
  }, [_vm._v(_vm._s(_vm.id ? 'Editar' : 'Nueva') + " clase")])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _c('span', [_vm._v("Volver")])])]), _c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "disabled": _vm.isLoadingClase
    },
    on: {
      "click": function($event) {
        return _vm.guardarClase()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('span', [_vm._v("Guardar")])])]), _c('div', {
    staticClass: "body pt-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Orden")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orden),
      expression: "orden"
    }],
    staticClass: "input w-90",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.orden)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orden = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Youtube link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkYT),
      expression: "linkYT"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.linkYT)
    },
    on: {
      "focus": function (e) { return e.target.select(); },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkYT = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Duración")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duracion),
      expression: "duracion"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "time",
      "step": "1",
      "disabled": _vm.isLoadingClase
    },
    domProps: {
      "value": (_vm.duracion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duracion = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap pt-10"
  }, [_c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-curso-lista', {
    ref: "materialesRef",
    attrs: {
      "type": "clase"
    },
    on: {
      "save": function($event) {
        return _vm.saveMaterial()
      }
    }
  })], 1), _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-curso-lista', {
    ref: "evaluacionesRef",
    attrs: {
      "type": "clase"
    },
    on: {
      "save": function($event) {
        return _vm.saveEvaluacion()
      }
    }
  })], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "mobile-navbar"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "router-link mobile-navbar-option",
    attrs: {
      "to": "/vacaciones"
    }
  }, [_c('i', {
    staticClass: "fa fa-plane"
  }), _c('span', [_vm._v("Mis vacaciones")])])], 1), _c('li', [_c('router-link', {
    staticClass: "router-link mobile-navbar-option",
    attrs: {
      "to": "/permisos"
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _c('span', [_vm._v("Mis permisos")])])], 1), _c('li', [_c('router-link', {
    staticClass: "router-link mobile-navbar-option",
    attrs: {
      "to": "/boletas"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _c('span', [_vm._v("Mis boletas")])])], 1), _c('li', {
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-navbar-option"
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _c('span', [_vm._v("Opciones")])])
}]}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarModalAsignarAsistenteExterno) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarModalAsignarAsistenteExterno = false
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.asistenteExterno.id) ? _c('span', [_vm._v("Actualizar asistente externo")]) : _c('span', [_vm._v("Insertar asistente interno")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Nombre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asistenteExterno.nombreExterno),
      expression: "asistenteExterno.nombreExterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.asistenteExterno.nombreExterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.asistenteExterno, "nombreExterno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Cargo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asistenteExterno.cargoExterno),
      expression: "asistenteExterno.cargoExterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.asistenteExterno.cargoExterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.asistenteExterno, "cargoExterno", $event.target.value)
      }
    }
  })])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.guardarAsistenteExterno
    }
  }, [(_vm.isSaving) ? _c('strong', [_vm._v("Guardando...")]) : _c('strong', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.closeModalAsignarAsistenteExterno
    }
  }, [_c('span', [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarModalAsignarEmpleado) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarModalAsignarEmpleado = false
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('seleccionar-empleado', {
    attrs: {
      "fetchEndpoint": _vm.fetchEndpoint,
      "filtroProp": _vm.filtroAsignarEmpleado,
      "asignarEmpleadosEndpoint": _vm.asignarEmpleadosEndpoint,
      "desasignarTodosEndpoint": _vm.desasignarTodosEndpoint,
      "asignarTodosEndpoint": _vm.asignarTodosEndpoint,
      "objAux": _vm.objAux
    },
    on: {
      "close": function($event) {
        return _vm.closeModalAsignarEmpleado()
      }
    }
  })], 1)], 1) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "text-center"
  }, [(!(_vm.esReunionTerminada || _vm.esReunionAnulada)) ? _c('button', {
    staticClass: "button is-small is-primary mb-5",
    on: {
      "click": function($event) {
        return _vm.abrirModalAsignarEmpleados({})
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Asignar Empleados")])]) : _vm._e(), (!(_vm.esReunionTerminada || _vm.esReunionAnulada)) ? _c('button', {
    staticClass: "button is-small is-primary mb-5 ml-5",
    on: {
      "click": function($event) {
        return _vm.abrirModalAsignarAsistenteExterno({})
      }
    }
  }, [_vm._m(2), _c('span', [_vm._v("Agregar Externo")])]) : _vm._e()]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "data overflow-y-scroll"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: 'asistente_' + index,
      staticClass: "asistentes-item position-relative",
      on: {
        "dblclick": function($event) {
          return _vm.abrirModalAsignarEmpleados(o)
        }
      }
    }, [_c('div', {
      staticClass: "asistentes-item-container display-flex"
    }, [_c('div', {
      staticClass: "display-flex fdc flex-1"
    }, [_c('div', {
      staticClass: "asistentes-name"
    }, [_c('span', [_vm._v(_vm._s(o.nombre || o.nombreExterno))])]), _c('div', {
      staticClass: "asistentes-cargo"
    }, [_c('span', [_vm._v(_vm._s(o.cargo || o.cargoExterno))]), (o.externo) ? _c('span', {
      staticClass: "externo-span"
    }, [_vm._v("  (Externo)")]) : _vm._e()])]), _c('div', {
      staticClass: "asistentes-checkbox"
    }, [(o.externo && !_vm.esReunionTerminada && !_vm.esReunionAnulada) ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.abrirModalAsignarAsistenteExterno(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })])]), _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.borrarAsistenteExterno(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])] : _vm._e(), (_vm.esReunionTerminada) ? _c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.asistio),
        expression: "o.asistio"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox",
        "name": "asistio",
        "disabled": !_vm.esReunionTerminada || _vm.codigoCreador === o.codigo || _vm.isSaving
      },
      domProps: {
        "checked": Array.isArray(o.asistio) ? _vm._i(o.asistio, null) > -1 : (o.asistio)
      },
      on: {
        "change": [function($event) {
          var $$a = o.asistio,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(o, "asistio", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(o, "asistio", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(o, "asistio", $$c)
          }
        }, function($event) {
          return _vm.changeCheckbox($event, o)
        }]
      }
    }), _c('span', {
      staticClass: "ml-5"
    }, [_vm._v("Asistió")])]) : _vm._e()], 2)])])
  }), 0), (_vm.lista.length === 0) ? _c('div', {
    key: "message_warning"
  }, [_vm._m(3)]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    key: "loading_spin",
    staticClass: "is-loading"
  }, [_vm._m(4)]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', [_vm._v("Asistentes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay alumnos registrados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [(_vm.isModalActive) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalActive
    }
  }), _c('div', {
    staticClass: "box position-relative has-text-left margin-right-10 margin-left-10"
  }, [_c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.item.descripcionAlgoritmo)) + ": " + _vm._s(_vm.item.nombreEmpleado))])]), (_vm.item.classes === 'solicitud-permisos' || _vm.item.classes === 'permisos') ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Tipo: ")]), _c('span', [_vm._v(_vm._s(_vm.item.descripcionTipo))])]) : _vm._e(), _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Fecha" + _vm._s(_vm.item.desde === _vm.item.hasta ? '' : 's') + ": ")]), _c('span', [_vm._v(_vm._s(_vm.item.desde) + " ")]), (_vm.item.desde !== _vm.item.hasta) ? _c('span', [_vm._v("- " + _vm._s(_vm.item.hasta))]) : _vm._e()]), (_vm.item.horaDesde) ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Horas: ")]), _c('span', [_vm._v(_vm._s(_vm.item.horaDesde) + " - " + _vm._s(_vm.item.horaHasta))])]) : _vm._e(), (_vm.item.classes.includes('solicitud')) ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Estado: ")]), _c('span', [_vm._v(_vm._s(_vm.item.descripcionEstado))])]) : _vm._e(), (_vm.item.classes.includes('solicitud') || _vm.item.classes === 'vacaciones') ? _c('div', [_c('span', {
    staticClass: "text-small"
  }, [_vm._v("Creación solicitud: ")]), _c('span', [_vm._v(_vm._s(_vm.item.fechaCreacionSolicitud))])]) : _vm._e()])]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-overlay"
  }, [_c('loading')], 1) : _vm._e(), _c('div', {
    staticClass: "flex mb-5"
  }, [_c('div', {
    staticClass: "flex flex-1 filtros-check"
  }, [(_vm.perfilVacaciones === 'recursos humanos') ? _c('div', {
    staticClass: "control flex"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.verTodos
    },
    on: {
      "change": _vm.verTodosChanged
    }
  }), _c('span', {
    staticClass: "ml-5 asc"
  }, [_vm._v("Ver todos los empleados")])]) : _vm._e(), _c('div', {
    staticClass: "control flex ml-15"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.meIncluyo
    },
    on: {
      "change": _vm.meIncluyoChanged
    }
  }), _c('span', {
    staticClass: "ml-5 asc"
  }, [_vm._v("Incluir mi información")])]), _c('div', {
    staticClass: "control flex ml-15"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.verSolicitudesAprobadas
    },
    on: {
      "change": _vm.verSolicitudesAprobadasChanged
    }
  }), _c('span', {
    staticClass: "ml-5 asc"
  }, [_vm._v("Ver solo aprobadas")])])]), _vm._m(0)]), _c('calendar-view', {
    staticClass: "theme-default holiday-us-traditional holiday-us-official",
    attrs: {
      "show-date": _vm.showDate,
      "items": _vm.lista,
      "startingDayOfWeek": 1,
      "periodChangedCallback": _vm.fetch
    },
    on: {
      "click-item": _vm.onItemClick
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(t) {
        return _c('calendar-view-header', {
          attrs: {
            "header-props": t.headerProps
          },
          on: {
            "input": _vm.setShowDate
          }
        })
      }
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-1 aic mb-5 leyenda"
  }, [_c('div', {
    staticClass: "seen-vacaciones"
  }, [_c('span', [_vm._v("Vacaciones")])]), _c('div', {
    staticClass: "seen-solicitud-vacaciones"
  }, [_c('span', [_vm._v("Solicitud de Vacaciones")])]), _c('div', {
    staticClass: "seen-permisos"
  }, [_c('span', [_vm._v("Permisos")])]), _c('div', {
    staticClass: "seen-solicitud-permisos"
  }, [_c('span', [_vm._v("Solicitud de Permisos")])])])
}]}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de excepciones de permisos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud"
  }, [_c('nueva-solicitud-vacaciones', {
    attrs: {
      "is-excepcion": true
    },
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Volver")])])])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-cajas",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "contenedor-glosa mb-0"
  }, [_c('h4', {
    staticClass: "titulo"
  }, [_c('strong', [_vm._v(_vm._s(_vm.titulo))])]), _c('br'), _c('h3', {
    staticClass: "organizador"
  }, [_vm._v("Organizador: " + _vm._s(_vm.nombreCreador))]), _c('h3', {
    staticClass: "fecha"
  }, [_vm._v("Cuando:  " + _vm._s(_vm.fecha) + " " + _vm._s(_vm.horaDesde && _vm.horaHasta ? (_vm.horaDesde + " - " + _vm.horaHasta) : ''))]), _c('br')]), _c('div', {
    staticClass: "contenedor-glosa flex cuerpo"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('p', {
    staticClass: "pt-10 descripcion mb-5",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.descripcion))
    }
  }), (_vm.salaTitulo) ? _c('section', [_c('h1', {
    staticClass: "tipo"
  }, [_vm._v("Lugar")]), _c('h3', {
    staticClass: "titulo"
  }, [_vm._v("Sala: " + _vm._s(_vm.salaTitulo))]), (_vm.salaDescripcion) ? [_c('p', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.salaDescripcion))
    }
  })] : _vm._e()], 2) : _vm._e(), (_vm.link) ? _c('section', {
    staticClass: "contenedor-glosa"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("Ingresar a " + _vm._s(_vm.tipo === 'reunion' ? 'la reunión' : 'la capacitación'))])]) : _vm._e()]), _c('div', {
    staticClass: "asistentes"
  }, [_c('h1', {
    staticClass: "tipo mb-10"
  }, [_vm._v("Asistentes")]), _c('div', {
    staticClass: "lista overflow-y-scroll"
  }, _vm._l((_vm.asistentes), function(o, index) {
    return _c('div', {
      staticClass: "asistente-item"
    }, [_c('h3', {
      staticClass: "nombre"
    }, [_vm._v(_vm._s(o.nombre || o.nombreExterno))]), _c('span', {
      staticClass: "cargo"
    }, [_vm._v(_vm._s(o.cargo || o.cargoExterno))]), (o.externo) ? _c('span', {
      staticClass: "externo-span"
    }, [_vm._v("  (Externo)")]) : _vm._e()])
  }), 0)])]), (_vm.estado === 0 && _vm.codigoCreador !== _vm.codigo) ? [_c('button', {
    staticClass: "button is-small is-success mr-5",
    on: {
      "click": function($event) {
        return _vm.marcarAsitencia(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up is-small"
  })]), _c('span', [_vm._v("Asistí")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        return _vm.marcarAsitencia(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down is-small"
  })]), _c('span', [_vm._v("No asistí")])])] : _vm._e(), (_vm.asistio !== null && _vm.fechaMarcaAsistio) ? _c('h2', [_vm._v("Marcó " + _vm._s(_vm.asistio ? 'sí' : 'no') + " asistió : " + _vm._s(_vm.fechaMarcaAsistio))]) : _vm._e(), (_vm.minutaLink || _vm.minutaDescripcion) ? _c('div', {
    staticClass: "contenedor-glosa"
  }, [_c('h1', {
    staticClass: "tipo"
  }, [_vm._v("Minuta")]), (_vm.minutaDescripcion) ? _c('p', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.minutaDescripcion))
    }
  }) : _vm._e(), (_vm.minutaLink) ? _c('a', {
    attrs: {
      "href": _vm.minutaLink,
      "target": "_blank"
    }
  }, [_vm._v("Ver minuta")]) : _vm._e()]) : _vm._e()], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Mis datos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarDatosFotoPerfil) ? _c('div', {
    key: "datos-foto-perfil",
    staticClass: "box"
  }, [_c('datos-personales-foto-perfil', {
    on: {
      "close": function($event) {
        _vm.mostrarDatosFotoPerfil = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarDatosSeguridad) ? _c('div', {
    key: "datos-seguridad",
    staticClass: "box"
  }, [_c('datos-personales-seguridad', {
    on: {
      "close": function($event) {
        _vm.mostrarDatosSeguridad = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarDatosConsulta) ? _c('div', {
    key: "datos-consulta",
    staticClass: "box"
  }, [_c('datos-personales-consulta', {
    on: {
      "close": function($event) {
        _vm.mostrarDatosConsulta = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarDatosEditable) ? _c('div', {
    key: "datos-editable",
    staticClass: "box"
  }, [_c('datos-personales-editable', {
    on: {
      "close": function($event) {
        _vm.mostrarDatosEditable = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_funcion",
      "folder": "funciones",
      "onlyPdf": true
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar Funcion")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo pdf que contiene la funcion")]), _c('span', {
    attrs: {
      "slot": "dropzoneDescription"
    },
    slot: "dropzoneDescription"
  }, [_vm._v("Arrastra el pdf que desees cargar o dale click al recuadro para buscar en tus archivos")]), _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.cargo) ? _c('span', [_vm._v("Editar funcion")]) : _c('span', [_vm._v("Crear funcion")])]), _c('span', {
    staticClass: "icon close pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Cargo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cargoLocal),
      expression: "cargoLocal"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.cargoLocal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cargoLocal = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "display-flex text-center jc-center"
  }, [_c('div', [(_vm.pathPdf) ? [(_vm.pathPdf.startsWith('http')) ? [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "href": _vm.pathPdf,
      "target": "_blank"
    }
  }, [_vm._m(0), _c('span', [_vm._v("Ver adjunto")])])] : [_c('button', {
    staticClass: "button is-small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.verAdjuntoLegacy
    }
  }, [_vm._m(1), _c('span', [_vm._v("Ver adjunto")])])]] : [_c('button', {
    staticClass: "button is-small is-primary",
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_vm._m(2), _c('span', [_vm._v("Adjuntar")])])]], 2), (_vm.pathPdf) ? _c('span', {
    staticClass: "icon color-red margin-left-5 cursor-pointer",
    attrs: {
      "tittle": "Borrar adjunto"
    },
    on: {
      "click": function($event) {
        _vm.pathPdf = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e()])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
}]}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('bar-chart', {
    attrs: {
      "isHorizontal": false,
      "series": _vm.series,
      "categories": _vm.categories,
      "yAxisTitle": "Solicitudes",
      "tooltipFormatter": _vm.tooltipFormatter,
      "xAxisTitle": "Jefes",
      "title": "Solicitudes de vacaciones pendientes",
      "subtitle": "Cantidad de Solicitudes de vacaciones pendientes por aprobar por jefe",
      "showLegend": false,
      "showXlabels": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.muestraModalExcelSaldo
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalExcelSaldo
    }
  }), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Mes")]), _c('div', {
    staticClass: "d-flex width-100"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "select is-small d-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesExportar),
      expression: "mesExportar"
    }],
    staticClass: "flex-1",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mesExportar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.arrayMeses), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.id + ' - ' + item.nombre))])
  }), 0)])])])]), _c('div', {
    staticClass: "column is-6"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Periodo")]), _c('div', {
    staticClass: "d-flex width-100"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "select is-small d-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodoExportar),
      expression: "periodoExportar"
    }],
    staticClass: "flex-1 width-600",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.periodoExportar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.arrayYear), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nombre))])
  }), 0)])])])])])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-outlined info-box-button is-uppercase",
    on: {
      "click": _vm.closeModalExcelSaldo
    }
  }, [_vm._v("Cancelar")]), [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button is-uppercase",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.fetchExportarExcelSaldo()
      }
    }
  }, [_c('span', [_vm._v("Exportar")])])]], 2)])]), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Empleados")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret",
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Urgencia")])]), _c('div', {
    staticClass: "status-container-filtro"
  }, _vm._l((_vm.filtrosUrgencia), function(o) {
    return _c('div', {
      staticClass: "status",
      class: {
        'selected': o === _vm.filtroUrgencia
      },
      on: {
        "click": function($event) {
          _vm.filtroUrgencia = o
        }
      }
    }, [_c('div', {
      staticClass: "circle",
      class: o
    })])
  }), 0)])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Excel")])]), _c('button', {
    staticClass: "button margin-button-top",
    on: {
      "click": _vm.showModalExportarExcelSaldo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-fw fa-lg"
  })]), _c('span', [_vm._v("Exportar Saldo Vacaciones")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha de Ingreso")]), _c('th', [_c('span', [_vm._v("Días por tomar / programar")])]), _c('th', [_vm._v("DNI")]), _c('th', [_vm._v("Jefe")]), _c('th', {
    staticClass: "td-status"
  })]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('tr', {
      key: index + '-desktop',
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.email))])]), _c('td', [_vm._v(_vm._s(o.fechaIngreso))]), _c('td', [_vm._v(_vm._s(o.diasReales) + " / " + _vm._s(o.diasDisponibles))]), _c('td', [_vm._v(_vm._s(o.dni))]), _c('td', [_c('span', {
      staticClass: "name hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(_vm._s(o.emailJefe))])]), _c('td', {
      staticClass: "td-status"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasDisponibles >= 35 && o.diasDisponibles <= 40,
          'red': o.diasDisponibles > 40
      }
    })])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.listaFiltrada), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left"
    }, [_c('div', {
      staticClass: "dias"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(o.diasReales) + " ")]), _c('span', [_vm._v("por tomar / ")]), _c('strong', [_vm._v(_vm._s(o.diasDisponibles) + " ")]), _c('span', [_vm._v("por programar ")])]), _c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        'yellow': o.diasDisponibles >= 35 && o.diasDisponibles <= 40,
          'red': o.diasDisponibles > 40
      }
    })])]), _c('div', {
      staticClass: "mt-10"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(o.email))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dni))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', {
      staticClass: "name hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Email Jefe: ")]), _c('span', [_vm._v(_vm._s(o.emailJefe))])])])
  }), 0), (_vm.listaFiltrada.length === 0 || _vm.listaFiltrada.length === -1 || _vm.listaFiltrada.length === undefined) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay empleados que cumplan con los siguientes filtros")])])]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Periodo y Mes")])])])
}]}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box margin-top-10 card-renovacion text-center"
  }, [(_vm.idSolicitud) ? _c('div', [_c('span', [_vm._v("Hay una solicitud de renovación con estado ")]), _c('strong', [_vm._v(_vm._s(_vm.descripcionEstado))])]) : _c('div', [_c('span', [_vm._v("Pedir renovación de contrato para ")]), _c('span', {
    staticClass: "bold hint--top",
    attrs: {
      "aria-label": 'Empleado: ' + _vm.codigo
    }
  }, [_vm._v(_vm._s(_vm.nombre))]), _c('br'), _c('br'), _c('div', [_c('span', {
    staticClass: "little-text"
  }, [_vm._v("Ingresa los meses de renovación")]), _c('div', {
    staticClass: "control text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesesARenovar),
      expression: "mesesARenovar"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": _vm.disableMeses
    },
    domProps: {
      "value": (_vm.mesesARenovar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mesesARenovar = $event.target.value
      }
    }
  })]), _c('span', {
    staticClass: "little-text text-center"
  }, [_vm._v("o activa el check de indeterminado")]), _c('br'), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indeterminado),
      expression: "indeterminado"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.indeterminado) ? _vm._i(_vm.indeterminado, null) > -1 : (_vm.indeterminado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.indeterminado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.indeterminado = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.indeterminado = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.indeterminado = $$c
        }
      }
    }
  }), _vm._v(" Contrato indeterminado")])]), _c('br'), _c('div', {
    staticClass: "display-flex jc-center"
  }, [_c('div', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.pedirRenovacion(false)
      }
    }
  }, [_vm._v("Pedir renovacion")]), _c('div', {
    staticClass: "button is-danger margin-left-5",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.pedirRenovacion(true)
      }
    }
  }, [_vm._v("No se renovará")])])])])
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), (_vm.mostrarModalRechazo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Motivo de rechazo")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivoRechazo),
      expression: "motivoRechazo"
    }],
    staticClass: "p-10",
    attrs: {
      "name": "motivoRechazo",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.motivoRechazo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivoRechazo = $event.target.value
      }
    }
  })]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.rechazar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Rechazar...")]) : _c('span', [_vm._v("Rechazar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.cerrarModalRechazo
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])]) : _vm._e(), (_vm.mostrarModalNotificar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarNotificar",
    on: {
      "close": _vm.closeModalNotificar,
      "do": _vm.notificar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea notificar a todos los empleados que no hayan cargado su documento?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Notificando...")]) : _c('span', [_vm._v("Notificar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigoEmpleado),
      expression: "filtros.codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtros.codigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigoEmpleado", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtros.codigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtros.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Documento")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.id),
      expression: "filtros.id"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Ninguno")]), _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento.id
      }
    }, [_vm._v(_vm._s(documento.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estado),
      expression: "filtros.estado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin carga")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sin revisar")]), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Revisado")])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Documentos activos?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.activo),
      expression: "filtros.activo"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "activo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Si")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("No")])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button m-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.notificar()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Notificar Masivo")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Doc.")]), _c('th', [_vm._v("Empleado")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion))])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))]), (o.rutaSubido) ? [_c('div', {
      staticClass: "seen"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Subido")]), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check fs-12"
    })])]), _c('div', {
      staticClass: "dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Fecha Subido: ")]), _c('span', [_vm._v(_vm._s(o.fechaSubidoArchivoEmpleado))])])] : _vm._e()], 2)]), _c('td', [_c('div', {
      staticClass: "text-center flex fdc"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.rutaSubido) ? _c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.rutaSubido,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye is-small fs-12"
    })]), _c('span', [_vm._v("Revisar")])]) : _vm._e(), (o.rutaSubido && !o.revisado) ? _c('button', {
      staticClass: "button is-small",
      class: {
        'is-loading': _vm.isProcessing
      },
      on: {
        "click": function($event) {
          return _vm.revisar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-check is-small fs-12"
    })]), _c('span', [_vm._v("Aprobar")])]) : _vm._e(), (!o.rutaSubido) ? _c('button', {
      staticClass: "button is-small is-primary mt-5",
      on: {
        "click": function($event) {
          return _vm.notificar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-envelope fs-12"
    })]), _c('span', [_vm._v("Notificar")])]) : _vm._e(), (o.rutaSubido) ? _c('button', {
      staticClass: "button is-small is-danger mt-5",
      on: {
        "click": function($event) {
          return _vm.abrirModalRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash fs-12"
    })]), _c('span', [_vm._v("Rechazar")])]) : _vm._e()])])])])
  }), 0)], 1) : _vm._e()])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de Documentos para Firmar")])])
}]}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [_vm._m(0), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "information",
    attrs: {
      "name": "fade-smooth",
      "tag": "tbody",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "curso-item"
    }, [_c('img', {
      staticClass: "curso-imagen",
      attrs: {
        "src": o.imagen,
        "alt": "Curso imagen"
      }
    }), _c('div', {
      staticClass: "curso-detalles"
    }, [_c('div', {
      staticClass: "curso-header"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))]), (o.descripcion) ? _c('div', {
      staticClass: "descripcion"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion, 30)))])]) : _vm._e()]), _c('div', {
      staticClass: "curso-info"
    }, [_c('span', [_vm._v("Duración: " + _vm._s(o.DuracionTotal))]), _c('span', [_vm._v("Clases: " + _vm._s(o.NumeroClases))]), _c('span', [_vm._v("Progreso: " + _vm._s(o.progreso) + "%")])])]), _c('div', {
      staticClass: "curso-botones"
    }, [(o.progreso === 0) ? _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.iniciarCurso(o.id)
        }
      }
    }, [_vm._v("Iniciar curso")]) : _vm._e(), (o.progreso > 0 && o.progreso < 100) ? _c('button', {
      staticClass: "button is-info",
      on: {
        "click": function($event) {
          return _vm.iniciarCurso(o.id)
        }
      }
    }, [_vm._v("Continuar")]) : _vm._e(), (o.progreso === 100) ? _c('button', {
      staticClass: "button is-warning",
      on: {
        "click": function($event) {
          return _vm.iniciarCurso(o.id)
        }
      }
    }, [_vm._v("Volver a iniciar")]) : _vm._e()])])
  }), 0), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', [_vm._m(1)]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis cursos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay cursos registrados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solicitud"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.isEditing) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Modificando la solicitud " + _vm._s(_vm.solicitud.id))]) : (_vm.isExcepcion) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Ingresa una solicitud de permisos sin validaciones")]) : _c('span', [_vm._v("Ingresa una solicitud de permisos")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [(_vm.mostrarIndicaciones && !_vm.isExcepcion) ? _c('div', {
    key: "indicaciones",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        _vm.mostrarIndicaciones = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud la debe aprobar ")]), _c('strong', [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('span', [_vm._v(_vm._s(_vm.jefe))])])])])]) : _vm._e(), _c('div', {
    key: "transaccion",
    staticClass: "contenedor-transaccion"
  }, [(_vm.isExcepcion) ? _c('div', {
    staticClass: "contenedor-input-relative"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('strong', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "datos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleado),
      expression: "codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), (_vm.nombreEmpleado) ? _c('div', {
    staticClass: "descripcion"
  }, [_c('p', [_vm._v(_vm._s(_vm.nombreEmpleado))])]) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _c('div', {
    staticClass: "contenedor-input-relative"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('strong', [_vm._v("Tipo de permiso")]), _c('div', {
    staticClass: "datos"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo),
      expression: "tipo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.tipo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipo = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaTipo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), (_vm.descripcionTipo) ? _c('div', {
    staticClass: "descripcion"
  }, [_c('p', [_vm._v(_vm._s(_vm.descripcionTipo))])]) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaTipo) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-tipos-permiso', {
    attrs: {
      "codigo": _vm.tipo
    },
    on: {
      "selected": _vm.seleccionarTipo,
      "close": function($event) {
        _vm.mostrarBusquedaTipo = false
      }
    }
  })], 1) : _vm._e()])], 1), _c('br'), _c('div', {
    staticClass: "motivo"
  }, [_c('div', [_c('strong', [_vm._v("Motivo")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivo),
      expression: "motivo"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.motivo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivo = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "title-detalle"
  }, [_c('strong', [_vm._v("Ingrese las fechas y horas que se ausentará")])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, _vm._l((_vm.detalle), function(o, index) {
    return _c('div', {
      key: 'fechas_horas_permisos_' + index,
      staticClass: "detalle"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Desde")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Desde")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.desde),
        expression: "o.desde"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
      },
      domProps: {
        "value": (o.desde)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "desde", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Hasta")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Hasta")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.hasta),
        expression: "o.hasta"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
      },
      domProps: {
        "value": (o.hasta)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "hasta", $event.target.value)
        }
      }
    })])]), _c('div', {
      staticClass: "flex jcc"
    }, [_c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Hora desde")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Hora desde")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.horaDesde),
        expression: "o.horaDesde"
      }],
      staticClass: "input",
      attrs: {
        "type": "time",
        "min": "8:00",
        "max": "18:30"
      },
      domProps: {
        "value": (o.horaDesde)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "horaDesde", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [(index === 0) ? _c('p', [_vm._v("Hora hasta")]) : _c('p', {
      staticClass: "mobile-headers"
    }, [_vm._v("Hora hasta")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.horaHasta),
        expression: "o.horaHasta"
      }],
      staticClass: "input",
      attrs: {
        "type": "time",
        "min": "8:00",
        "max": "18:30"
      },
      domProps: {
        "value": (o.horaHasta)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "horaHasta", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "delete-detalle"
    }, [_c('span', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          return _vm.eliminarDetalle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0), _c('div', {
    staticClass: "agregar-linea"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.agregarDetalleVacio
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Agregar linea")])])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('span', [_vm._v("Guardar")])]), (!_vm.isExcepcion) ? _c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _c('span', [_vm._v("Guardar y Enviar")])]) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base badge-delegacion",
    class: {
      'is-in-mobile': _vm.isMobile
    },
    on: {
      "click": function($event) {
        _vm.showPopup = !_vm.showPopup
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarInactivarDelegación) ? _c('div', {
    staticClass: "background-popup-birthday"
  }, [_c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Inactivar delegación")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.mostrarInactivarDelegación = false
      }
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("¿Estás seguro de inactivar la delegación?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.inactivar
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Inactivando...")]) : _c('span', [_vm._v("Inactivar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        _vm.mostrarInactivarDelegación = false
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])]) : _vm._e()]), _c('strong', [_vm._v(_vm._s(_vm.estoySiendoReemplazado ? 'Estás siendo reemplazado por' : _vm.estoyReemplazando ? 'Estás reemplazando a' : '') + " " + _vm._s(_vm.isMobile ? _vm.nombreReemplazo : _vm.nombreReemplazoTrim))]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPopup) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "popup",
    class: {
      'popup-top': !_vm.isMobile, 'popup-bottom': _vm.isMobile
    },
    style: ({
      bottom: _vm.isMobile ? _vm.badgeHeight + 'px' : 'none'
    })
  }, [_c('h3', [_vm._v(_vm._s(_vm.estoySiendoReemplazado ? 'Siendo reemplazado por' : _vm.estoyReemplazando ? 'Reemplazando a' : '') + " "), _c('strong', [_vm._v(_vm._s(_vm.nombreReemplazo))])]), _c('p', [_vm._v("Fecha: " + _vm._s(_vm.fechaInicioFormat == _vm.fechaFinFormat ? _vm.fechaInicioFormat : _vm.fechaInicioFormat + ' - ' + _vm.fechaFinFormat))]), (_vm.estoySiendoReemplazado) ? _c('button', {
    staticClass: "button is-small is-danger mt-5",
    on: {
      "click": function($event) {
        _vm.mostrarInactivarDelegación = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Inactivar")])]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('bar-chart', {
    attrs: {
      "isHorizontal": _vm.isHorizontal,
      "series": _vm.empleadosSeries,
      "categories": _vm.areas,
      "yAxisTitle": _vm.isHorizontal ? 'Areas' : 'Empleados',
      "tooltipFormatter": _vm.tooltipFormatter,
      "xAxisTitle": !_vm.isHorizontal ? 'Areas' : 'Empleados',
      "title": "Cantidad de Empleados por Area",
      "showLegend": false,
      "showXlabels": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card"
  }, [_vm._m(0), (_vm.lista.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._m(1)]) : _vm._e(), _c('div', {
    ref: "courses",
    staticClass: "courses",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.lista), function(curso) {
    return _c('div', {
      key: curso.id,
      staticClass: "course"
    }, [_c('div', {
      staticClass: "course-heading"
    }, [_c('div', {
      staticClass: "course-main"
    }, [_c('strong', [_vm._v(_vm._s(curso.titulo))]), _c('div', {
      staticClass: "course-meta"
    }, [_c('span', [_vm._v(_vm._s(curso.NumeroClases) + " clase(s)")]), _c('span', {
      staticClass: "separator"
    }, [_vm._v("•")]), _c('span', [_vm._v(_vm._s(curso.DuracionTotal))])])]), _c('span', {
      staticClass: "status",
      class: {
        completed: curso.progreso === 100
      }
    }, [_vm._v(_vm._s(curso.progreso === 100 ? 'Completado' : 'Pendiente'))])]), _c('div', {
      staticClass: "progress-header"
    }, [_c('span', [_vm._v("Progreso")]), _c('strong', [_vm._v(_vm._s(curso.progreso) + "%")])]), _c('div', {
      staticClass: "progress-bar"
    }, [_c('div', {
      staticClass: "progress-value",
      style: ({
        width: curso.progreso + '%'
      })
    })]), _c('button', {
      staticClass: "course-action",
      on: {
        "click": function($event) {
          return _vm.continuar(curso.id)
        }
      }
    }, [_vm._v(_vm._s(curso.progreso > 0 ? 'Continuar curso' : 'Comenzar curso')), _c('span', [_vm._v("→")])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Mis cursos")]), _c('p', [_vm._v("Capacitaciones y cursos asignados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-info"
  }, [_c('strong', [_vm._v("No tienes Cursos Asignados")])])
}]}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('bar-chart', {
    attrs: {
      "isHorizontal": false,
      "series": _vm.series,
      "categories": _vm.categories,
      "yAxisTitle": "Dias disponibles",
      "tooltipFormatter": _vm.tooltipFormatter,
      "title": "Top 10 empleados con más días disponibles",
      "showLegend": false,
      "showXlabels": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isModalActive) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.isModalActive = false
      }
    }
  }), _c('div', {
    staticClass: "box position-relative has-text-left margin-right-10 margin-left-10"
  }, [_vm._m(0), _c('div', _vm._l((_vm.lista), function(o, index) {
    return _c('span', {
      staticClass: "text-small"
    }, [_vm._v(_vm._s(o.descripcion)), _c('br')])
  }), 0), _c('br'), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.goToMisDocumentos()
      }
    }
  }, [_vm._v("Ir a mis documentos por firmar")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v("Tienes los siguientes documentos por firmar y cargar:")])])
}]}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Links importantes")]), (_vm.isLoading) ? _c('loading') : (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay links importantes ingresados")])])]) : _vm._e(), _c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "p-10 pt-20"
  }, [_c('ol', _vm._l((_vm.lista), function(o, index) {
    return _c('li', {
      staticClass: "cursor-pointer text-left transition-quick mb-8"
    }, [_c('a', {
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(o.descripcion))])])
  }), 0)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes de vacaciones no aprobadas")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isEditing) ? _c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [(_vm.mostrarConfirmacionEnviar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEnviar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea Aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazarMasiva = false
      },
      "do": _vm.rechazarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionAprobarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobarMasiva = false
      },
      "do": _vm.aprobarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "solicitud"
    },
    domProps: {
      "checked": _vm.seleccionadosTodos
    },
    on: {
      "change": function($event) {
        return _vm.check('all')
      }
    }
  })]), _c('th', [_vm._v("Nombre")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Retorno")]), _c('th', [_vm._v("Estado")]), (!_vm.isSeleccionMasiva) ? _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Acciones")]) : _vm._e()]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', {
      staticClass: "ta-center"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "dates-wrapper hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), (o.desde !== o.hasta) ? [_c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])] : _vm._e()], 2), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Retorno:")]), _c('span', [_vm._v(_vm._s(o.retorno))]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")]), _c('span', {
      staticClass: "email has-text-danger"
    }, [_vm._v(_vm._s(o.diasPasados) + " días pasados")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")]), _c('br'), _c('span', {
      staticClass: "email has-text-danger"
    }, [_vm._v(_vm._s(o.diasPasados) + " días pasados")])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('strong', [_vm._v(_vm._s(o.estadoData.descripcion))]), _c('br'), (!_vm.isSeleccionMasiva) ? _c('div', {
      staticClass: "show-break-1 contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()])]), (!_vm.isSeleccionMasiva) ? _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])])])]) : _vm._e()])
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 1) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title")], 2), _vm._m(0)]), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("default", [_c('small', [_vm._v("Esta operación")]), _c('strong', [_vm._v("no se puede")]), _c('small', [_vm._v("revertir")]), _c('br')])], 2), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('do')
      }
    }
  }, [_vm._t("primaryAction")], 2), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  })])])
}]}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "half-width margin-auto"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Ingrese sus credenciales")]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "DNI"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._m(0)])]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._m(1)])]), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/forgot-password-request"
    }
  }, [_vm._v("¿Olvidaste tu contraseña?")]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Ingresar")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorMessage) ? _c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Reportes de permisos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitudes",
    staticClass: "box"
  }, [_c('lista-solicitud-permisos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaPermisos) ? _c('div', {
    key: "lista_permisos",
    staticClass: "box position-relative"
  }, [_c('lista-permisos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaPermisos = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalInforme
    }
  }), _c('div', {
    staticClass: "card card-padre",
    class: {
      'sidebar-open-card': _vm.showSidebarDesktop
    }
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_vm._m(0), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content position-relative"
  }, [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(1), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top inline",
      attrs: {
        "aria-label": 'log: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion || o.accion) + " ")]), _c('span', {
      staticClass: "hint--top has-text-bold",
      attrs: {
        "aria-label": o.fechaString
      }
    }, [_vm._v(_vm._s(_vm._f("fromNow")(o.fecha)))])]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(o.modulo)))])]), _c('td', [_c('div', [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Accion: ")]), _c('span', {
      staticClass: "hint--top tipo-icon",
      attrs: {
        "aria-label": o.tipo
      }
    }, [_c('i', {
      class: _vm.tipoIcon[o.tipo]
    })])]), _vm._l((o.datos), function(value, key) {
      return _c('div', [_c('span', {
        staticClass: "has-text-bold"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])
    })], 2)])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o) {
    return _c('div', {
      staticClass: "position-relative informe-contenedor"
    }, [_c('div', {
      staticClass: "fecha"
    }, [_c('span', [_vm._v(_vm._s(o.fechaString))])]), _c('div', {
      staticClass: "modulo"
    }, [_c('span', [_vm._v(_vm._s(o.modulo))])]), _c('div', {
      staticClass: "descripcion"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.descripcion))])]), _vm._l((o.datos), function(value, key) {
      return _c('div', {
        staticClass: "datos"
      }, [_c('div', [_c('span', {
        staticClass: "text-small"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])])
    }), _c('div', {
      staticClass: "solicitud"
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Solicitud: ")]), _c('span', [_vm._v(_vm._s(o.idRelacionado))])])], 2)
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Informe de delegación")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Módulo")]), _c('th', [_vm._v("Datos")])])
}]}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarReporteBoletasPendientes) ? _c('div', {
    key: "reporte_boletas",
    staticClass: "box position-relative"
  }, [_c('lista-boletas-pendientes', {
    on: {
      "close": function($event) {
        _vm.mostrarReporteBoletasPendientes = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarReporteBoletas) ? _c('div', {
    key: "reporte_boletas",
    staticClass: "box position-relative"
  }, [_c('lista-boletas', {
    on: {
      "close": function($event) {
        _vm.mostrarReporteBoletas = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud contenedor-interno"
  }, [(_vm.mostrarConfirmacionGestionar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionGestionar = false
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarGestionar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionGestionar = false
      },
      "do": _vm.gestionarRenovacion
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea indicar que ya se realizo la renovación?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Confirmando...")] : [_vm._v("Confirmar")]], 2)])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes aprobadas")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._m(0), _c('div', {
    staticClass: "contenedor-fechas-boton"
  }, [_c('div', [_c('p', [_vm._v("Fecha fin de contrato")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFinContrato),
      expression: "fechaFinContrato"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFinContrato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFinContrato = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "padding-left-20"
  }, [_c('div', {
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._m(1), _c('span', [_vm._v("Refrescar")])])])])]), _c('div', {
    staticClass: "body"
  }, [(!_vm.isLoading) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(2), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigo
      }
    }, [_c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('div', {
      staticClass: "show-break-1"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Renovacion:")]), _c('br'), (o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [(o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])]), _c('td', [_vm._v(_vm._s(o.descripcionEstado))]), _c('td', [_c('span', [_vm._v(_vm._s(o.creadoPor))]), _c('br'), _c('div', {
      staticClass: "show-break-1"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Vencimiento:")]), _c('br'), _c('span', [_vm._v(_vm._s(o.fechaFinContrato))]), _c('br'), _c('div', {
      staticClass: "button is-small is-info mt-5",
      on: {
        "click": function($event) {
          return _vm.confirmacionYaSeGestiono(o)
        }
      }
    }, [_vm._m(3, true), _c('span', [_vm._v("Ya se gestionó")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.fechaFinContrato))]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('div', {
      staticClass: "button is-small is-info",
      on: {
        "click": function($event) {
          return _vm.confirmacionYaSeGestiono(o)
        }
      }
    }, [_vm._m(4, true), _c('span', [_vm._v("Ya se gestionó")])])])])])
  }), 0)], 1) : _vm._e(), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Solo aparecen las solicitudes de renovación aprobadas por la gerencia")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Gestione la renovación de contrato")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud desaparecerá de la lista, cuando se envíe la información desde el sistema de planillas")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Tipo renovación")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Creado por")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Fecha vencimiento")]), _c('th', {
    staticClass: "hide-break-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw fa-lg"
  })])
}]}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solicitud-vacaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.isEditing) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Modificando la solicitud " + _vm._s(_vm.solicitud.id))]) : (_vm.isExcepcion) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Ingresa una solicitud de vacaciones sin validaciones")]) : _c('span', [_vm._v("Ingresa una solicitud de vacaciones")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [(_vm.mostrarIndicaciones) ? _c('div', {
    key: "indicaciones",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        _vm.mostrarIndicaciones = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud la debe aprobar ")]), _c('strong', [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('span', [_vm._v(_vm._s(_vm.jefe))])])])])]) : _vm._e(), (_vm.empleadoExcepcion && _vm.empleadoExcepcion.codigo) ? _c('div', {
    key: "indicaciones-excepcion",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Ingresando una excepción para ")]), _c('strong', [_vm._v(_vm._s(_vm.empleadoExcepcion.nombre))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud la debe aprobar ")]), _c('strong', [_vm._v(_vm._s(_vm.empleadoExcepcion.nombreJefe))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por tomar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleadoExcepcion.diasReales))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por programar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleadoExcepcion.diasDisponibles))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La fecha de retorno debe ser ")]), _c('strong', [_vm._v("después a hoy")]), _c('span', [_vm._v(", si no fuera el caso, por favor comunicarse con sistemas")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Le llegará un mail de notificación a " + _vm._s(_vm.empleadoExcepcion.nombre) + " para que ")]), _c('strong', [_vm._v("envíe ")]), _c('span', [_vm._v("la solicitud a su jefe")])])])]) : _vm._e(), _c('div', {
    key: "transaccion",
    staticClass: "contenedor-transaccion"
  }, [(_vm.isExcepcion) ? _c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleado),
      expression: "codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _c('div', {
    staticClass: "fechas"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desde),
      expression: "desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.desde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desde = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasta),
      expression: "hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.hasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hasta = $event.target.value
      }
    }
  })])]), _c('p', [_c('span', [_vm._v("Retornarias el ")]), _c('strong', [_vm._v(_vm._s(_vm.retorno))])]), _c('p', [_c('span', [_vm._v("Te tomarias ")]), _c('strong', [_vm._v(_vm._s(_vm.dias))]), _c('span', [_vm._v(" dias de vacaciones")])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('span', [_vm._v("Guardar")])]), (!_vm.isExcepcion) ? _c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _c('span', [_vm._v("Guardar y Enviar")])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-component'), (_vm.showPopupBirthday) ? _c('div', {
    staticClass: "background-popup-birthday"
  }, [_c('div', {
    staticClass: "popup-birthday"
  }, [_c('div', {
    staticClass: "popup-birthday-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "popup-birthday-header-close",
    on: {
      "click": _vm.cerrarPopupBirthday
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-times-circle"
  })])]), _vm._m(1)])]) : _vm._e(), _c('component-mis-documentos-sin-cargar'), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalDelegacion) ? _c('div', {
    staticClass: "background-popup-birthday"
  }, [_c('div', {
    staticClass: "modal is-active"
  }, [_c('gestion-delegacion-guardar', {
    attrs: {
      "info": _vm.info,
      "isCreatingSelf": true
    },
    on: {
      "close": function($event) {
        _vm.mostrarModalDelegacion = false
      }
    }
  })], 1)]) : _vm._e()]), (_vm.showSidebarMobile) ? _c('div', {
    staticClass: "background-sidebar",
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('setSidebarMobile', false)
      }
    }
  }) : _vm._e(), _c('sidebar', {
    on: {
      "delegacion": function($event) {
        _vm.mostrarModalDelegacion = true
      }
    }
  }), _c('div', {
    staticClass: "position-b-sidebar",
    class: _vm.showSidebarDesktop ? 'left-sidebar' : '',
    on: {
      "click": function($event) {
        return _vm.sidebarHide()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-1x",
    class: _vm.showSidebarDesktop ? 'fa-caret-left' : 'fa-caret-right'
  })]), _c('div', {
    staticClass: "contenedor",
    class: !_vm.showSidebarDesktop ? 'padding-left-sidebar' : ''
  }, [_c('div', {
    staticClass: "is-fluid is-marginless padding-20 min-height-full"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)]), _c('notifications'), _c('bottom-bar', {
    staticClass: "app-bottom-bar"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-birthday-header-title"
  }, [_vm._v("¡Feliz cumpleaños! "), _c('span', [_c('i', {
    staticClass: "fa fa-birthday-cake"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-birthday-body"
  }, [_c('div', {
    staticClass: "popup-birthday-body-title"
  }, [_vm._v("Hoy es tu cumpleaños, te deseamos lo mejor en este día especial.")])])
}]}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "contenedor-box"
  }, [_c('div', {
    staticClass: "box"
  }, [(!_vm.estoySiendoReemplazado) ? _c('form', [_c('div', {
    staticClass: "flex fdr space-evenly"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "reemplazante"
    }
  }, [_vm._v("Reemplazante")]), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoReemplazante),
      expression: "codigoReemplazante"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoReemplazante)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaReemplazante = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoReemplazante = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.codigoReemplazante = ''
      }
    }
  }, [_vm._m(0)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaReemplazante) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoReemplazante
    },
    on: {
      "selected": _vm.seleccionarReemplazante,
      "close": function($event) {
        _vm.mostrarBusquedaReemplazante = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "fechaInicio"
    }
  }, [_vm._v("Fecha de Inicio")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaInicio),
      expression: "fechaInicio"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "min": _vm.getTodayDate()
    },
    domProps: {
      "value": (_vm.fechaInicio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaInicio = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "fechaFin"
    }
  }, [_vm._v("Fecha de Fin")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFin),
      expression: "fechaFin"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFin = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "field pt-20px"
  }, [_c('div', {
    staticClass: "control flex jcc"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._m(1), _c('span', [_vm._v("Guardar")])])])])]) : _vm._e(), (_vm.estoySiendoReemplazado) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("Ya estas siendo reemplazado por "), _c('strong', [_vm._v(_vm._s(_vm.nombreReemplazo))])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])
}]}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar delegacion ID - " + _vm._s(_vm.id))]) : _c('span', [_vm._v("Crear delegacion")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "fechas"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaInicio),
      expression: "fechaInicio"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaInicio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaInicio = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFin),
      expression: "fechaFin"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFin = $event.target.value
      }
    }
  })])]), (!_vm.isCreatingSelf) ? _c('div', {
    staticClass: "codigo-empleado"
  }, [_c('label', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleadoOrigen),
      expression: "codigoEmpleadoOrigen"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": _vm.id != 0
    },
    domProps: {
      "value": (_vm.codigoEmpleadoOrigen)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleadoOrigen = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleadoOrigen = $event.target.value
      }
    }
  }), (!_vm.id) ? _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.codigoEmpleadoOrigen = ''
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleadoOrigen) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleadoOrigen
    },
    on: {
      "selected": _vm.seleccionarEmpleadoOrigen,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleadoOrigen = false
      }
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), _c('div', {
    staticClass: "codigo-empleado pt-10"
  }, [_c('label', [_vm._v("Reemplazante")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleadoReemplazante),
      expression: "codigoEmpleadoReemplazante"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleadoReemplazante)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleadoReemplazante = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleadoReemplazante = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.codigoEmpleadoReemplazante = ''
      }
    }
  }, [_vm._m(1)]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleadoReemplazante) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleadoReemplazante
    },
    on: {
      "selected": _vm.seleccionarEmpleadoReemplazante,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleadoReemplazante = false
      }
    }
  })], 1) : _vm._e()])], 1)])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
}]}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalAdjuntar
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_foto_perfil",
      "folder": "fotoPerfil",
      "onlyImg": true
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar Foto de Perfil")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la imagen que deseas usar como foto de perfil")]), _c('span', {
    attrs: {
      "slot": "dropzoneDescription"
    },
    slot: "dropzoneDescription"
  }, [_vm._v("Arrastra la imagen que desees cargar o dale click al recuadro para buscar en tus archivos")]), _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1)])], 1) : _vm._e(), (_vm.mostrarConfirmacionEliminar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.eliminarFotoPerfil
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar su foto de perfil?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Foto de Perfil")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.isLoading) ? [_c('loading')] : [(_vm.pathFoto) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathFoto,
      "alt": "foto-usuario"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "contenedor-acciones"
  }, [(!_vm.pathFoto) ? _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_vm._m(0), _c('span', [_vm._v("Adjuntar")])]) : _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminar = true
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Eliminar foto")])])])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
}]}

/***/ })
],[273]);


// WEBPACK FOOTER //
// static/js/app.b2eabc7beca4b9ea4384.js